
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("luNAU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $aXWIB = parcelRequire("aXWIB");


var $kyKWe = parcelRequire("kyKWe");


var $inPa6 = parcelRequire("inPa6");





var $l998X = parcelRequire("l998X");





var $hm6w9 = parcelRequire("hm6w9");

const $c6d32a8c2bb13381$var$Context = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $c6d32a8c2bb13381$export$f413f968bd5eda1d = ({ children: children })=>{
    const config = (0, $42omo.useMemo)(()=>(0, $hm6w9.getBackendExperimentConfig)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($c6d32a8c2bb13381$var$Context.Provider, {
        value: config,
        children: children
    });
};
const $c6d32a8c2bb13381$export$284401669662f77b = ()=>{
    return (0, $42omo.useContext)($c6d32a8c2bb13381$var$Context);
};



var $lt6Lx = parcelRequire("lt6Lx");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");


var $3tUdX = parcelRequire("3tUdX");


var $dppWL = parcelRequire("dppWL");


var $bQm3c = parcelRequire("bQm3c");


var $dIdGO = parcelRequire("dIdGO");














var $4ymXE = parcelRequire("4ymXE");


var $i25hX = parcelRequire("i25hX");


var $4acD6 = parcelRequire("4acD6");


var $6Htct = parcelRequire("6Htct");


var $amW67 = parcelRequire("amW67");








var $lDwiy = parcelRequire("lDwiy");




const $acf42091f21d5b64$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    findRelatedPagesMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.find-related-pages",
        defaultMessage: "Find pages related to {query} owned by my team"
    },
    summarizeTopResultsMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.summarize-top-results",
        defaultMessage: "Summarize top results about: {query}"
    },
    whoHasRecentlyWorkedMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.who-has-recently-worked",
        defaultMessage: "Who has recently worked on {query} across my org?"
    },
    nudgeToQueryStartersTitle: {
        id: "search-page-rovo-config-common.nudge.title.nudge-to-query-starters",
        defaultMessage: "Can I help you find something?"
    },
    truncatedFindRelatedPagesMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.truncated-find-related-pages",
        defaultMessage: "Find pages related to my search query that are owned by my team"
    },
    truncatedSummarizeTopResultsMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.truncated-summarize-top-results",
        defaultMessage: "Summarize top results about my search query"
    },
    truncatedWhoHasRecentlyWorkedMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.truncated-who-has-recently-worked",
        defaultMessage: "Who has recently worked on items related to my search query across my org?"
    }
});
const $acf42091f21d5b64$export$e336dc06ffbdf437 = (query)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const formattedQuery = `'${query}'`;
    const useTruncatedLabels = formattedQuery.length > 52;
    // Find related pages action
    const findRelatedPagesAction = (0, $42omo.useCallback)(()=>({
            id: 'find-related-pages-action',
            title: useTruncatedLabels ? formatMessage($acf42091f21d5b64$export$defe85febe8b728c.truncatedFindRelatedPagesMenuItemLabel) : formatMessage($acf42091f21d5b64$export$defe85febe8b728c.findRelatedPagesMenuItemLabel, {
                query: formattedQuery
            }),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: "",
                    testId: "find-related-pages-action.icon"
                }),
            handleType: (0, $6Htct.HandleActionType).Chat,
            staticPrompt: formatMessage($acf42091f21d5b64$export$defe85febe8b728c.findRelatedPagesMenuItemLabel, {
                query: formattedQuery
            }),
            type: 'convo-starter-action',
            starterType: 'static'
        }), [
        formatMessage,
        formattedQuery,
        useTruncatedLabels
    ]);
    // Summarize top results action
    const summarizeTopResultsAction = (0, $42omo.useCallback)(()=>({
            id: 'summarize-top-results-action',
            title: useTruncatedLabels ? formatMessage($acf42091f21d5b64$export$defe85febe8b728c.truncatedSummarizeTopResultsMenuItemLabel) : formatMessage($acf42091f21d5b64$export$defe85febe8b728c.summarizeTopResultsMenuItemLabel, {
                query: formattedQuery
            }),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: "",
                    testId: "summarize-top-results-action.icon"
                }),
            handleType: (0, $6Htct.HandleActionType).Chat,
            staticPrompt: formatMessage($acf42091f21d5b64$export$defe85febe8b728c.summarizeTopResultsMenuItemLabel, {
                query: formattedQuery
            }),
            type: 'convo-starter-action',
            starterType: 'static'
        }), [
        formatMessage,
        formattedQuery,
        useTruncatedLabels
    ]);
    // Who has recently worked action
    const whoHasRecentlyWorkedAction = (0, $42omo.useCallback)(()=>({
            id: 'who-has-recently-worked-action',
            title: useTruncatedLabels ? formatMessage($acf42091f21d5b64$export$defe85febe8b728c.truncatedWhoHasRecentlyWorkedMenuItemLabel) : formatMessage($acf42091f21d5b64$export$defe85febe8b728c.whoHasRecentlyWorkedMenuItemLabel, {
                query: formattedQuery
            }),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: "",
                    testId: "who-has-recently-worked-action.icon"
                }),
            handleType: (0, $6Htct.HandleActionType).Chat,
            staticPrompt: formatMessage($acf42091f21d5b64$export$defe85febe8b728c.whoHasRecentlyWorkedMenuItemLabel, {
                query: formattedQuery
            }),
            type: 'convo-starter-action',
            starterType: 'static'
        }), [
        formatMessage,
        formattedQuery,
        useTruncatedLabels
    ]);
    return (0, $42omo.useCallback)(()=>{
        if (!query) return [];
        return [
            {
                id: 'find-related-pages-action',
                action: findRelatedPagesAction()
            },
            {
                id: 'summarize-top-results-action',
                action: summarizeTopResultsAction()
            },
            {
                id: 'who-has-recently-worked-action',
                action: whoHasRecentlyWorkedAction()
            }
        ];
    }, [
        findRelatedPagesAction,
        summarizeTopResultsAction,
        whoHasRecentlyWorkedAction,
        query
    ]);
};





var $3ce948c4bef5c88a$exports = {};
$3ce948c4bef5c88a$exports = new URL("search-icon-colorized-dark.8306f628.svg", import.meta.url).toString();


var $0844892267ef0071$exports = {};
$0844892267ef0071$exports = new URL("search-icon-colorized-light.d26567fa.svg", import.meta.url).toString();


const $29498a66b37ef077$var$messages = (0, $aXWIB.defineMessages)({
    searchAssistanceGreetingTitle: {
        id: "advanced-search.rovo-config-provider.search-assistance-greeting-title",
        defaultMessage: "Can I help you find something{name, select, undefined {} other {, {name}}}?"
    },
    searchAssistanceNudgeSubheaderLabel: {
        id: "advanced-search.rovo-config-provider.search-assistance-nudge-subheader",
        defaultMessage: "Search across your work to find what you need"
    }
});
const $29498a66b37ef077$var$EMPTY_ROVO_CONFIG = {
    getActions: async ()=>[]
};
const $29498a66b37ef077$export$f87ff91cbdaa6153 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { setConfiguration: setConfiguration } = t0;
    const props = (0, $amW67.useRovoConfigProviderProps)();
    const { getSearchQuery: getSearchQuery, shouldUseSearchPageRovoConfig: shouldUseSearchPageRovoConfig, shouldNudgeToQueryStarters: shouldNudgeToQueryStarters, shouldNudgeToSummarizeQuery: shouldNudgeToSummarizeQuery } = props;
    let t1;
    if ($[0] !== getSearchQuery) {
        t1 = (getSearchQuery?.() ?? "").toString();
        $[0] = getSearchQuery;
        $[1] = t1;
    } else t1 = $[1];
    const query = t1;
    const getSearchPageRovoActions = (0, $acf42091f21d5b64$export$e336dc06ffbdf437)(query);
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const publishRovo = (0, $i25hX.usePublish)("ai-mate");
    const intl = (0, $aXWIB.useIntl)();
    let t2;
    if ($[2] !== displayName || $[3] !== intl) {
        const firstName = displayName?.split(" ")[0];
        t2 = intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceGreetingTitle, {
            name: firstName ?? undefined
        });
        $[2] = displayName;
        $[3] = intl;
        $[4] = t2;
    } else t2 = $[4];
    const title = t2;
    const useSearchPageConfig = shouldUseSearchPageRovoConfig ?? false;
    let t3;
    if ($[5] !== getSearchPageRovoActions || $[6] !== query || $[7] !== title || $[8] !== useSearchPageConfig) {
        t3 = useSearchPageConfig && query !== "" ? {
            getActions: async ()=>{
                const actionEntries = getSearchPageRovoActions();
                const actions = actionEntries.map($29498a66b37ef077$var$_temp);
                return Promise.resolve(actions);
            },
            customGreeting: {
                title: title,
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($0844892267ef0071$exports))),
                iconSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($3ce948c4bef5c88a$exports))),
                truncateGreeting: false
            },
            prioritizeCustomActionResults: true,
            shouldShowGreeting: true
        } : $29498a66b37ef077$var$EMPTY_ROVO_CONFIG;
        $[5] = getSearchPageRovoActions;
        $[6] = query;
        $[7] = title;
        $[8] = useSearchPageConfig;
        $[9] = t3;
    } else t3 = $[9];
    const config = t3;
    let t4;
    let t5;
    if ($[10] !== config || $[11] !== getSearchPageRovoActions || $[12] !== intl || $[13] !== publishRovo || $[14] !== setConfiguration || $[15] !== setNudges || $[16] !== shouldNudgeToQueryStarters || $[17] !== shouldNudgeToSummarizeQuery || $[18] !== title) {
        t4 = ()=>{
            setConfiguration(config);
            if (shouldNudgeToQueryStarters) {
                const openSearchChat = ()=>{
                    publishRovo({
                        type: "chat-new",
                        source: "advanced-search-confluence",
                        openChat: true,
                        openChatMode: "mini-modal",
                        data: {
                            dialogues: []
                        }
                    });
                };
                const baseQueryStartersNudge = {
                    id: "nudge-to-query-starters-ai-action",
                    title: title,
                    secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                    icon: $29498a66b37ef077$var$_temp2,
                    handleType: (0, $6Htct.HandleActionType).Base,
                    type: "ai-action",
                    nudgeContext: {
                        id: "nudge-to-query-starters"
                    },
                    onClick: openSearchChat
                };
                setNudges([
                    {
                        ...baseQueryStartersNudge
                    }
                ]);
            }
            if (shouldNudgeToSummarizeQuery) {
                const actionsEntries = getSearchPageRovoActions();
                const actions_0 = actionsEntries.map($29498a66b37ef077$var$_temp3);
                const summarizeTopResultsAction = actions_0.find($29498a66b37ef077$var$_temp4);
                const transformedAction = summarizeTopResultsAction ? {
                    ...summarizeTopResultsAction,
                    secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                    nudgeContext: {
                        id: "nudge-to-summarize-query"
                    }
                } : null;
                setNudges(transformedAction ? [
                    transformedAction
                ] : []);
            }
        };
        t5 = [
            config,
            setConfiguration,
            shouldNudgeToQueryStarters,
            shouldNudgeToSummarizeQuery,
            getSearchPageRovoActions,
            setNudges,
            intl,
            publishRovo,
            title
        ];
        $[10] = config;
        $[11] = getSearchPageRovoActions;
        $[12] = intl;
        $[13] = publishRovo;
        $[14] = setConfiguration;
        $[15] = setNudges;
        $[16] = shouldNudgeToQueryStarters;
        $[17] = shouldNudgeToSummarizeQuery;
        $[18] = title;
        $[19] = t4;
        $[20] = t5;
    } else {
        t4 = $[19];
        t5 = $[20];
    }
    (0, $42omo.useEffect)(t4, t5);
    return null;
} : ({ setConfiguration: setConfiguration })=>{
    const props = (0, $amW67.useRovoConfigProviderProps)();
    const { getSearchQuery: getSearchQuery, shouldUseSearchPageRovoConfig: shouldUseSearchPageRovoConfig, shouldNudgeToQueryStarters: shouldNudgeToQueryStarters, shouldNudgeToSummarizeQuery: shouldNudgeToSummarizeQuery } = props;
    const query = (getSearchQuery?.() ?? '').toString();
    const getSearchPageRovoActions = (0, $acf42091f21d5b64$export$e336dc06ffbdf437)(query);
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const publishRovo = (0, $i25hX.usePublish)('ai-mate');
    const intl = (0, $aXWIB.useIntl)();
    // Use first name for greeting when available; fallback for anonymous or missing displayName
    const firstName = displayName?.split(' ')[0];
    const title = intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceGreetingTitle, {
        name: firstName ?? undefined
    });
    // When undefined (e.g. prop not passed), use empty config for backward compatibility
    const useSearchPageConfig = shouldUseSearchPageRovoConfig ?? false;
    const config = (0, $42omo.useMemo)(()=>useSearchPageConfig && query !== '' ? {
            getActions: async ()=>{
                const actionEntries = getSearchPageRovoActions();
                const actions = actionEntries.map(({ action: action })=>action);
                return Promise.resolve(actions);
            },
            customGreeting: {
                title: title,
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($0844892267ef0071$exports))),
                iconSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($3ce948c4bef5c88a$exports))),
                truncateGreeting: false
            },
            prioritizeCustomActionResults: true,
            shouldShowGreeting: true
        } : $29498a66b37ef077$var$EMPTY_ROVO_CONFIG, [
        useSearchPageConfig,
        getSearchPageRovoActions,
        title,
        query
    ]);
    (0, $42omo.useEffect)(()=>{
        setConfiguration(config);
        //If user is in the nudge to query starters cohort, set the nudge to query starters action
        if (shouldNudgeToQueryStarters) {
            const openSearchChat = ()=>{
                publishRovo({
                    type: 'chat-new',
                    source: 'advanced-search-confluence',
                    openChat: true,
                    openChatMode: 'mini-modal',
                    data: {
                        dialogues: []
                    }
                });
            };
            const baseQueryStartersNudge = {
                id: 'nudge-to-query-starters-ai-action',
                title: title,
                secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
                        label: ""
                    }),
                handleType: (0, $6Htct.HandleActionType).Base,
                type: 'ai-action',
                nudgeContext: {
                    id: 'nudge-to-query-starters'
                },
                onClick: openSearchChat
            };
            setNudges([
                {
                    ...baseQueryStartersNudge
                }
            ]);
        }
        //If user is in the nudge to summarize query cohort, set the summarize top results action
        if (shouldNudgeToSummarizeQuery) {
            const actionsEntries = getSearchPageRovoActions();
            const actions_0 = actionsEntries.map(({ action: action_0 })=>action_0);
            const summarizeTopResultsAction = actions_0.find((a)=>a.id === 'summarize-top-results-action');
            const transformedAction = summarizeTopResultsAction ? {
                ...summarizeTopResultsAction,
                secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                nudgeContext: {
                    id: 'nudge-to-summarize-query'
                }
            } : null;
            setNudges(transformedAction ? [
                transformedAction
            ] : []);
        }
    }, [
        config,
        setConfiguration,
        shouldNudgeToQueryStarters,
        shouldNudgeToSummarizeQuery,
        getSearchPageRovoActions,
        setNudges,
        intl,
        publishRovo,
        title
    ]);
    return null;
};
function $29498a66b37ef077$var$_temp(t0) {
    const { action: action } = t0;
    return action;
}
function $29498a66b37ef077$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
        label: ""
    });
}
function $29498a66b37ef077$var$_temp3(t0) {
    const { action: action_0 } = t0;
    return action_0;
}
function $29498a66b37ef077$var$_temp4(a) {
    return a.id === "summarize-top-results-action";
}












var $dpPtd = parcelRequire("dpPtd");























var $ePNCU = parcelRequire("ePNCU");


var $4TB09 = parcelRequire("4TB09");

const $5d0f8354a84fe01a$export$ce35a99c900a2a66 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const { searchSessionId: searchSessionId, fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    let t0;
    let t1;
    if ($[0] !== fireAnalytics || $[1] !== searchSessionId) {
        t0 = ()=>{
            if (searchSessionId) {
                const eventData = $5d0f8354a84fe01a$var$buildEventData(searchSessionId);
                (0, $ePNCU.getDwellTimeTracker)().then((tracker)=>{
                    tracker.startAny(eventData, (callbackData)=>{
                        const { dwellTime: dwellTime, finalDwellEvent: finalDwellEvent } = callbackData.attributes;
                        if (finalDwellEvent && !dwellTime) return;
                        fireAnalytics({
                            type: "sendTrackEvent",
                            action: "dwelled",
                            actionSubject: callbackData.actionSubject,
                            additionalAttributes: callbackData.attributes
                        });
                    });
                });
            }
            return $5d0f8354a84fe01a$var$_temp2;
        };
        t1 = [
            searchSessionId,
            fireAnalytics
        ];
        $[0] = fireAnalytics;
        $[1] = searchSessionId;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
} : ()=>{
    const { searchSessionId: searchSessionId, fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        if (searchSessionId) {
            const eventData = $5d0f8354a84fe01a$var$buildEventData(searchSessionId);
            (0, $ePNCU.getDwellTimeTracker)().then((tracker)=>{
                tracker.startAny(eventData, (callbackData)=>{
                    // When leaving the page and using browser-back to reenter, we get a second invalid finalDwellEvent
                    // It is unclear how this is happening, and the pattern here already matches recommended implementation in import { useDwellTime } from "@confluence/dwell"
                    // We can safely ignore this event
                    const { dwellTime: dwellTime, finalDwellEvent: finalDwellEvent } = callbackData.attributes;
                    if (finalDwellEvent && !dwellTime) return;
                    fireAnalytics({
                        type: 'sendTrackEvent',
                        action: 'dwelled',
                        actionSubject: callbackData.actionSubject,
                        additionalAttributes: callbackData.attributes
                    });
                });
            });
        }
        return ()=>{
            (0, $ePNCU.getDwellTimeTracker)().then((tracker_0)=>{
                tracker_0.stop();
            });
        };
    }, [
        searchSessionId,
        fireAnalytics
    ]);
};
const $5d0f8354a84fe01a$var$buildEventData = (searchSessionId)=>({
        source: 'advancedSearchScreen',
        actionSubject: 'searchPage',
        attributes: {
            searchSessionId: searchSessionId,
            isFullPageSearch: false
        }
    });
function $5d0f8354a84fe01a$var$_temp(tracker_0) {
    tracker_0.stop();
}
function $5d0f8354a84fe01a$var$_temp2() {
    (0, $ePNCU.getDwellTimeTracker)().then($5d0f8354a84fe01a$var$_temp);
}



var $dmHCt = parcelRequire("dmHCt");











var $gMc0m = parcelRequire("gMc0m");

const $7adf2f9ada840466$export$1c7ad7ad25850bd5 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "main" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2hwx1wug _18u01wug _10qf1e2i _10yz1yw0 _1wf9idpf _xy6b1oqx _79xfidpf _bcgv1oqx _s7ko1f2o _13f9idpf _1nlv68cl _1hzoidpf _1ro068cl _1nqx6fgy _d69bidpf _1m2i68cl _to10idpf _139y68cl _cb401fra _16oz1fra _1oje1e2i",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "main", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx1wug _18u01wug _10qf1e2i _10yz1yw0 _1wf9idpf _xy6b1oqx _79xfidpf _bcgv1oqx _s7ko1f2o _13f9idpf _1nlv68cl _1hzoidpf _1ro068cl _1nqx6fgy _d69bidpf _1m2i68cl _to10idpf _139y68cl _cb401fra _16oz1fra _1oje1e2i",
            __cmplp.className
        ])
    });
});
const $7adf2f9ada840466$export$cb4aeb4aba07ad10 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _19pkidpf _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19pkidpf _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7adf2f9ada840466$export$6e4640db3f243f9f = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _16jlkb7n _2lx21bp4 _1ul91vif _n3td1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _16jlkb7n _2lx21bp4 _1ul91vif _n3td1ul9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7adf2f9ada840466$export$4538ac878c0b3606 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7adf2f9ada840466$export$8a2b6afa02539da2 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _1ltvp3fh",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1ltvp3fh",
            __cmplp.className
        ])
    });
});






var $jmjWc = parcelRequire("jmjWc");


var $b3j2Y = parcelRequire("b3j2Y");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");














var $fGkN6 = parcelRequire("fGkN6");







/**
 * @generated SignedSource<<9601eb546a3c455e03f7310bf092304a>>
 * @relayHash e68741e9aa55c22f15fb45988e20f49c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e9841b592e24f4fe2f48f0cd28d8ceee782653f661bb001b3beae451fa106b
const $f8c5981925c238e7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "analytics"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLivePagesEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "analytics",
            "variableName": "analytics"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "experimentContext",
            "variableName": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "url"
    }, v13 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v16 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "webUiLink"
    }, v19 = {
        "concreteType": "SearchConfluenceResultSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "spaceId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ ,
            v11 /*: any*/ ,
            {
                "condition": "isLivePagesEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    }
                ]
            },
            {
                "concreteType": "ConfluencePage",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    v9 /*: any*/ ,
                    {
                        "concreteType": "ConfluencePageLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "webUi"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceContentTitleEmoji",
                        "kind": "LinkedField",
                        "name": "titleEmojiPublished",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ConfluencePage"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconPath"
            },
            v18 /*: any*/ 
        ],
        "type": "SearchConfluenceSpace"
    }, v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = {
        "concreteType": "SearchAbTest",
        "kind": "LinkedField",
        "name": "abTest",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "abTestId"
            },
            {
                "kind": "ScalarField",
                "name": "controlId"
            },
            {
                "kind": "ScalarField",
                "name": "experimentId"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useResultSupplierAdvancedAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useResultSupplierAdvancedAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v9 /*: any*/ 
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e68741e9aa55c22f15fb45988e20f49c",
            "id": "44e9841b592e24f4fe2f48f0cd28d8ceee782653f661bb001b3beae451fa106b",
            "metadata": {},
            "name": "useResultSupplierAdvancedAGGSearchQuery",
            "operationKind": "query",
            "text": "query useResultSupplierAdvancedAGGSearchQuery($experience:String!,$analytics:SearchAnalyticsInput,$query:String!,$first:Int,$after:String,$filters:SearchFilterInput!,$experimentContext:SearchExperimentContextInput,$isLivePagesEnabled:Boolean!){search{search(experience:$experience,analytics:$analytics,query:$query,first:$first,after:$after,filters:$filters,experimentContext:$experimentContext){edges{node{__typename,id,title,type,url,...on SearchConfluencePageBlogAttachment{entityId,excerpt,isVerified,lastModified,space{id,spaceId,name,key,webUiLink},confluenceEntity{__typename,...on ConfluencePage{id,type,subtype@include(if:$isLivePagesEnabled),ancestors{title,id,links{webUi}},metadata{titleEmojiPublished{id,key,value}}},...on Node{__isNode:__typename,id}}},...on SearchConfluenceSpace{entityId,key,iconPath,webUiLink}}},pageInfo{endCursor},abTest{abTestId,controlId,experimentId},totalCount}}}"
        }
    };
}();
$f8c5981925c238e7$var$node.hash = "fdb63333f98d16f9fffdf0161967f496";
var $f8c5981925c238e7$export$2e2bcd8739ae039 = $f8c5981925c238e7$var$node;


/**
 * @generated SignedSource<<cf92e8027be7245ddd311157f6f829f2>>
 * @relayHash 25d0e10d688d30e93b8445b211278591
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 93cbefe71fefe31a319254ba4dbc6ddacf9e21160a8224fcef17c37ba27d7cf1
const $4ff2c0b2ff8c3a1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "alias": "webUi",
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "entityType"
                        },
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "excerpt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastModified"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "KeyValueHierarchyMap",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v8 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useResultSupplierAdvancedSearchCQLQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useResultSupplierAdvancedSearchCQLQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "25d0e10d688d30e93b8445b211278591",
            "id": "93cbefe71fefe31a319254ba4dbc6ddacf9e21160a8224fcef17c37ba27d7cf1",
            "metadata": {},
            "name": "useResultSupplierAdvancedSearchCQLQuery",
            "operationKind": "query",
            "text": "query useResultSupplierAdvancedSearchCQLQuery($cql:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,first:$first,after:$after){nodes{entityType,title,excerpt,url,lastModified,content{id,type,ancestors{id,title,links{webUi:webui}},space{id,key,name,links{webUi:webui},status},extensions{key,value}},space{id,name,type,icon{path}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$4ff2c0b2ff8c3a1f$var$node.hash = "67a35c51a1f67fc0a0672cfb84296594";
var $4ff2c0b2ff8c3a1f$export$2e2bcd8739ae039 = $4ff2c0b2ff8c3a1f$var$node;












var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9eE57 = parcelRequire("9eE57");


var $yuLaV = parcelRequire("yuLaV");


var $kDja4 = parcelRequire("kDja4");








var $1HFOS = parcelRequire("1HFOS");


var $iD4ky = parcelRequire("iD4ky");


var $jghB4 = parcelRequire("jghB4");

const $74fb5df0686fb3e5$export$5224e5b54073ec2c = (cql)=>{
    if (Array.isArray(cql)) cql = cql[0];
    return {
        variables: {
            cql: cql,
            first: (0, $jghB4.PAGE_SIZE)
        }
    };
};
const $74fb5df0686fb3e5$export$2625640bc44129f6 = ({ searchQueryText: searchQueryText, selectedFilters: selectedFilters, confluenceInstance: confluenceInstance, searchSessionId: searchSessionId, activationId: activationId, isWhiteboardsEnabled: isWhiteboardsEnabled = false, isDatabasesEnabled: isDatabasesEnabled = false, isSlidesEnabled: isSlidesEnabled = false, isLivePagesEnabled: isLivePagesEnabled = false, experimentId: experimentId, experimentLayers: experimentLayers })=>{
    return {
        variables: {
            experience: (0, $jghB4.CONFLUENCE_AS_EXPERIENCE),
            analytics: {
                searchSessionId: searchSessionId
            },
            query: searchQueryText || '',
            first: (0, $jghB4.PAGE_SIZE),
            filters: {
                entities: $74fb5df0686fb3e5$export$e2e3f9f64b249105({
                    filters: selectedFilters,
                    isDatabasesEnabled: isDatabasesEnabled,
                    isWhiteboardsEnabled: isWhiteboardsEnabled,
                    isSlidesEnabled: isSlidesEnabled
                }),
                locations: [
                    confluenceInstance
                ],
                confluenceFilters: (0, $iD4ky.createAggFilters)(selectedFilters, activationId)
            },
            experimentContext: {
                experimentId: experimentId,
                experimentLayers: experimentLayers
            },
            isLivePagesEnabled: isLivePagesEnabled
        }
    };
};
const $74fb5df0686fb3e5$export$e2e3f9f64b249105 = ({ filters: filters, isDatabasesEnabled: isDatabasesEnabled, isWhiteboardsEnabled: isWhiteboardsEnabled, isSlidesEnabled: isSlidesEnabled })=>{
    let entities = (0, $jghB4.DEFAULT_ENTITIES);
    if (isWhiteboardsEnabled) entities = entities.concat([
        (0, $jghB4.ConfluenceATIs).WHITEBOARD
    ]);
    if (isDatabasesEnabled) entities = entities.concat([
        (0, $jghB4.ConfluenceATIs).DATABASE
    ]);
    if (isSlidesEnabled) entities = entities.concat([
        (0, $jghB4.ConfluenceATIs).SLIDE
    ]);
    // https://hello.atlassian.net/wiki/spaces/~638712e7f48fbd9b62d80f9a/pages/2353884324/Confluence+Search+Filter+by+Content+Type
    // shows how entities need to be set for Confluence and special content types
    const selectedTypeFilters = filters[(0, $jghB4.FilterIds).TYPE].filter((typeOption)=>typeOption.isSelected);
    if (selectedTypeFilters.length > 0) {
        // only one type can be selected at a time
        const selectedFilter = selectedTypeFilters[0];
        switch(selectedFilter.value){
            case 'page':
                entities = [
                    (0, $jghB4.ConfluenceATIs).PAGE
                ];
                break;
            case 'blogpost':
                entities = [
                    (0, $jghB4.ConfluenceATIs).BLOG
                ];
                break;
            case 'attachment':
                entities = [
                    (0, $jghB4.ConfluenceATIs).ATTACHMENT
                ];
                break;
            case 'space':
                entities = [
                    (0, $jghB4.ConfluenceATIs).SPACE
                ];
                break;
            case 'whiteboard':
                if (isWhiteboardsEnabled) entities = [
                    (0, $jghB4.ConfluenceATIs).WHITEBOARD
                ];
                break;
            case 'database':
                if (isDatabasesEnabled) entities = [
                    (0, $jghB4.ConfluenceATIs).DATABASE
                ];
                break;
            case 'slide':
                if (isSlidesEnabled) entities = [
                    (0, $jghB4.ConfluenceATIs).SLIDE
                ];
                break;
            case 'embed':
                entities = [
                    (0, $jghB4.ConfluenceATIs).EMBED
                ];
                break;
            case 'folder':
                entities = [
                    (0, $jghB4.ConfluenceATIs).FOLDER
                ];
                break;
            case 'comment':
                entities = [
                    (0, $jghB4.ConfluenceATIs).COMMENT
                ];
                break;
            default:
                // special content types are populated dynamically in type filter drop down pane
                // by the cgraphQL ContentTypesQuery and need 'confluence.' prepended
                const specialContentType = `confluence.${selectedFilter.value}`;
                entities = [
                    specialContentType
                ];
        }
    }
    return entities;
};






var $jlIaF = parcelRequire("jlIaF");

const $52721e76b9522f41$export$71690642bed3c02b = (ancestors, baseSpace)=>{
    const transformedAncestors = ancestors.map((ancestor)=>({
            id: ancestor?.id || '',
            title: ancestor?.title || '',
            href: ancestor?.links?.webUi ? `${0, $jlIaF.CONTEXT_PATH}${ancestor.links.webUi}` : ''
        }));
    // The first breadcrumb ancestor does not contain the correct space name so need to replace by the base space the result comes from
    // Also, non-page results don't have ancestors so we need to make sure it includes the space as its only ancestor
    return baseSpace ? [
        {
            ...baseSpace,
            href: `${(0, $jlIaF.CONTEXT_PATH)}${baseSpace.href}`
        },
        ...transformedAncestors.slice(1)
    ] : transformedAncestors;
};





const $ee3cd531a9283c07$export$8671a7176e88846c = (cqlData)=>{
    const nodes = cqlData?.search?.nodes || [];
    return nodes.map((node)=>{
        const baseAncestor = node?.content?.space ? {
            id: node.content.space.id || '',
            title: node.content.space.name || '',
            href: node.content.space.links?.webUi || ''
        } : null;
        return {
            entityType: node?.entityType || '',
            title: node?.title || '',
            excerpt: node?.excerpt || '',
            url: node?.url || '',
            lastModified: node?.lastModified || '',
            content: {
                id: node?.content?.id || '',
                type: (node?.content?.type || '').toLowerCase(),
                space: {
                    id: node?.content?.space?.id || '',
                    key: node?.content?.space?.key || '',
                    name: node?.content?.space?.name || '',
                    links: {
                        webui: node?.content?.space?.links?.webUi || ''
                    }
                }
            },
            space: {
                id: node?.space?.id || '',
                icon: {
                    path: node?.space?.icon?.path || ''
                },
                webui: node?.url || ''
            },
            ancestors: (0, $52721e76b9522f41$export$71690642bed3c02b)((node?.content?.ancestors || []).map((a)=>a ?? null), baseAncestor)
        };
    });
};
const $ee3cd531a9283c07$export$d449648a99616a75 = (url)=>{
    try {
        return url.replace(`${new URL(url).origin + (0, $jghB4.CONTEXT_PATH)}`, '');
    } catch  {
        return url;
    }
};
const $ee3cd531a9283c07$export$6c388bd8b7d94f1c = (aggData)=>{
    const edges = aggData?.search?.search?.edges || [];
    return edges.map((edge)=>{
        const node = edge.node;
        const baseAncestor = node?.space ? {
            id: node.space.spaceId || '',
            title: node.space.name || '',
            href: node.space.webUiLink || ''
        } : null;
        return {
            entityType: node?.type || '',
            subtype: node?.confluenceEntity?.subtype || '',
            title: node?.title || '',
            excerpt: node?.excerpt || '',
            url: $ee3cd531a9283c07$export$d449648a99616a75(node?.url || ''),
            lastModified: node?.lastModified?.toString() || '',
            isVerified: node?.isVerified || false,
            content: {
                id: node?.entityId || '',
                type: (node?.type || '').toLowerCase(),
                space: {
                    id: node?.space?.spaceId || '',
                    key: node?.space?.key || '',
                    name: node?.space?.name || '',
                    links: {
                        webui: node?.space?.webUiLink || ''
                    }
                }
            },
            space: {
                id: node?.entityId || '',
                icon: {
                    path: node?.iconPath || ''
                },
                webui: node?.webUiLink || ''
            },
            ancestors: (0, $52721e76b9522f41$export$71690642bed3c02b)((node?.confluenceEntity?.ancestors || []).map((a)=>a ?? null), baseAncestor),
            emoji: node?.confluenceEntity?.metadata?.titleEmojiPublished?.value || ''
        };
    });
};



var $jMyy4 = parcelRequire("jMyy4");

/**
 * This error can be reproduced when a user is searching in a stale container & aren't authenticated.
 * To reproduce, open two tabs on Advanced Search. Log out of confluence from one of the tabs, and search in the other.
 * You should get a network call with a 200 status code and an error message 403 forbidden.
 * It is thrown by api_search intentionally and counted as user errors, and thus is expected and should not affect our reliability metrics.
 */ const $6e8ed5702282fcbb$var$isExpected403Error = (error)=>error.message.includes('Problem while calling endpoint api_search: HTTP 403 Forbidden');
const $6e8ed5702282fcbb$var$loadMoreData = (fetchMore, after, aggSearchQueryEnabled = false)=>{
    (0, $9eE57.perfMarkStart)({
        subject: 'advancedSearchLoadMoreResult'
    });
    fetchMore({
        variables: {
            first: (0, $jghB4.PAGE_SIZE),
            after: after
        },
        updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
            if (aggSearchQueryEnabled) {
                const prevAGGResults = prev?.search?.search?.edges || [];
                const nextAGGResults = fetchMoreResult?.search?.search?.edges || [];
                return {
                    search: {
                        __typename: prev.search.__typename,
                        search: {
                            ...fetchMoreResult.search.search,
                            edges: [
                                ...prevAGGResults,
                                ...nextAGGResults
                            ]
                        }
                    }
                };
            }
            const prevResults = prev?.search?.nodes || [];
            const nextResults = fetchMoreResult?.search?.nodes || [];
            return {
                search: {
                    ...fetchMoreResult.search,
                    nodes: [
                        ...prevResults,
                        ...nextResults
                    ]
                }
            };
        }
    });
};
const $6e8ed5702282fcbb$var$isCustomerAccountError = (error)=>error.message.includes('Service search does not support customer accounts');
const $6e8ed5702282fcbb$export$a3bd2c7cebafe892 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { queryType: queryType, searchQueryText: searchQueryText, cql: cql, searchFilters: searchFilters, searchSessionId: searchSessionId, sessionHasUserInput: sessionHasUserInput } = t0;
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled("whiteboardsEnabled");
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database");
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("slide");
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluenceInstance = (0, $jghB4.CONFLUENCE_ARI).concat(cloudId);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t1 = cql ?? "";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $74fb5df0686fb3e5$export$5224e5b54073ec2c)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = queryType !== "CQLQuery";
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            ...t2,
            skip: t3,
            notifyOnNetworkStatusChange: true,
            errorPolicy: "all"
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: cqlData, loading: cqlLoading, error: cqlError, fetchMore: cqlFetchMore } = (0, $jMyy4.useQueryInterop)((0, $4ff2c0b2ff8c3a1f$export$2e2bcd8739ae039), {
        ...t4,
        __callerPackage__: "@confluence/advanced-search"
    });
    const entities = (0, $74fb5df0686fb3e5$export$e2e3f9f64b249105)({
        filters: searchFilters,
        isWhiteboardsEnabled: isWhiteboardsEnabledAS,
        isDatabasesEnabled: isDatabasesEnabledAS,
        isSlidesEnabled: isSlidesEnabledAS
    });
    const { backendExperiment: dynamicBackendExperiment, loading: dynamicBackendExperimentLoading, productEdition: productEdition } = (0, $1HFOS.useDynamicBackendExperiment)({
        cloudId: cloudId,
        entities: entities,
        userId: userId || undefined,
        experience: "advanced-search"
    }) || {};
    const backendExperiment = dynamicBackendExperiment;
    const t5 = (0, $74fb5df0686fb3e5$export$2625640bc44129f6)({
        searchQueryText: searchQueryText,
        selectedFilters: searchFilters,
        confluenceInstance: confluenceInstance,
        searchSessionId: searchSessionId,
        activationId: activationId,
        userId: userId,
        isWhiteboardsEnabled: isWhiteboardsEnabledAS,
        isDatabasesEnabled: isDatabasesEnabledAS,
        isSlidesEnabled: isSlidesEnabledAS,
        isLivePagesEnabled: (0, $9wGTI.fg)("confluence_live_pages_open_beta_trait_opted_in"),
        experimentId: backendExperiment?.experimentId,
        experimentLayers: backendExperiment?.experimentLayers?.map($6e8ed5702282fcbb$var$_temp)
    });
    const t6 = Boolean(queryType !== "AGGQuery" || !sessionHasUserInput || dynamicBackendExperimentLoading);
    let t7;
    if ($[5] !== t5 || $[6] !== t6) {
        t7 = {
            ...t5,
            skip: t6,
            notifyOnNetworkStatusChange: true,
            errorPolicy: "all",
            interopApolloAggClient: true
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const { data: aggData, loading: aggLoading, error: aggError, fetchMore: aggFetchMore } = (0, $jMyy4.useQueryInterop)((0, $f8c5981925c238e7$export$2e2bcd8739ae039), {
        ...t7,
        __callerPackage__: "@confluence/advanced-search"
    });
    if (aggError) {
        if ($6e8ed5702282fcbb$var$isCustomerAccountError(aggError) || (0, $aMcHK.isStatusCodeError)(aggError, "401") || $6e8ed5702282fcbb$var$isExpected403Error(aggError)) {
            (0, $7Sm4c.markErrorAsHandled)(aggError);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: "user not authorized"
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: aggError
        });
    }
    let t8;
    if ($[8] !== aggData || $[9] !== aggError || $[10] !== aggFetchMore || $[11] !== aggLoading || $[12] !== backendExperiment?.experimentLayers || $[13] !== cqlData || $[14] !== cqlError || $[15] !== cqlFetchMore || $[16] !== cqlLoading || $[17] !== productEdition || $[18] !== queryType) {
        t8 = queryType === "CQLQuery" ? {
            results: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData),
            loading: cqlLoading,
            error: cqlError,
            loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(cqlFetchMore, cqlData?.search?.pageInfo?.endCursor || ""),
            hasNextPage: cqlData?.search?.pageInfo?.hasNextPage || false,
            numResults: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData).length || 0,
            abTest: null
        } : {
            results: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData),
            loading: aggLoading,
            error: aggError,
            loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(aggFetchMore, aggData?.search?.search?.pageInfo?.endCursor || "", true),
            hasNextPage: !!aggData?.search?.search?.pageInfo?.endCursor,
            totalCount: aggData?.search?.search?.totalCount,
            numResults: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData).length || 0,
            abTest: null,
            experimentLayers: backendExperiment?.experimentLayers?.map($6e8ed5702282fcbb$var$_temp2),
            productEdition: productEdition
        };
        $[8] = aggData;
        $[9] = aggError;
        $[10] = aggFetchMore;
        $[11] = aggLoading;
        $[12] = backendExperiment?.experimentLayers;
        $[13] = cqlData;
        $[14] = cqlError;
        $[15] = cqlFetchMore;
        $[16] = cqlLoading;
        $[17] = productEdition;
        $[18] = queryType;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ queryType: queryType, searchQueryText: searchQueryText, cql: cql, searchFilters: searchFilters, searchSessionId: searchSessionId, sessionHasUserInput: sessionHasUserInput })=>{
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluenceInstance = (0, $jghB4.CONFLUENCE_ARI).concat(cloudId);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { data: cqlData, loading: cqlLoading, error: cqlError, fetchMore: cqlFetchMore } = (0, $jMyy4.useQueryInterop)(/** @schema cc */ (0, $4ff2c0b2ff8c3a1f$export$2e2bcd8739ae039), {
        ...(0, $74fb5df0686fb3e5$export$5224e5b54073ec2c)(cql ?? ''),
        skip: queryType !== 'CQLQuery',
        notifyOnNetworkStatusChange: true,
        errorPolicy: 'all',
        __callerPackage__: "@confluence/advanced-search"
    });
    const entities = (0, $74fb5df0686fb3e5$export$e2e3f9f64b249105)({
        filters: searchFilters,
        isWhiteboardsEnabled: isWhiteboardsEnabledAS,
        isDatabasesEnabled: isDatabasesEnabledAS,
        isSlidesEnabled: isSlidesEnabledAS
    });
    const { backendExperiment: dynamicBackendExperiment, loading: dynamicBackendExperimentLoading, productEdition: productEdition } = (0, $1HFOS.useDynamicBackendExperiment)({
        cloudId: cloudId,
        entities: entities,
        userId: userId || undefined,
        experience: 'advanced-search'
    }) || {};
    const backendExperiment = dynamicBackendExperiment;
    const { data: aggData, loading: aggLoading, error: aggError, fetchMore: aggFetchMore } = (0, $jMyy4.useQueryInterop)(/** @schema agg */ (0, $f8c5981925c238e7$export$2e2bcd8739ae039), {
        ...(0, $74fb5df0686fb3e5$export$2625640bc44129f6)({
            searchQueryText: searchQueryText,
            selectedFilters: searchFilters,
            confluenceInstance: confluenceInstance,
            searchSessionId: searchSessionId,
            activationId: activationId,
            userId: userId,
            isWhiteboardsEnabled: isWhiteboardsEnabledAS,
            isDatabasesEnabled: isDatabasesEnabledAS,
            isSlidesEnabled: isSlidesEnabledAS,
            isLivePagesEnabled: (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in'),
            experimentId: backendExperiment?.experimentId,
            experimentLayers: backendExperiment?.experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                    name: name,
                    layerId: layerId,
                    shadowId: shadowId,
                    definitions: definitions
                }))
        }),
        skip: Boolean(queryType !== 'AGGQuery' || !sessionHasUserInput || dynamicBackendExperimentLoading),
        notifyOnNetworkStatusChange: true,
        errorPolicy: 'all',
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/advanced-search"
    });
    if (aggError) {
        if ($6e8ed5702282fcbb$var$isCustomerAccountError(aggError) || (0, $aMcHK.isStatusCodeError)(aggError, '401') || $6e8ed5702282fcbb$var$isExpected403Error(aggError)) {
            (0, $7Sm4c.markErrorAsHandled)(aggError);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: 'user not authorized'
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: aggError
        });
    }
    return queryType === 'CQLQuery' ? {
        results: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData),
        loading: cqlLoading,
        error: cqlError,
        loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(cqlFetchMore, cqlData?.search?.pageInfo?.endCursor || ''),
        hasNextPage: cqlData?.search?.pageInfo?.hasNextPage || false,
        numResults: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData).length || 0,
        abTest: null
    } : {
        results: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData),
        loading: aggLoading,
        error: aggError,
        loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(aggFetchMore, aggData?.search?.search?.pageInfo?.endCursor || '', true),
        hasNextPage: !!aggData?.search?.search?.pageInfo?.endCursor,
        totalCount: aggData?.search?.search?.totalCount,
        numResults: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData).length || 0,
        abTest: null,
        experimentLayers: backendExperiment?.experimentLayers?.map((layer)=>{
            const { analyticsDefinitions: analyticsDefinitions, definitions: _definitions, ...rest } = layer;
            return {
                ...rest,
                definitions: analyticsDefinitions
            };
        }),
        productEdition: productEdition
    };
};
function $6e8ed5702282fcbb$var$_temp(t0) {
    const { name: name, layerId: layerId, shadowId: shadowId, definitions: definitions } = t0;
    return {
        name: name,
        layerId: layerId,
        shadowId: shadowId,
        definitions: definitions
    };
}
function $6e8ed5702282fcbb$var$_temp2(layer) {
    const { analyticsDefinitions: analyticsDefinitions, definitions: _definitions, ...rest } = layer;
    return {
        ...rest,
        definitions: analyticsDefinitions
    };
}


const $e002af62c9e690dc$export$b798fd863f55912e = {
    en: [
        'i',
        'me',
        'my',
        'myself',
        'we',
        'our',
        'ours',
        'ourselves',
        'you',
        "you're",
        "you've",
        "you'll",
        "you'd",
        'your',
        'yours',
        'yourself',
        'yourselves',
        'he',
        'him',
        'his',
        'himself',
        'she',
        "she's",
        'her',
        'hers',
        'herself',
        'it',
        "it's",
        'its',
        'itself',
        'they',
        'them',
        'their',
        'theirs',
        'themselves',
        'what',
        'which',
        'who',
        'whom',
        'this',
        'that',
        "that'll",
        'these',
        'those',
        'am',
        'is',
        'are',
        'was',
        'were',
        'be',
        'been',
        'being',
        'have',
        'has',
        'had',
        'having',
        'do',
        'does',
        'did',
        'doing',
        'a',
        'an',
        'the',
        'and',
        'but',
        'if',
        'or',
        'because',
        'as',
        'until',
        'while',
        'of',
        'at',
        'by',
        'for',
        'with',
        'about',
        'against',
        'between',
        'into',
        'through',
        'during',
        'before',
        'after',
        'above',
        'below',
        'to',
        'from',
        'up',
        'down',
        'in',
        'out',
        'on',
        'off',
        'over',
        'under',
        'again',
        'further',
        'then',
        'once',
        'here',
        'there',
        'when',
        'where',
        'why',
        'how',
        'all',
        'any',
        'both',
        'each',
        'few',
        'more',
        'most',
        'other',
        'some',
        'such',
        'no',
        'nor',
        'not',
        'only',
        'own',
        'same',
        'so',
        'than',
        'too',
        'very',
        'can',
        'will',
        'just',
        'don',
        "don't",
        'should',
        "should've",
        'now',
        'ain',
        'aren',
        "aren't",
        'couldn',
        "couldn't",
        'didn',
        "didn't",
        'doesn',
        "doesn't",
        'hadn',
        "hadn't",
        'hasn',
        "hasn't",
        'haven',
        "haven't",
        'isn',
        "isn't",
        'ma',
        'mightn',
        "mightn't",
        'mustn',
        "mustn't",
        'needn',
        "needn't",
        'shan',
        "shan't",
        'shouldn',
        "shouldn't",
        'wasn',
        "wasn't",
        'weren',
        "weren't",
        'won',
        "won't",
        'wouldn',
        "wouldn't"
    ],
    de: [
        'de',
        'en',
        'van',
        'ik',
        'te',
        'dat',
        'die',
        'in',
        'een',
        'hij',
        'het',
        'niet',
        'zijn',
        'is',
        'was',
        'op',
        'aan',
        'met',
        'als',
        'voor',
        'had',
        'er',
        'maar',
        'om',
        'hem',
        'dan',
        'zou',
        'of',
        'wat',
        'mijn',
        'men',
        'dit',
        'zo',
        'door',
        'over',
        'ze',
        'zich',
        'bij',
        'ook',
        'tot',
        'je',
        'mij',
        'uit',
        'der',
        'daar',
        'haar',
        'naar',
        'heb',
        'hoe',
        'heeft',
        'hebben',
        'deze',
        'u',
        'want',
        'nog',
        'zal',
        'me',
        'zij',
        'nu',
        'ge',
        'geen',
        'omdat',
        'iets',
        'worden',
        'toch',
        'al',
        'waren',
        'veel',
        'meer',
        'doen',
        'toen',
        'moet',
        'ben',
        'zonder',
        'kan',
        'hun',
        'dus',
        'alles',
        'onder',
        'ja',
        'eens',
        'hier',
        'wie',
        'werd',
        'altijd',
        'doch',
        'wordt',
        'wezen',
        'kunnen',
        'ons',
        'zelf',
        'tegen',
        'na',
        'reeds',
        'wil',
        'kon',
        'niets',
        'uw',
        'iemand',
        'geweest',
        'andere'
    ],
    ru: [
        "\u0438",
        "\u0432",
        "\u0432\u043E",
        "\u043D\u0435",
        "\u0447\u0442\u043E",
        "\u043E\u043D",
        "\u043D\u0430",
        "\u044F",
        "\u0441",
        "\u0441\u043E",
        "\u043A\u0430\u043A",
        "\u0430",
        "\u0442\u043E",
        "\u0432\u0441\u0435",
        "\u043E\u043D\u0430",
        "\u0442\u0430\u043A",
        "\u0435\u0433\u043E",
        "\u043D\u043E",
        "\u0434\u0430",
        "\u0442\u044B",
        "\u043A",
        "\u0443",
        "\u0436\u0435",
        "\u0432\u044B",
        "\u0437\u0430",
        "\u0431\u044B",
        "\u043F\u043E",
        "\u0442\u043E\u043B\u044C\u043A\u043E",
        "\u0435\u0435",
        "\u043C\u043D\u0435",
        "\u0431\u044B\u043B\u043E",
        "\u0432\u043E\u0442",
        "\u043E\u0442",
        "\u043C\u0435\u043D\u044F",
        "\u0435\u0449\u0435",
        "\u043D\u0435\u0442",
        "\u043E",
        "\u0438\u0437",
        "\u0435\u043C\u0443",
        "\u0442\u0435\u043F\u0435\u0440\u044C",
        "\u043A\u043E\u0433\u0434\u0430",
        "\u0434\u0430\u0436\u0435",
        "\u043D\u0443",
        "\u0432\u0434\u0440\u0443\u0433",
        "\u043B\u0438",
        "\u0435\u0441\u043B\u0438",
        "\u0443\u0436\u0435",
        "\u0438\u043B\u0438",
        "\u043D\u0438",
        "\u0431\u044B\u0442\u044C",
        "\u0431\u044B\u043B",
        "\u043D\u0435\u0433\u043E",
        "\u0434\u043E",
        "\u0432\u0430\u0441",
        "\u043D\u0438\u0431\u0443\u0434\u044C",
        "\u043E\u043F\u044F\u0442\u044C",
        "\u0443\u0436",
        "\u0432\u0430\u043C",
        "\u0432\u0435\u0434\u044C",
        "\u0442\u0430\u043C",
        "\u043F\u043E\u0442\u043E\u043C",
        "\u0441\u0435\u0431\u044F",
        "\u043D\u0438\u0447\u0435\u0433\u043E",
        "\u0435\u0439",
        "\u043C\u043E\u0436\u0435\u0442",
        "\u043E\u043D\u0438",
        "\u0442\u0443\u0442",
        "\u0433\u0434\u0435",
        "\u0435\u0441\u0442\u044C",
        "\u043D\u0430\u0434\u043E",
        "\u043D\u0435\u0439",
        "\u0434\u043B\u044F",
        "\u043C\u044B",
        "\u0442\u0435\u0431\u044F",
        "\u0438\u0445",
        "\u0447\u0435\u043C",
        "\u0431\u044B\u043B\u0430",
        "\u0441\u0430\u043C",
        "\u0447\u0442\u043E\u0431",
        "\u0431\u0435\u0437",
        "\u0431\u0443\u0434\u0442\u043E",
        "\u0447\u0435\u0433\u043E",
        "\u0440\u0430\u0437",
        "\u0442\u043E\u0436\u0435",
        "\u0441\u0435\u0431\u0435",
        "\u043F\u043E\u0434",
        "\u0431\u0443\u0434\u0435\u0442",
        "\u0436",
        "\u0442\u043E\u0433\u0434\u0430",
        "\u043A\u0442\u043E",
        "\u044D\u0442\u043E\u0442",
        "\u0442\u043E\u0433\u043E",
        "\u043F\u043E\u0442\u043E\u043C\u0443",
        "\u044D\u0442\u043E\u0433\u043E",
        "\u043A\u0430\u043A\u043E\u0439",
        "\u0441\u043E\u0432\u0441\u0435\u043C",
        "\u043D\u0438\u043C",
        "\u0437\u0434\u0435\u0441\u044C",
        "\u044D\u0442\u043E\u043C",
        "\u043E\u0434\u0438\u043D",
        "\u043F\u043E\u0447\u0442\u0438",
        "\u043C\u043E\u0439",
        "\u0442\u0435\u043C",
        "\u0447\u0442\u043E\u0431\u044B",
        "\u043D\u0435\u0435",
        "\u0441\u0435\u0439\u0447\u0430\u0441",
        "\u0431\u044B\u043B\u0438",
        "\u043A\u0443\u0434\u0430",
        "\u0437\u0430\u0447\u0435\u043C",
        "\u0432\u0441\u0435\u0445",
        "\u043D\u0438\u043A\u043E\u0433\u0434\u0430",
        "\u043C\u043E\u0436\u043D\u043E",
        "\u043F\u0440\u0438",
        "\u043D\u0430\u043A\u043E\u043D\u0435\u0446",
        "\u0434\u0432\u0430",
        "\u043E\u0431",
        "\u0434\u0440\u0443\u0433\u043E\u0439",
        "\u0445\u043E\u0442\u044C",
        "\u043F\u043E\u0441\u043B\u0435",
        "\u043D\u0430\u0434",
        "\u0431\u043E\u043B\u044C\u0448\u0435",
        "\u0442\u043E\u0442",
        "\u0447\u0435\u0440\u0435\u0437",
        "\u044D\u0442\u0438",
        "\u043D\u0430\u0441",
        "\u043F\u0440\u043E",
        "\u0432\u0441\u0435\u0433\u043E",
        "\u043D\u0438\u0445",
        "\u043A\u0430\u043A\u0430\u044F",
        "\u043C\u043D\u043E\u0433\u043E",
        "\u0440\u0430\u0437\u0432\u0435",
        "\u0442\u0440\u0438",
        "\u044D\u0442\u0443",
        "\u043C\u043E\u044F",
        "\u0432\u043F\u0440\u043E\u0447\u0435\u043C",
        "\u0445\u043E\u0440\u043E\u0448\u043E",
        "\u0441\u0432\u043E\u044E",
        "\u044D\u0442\u043E\u0439",
        "\u043F\u0435\u0440\u0435\u0434",
        "\u0438\u043D\u043E\u0433\u0434\u0430",
        "\u043B\u0443\u0447\u0448\u0435",
        "\u0447\u0443\u0442\u044C",
        "\u0442\u043E\u043C",
        "\u043D\u0435\u043B\u044C\u0437\u044F",
        "\u0442\u0430\u043A\u043E\u0439",
        "\u0438\u043C",
        "\u0431\u043E\u043B\u0435\u0435",
        "\u0432\u0441\u0435\u0433\u0434\u0430",
        "\u043A\u043E\u043D\u0435\u0447\u043D\u043E",
        "\u0432\u0441\u044E",
        "\u043C\u0435\u0436\u0434\u0443"
    ],
    fr: [
        'au',
        'aux',
        'avec',
        'ce',
        'ces',
        'dans',
        'de',
        'des',
        'du',
        'elle',
        'en',
        'et',
        'eux',
        'il',
        'ils',
        'je',
        'la',
        'le',
        'les',
        'leur',
        'lui',
        'ma',
        'mais',
        'me',
        "m\xeame",
        'mes',
        'moi',
        'mon',
        'ne',
        'nos',
        'notre',
        'nous',
        'on',
        'ou',
        'par',
        'pas',
        'pour',
        'qu',
        'que',
        'qui',
        'sa',
        'se',
        'ses',
        'son',
        'sur',
        'ta',
        'te',
        'tes',
        'toi',
        'ton',
        'tu',
        'un',
        'une',
        'vos',
        'votre',
        'vous',
        'c',
        'd',
        'j',
        'l',
        "\xe0",
        'm',
        'n',
        's',
        't',
        'y',
        "\xe9t\xe9",
        "\xe9t\xe9e",
        "\xe9t\xe9es",
        "\xe9t\xe9s",
        "\xe9tant",
        "\xe9tante",
        "\xe9tants",
        "\xe9tantes",
        'suis',
        'es',
        'est',
        'sommes',
        "\xeates",
        'sont',
        'serai',
        'seras',
        'sera',
        'serons',
        'serez',
        'seront',
        'serais',
        'serait',
        'serions',
        'seriez',
        'seraient',
        "\xe9tais",
        "\xe9tait",
        "\xe9tions",
        "\xe9tiez",
        "\xe9taient",
        'fus',
        'fut',
        "f\xfbmes",
        "f\xfbtes",
        'furent',
        'sois',
        'soit',
        'soyons',
        'soyez',
        'soient',
        'fusse',
        'fusses',
        "f\xfbt",
        'fussions',
        'fussiez',
        'fussent',
        'ayant',
        'ayante',
        'ayantes',
        'ayants',
        'eu',
        'eue',
        'eues',
        'eus',
        'ai',
        'as',
        'avons',
        'avez',
        'ont',
        'aurai',
        'auras',
        'aura',
        'aurons',
        'aurez',
        'auront',
        'aurais',
        'aurait',
        'aurions',
        'auriez',
        'auraient',
        'avais',
        'avait',
        'avions',
        'aviez',
        'avaient',
        'eut',
        "e\xfbmes",
        "e\xfbtes",
        'eurent',
        'aie',
        'aies',
        'ait',
        'ayons',
        'ayez',
        'aient',
        'eusse',
        'eusses',
        "e\xfbt",
        'eussions',
        'eussiez',
        'eussent'
    ],
    pt: [
        'a',
        "\xe0",
        'ao',
        'aos',
        'aquela',
        'aquelas',
        'aquele',
        'aqueles',
        'aquilo',
        'as',
        "\xe0s",
        "at\xe9",
        'com',
        'como',
        'da',
        'das',
        'de',
        'dela',
        'delas',
        'dele',
        'deles',
        'depois',
        'do',
        'dos',
        'e',
        "\xe9",
        'ela',
        'elas',
        'ele',
        'eles',
        'em',
        'entre',
        'era',
        'eram',
        "\xe9ramos",
        'essa',
        'essas',
        'esse',
        'esses',
        'esta',
        "est\xe1",
        'estamos',
        "est\xe3o",
        'estar',
        'estas',
        'estava',
        'estavam',
        "est\xe1vamos",
        'este',
        'esteja',
        'estejam',
        'estejamos',
        'estes',
        'esteve',
        'estive',
        'estivemos',
        'estiver',
        'estivera',
        'estiveram',
        "estiv\xe9ramos",
        'estiverem',
        'estivermos',
        'estivesse',
        'estivessem',
        "estiv\xe9ssemos",
        'estou',
        'eu',
        'foi',
        'fomos',
        'for',
        'fora',
        'foram',
        "f\xf4ramos",
        'forem',
        'formos',
        'fosse',
        'fossem',
        "f\xf4ssemos",
        'fui',
        "h\xe1",
        'haja',
        'hajam',
        'hajamos',
        "h\xe3o",
        'havemos',
        'haver',
        'hei',
        'houve',
        'houvemos',
        'houver',
        'houvera',
        "houver\xe1",
        'houveram',
        "houv\xe9ramos",
        "houver\xe3o",
        'houverei',
        'houverem',
        'houveremos',
        'houveria',
        'houveriam',
        "houver\xedamos",
        'houvermos',
        'houvesse',
        'houvessem',
        "houv\xe9ssemos",
        'isso',
        'isto',
        "j\xe1",
        'lhe',
        'lhes',
        'mais',
        'mas',
        'me',
        'mesmo',
        'meu',
        'meus',
        'minha',
        'minhas',
        'muito',
        'na',
        "n\xe3o",
        'nas',
        'nem',
        'no',
        'nos',
        "n\xf3s",
        'nossa',
        'nossas',
        'nosso',
        'nossos',
        'num',
        'numa',
        'o',
        'os',
        'ou',
        'para',
        'pela',
        'pelas',
        'pelo',
        'pelos',
        'por',
        'qual',
        'quando',
        'que',
        'quem',
        "s\xe3o",
        'se',
        'seja',
        'sejam',
        'sejamos',
        'sem',
        'ser',
        "ser\xe1",
        "ser\xe3o",
        'serei',
        'seremos',
        'seria',
        'seriam',
        "ser\xedamos",
        'seu',
        'seus',
        "s\xf3",
        'somos',
        'sou',
        'sua',
        'suas',
        "tamb\xe9m",
        'te',
        'tem',
        "t\xe9m",
        'temos',
        'tenha',
        'tenham',
        'tenhamos',
        'tenho',
        "ter\xe1",
        "ter\xe3o",
        'terei',
        'teremos',
        'teria',
        'teriam',
        "ter\xedamos",
        'teu',
        'teus',
        'teve',
        'tinha',
        'tinham',
        "t\xednhamos",
        'tive',
        'tivemos',
        'tiver',
        'tivera',
        'tiveram',
        "tiv\xe9ramos",
        'tiverem',
        'tivermos',
        'tivesse',
        'tivessem',
        "tiv\xe9ssemos",
        'tu',
        'tua',
        'tuas',
        'um',
        'uma',
        "voc\xea",
        "voc\xeas",
        'vos'
    ],
    cs: [
        'a',
        'aby',
        'ahoj',
        'aj',
        'ale',
        'anebo',
        'ani',
        "ani\u017E",
        'ano',
        'asi',
        "aspo\u0148",
        'atd',
        'atp',
        'az',
        "a\u010Dkoli",
        "a\u017E",
        'bez',
        'beze',
        "bl\xedzko",
        "bohu\u017Eel",
        'brzo',
        'bude',
        'budem',
        'budeme',
        'budes',
        'budete',
        "bude\u0161",
        'budou',
        'budu',
        'by',
        'byl',
        'byla',
        'byli',
        'bylo',
        'byly',
        'bys',
        'byt',
        "b\xfdt",
        "b\u011Bhem",
        'chce',
        'chceme',
        'chcete',
        "chce\u0161",
        'chci',
        "cht\xedt",
        "cht\u011Bj\xed",
        "chut'",
        'chuti',
        'ci',
        'clanek',
        'clanku',
        'clanky',
        'co',
        'coz',
        "co\u017E",
        'cz',
        'daleko',
        'dalsi',
        "dal\u0161\xed",
        'den',
        'deset',
        'design',
        "devaten\xe1ct",
        "dev\u011Bt",
        'dnes',
        'do',
        "dobr\xfd",
        'docela',
        'dva',
        'dvacet',
        "dvan\xe1ct",
        "dv\u011B",
        "d\xe1l",
        "d\xe1le",
        "d\u011Bkovat",
        "d\u011Bkujeme",
        "d\u011Bkuji",
        'email',
        'ho',
        "hodn\u011B",
        'i',
        'jak',
        'jakmile',
        'jako',
        "jako\u017E",
        'jde',
        'je',
        'jeden',
        "jeden\xe1ct",
        'jedna',
        'jedno',
        'jednou',
        'jedou',
        'jeho',
        "jeho\u017E",
        'jej',
        'jeji',
        'jejich',
        "jej\xed",
        "jeliko\u017E",
        'jemu',
        'jen',
        'jenom',
        "jen\u017E",
        'jeste',
        'jestli',
        "jestli\u017Ee",
        "je\u0161t\u011B",
        "je\u017E",
        'ji',
        'jich',
        'jimi',
        'jinak',
        'jine',
        "jin\xe9",
        'jiz',
        "ji\u017E",
        'jsem',
        'jses',
        "jse\u0161",
        'jsi',
        'jsme',
        'jsou',
        'jste',
        "j\xe1",
        "j\xed",
        "j\xedm",
        "j\xed\u017E",
        "j\u0161te",
        'k',
        'kam',
        "ka\u017Ed\xfd",
        'kde',
        'kdo',
        'kdy',
        'kdyz',
        "kdy\u017E",
        'ke',
        'kolik',
        "krom\u011B",
        'ktera',
        'ktere',
        'kteri',
        'kterou',
        'ktery',
        "kter\xe1",
        "kter\xe9",
        "kter\xfd",
        "kte\u0159i",
        "kte\u0159\xed",
        'ku',
        "kv\u016Fli",
        'ma',
        "maj\xed",
        'mate',
        'me',
        'mezi',
        'mi',
        'mit',
        'mne',
        'mnou',
        "mn\u011B",
        'moc',
        'mohl',
        'mohou',
        'moje',
        'moji',
        "mo\u017En\xe1",
        'muj',
        "mus\xed",
        'muze',
        'my',
        "m\xe1",
        "m\xe1lo",
        "m\xe1m",
        "m\xe1me",
        "m\xe1te",
        "m\xe1\u0161",
        "m\xe9",
        "m\xed",
        "m\xedt",
        "m\u011B",
        "m\u016Fj",
        "m\u016F\u017Ee",
        'na',
        'nad',
        'nade',
        'nam',
        'napiste',
        "napi\u0161te",
        'naproti',
        'nas',
        'nasi',
        "na\u010De\u017E",
        "na\u0161e",
        "na\u0161i",
        'ne',
        'nebo',
        'nebyl',
        'nebyla',
        'nebyli',
        'nebyly',
        "nech\u0165",
        "ned\u011Blaj\xed",
        "ned\u011Bl\xe1",
        "ned\u011Bl\xe1m",
        "ned\u011Bl\xe1me",
        "ned\u011Bl\xe1te",
        "ned\u011Bl\xe1\u0161",
        'neg',
        'nejsi',
        'nejsou',
        "nemaj\xed",
        "nem\xe1me",
        "nem\xe1te",
        "nem\u011Bl",
        'neni',
        "nen\xed",
        "nesta\u010D\xed",
        "nevad\xed",
        'nez',
        "ne\u017E",
        'nic',
        'nich',
        'nimi',
        'nove',
        'novy',
        "nov\xe9",
        "nov\xfd",
        'nula',
        "n\xe1",
        "n\xe1m",
        "n\xe1mi",
        "n\xe1s",
        "n\xe1\u0161",
        "n\xed",
        "n\xedm",
        "n\u011B",
        "n\u011Bco",
        "n\u011Bjak",
        "n\u011Bkde",
        "n\u011Bkdo",
        "n\u011Bmu",
        "n\u011Bmu\u017E",
        'o',
        'od',
        'ode',
        'on',
        'ona',
        'oni',
        'ono',
        'ony',
        'osm',
        "osmn\xe1ct",
        'pak',
        "patn\xe1ct",
        'po',
        'pod',
        'podle',
        'pokud',
        'potom',
        'pouze',
        "pozd\u011B",
        "po\u0159\xe1d",
        'prave',
        "prav\xe9",
        'pred',
        'pres',
        'pri',
        'pro',
        'proc',
        "prost\u011B",
        "pros\xedm",
        'proti',
        'proto',
        'protoze',
        "proto\u017Ee",
        "pro\u010D",
        'prvni',
        "prvn\xed",
        "pr\xe1ve",
        'pta',
        "p\u011Bt",
        "p\u0159ed",
        "p\u0159ede",
        "p\u0159es",
        "p\u0159ese",
        "p\u0159i",
        "p\u0159i\u010Dem\u017E",
        're',
        "rovn\u011B",
        's',
        'se',
        'sedm',
        "sedmn\xe1ct",
        'si',
        'sice',
        'skoro',
        "sm\xed",
        "sm\u011Bj\xed",
        'snad',
        'spolu',
        'sta',
        'sto',
        'strana',
        "st\xe9",
        'sve',
        'svych',
        'svym',
        'svymi',
        "sv\xe9",
        "sv\xfdch",
        "sv\xfdm",
        "sv\xfdmi",
        "sv\u016Fj",
        'ta',
        'tady',
        'tak',
        'take',
        'takhle',
        'taky',
        'takze',
        "tak\xe9",
        "tak\u017Ee",
        'tam',
        'tamhle',
        'tamhleto',
        'tamto',
        'tato',
        'te',
        'tebe',
        'tebou',
        "ted'",
        'tedy',
        'tema',
        'ten',
        'tento',
        'teto',
        'ti',
        'tim',
        'timto',
        'tipy',
        "tis\xedc",
        "tis\xedce",
        'to',
        "tob\u011B",
        'tohle',
        'toho',
        'tohoto',
        'tom',
        'tomto',
        'tomu',
        'tomuto',
        'toto',
        "tro\u0161ku",
        'tu',
        'tuto',
        'tvoje',
        "tv\xe1",
        "tv\xe9",
        "tv\u016Fj",
        'ty',
        'tyto',
        "t\xe9ma",
        "t\xe9to",
        "t\xedm",
        "t\xedmto",
        "t\u011B",
        "t\u011Bm",
        "t\u011Bma",
        "t\u011Bmu",
        "t\u0159eba",
        "t\u0159i",
        "t\u0159in\xe1ct",
        'u',
        "ur\u010Dit\u011B",
        'uz',
        "u\u017E",
        'v',
        'vam',
        'vas',
        'vase',
        "va\u0161e",
        "va\u0161i",
        've',
        'vedle',
        "ve\u010Der",
        'vice',
        "vlastn\u011B",
        'vsak',
        'vy',
        "v\xe1m",
        "v\xe1mi",
        "v\xe1s",
        "v\xe1\u0161",
        "v\xedce",
        "v\u0161ak",
        "v\u0161echen",
        "v\u0161echno",
        "v\u0161ichni",
        "v\u016Fbec",
        "v\u017Edy",
        'z',
        'za',
        "zat\xedmco",
        "za\u010D",
        'zda',
        'zde',
        'ze',
        'zpet',
        'zpravy',
        "zpr\xe1vy",
        "zp\u011Bt",
        "\u010Dau",
        "\u010Di",
        "\u010Dl\xe1nek",
        "\u010Dl\xe1nku",
        "\u010Dl\xe1nky",
        "\u010Dtrn\xe1ct",
        "\u010Dty\u0159i",
        "\u0161est",
        "\u0161estn\xe1ct",
        "\u017Ee"
    ],
    el: [
        "\u03B1\u03BB\u03BB\u03B1",
        "\u03B1\u03BD",
        "\u03B1\u03BD\u03C4\u03B9",
        "\u03B1\u03C0\u03BF",
        "\u03B1\u03C5\u03C4\u03B1",
        "\u03B1\u03C5\u03C4\u03B5\u03C3",
        "\u03B1\u03C5\u03C4\u03B7",
        "\u03B1\u03C5\u03C4\u03BF",
        "\u03B1\u03C5\u03C4\u03BF\u03B9",
        "\u03B1\u03C5\u03C4\u03BF\u03C3",
        "\u03B1\u03C5\u03C4\u03BF\u03C5\u03C3",
        "\u03B1\u03C5\u03C4\u03C9\u03BD",
        "\u03B1\u1F31",
        "\u03B1\u1F33",
        "\u03B1\u1F35",
        "\u03B1\u1F50\u03C4\u03CC\u03C3",
        "\u03B1\u1F50\u03C4\u1F78\u03C2",
        "\u03B1\u1F56",
        "\u03B3\u03AC\u03C1",
        "\u03B3\u03B1",
        "\u03B3\u03B5",
        "\u03B3\u03B9\u03B1",
        "\u03B3\u03BF\u1FE6\u03BD",
        "\u03B3\u1F70\u03C1",
        "\u03B4'",
        "\u03B4\u03AD",
        "\u03B4\u03AE",
        "\u03B4\u03B1\u03AF",
        "\u03B4\u03B1\u03AF\u03C3",
        "\u03B4\u03B1\u1F76",
        "\u03B4\u03B1\u1F76\u03C2",
        "\u03B4\u03B5",
        "\u03B4\u03B5\u03BD",
        "\u03B4\u03B9'",
        "\u03B4\u03B9\u03AC",
        "\u03B4\u03B9\u1F70",
        "\u03B4\u1F72",
        "\u03B4\u1F74",
        "\u03B4\u2019",
        "\u03B5\u03B1\u03BD",
        "\u03B5\u03B9\u03BC\u03B1\u03B9",
        "\u03B5\u03B9\u03BC\u03B1\u03C3\u03C4\u03B5",
        "\u03B5\u03B9\u03BD\u03B1\u03B9",
        "\u03B5\u03B9\u03C3\u03B1\u03B9",
        "\u03B5\u03B9\u03C3\u03C4\u03B5",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03B1",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03B5\u03C3",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03B7",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF\u03B9",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF\u03C3",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF\u03C5\u03C3",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03C9\u03BD",
        "\u03B5\u03BD\u03C9",
        "\u03B5\u03C0",
        "\u03B5\u03C0\u03B9",
        "\u03B5\u1F30",
        "\u03B5\u1F30\u03BC\u03AF",
        "\u03B5\u1F30\u03BC\u1F76",
        "\u03B5\u1F30\u03C2",
        "\u03B5\u1F30\u03C3",
        "\u03B5\u1F34",
        "\u03B5\u1F34\u03BC\u03B9",
        "\u03B5\u1F34\u03C4\u03B5",
        "\u03B7",
        "\u03B8\u03B1",
        "\u03B9\u03C3\u03C9\u03C3",
        "\u03BA",
        "\u03BA\u03B1\u03AF",
        "\u03BA\u03B1\u03AF\u03C4\u03BF\u03B9",
        "\u03BA\u03B1\u03B8",
        "\u03BA\u03B1\u03B9",
        "\u03BA\u03B1\u03C4",
        "\u03BA\u03B1\u03C4\u03AC",
        "\u03BA\u03B1\u03C4\u03B1",
        "\u03BA\u03B1\u03C4\u1F70",
        "\u03BA\u03B1\u1F76",
        "\u03BA\u03B9",
        "\u03BA\u1F00\u03BD",
        "\u03BA\u1F02\u03BD",
        "\u03BC\u03AD\u03BD",
        "\u03BC\u03AE",
        "\u03BC\u03AE\u03C4\u03B5",
        "\u03BC\u03B1",
        "\u03BC\u03B5",
        "\u03BC\u03B5\u03B8",
        "\u03BC\u03B5\u03C4",
        "\u03BC\u03B5\u03C4\u03AC",
        "\u03BC\u03B5\u03C4\u03B1",
        "\u03BC\u03B5\u03C4\u1F70",
        "\u03BC\u03B7",
        "\u03BC\u03B7\u03BD",
        "\u03BC\u1F10\u03BD",
        "\u03BC\u1F72\u03BD",
        "\u03BC\u1F74",
        "\u03BC\u1F74\u03BD",
        "\u03BD\u03B1",
        "\u03BF",
        "\u03BF\u03B9",
        "\u03BF\u03BC\u03C9\u03C3",
        "\u03BF\u03C0\u03C9\u03C3",
        "\u03BF\u03C3\u03BF",
        "\u03BF\u03C4\u03B9",
        "\u03BF\u1F31",
        "\u03BF\u1F33",
        "\u03BF\u1F37\u03C2",
        "\u03BF\u1F50",
        "\u03BF\u1F50\u03B4",
        "\u03BF\u1F50\u03B4\u03AD",
        "\u03BF\u1F50\u03B4\u03B5\u03AF\u03C3",
        "\u03BF\u1F50\u03B4\u03B5\u1F76\u03C2",
        "\u03BF\u1F50\u03B4\u1F72",
        "\u03BF\u1F50\u03B4\u1F72\u03BD",
        "\u03BF\u1F50\u03BA",
        "\u03BF\u1F50\u03C7",
        "\u03BF\u1F50\u03C7\u1F76",
        "\u03BF\u1F53\u03C2",
        "\u03BF\u1F54\u03C4\u03B5",
        "\u03BF\u1F55\u03C4\u03C9",
        "\u03BF\u1F55\u03C4\u03C9\u03C2",
        "\u03BF\u1F55\u03C4\u03C9\u03C3",
        "\u03BF\u1F56\u03BD",
        "\u03BF\u1F57",
        "\u03BF\u1F57\u03C4\u03BF\u03C2",
        "\u03BF\u1F57\u03C4\u03BF\u03C3",
        "\u03C0\u03B1\u03C1",
        "\u03C0\u03B1\u03C1\u03AC",
        "\u03C0\u03B1\u03C1\u03B1",
        "\u03C0\u03B1\u03C1\u1F70",
        "\u03C0\u03B5\u03C1\u03AF",
        "\u03C0\u03B5\u03C1\u1F76",
        "\u03C0\u03BF\u03B9\u03B1",
        "\u03C0\u03BF\u03B9\u03B5\u03C3",
        "\u03C0\u03BF\u03B9\u03BF",
        "\u03C0\u03BF\u03B9\u03BF\u03B9",
        "\u03C0\u03BF\u03B9\u03BF\u03C3",
        "\u03C0\u03BF\u03B9\u03BF\u03C5\u03C3",
        "\u03C0\u03BF\u03B9\u03C9\u03BD",
        "\u03C0\u03BF\u03C4\u03B5",
        "\u03C0\u03BF\u03C5",
        "\u03C0\u03BF\u1FE6",
        "\u03C0\u03C1\u03BF",
        "\u03C0\u03C1\u03BF\u03C3",
        "\u03C0\u03C1\u03CC\u03C3",
        "\u03C0\u03C1\u1F78",
        "\u03C0\u03C1\u1F78\u03C2",
        "\u03C0\u03C9\u03C2",
        "\u03C0\u03C9\u03C3",
        "\u03C3\u03B5",
        "\u03C3\u03C4\u03B7",
        "\u03C3\u03C4\u03B7\u03BD",
        "\u03C3\u03C4\u03BF",
        "\u03C3\u03C4\u03BF\u03BD",
        "\u03C3\u03CC\u03C3",
        "\u03C3\u03CD",
        "\u03C3\u03CD\u03BD",
        "\u03C3\u1F78\u03C2",
        "\u03C3\u1F7A",
        "\u03C3\u1F7A\u03BD",
        "\u03C4\u03AC",
        "\u03C4\u03AE\u03BD",
        "\u03C4\u03AF",
        "\u03C4\u03AF\u03C2",
        "\u03C4\u03AF\u03C3",
        "\u03C4\u03B1",
        "\u03C4\u03B1\u1FD6\u03C2",
        "\u03C4\u03B5",
        "\u03C4\u03B7\u03BD",
        "\u03C4\u03B7\u03C3",
        "\u03C4\u03B9",
        "\u03C4\u03B9\u03BD\u03B1",
        "\u03C4\u03B9\u03C2",
        "\u03C4\u03B9\u03C3",
        "\u03C4\u03BF",
        "\u03C4\u03BF\u03AF",
        "\u03C4\u03BF\u03B9",
        "\u03C4\u03BF\u03B9\u03BF\u1FE6\u03C4\u03BF\u03C2",
        "\u03C4\u03BF\u03B9\u03BF\u1FE6\u03C4\u03BF\u03C3",
        "\u03C4\u03BF\u03BD",
        "\u03C4\u03BF\u03C4\u03B5",
        "\u03C4\u03BF\u03C5",
        "\u03C4\u03BF\u03CD\u03C3",
        "\u03C4\u03BF\u1F7A\u03C2",
        "\u03C4\u03BF\u1FD6\u03C2",
        "\u03C4\u03BF\u1FE6",
        "\u03C4\u03C9\u03BD",
        "\u03C4\u03CC",
        "\u03C4\u03CC\u03BD",
        "\u03C4\u03CC\u03C4\u03B5",
        "\u03C4\u1F70",
        "\u03C4\u1F70\u03C2",
        "\u03C4\u1F74\u03BD",
        "\u03C4\u1F78",
        "\u03C4\u1F78\u03BD",
        "\u03C4\u1FC6\u03C2",
        "\u03C4\u1FC6\u03C3",
        "\u03C4\u1FC7",
        "\u03C4\u1FF6\u03BD",
        "\u03C4\u1FF7",
        "\u03C9\u03C3",
        "\u1F00\u03BB\u03BB'",
        "\u1F00\u03BB\u03BB\u03AC",
        "\u1F00\u03BB\u03BB\u1F70",
        "\u1F00\u03BB\u03BB\u2019",
        "\u1F00\u03C0",
        "\u1F00\u03C0\u03CC",
        "\u1F00\u03C0\u1F78",
        "\u1F00\u03C6",
        "\u1F02\u03BD",
        "\u1F03",
        "\u1F04\u03BB\u03BB\u03BF\u03C2",
        "\u1F04\u03BB\u03BB\u03BF\u03C3",
        "\u1F04\u03BD",
        "\u1F04\u03C1\u03B1",
        "\u1F05\u03BC\u03B1",
        "\u1F10\u03AC\u03BD",
        "\u1F10\u03B3\u03CE",
        "\u1F10\u03B3\u1F7C",
        "\u1F10\u03BA",
        "\u1F10\u03BC\u03CC\u03C3",
        "\u1F10\u03BC\u1F78\u03C2",
        "\u1F10\u03BD",
        "\u1F10\u03BE",
        "\u1F10\u03C0\u03AF",
        "\u1F10\u03C0\u03B5\u1F76",
        "\u1F10\u03C0\u1F76",
        "\u1F10\u03C3\u03C4\u03B9",
        "\u1F10\u03C6",
        "\u1F10\u1F70\u03BD",
        "\u1F11\u03B1\u03C5\u03C4\u03BF\u1FE6",
        "\u1F14\u03C4\u03B9",
        "\u1F21",
        "\u1F22",
        "\u1F23",
        "\u1F24",
        "\u1F25",
        "\u1F27\u03C2",
        "\u1F35\u03BD\u03B1",
        "\u1F41",
        "\u1F43",
        "\u1F43\u03BD",
        "\u1F43\u03C2",
        "\u1F45",
        "\u1F45\u03B4\u03B5",
        "\u1F45\u03B8\u03B5\u03BD",
        "\u1F45\u03C0\u03B5\u03C1",
        "\u1F45\u03C2",
        "\u1F45\u03C3",
        "\u1F45\u03C3\u03C4\u03B9\u03C2",
        "\u1F45\u03C3\u03C4\u03B9\u03C3",
        "\u1F45\u03C4\u03B5",
        "\u1F45\u03C4\u03B9",
        "\u1F51\u03BC\u03CC\u03C3",
        "\u1F51\u03C0",
        "\u1F51\u03C0\u03AD\u03C1",
        "\u1F51\u03C0\u03CC",
        "\u1F51\u03C0\u1F72\u03C1",
        "\u1F51\u03C0\u1F78",
        "\u1F61\u03C2",
        "\u1F61\u03C3",
        "\u1F65\u03C2",
        "\u1F65\u03C3\u03C4\u03B5",
        "\u1F66",
        "\u1FA7"
    ],
    ja: [
        "\u3042\u305D\u3053",
        "\u3042\u306E",
        "\u3042\u306E\u4EBA",
        "\u3042\u308A\u307E\u3059",
        "\u3042\u308B",
        "\u3042\u308C",
        "\u3044\u3046",
        "\u3044\u307E\u3059",
        "\u3044\u308B",
        "\u3044\u3064",
        "\u3046\u3061",
        "\u304A\u3088\u3073",
        "\u304A\u308A",
        "\u304A\u308A\u307E\u3059",
        "\u304B\u3064\u3066",
        "\u304B\u3089",
        "\u3053\u3053",
        "\u3053\u3061\u3089",
        "\u3053\u3068",
        "\u3053\u306E",
        "\u3053\u308C",
        "\u3053\u308C\u3089",
        "\u3055\u3089\u306B",
        "\u3057\u304B\u3057",
        "\u3059\u308B",
        "\u305B\u308B",
        "\u305D\u3053",
        "\u305D\u3057\u3066",
        "\u305D\u306E",
        "\u305D\u306E\u4ED6",
        "\u305D\u306E\u5F8C",
        "\u305D\u308C",
        "\u305D\u308C\u305E\u308C",
        "\u305D\u308C\u3067",
        "\u305F\u3060\u3057",
        "\u305F\u3061",
        "\u305F\u3081",
        "\u305F\u308A",
        "\u3060\u3063",
        "\u3060\u308C",
        "\u3067\u304D",
        "\u3067\u304D\u308B",
        "\u3067\u3059",
        "\u3067\u306F",
        "\u3067\u3082",
        "\u3068\u3044\u3046",
        "\u3068\u3044\u3063\u305F",
        "\u3068\u304D",
        "\u3068\u3053\u308D",
        "\u3068\u3057\u3066",
        "\u3068\u3068\u3082\u306B",
        "\u3068\u3082",
        "\u3068\u5171\u306B",
        "\u3069\u3053",
        "\u3069\u306E",
        "\u306A\u3044",
        "\u306A\u304A",
        "\u306A\u304B\u3063",
        "\u306A\u304C\u3089",
        "\u306A\u304F",
        "\u306A\u3063",
        "\u306A\u3069",
        "\u306A\u306B",
        "\u306A\u3089",
        "\u306A\u308A",
        "\u306A\u308B",
        "\u306A\u3093",
        "\u306B\u304A\u3044\u3066",
        "\u306B\u304A\u3051\u308B",
        "\u306B\u3064\u3044\u3066",
        "\u306B\u3066",
        "\u306B\u3088\u3063\u3066",
        "\u306B\u3088\u308A",
        "\u306B\u3088\u308B",
        "\u306B\u5BFE\u3057\u3066",
        "\u306B\u5BFE\u3059\u308B",
        "\u306B\u95A2\u3059\u308B",
        "\u306E\u3067",
        "\u306E\u307F",
        "\u307B\u304B",
        "\u307B\u3068\u3093\u3069",
        "\u307B\u3069",
        "\u307E\u3059",
        "\u307E\u305F",
        "\u307E\u305F\u306F",
        "\u307E\u3067",
        "\u3082\u306E",
        "\u3088\u3046",
        "\u3088\u308A",
        "\u3089\u308C",
        "\u3089\u308C\u308B",
        "\u308C\u308B",
        "\u4F55"
    ],
    zh: [
        "\u4E00\u4E0B",
        "\u4E00\u4E9B",
        "\u4E00\u5207",
        "\u4E00\u5219",
        "\u4E00\u5929",
        "\u4E00\u5B9A",
        "\u4E00\u65B9\u9762",
        "\u4E00\u65E6",
        "\u4E00\u65F6",
        "\u4E00\u6765",
        "\u4E00\u6837",
        "\u4E00\u6B21",
        "\u4E00\u7247",
        "\u4E00\u76F4",
        "\u4E00\u81F4",
        "\u4E00\u822C",
        "\u4E00\u8D77",
        "\u4E00\u8FB9",
        "\u4E00\u9762",
        "\u4E07\u4E00",
        "\u4E0A\u4E0B",
        "\u4E0A\u5347",
        "\u4E0A\u53BB",
        "\u4E0A\u6765",
        "\u4E0A\u8FF0",
        "\u4E0A\u9762",
        "\u4E0B\u5217",
        "\u4E0B\u53BB",
        "\u4E0B\u6765",
        "\u4E0B\u9762",
        "\u4E0D\u4E00",
        "\u4E0D\u4E45",
        "\u4E0D\u4EC5",
        "\u4E0D\u4F1A",
        "\u4E0D\u4F46",
        "\u4E0D\u5149",
        "\u4E0D\u5355",
        "\u4E0D\u53D8",
        "\u4E0D\u53EA",
        "\u4E0D\u53EF",
        "\u4E0D\u540C",
        "\u4E0D\u591F",
        "\u4E0D\u5982",
        "\u4E0D\u5F97",
        "\u4E0D\u6015",
        "\u4E0D\u60DF",
        "\u4E0D\u6210",
        "\u4E0D\u62D8",
        "\u4E0D\u6562",
        "\u4E0D\u65AD",
        "\u4E0D\u662F",
        "\u4E0D\u6BD4",
        "\u4E0D\u7136",
        "\u4E0D\u7279",
        "\u4E0D\u72EC",
        "\u4E0D\u7BA1",
        "\u4E0D\u80FD",
        "\u4E0D\u8981",
        "\u4E0D\u8BBA",
        "\u4E0D\u8DB3",
        "\u4E0D\u8FC7",
        "\u4E0D\u95EE",
        "\u4E0E\u5176",
        "\u4E0E\u5426",
        "\u4E0E\u6B64\u540C\u65F6",
        "\u4E13\u95E8",
        "\u4E24\u8005",
        "\u4E25\u683C",
        "\u4E25\u91CD",
        "\u4E2A\u4EBA",
        "\u4E2A\u522B",
        "\u4E2D\u5C0F",
        "\u4E2D\u95F4",
        "\u4E30\u5BCC",
        "\u4E3A\u4E3B",
        "\u4E3A\u4E86",
        "\u4E3A\u4EC0\u4E48",
        "\u4E3A\u4EC0\u9EBD",
        "\u4E3A\u4F55",
        "\u4E3A\u7740",
        "\u4E3B\u5F20",
        "\u4E3B\u8981",
        "\u4E3E\u884C",
        "\u4E43\u81F3",
        "\u4E4B\u4E00",
        "\u4E4B\u524D",
        "\u4E4B\u540E",
        "\u4E4B\u5F8C",
        "\u4E4B\u6240\u4EE5",
        "\u4E4B\u7C7B",
        "\u4E4C\u4E4E",
        "\u4E5F\u597D",
        "\u4E5F\u662F",
        "\u4E5F\u7F62",
        "\u4E86\u89E3",
        "\u4E89\u53D6",
        "\u4E8E\u662F",
        "\u4E8E\u662F\u4E4E",
        "\u4E91\u4E91",
        "\u4E92\u76F8",
        "\u4EA7\u751F",
        "\u4EBA\u4EEC",
        "\u4EBA\u5BB6",
        "\u4EC0\u4E48",
        "\u4EC0\u4E48\u6837",
        "\u4EC0\u9EBD",
        "\u4ECA\u540E",
        "\u4ECA\u5929",
        "\u4ECA\u5E74",
        "\u4ECA\u5F8C",
        "\u4ECD\u7136",
        "\u4ECE\u4E8B",
        "\u4ECE\u800C",
        "\u4ED6\u4EBA",
        "\u4ED6\u4EEC",
        "\u4ED6\u7684",
        "\u4EE3\u66FF",
        "\u4EE5\u4E0A",
        "\u4EE5\u4E0B",
        "\u4EE5\u4E3A",
        "\u4EE5\u4FBF",
        "\u4EE5\u514D",
        "\u4EE5\u524D",
        "\u4EE5\u53CA",
        "\u4EE5\u540E",
        "\u4EE5\u5916",
        "\u4EE5\u5F8C",
        "\u4EE5\u6765",
        "\u4EE5\u81F3",
        "\u4EE5\u81F3\u4E8E",
        "\u4EE5\u81F4",
        "\u4EFB\u4F55",
        "\u4EFB\u51ED",
        "\u4EFB\u52A1",
        "\u4F01\u56FE",
        "\u4F1F\u5927",
        "\u4F3C\u4E4E",
        "\u4F3C\u7684",
        "\u4F46\u662F",
        "\u4F55",
        "\u4F55\u51B5",
        "\u4F55\u5904",
        "\u4F55\u65F6",
        "\u4F5C\u4E3A",
        "\u4F60\u4EEC",
        "\u4F60\u7684",
        "\u4F7F\u5F97",
        "\u4F7F\u7528",
        "\u4F8B\u5982",
        "\u4F9D\u7167",
        "\u4F9D\u9760",
        "\u4FC3\u8FDB",
        "\u4FDD\u6301",
        "\u4FFA\u4EEC",
        "\u5018\u4F7F",
        "\u5018\u6216",
        "\u5018\u7136",
        "\u5018\u82E5",
        "\u5047\u4F7F",
        "\u5047\u5982",
        "\u5047\u82E5",
        "\u505A\u5230",
        "\u5141\u8BB8",
        "\u5145\u5206",
        "\u5148\u540E",
        "\u5148\u5F8C",
        "\u5148\u751F",
        "\u5168\u90E8",
        "\u5168\u9762",
        "\u5171\u540C",
        "\u5173\u4E8E",
        "\u5176\u4E00",
        "\u5176\u4E2D"
    ],
    ko: [
        "\uAC00\uAE4C\uC2A4\uB85C",
        "\uAC00\uB839",
        "\uAC01\uAC01",
        "\uAC01\uC790",
        "\uAC01\uC885",
        "\uAC16\uACE0\uB9D0\uD558\uC790\uBA74",
        "\uAC19\uB2E4",
        "\uAC19\uC774",
        "\uAC1C\uC758\uCE58\uC54A\uACE0",
        "\uAC70\uB2C8\uC640",
        "\uAC70\uBC14",
        "\uAC70\uC758",
        "\uAC83\uB4E4",
        "\uAC8C\uB2E4\uAC00",
        "\uAC8C\uC6B0\uB2E4",
        "\uACA8\uC6B0",
        "\uACAC\uC9C0\uC5D0\uC11C",
        "\uACB0\uAD6D",
        "\uACB8\uC0AC\uACB8\uC0AC",
        "\uACE0\uB824\uD558\uBA74",
        "\uACE0\uB85C",
        "\uACF5\uB3D9\uC73C\uB85C",
        "\uACFC\uC5F0",
        "\uAD00\uACC4\uC5C6\uC774",
        "\uAD00\uD558\uC5EC",
        "\uAD00\uD55C",
        "\uAD00\uD574\uC11C\uB294",
        "\uAD6C\uCCB4\uC801\uC73C\uB85C",
        "\uAD6C\uD1A0\uD558\uB2E4",
        "\uADF8\uB4E4",
        "\uADF8\uB54C",
        "\uADF8\uB798",
        "\uADF8\uB798\uB3C4",
        "\uADF8\uB798\uC11C",
        "\uADF8\uB7EC\uB098",
        "\uADF8\uB7EC\uB2C8",
        "\uADF8\uB7EC\uB2C8\uAE4C",
        "\uADF8\uB7EC\uBA74",
        "\uADF8\uB7EC\uBBC0\uB85C",
        "\uADF8\uB7EC\uD55C\uC989",
        "\uADF8\uB7F0\uB370",
        "\uADF8\uB7F0\uC989",
        "\uADF8\uB7FC",
        "\uADF8\uB807\uC9C0",
        "\uADF8\uB807\uC9C0\uB9CC",
        "\uADF8\uB807\uC9C0\uC54A\uC73C\uBA74",
        "\uADF8\uB9AC\uACE0",
        "\uADF8\uB9AC\uD558\uC5EC",
        "\uADF8\uB9CC\uC774\uB2E4",
        "\uADF8\uC704\uC5D0",
        "\uADF8\uC800",
        "\uADF8\uC911\uC5D0\uC11C",
        "\uADFC\uAC70\uB85C",
        "\uADFC\uAC70\uD558\uC5EC",
        "\uAE30\uB300\uC5EC",
        "\uAE30\uC810\uC73C\uB85C",
        "\uAE30\uC900\uC73C\uB85C",
        "\uAE30\uD0C0",
        "\uAE4C\uB2ED\uC73C\uB85C",
        "\uAE4C\uC545",
        "\uAE4C\uC9C0",
        "\uAE4C\uC9C0\uB3C4",
        "\uAF48\uB2F9"
    ]
};
const $e002af62c9e690dc$export$bd2c824c45156b2b = [
    'en',
    'de',
    'ru',
    'fr',
    'pt',
    'cs',
    'el'
];
const $e002af62c9e690dc$export$175fffd27b9ba43e = [
    'zh',
    'ja',
    'ko'
];


const $d2a34a77c4375f0a$export$6400d1662a02abfb = ({ query: query, locale: locale })=>{
    const language = locale.split('-')[0].toLowerCase();
    const stopWords = (0, $e002af62c9e690dc$export$b798fd863f55912e)[language];
    const text = query.replace(/[.,\/#!$?%\^&\*;:{}=\-_`~()]/g, '');
    if ((0, $e002af62c9e690dc$export$175fffd27b9ba43e).includes(language)) {
        const processedQuery = stopWords.reduce((result, word)=>result.replace(word, ''), text);
        return processedQuery;
    }
    if ((0, $e002af62c9e690dc$export$bd2c824c45156b2b).includes(language)) {
        const lowerText = text.toLocaleLowerCase(locale);
        const queryWords = lowerText.split(' ');
        const processedQuery = queryWords.filter((word)=>!stopWords.includes(word)).join(' ');
        return processedQuery;
    }
    return query;
};


var $ebe98f756f87ec8a$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["PREQUERY"] = "PreQuery";
    QueryState["ERROR"] = "Error";
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["LOADING"] = "Loading";
    return QueryState;
}({});
const $ebe98f756f87ec8a$export$14442ac05bc0c222 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    queryState: "PreQuery",
    results: [],
    searchSessionId: '',
    loading: false,
    hasNextPage: false,
    loadMore: ()=>{},
    error: undefined,
    numResults: 0,
    abTest: null,
    experimentLayers: undefined,
    productEdition: undefined
});
const $ebe98f756f87ec8a$export$717d616a26dcb8b9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($ebe98f756f87ec8a$export$14442ac05bc0c222);
} : ()=>(0, $42omo.useContext)($ebe98f756f87ec8a$export$14442ac05bc0c222);
const $ebe98f756f87ec8a$export$62570eb54a58c251 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { searchSessionId: searchSessionId, children: children } = t0;
    const { cql: cql, queryType: queryType, searchQuery: searchQuery, filters: filters, sessionHasUserInput: sessionHasUserInput, showSearchAI: showSearchAI } = (0, $fGkN6.useSearchInputContext)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== locale || $[1] !== searchQuery || $[2] !== showSearchAI) {
        t1 = showSearchAI ? (0, $d2a34a77c4375f0a$export$6400d1662a02abfb)({
            query: searchQuery,
            locale: locale
        }) : searchQuery;
        $[0] = locale;
        $[1] = searchQuery;
        $[2] = showSearchAI;
        $[3] = t1;
    } else t1 = $[3];
    const processedQuery = t1;
    let t2;
    if ($[4] !== cql || $[5] !== filters || $[6] !== processedQuery || $[7] !== queryType || $[8] !== searchSessionId || $[9] !== sessionHasUserInput) {
        t2 = {
            queryType: queryType,
            searchQueryText: processedQuery,
            cql: cql,
            searchFilters: filters,
            searchSessionId: searchSessionId,
            sessionHasUserInput: sessionHasUserInput
        };
        $[4] = cql;
        $[5] = filters;
        $[6] = processedQuery;
        $[7] = queryType;
        $[8] = searchSessionId;
        $[9] = sessionHasUserInput;
        $[10] = t2;
    } else t2 = $[10];
    const resultSupplierContext = (0, $6e8ed5702282fcbb$export$a3bd2c7cebafe892)(t2);
    const queryState = (sessionHasUserInput || cql) && !resultSupplierContext.loading && !resultSupplierContext.error ? "PostQuery" : resultSupplierContext.loading ? "Loading" : resultSupplierContext.error ? "Error" : "PreQuery";
    let t3;
    if ($[11] !== queryState || $[12] !== resultSupplierContext || $[13] !== searchSessionId) {
        t3 = {
            ...resultSupplierContext,
            queryState: queryState,
            searchSessionId: searchSessionId
        };
        $[11] = queryState;
        $[12] = resultSupplierContext;
        $[13] = searchSessionId;
        $[14] = t3;
    } else t3 = $[14];
    const contextValue = t3;
    let t4;
    if ($[15] !== children || $[16] !== contextValue) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ebe98f756f87ec8a$export$14442ac05bc0c222.Provider, {
            value: contextValue
        }, children);
        $[15] = children;
        $[16] = contextValue;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ searchSessionId: searchSessionId, children: children })=>{
    const { cql: cql, queryType: queryType, searchQuery: searchQuery, filters: filters, sessionHasUserInput: sessionHasUserInput, showSearchAI: showSearchAI } = (0, $fGkN6.useSearchInputContext)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const processedQuery = showSearchAI ? (0, $d2a34a77c4375f0a$export$6400d1662a02abfb)({
        query: searchQuery,
        locale: locale
    }) : searchQuery;
    const resultSupplierContext = (0, $6e8ed5702282fcbb$export$a3bd2c7cebafe892)({
        queryType: queryType,
        searchQueryText: processedQuery,
        cql: cql,
        searchFilters: filters,
        searchSessionId: searchSessionId,
        sessionHasUserInput: sessionHasUserInput
    });
    const queryState = (sessionHasUserInput || cql) && !resultSupplierContext.loading && !resultSupplierContext.error ? "PostQuery" : resultSupplierContext.loading ? "Loading" : resultSupplierContext.error ? "Error" : "PreQuery";
    const contextValue = (0, $42omo.useMemo)(()=>({
            ...resultSupplierContext,
            queryState: queryState,
            searchSessionId: searchSessionId
        }), [
        queryState,
        resultSupplierContext,
        searchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ebe98f756f87ec8a$export$14442ac05bc0c222.Provider, {
        value: contextValue
    }, children);
};






var $cacu1 = parcelRequire("cacu1");








var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $iXCQx = parcelRequire("iXCQx");








var $6Igo2 = parcelRequire("6Igo2");

var $c5652a42aa7dde6c$exports = {};
$c5652a42aa7dde6c$exports = new URL("Search.1de50555.svg", import.meta.url).toString();


var $9fb0c624a08be775$exports = {};
$9fb0c624a08be775$exports = new URL("SearchDark.c639e3c8.svg", import.meta.url).toString();


const $5762a0d820ceeb6a$export$192d2d3653f9ca9d = ()=>{
    const { fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        fireAnalytics({
            type: 'sendTrackEvent',
            action: 'shown',
            actionSubject: 'advancedSearchPreQuery'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchMessagesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c5652a42aa7dde6c$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($9fb0c624a08be775$exports))),
        width: "200",
        height: "200",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dIdGO.i18n).landingPageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $dIdGO.i18n).landingPageText,
        "data-test-id": "search-result-landing-text"
    })));
};


















var $2XqLN = parcelRequire("2XqLN");


var $7H6GR = parcelRequire("7H6GR");



var $cb6fO = parcelRequire("cb6fO");


var $1AV5C = parcelRequire("1AV5C");




// unlike __types__/AdvancedSearchCQLQuery.ts, this file is not autogenerated
// as the AGG client in CFE isn't set up yet to autogenerate types
var $d0fd843c5e8ebef1$export$ff14a801544d24f3 = /*#__PURE__*/ function(AdvancedAGGSearchQueryFilterRangeField) {
    AdvancedAGGSearchQueryFilterRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    return AdvancedAGGSearchQueryFilterRangeField;
}({});
var $d0fd843c5e8ebef1$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $d0fd843c5e8ebef1$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["ATTACHMENT"] = "ATTACHMENT";
    ConfluenceContentType["BLOG_POST"] = "BLOG_POST";
    ConfluenceContentType["COMMENT"] = "COMMENT";
    ConfluenceContentType["PAGE"] = "PAGE";
    return ConfluenceContentType;
}({});
var $d0fd843c5e8ebef1$export$2607d60870895ed3 = /*#__PURE__*/ function(ConfluenceSpaceStatus) {
    ConfluenceSpaceStatus["ARCHIVED"] = "ARCHIVED";
    ConfluenceSpaceStatus["CURRENT"] = "CURRENT";
    return ConfluenceSpaceStatus;
}({});
var $d0fd843c5e8ebef1$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["GLOBAL"] = "GLOBAL";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    return ConfluenceSpaceType;
}({});





















var $1s5hv = parcelRequire("1s5hv");




var $bh5s2 = parcelRequire("bh5s2");


var $hl1Kw = parcelRequire("hl1Kw");





var $8lYIw = parcelRequire("8lYIw");














var $3ro6F = parcelRequire("3ro6F");

var $kGnTD = parcelRequire("kGnTD");










/**
 * @generated SignedSource<<ec00ca52fa04c88efd96d45f4b25ae95>>
 * @relayHash 3f8e98ff1bfe9218f6906dc5497946e1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eaf104582cf6f0995e1967b3eeddc5229f4c0c06df1eef28c8abb2bd71edeaa7
const $24a4e733c0b1b3ac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKeys"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKeys",
                    "variableName": "spaceKeys"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "contentIds"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-title-published\")"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchBreadcrumbsProviderSearchBreadcrumbsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SearchBreadcrumbsProviderSearchBreadcrumbsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "3f8e98ff1bfe9218f6906dc5497946e1",
            "id": "eaf104582cf6f0995e1967b3eeddc5229f4c0c06df1eef28c8abb2bd71edeaa7",
            "metadata": {},
            "name": "SearchBreadcrumbsProviderSearchBreadcrumbsQuery",
            "operationKind": "query",
            "text": "query SearchBreadcrumbsProviderSearchBreadcrumbsQuery($spaceKeys:[String],$contentIds:[ID]){spaces(spaceKeys:$spaceKeys){nodes{alias,id,key,name,homepage{id}}},content(ids:$contentIds){nodes{id,status,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},ancestors{id,title,links{webui}}}}}"
        }
    };
}();
$24a4e733c0b1b3ac$var$node.hash = "e2c4f1f83bdd890f090adaf1360b5994";
var $24a4e733c0b1b3ac$export$2e2bcd8739ae039 = $24a4e733c0b1b3ac$var$node;









var $1NBp8 = parcelRequire("1NBp8");










const $df779b0c01cd26c0$export$160727d69d86321d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getAncestors: ()=>[],
    getEmoji: ()=>'',
    loading: false,
    error: undefined
});
const $df779b0c01cd26c0$var$resultsTransformer = (results)=>{
    const contentIds = new Set();
    const spaceKeys = new Set();
    results.forEach((result)=>{
        if (result?.content?.id && result.content.type !== 'space') contentIds.add(result.content.id);
        if (result?.content?.space?.key) spaceKeys.add(result.content.space.key);
    });
    return [
        [
            ...contentIds
        ],
        [
            ...spaceKeys
        ]
    ];
};
const $df779b0c01cd26c0$var$ancestorsTransformer = (ancestors)=>{
    return Array.from(ancestors).map((ancestor)=>{
        return {
            id: ancestor?.id || '',
            title: ancestor?.title || '',
            href: ancestor?.links?.webui ? `${0, $jlIaF.CONTEXT_PATH}${ancestor.links.webui}` : ''
        };
    });
};
const $df779b0c01cd26c0$export$67718d2b33e2bf0b = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { results: results, searchLoading: searchLoading, children: children } = t0;
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [loading, setLoading] = (0, $42omo.useState)(searchLoading);
    const contentCountRef = (0, $42omo.useRef)(0);
    const spaceCountRef = (0, $42omo.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Map();
        $[0] = t1;
    } else t1 = $[0];
    const [contentMap, setContentMap] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Map();
        $[1] = t2;
    } else t2 = $[1];
    const [spaceMap, setSpaceMap] = (0, $42omo.useState)(t2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Map();
        $[2] = t3;
    } else t3 = $[2];
    const [emojiMap, setEmojiMap] = (0, $42omo.useState)(t3);
    let contentIds;
    let contentIdsToFetchBreadcrumbs;
    let t4;
    if ($[3] !== contentMap || $[4] !== results || $[5] !== spaceMap) {
        const [t5, spaceKeys] = $df779b0c01cd26c0$var$resultsTransformer(results);
        contentIds = t5;
        let t6;
        if ($[9] !== contentMap) {
            t6 = (id)=>!contentMap.has(id);
            $[9] = contentMap;
            $[10] = t6;
        } else t6 = $[10];
        contentIdsToFetchBreadcrumbs = contentIds.filter(t6);
        let t7;
        if ($[11] !== spaceMap) {
            t7 = (key)=>!spaceMap.has(key);
            $[11] = spaceMap;
            $[12] = t7;
        } else t7 = $[12];
        t4 = spaceKeys.filter(t7);
        $[3] = contentMap;
        $[4] = results;
        $[5] = spaceMap;
        $[6] = contentIds;
        $[7] = contentIdsToFetchBreadcrumbs;
        $[8] = t4;
    } else {
        contentIds = $[6];
        contentIdsToFetchBreadcrumbs = $[7];
        t4 = $[8];
    }
    const spaceKeysToFetchBreadcrumbs = t4;
    const skipBreadcrumbsQuery = !results.length || !contentIds.length || !contentIdsToFetchBreadcrumbs.length || !spaceKeysToFetchBreadcrumbs.length;
    let t5;
    if ($[13] !== contentMap.size || $[14] !== spaceMap) {
        t5 = ()=>{
            if (contentMap.size !== contentCountRef.current || spaceMap.size !== spaceCountRef.current) {
                setLoading(false);
                contentCountRef.current = contentMap.size;
                spaceCountRef.current = spaceMap.size;
            }
        };
        $[13] = contentMap.size;
        $[14] = spaceMap;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== contentMap || $[17] !== spaceMap) {
        t6 = [
            contentMap,
            spaceMap,
            contentCountRef,
            spaceCountRef
        ];
        $[16] = contentMap;
        $[17] = spaceMap;
        $[18] = t6;
    } else t6 = $[18];
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[19] !== contentMap || $[20] !== emojiMap || $[21] !== spaceMap || $[22] !== toUrl) {
        t7 = (data)=>{
            const contentData = data?.content?.nodes;
            const spaceData = data?.spaces?.nodes;
            const newContentMap = new Map();
            const newEmojiMap = new Map();
            const newSpaceMap = new Map();
            contentData?.forEach((item)=>{
                if (item?.id && item.ancestors) {
                    const ancestors = $df779b0c01cd26c0$var$ancestorsTransformer(item.ancestors);
                    newContentMap.set(item.id, ancestors);
                }
                if (item?.id) {
                    const emoji = (item?.emoji?.nodes?.[0]?.value || "").replace(/['"]+/g, "").replace(/null/, "");
                    if (emoji) newEmojiMap.set(item.id, emoji);
                    if (item.ancestors) {
                        const ancestors_0 = $df779b0c01cd26c0$var$ancestorsTransformer(item.ancestors);
                        newContentMap.set(item.id, ancestors_0);
                    }
                }
            });
            setEmojiMap(new Map([
                ...emojiMap,
                ...newEmojiMap
            ]));
            setContentMap(new Map([
                ...contentMap,
                ...newContentMap
            ]));
            spaceData?.forEach((item_0)=>{
                if (item_0?.key) {
                    const spaceOverviewLink = toUrl((0, $1NBp8.SPACE_OVERVIEW).name, {
                        spaceKey: item_0.alias || item_0.key,
                        query: {
                            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: item_0?.homepage?.id || undefined
                        }
                    });
                    const spaceAncestor = {
                        id: item_0.id || item_0.key,
                        href: spaceOverviewLink,
                        title: item_0.name || item_0.key
                    };
                    newSpaceMap.set(item_0.key, spaceAncestor);
                }
            });
            setSpaceMap(new Map([
                ...spaceMap,
                ...newSpaceMap
            ]));
        };
        $[19] = contentMap;
        $[20] = emojiMap;
        $[21] = spaceMap;
        $[22] = toUrl;
        $[23] = t7;
    } else t7 = $[23];
    const onQueryComplete = t7;
    let t8;
    if ($[24] !== contentIdsToFetchBreadcrumbs || $[25] !== spaceKeysToFetchBreadcrumbs) {
        t8 = {
            contentIds: contentIdsToFetchBreadcrumbs,
            spaceKeys: spaceKeysToFetchBreadcrumbs
        };
        $[24] = contentIdsToFetchBreadcrumbs;
        $[25] = spaceKeysToFetchBreadcrumbs;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== onQueryComplete || $[28] !== skipBreadcrumbsQuery || $[29] !== t8) {
        t9 = {
            variables: t8,
            skip: skipBreadcrumbsQuery,
            errorPolicy: "all",
            onCompleted: onQueryComplete
        };
        $[27] = onQueryComplete;
        $[28] = skipBreadcrumbsQuery;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    const { error: error } = (0, $jMyy4.useQueryInterop)((0, $24a4e733c0b1b3ac$export$2e2bcd8739ae039), {
        ...t9,
        __callerPackage__: "@confluence/search-breadcrumbs"
    });
    let t10;
    if ($[31] !== contentMap || $[32] !== spaceMap) {
        t10 = (id_0, key_0)=>{
            const ancestors_1 = contentMap.get(id_0);
            const spaceAncestor_0 = spaceMap.get(key_0);
            if (spaceAncestor_0) {
                if (ancestors_1) {
                    if (ancestors_1.length === 0) ancestors_1.push(spaceAncestor_0);
                    else ancestors_1[0] = spaceAncestor_0;
                    return ancestors_1;
                } else return [
                    spaceAncestor_0
                ];
            }
            return [];
        };
        $[31] = contentMap;
        $[32] = spaceMap;
        $[33] = t10;
    } else t10 = $[33];
    const getAncestors = t10;
    let t11;
    if ($[34] !== emojiMap) {
        t11 = (id_1)=>emojiMap.get(id_1) || "";
        $[34] = emojiMap;
        $[35] = t11;
    } else t11 = $[35];
    const getEmoji = t11;
    const breadcrumbsLoading = results.length > 0 && !error ? loading : false;
    let t12;
    if ($[36] !== breadcrumbsLoading || $[37] !== error || $[38] !== getAncestors || $[39] !== getEmoji) {
        t12 = {
            getAncestors: getAncestors,
            getEmoji: getEmoji,
            loading: breadcrumbsLoading,
            error: error
        };
        $[36] = breadcrumbsLoading;
        $[37] = error;
        $[38] = getAncestors;
        $[39] = getEmoji;
        $[40] = t12;
    } else t12 = $[40];
    const searchBreadcrumbContextValue = t12;
    let t13;
    if ($[41] !== error) {
        t13 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[41] = error;
        $[42] = t13;
    } else t13 = $[42];
    let t14;
    if ($[43] !== children || $[44] !== searchBreadcrumbContextValue || $[45] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df779b0c01cd26c0$export$160727d69d86321d.Provider, {
            value: searchBreadcrumbContextValue
        }, children, t13);
        $[43] = children;
        $[44] = searchBreadcrumbContextValue;
        $[45] = t13;
        $[46] = t14;
    } else t14 = $[46];
    return t14;
};
const $df779b0c01cd26c0$export$2535d2f5bb2bcb34 = ()=>{
    return (0, $42omo.useContext)($df779b0c01cd26c0$export$160727d69d86321d);
};


const $b74d421c87f9e13e$var$SearchBreadcrumbsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ymgvotz2 _1iev1y44 _1q1gazsu _vj2rwadc _euwiazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $b74d421c87f9e13e$export$725c9be8a2ae4e69 = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { index: index, contentId: contentId, spaceKey: spaceKey, ancestors: ancestors } = t0;
    const [t1] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let pageAncestors;
    const { getAncestors: getAncestors } = (0, $df779b0c01cd26c0$export$2535d2f5bb2bcb34)();
    if (ancestors) pageAncestors = ancestors;
    else pageAncestors = getAncestors(contentId, spaceKey);
    pageAncestors;
    const t2 = pageAncestors.length + 1;
    let t3;
    if ($[0] !== contentId || $[1] !== index || $[2] !== searchSessionId || $[3] !== spaceKey || $[4] !== t2) {
        t3 = {
            navVersion: 3,
            origin: "advancedSearch",
            breadcrumbsTotal: t2,
            searchResultIndex: index,
            searchResultId: contentId,
            searchResultSpaceKey: spaceKey,
            searchSessionId: searchSessionId
        };
        $[0] = contentId;
        $[1] = index;
        $[2] = searchSessionId;
        $[3] = spaceKey;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const analyticsContext = t3;
    let t4;
    if ($[6] !== analyticsContext || $[7] !== createAnalyticsEvent) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "expanded",
                    actionSubject: "searchBreadcrumbs",
                    source: "containerNavigation",
                    attributes: {
                        ...analyticsContext
                    }
                }
            }).fire();
        };
        $[6] = analyticsContext;
        $[7] = createAnalyticsEvent;
        $[8] = t4;
    } else t4 = $[8];
    const onExpand = t4;
    let t5;
    if ($[9] !== analyticsContext || $[10] !== createAnalyticsEvent) {
        t5 = (itemIndex, title)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "breadcrumbsItem",
                        source: "containerNavigation",
                        attributes: {
                            ...analyticsContext,
                            ancestorIndex: itemIndex,
                            destination: itemIndex === 0 ? "SPACE" : "ANCESTOR",
                            titleLength: title.length
                        }
                    }
                }).fire();
            };
        $[9] = analyticsContext;
        $[10] = createAnalyticsEvent;
        $[11] = t5;
    } else t5 = $[11];
    const onBreadcrumbItemClick = t5;
    let t6;
    if ($[12] !== analyticsContext || $[13] !== createAnalyticsEvent) {
        t6 = (itemIndex_0, title_0)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "displayed",
                        actionSubject: "searchBreadcrumbsTooltip",
                        source: "containerNavigation",
                        attributes: {
                            ...analyticsContext,
                            ancestorIndex: itemIndex_0,
                            destination: itemIndex_0 === 0 ? "SPACE" : "ANCESTOR",
                            titleLength: title_0.length
                        }
                    }
                }).fire();
            };
        $[12] = analyticsContext;
        $[13] = createAnalyticsEvent;
        $[14] = t6;
    } else t6 = $[14];
    const onBreadcrumbItemTooltipShown = t6;
    let t7;
    if ($[15] !== searchSessionId) {
        t7 = (href)=>searchSessionId ? (0, $cb6fO.addQueryParams)(href, {
                search_id: searchSessionId
            }) : href;
        $[15] = searchSessionId;
        $[16] = t7;
    } else t7 = $[16];
    const addSearchSessionToURL = t7;
    let t8;
    if ($[17] !== addSearchSessionToURL || $[18] !== onBreadcrumbItemClick || $[19] !== onBreadcrumbItemTooltipShown || $[20] !== pageAncestors) {
        let t9;
        if ($[22] !== addSearchSessionToURL || $[23] !== onBreadcrumbItemClick || $[24] !== onBreadcrumbItemTooltipShown || $[25] !== pageAncestors.length) {
            t9 = (t10, itemIndex_1)=>{
                const { href: href_0, id: id, title: title_1 } = t10;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ro6F.default), {
                    key: id,
                    truncationWidth: itemIndex_1 === pageAncestors.length - 1 || itemIndex_1 === 0 ? 192 : 50,
                    testId: id,
                    text: title_1,
                    href: addSearchSessionToURL(href_0),
                    onClick: onBreadcrumbItemClick(itemIndex_1, title_1),
                    onTooltipShown: onBreadcrumbItemTooltipShown(itemIndex_1, title_1)
                });
            };
            $[22] = addSearchSessionToURL;
            $[23] = onBreadcrumbItemClick;
            $[24] = onBreadcrumbItemTooltipShown;
            $[25] = pageAncestors.length;
            $[26] = t9;
        } else t9 = $[26];
        t8 = pageAncestors.map(t9);
        $[17] = addSearchSessionToURL;
        $[18] = onBreadcrumbItemClick;
        $[19] = onBreadcrumbItemTooltipShown;
        $[20] = pageAncestors;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[27] !== onExpand || $[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b74d421c87f9e13e$var$SearchBreadcrumbsWrapper, {
            "data-testid": "search-breadcrumbs-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGnTD.default), {
            maxItems: 3,
            onExpand: onExpand
        }, t8));
        $[27] = onExpand;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    return t9;
};



var $1YXTQ = parcelRequire("1YXTQ");


var $6p02T = parcelRequire("6p02T");














var $bmowW = parcelRequire("bmowW");





var $4KS7f = parcelRequire("4KS7f");


var $3DisR = parcelRequire("3DisR");

const $9a47e03ae9a38d16$export$8bc6ebae82b71102 = ({ summarizeText: summarizeText, buttonStyles: buttonStyles = {} })=>{
    const customTheme = (currentTheme, theme)=>{
        const existingTheme = currentTheme(theme);
        const defaultStyles = {
            buttonStyles: {
                ...existingTheme.buttonStyles,
                alignItems: 'center',
                gap: "var(--ds-space-025, 2px)",
                padding: buttonStyles?.padding || `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
                border: buttonStyles?.border || existingTheme.buttonStyles.border,
                borderRadius: buttonStyles?.borderRadius || existingTheme.buttonStyles.borderRadius
            }
        };
        return {
            ...existingTheme,
            ...defaultStyles
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        theme: customTheme,
        spacing: "none",
        appearance: "subtle",
        isDisabled: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3DisR.QuickSummaryIcon), {
            label: ""
        }),
        testId: "ai-summarize-button-placeholder"
    }, summarizeText);
};


const $e7c24b6f3e31fd37$export$e6971f9d0321afc9 = ({ summarizeText: summarizeText, buttonStyles: buttonStyles })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const buttonText = summarizeText ?? formatMessage((0, $bmowW.i18n).quickSummaryToolTipText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9a47e03ae9a38d16$export$8bc6ebae82b71102), {
        summarizeText: buttonText,
        buttonStyles: buttonStyles
    });
};



const $514dda4d5b510fec$export$e82b88b8e9b29fb6 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IpVSe",
    name: "QuickSummaryPopup",
    loader: async ()=>(await (parcelRequire("3frzj"))).QuickSummaryPopup,
    loading: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e7c24b6f3e31fd37$export$e6971f9d0321afc9), {
            buttonStyles: buttonStyles
        })
});



















var $di8q4 = parcelRequire("di8q4");


var $bCECL = parcelRequire("bCECL");


var $iKskQ = parcelRequire("iKskQ");


var $8WOej = parcelRequire("8WOej");





const $a5a38d4575b6a35c$export$f04a61298a47a40f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { contentType: contentType, subType: t1, resultTitle: resultTitle, emojiValue: emojiValue, iconPath: iconPath } = t0;
    const subType = t1 === undefined ? "" : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment) {
        let t2;
        if ($[0] !== resultTitle) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8WOej.AttachmentIcon), {
                title: resultTitle,
                size: "medium"
            });
            $[0] = resultTitle;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space) {
        let t2;
        if ($[2] !== formatMessage || $[3] !== resultTitle) {
            t2 = formatMessage((0, $dIdGO.i18n).spaceIconLabel, {
                spaceName: resultTitle
            });
            $[2] = formatMessage;
            $[3] = resultTitle;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== iconPath || $[6] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
                size: "small",
                src: iconPath,
                label: t2
            });
            $[5] = iconPath;
            $[6] = t2;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (emojiValue && !subType) {
        let t2;
        if ($[8] !== emojiValue) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: emojiValue,
                context: "AdvancedSearchResultView",
                height: 24
            });
            $[8] = emojiValue;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    }
    let t2;
    if ($[10] !== contentType || $[11] !== subType) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            height: 24
        });
        $[10] = contentType;
        $[11] = subType;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ contentType: contentType, subType: subType = '', resultTitle: resultTitle, emojiValue: emojiValue, iconPath: iconPath })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    // Handle attachment type - AttachmentIcon is different than ContentIcon
    // in that it will render icon based on attachment extension
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment) return(// @ts-expect-error FIXME: legacy ignore after migration; don't add new ones. Error: "label" must be specified for accessibility purposes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8WOej.AttachmentIcon), {
        title: resultTitle,
        size: "medium"
    }));
    // Handle space type - SpaceIcon will render space image
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
        size: "small",
        src: iconPath,
        label: formatMessage((0, $dIdGO.i18n).spaceIconLabel, {
            spaceName: resultTitle
        })
    });
    // Handle emoji value without subType
    if (emojiValue && !subType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiValue,
        context: "AdvancedSearchResultView",
        height: 24
    });
    // Default fallback to ContentIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: contentType,
        subType: subType,
        height: 24
    });
};




















const $95343f1bcab811d5$export$56e008c8bd1ccf7c = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _n3tdu2gc _2lx21bp4 _1sy5u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _n3tdu2gc _2lx21bp4 _1sy5u2gc",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$5c12c8af6ba308d8 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _syazi7uo _s7n41q9y",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazi7uo _s7n41q9y",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$b4a9cddf74daca12 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr4jg8 _1bj31b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr4jg8 _1bj31b66",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$e0842d67f8c161b5 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_p12f1tcg _yajw1ato _n7opgktf _na3lgktf _1jsj1tcg _whn51tcg _lr2ngktf _10n8gktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1tcg _yajw1ato _n7opgktf _na3lgktf _1jsj1tcg _whn51tcg _lr2ngktf _10n8gktf",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$c46635e0b5c4943 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4171m _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4171m _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$d971b98a124cabfc = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _o5721q9c _1reo15vq _1bto1l2s _n3tdv77o _1b1edv2p _1ctf1r31 _1hex8stv _xildnqa1 _irlsdv2p",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _o5721q9c _1reo15vq _1bto1l2s _n3tdv77o _1b1edv2p _1ctf1r31 _1hex8stv _xildnqa1 _irlsdv2p",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$6acd8eb1223875ed = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8sb0y _11c8wadc _syaz1lj7 _1e0c1txw _4cvr1q9y _1n261g80 _1msji7uo _1dtci7uo _5xy1u3tg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8sb0y _11c8wadc _syaz1lj7 _1e0c1txw _4cvr1q9y _1n261g80 _1msji7uo _1dtci7uo _5xy1u3tg",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$3daa6119b619c70c = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1yt4dqld _16jlkb7n _1i4q1hna",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1yt4dqld _16jlkb7n _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$87791440d5143001 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_otyrpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$160e94802e028924 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbmko7 _4t3i7vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbmko7 _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$c31c29c2535484c5 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbuxkd _4t3i1crf _19pk12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbuxkd _4t3i1crf _19pk12x7",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$68bc5b3ff8349c5 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$35a9671a565aeb08 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsb1osq _4t3i7vkz _19pk12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsb1osq _4t3i7vkz _19pk12x7",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$5e67fe52e2a75774 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7izff _2rko1rr0 _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7izff _2rko1rr0 _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});


const $4073f849b8cb22a9$export$9e118db64676565a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(66);
    const { searchResult: searchResult, searchResultIdx: searchResultIdx, onClickResult: onClickResult, onContextClickResult: onContextClickResult } = t0;
    const { entityType: entityType, title: title, subtype: subtype, excerpt: excerpt, url: url, lastModified: lastModified, content: t1, ancestors: ancestors, emoji: emoji, isVerified: isVerified } = searchResult;
    const { id: contentId, type: contentType, space: t2 } = t1;
    const { key: spaceKey } = t2;
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const [t3] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId } = t3;
    const lastModifiedText = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment ? (0, $dIdGO.i18n).resultLastModifiedAttachment : (0, $dIdGO.i18n).resultLastModifiedContent;
    let t4;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== edition || $[3] !== isAdminHubAIEnabled || $[4] !== searchResultIdx || $[5] !== searchSessionId) {
        t4 = ()=>{
            setIsPopupOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "advancedSearch",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "quickSummaryAdvancedSearchButton",
                    attributes: {
                        contentId: contentId,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        rowIndex: searchResultIdx,
                        searchSessionId: searchSessionId
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = edition;
        $[3] = isAdminHubAIEnabled;
        $[4] = searchResultIdx;
        $[5] = searchSessionId;
        $[6] = t4;
    } else t4 = $[6];
    const onOpen = t4;
    const t5 = `${(0, $jghB4.CONTEXT_PATH)}${url}`;
    let t6;
    if ($[7] !== title) {
        t6 = (0, $6p02T.enrichExcerpt)(title);
        $[7] = title;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== onClickResult || $[10] !== onContextClickResult || $[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            href: t5,
            onClick: onClickResult,
            onContextMenu: onContextClickResult,
            className: "searchResultLink"
        }, t6));
        $[9] = onClickResult;
        $[10] = onContextClickResult;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    const ResultTitleWithLink = t7;
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, "\u30FB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
            label: "verified",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[14] = t8;
    } else t8 = $[14];
    const VerifiedBadge = t8;
    let t10;
    let t11;
    let t12;
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>setHovered(true);
        t10 = ()=>setHovered(true);
        t11 = ()=>setHovered(false);
        t12 = ()=>setHovered(false);
        $[15] = t10;
        $[16] = t11;
        $[17] = t12;
        $[18] = t9;
    } else {
        t10 = $[15];
        t11 = $[16];
        t12 = $[17];
        t9 = $[18];
    }
    let t13;
    if ($[19] !== title) {
        t13 = (0, $6p02T.cleanExcerpt)(title);
        $[19] = title;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== emoji || $[22] !== entityType || $[23] !== subtype || $[24] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
            contentType: entityType,
            subType: subtype,
            resultTitle: t13,
            emojiValue: emoji
        }));
        $[21] = emoji;
        $[22] = entityType;
        $[23] = subtype;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    const t15 = spaceKey || "";
    let t16;
    if ($[26] !== ancestors || $[27] !== contentId || $[28] !== searchResultIdx || $[29] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b74d421c87f9e13e$export$725c9be8a2ae4e69), {
            index: searchResultIdx,
            contentId: contentId,
            spaceKey: t15,
            ancestors: ancestors
        });
        $[26] = ancestors;
        $[27] = contentId;
        $[28] = searchResultIdx;
        $[29] = t15;
        $[30] = t16;
    } else t16 = $[30];
    let t17;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, "\u30FB");
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== lastModifiedText) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), lastModifiedText);
        $[32] = lastModifiedText;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== lastModified) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: lastModified
        });
        $[34] = lastModified;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== t18 || $[37] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$5c12c8af6ba308d8), null, t17, t18, " ", t19);
        $[36] = t18;
        $[37] = t19;
        $[38] = t20;
    } else t20 = $[38];
    const t21 = isVerified && VerifiedBadge;
    let t22;
    if ($[39] !== t16 || $[40] !== t20 || $[41] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$6acd8eb1223875ed), null, t16, t20, t21);
        $[39] = t16;
        $[40] = t20;
        $[41] = t21;
        $[42] = t22;
    } else t22 = $[42];
    let t23;
    if ($[43] !== ResultTitleWithLink || $[44] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, ResultTitleWithLink, t22);
        $[43] = ResultTitleWithLink;
        $[44] = t22;
        $[45] = t23;
    } else t23 = $[45];
    let t24;
    if ($[46] !== contentId || $[47] !== contentType || $[48] !== isHovered || $[49] !== isPopupOpen || $[50] !== lastModified || $[51] !== onOpen || $[52] !== spaceKey || $[53] !== url) {
        t24 = (isHovered || isPopupOpen) && (0, $9wGTI.fg)("central_ai_quick_summary_in_advanced_search") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $514dda4d5b510fec$export$e82b88b8e9b29fb6), {
            source: "advancedSearch",
            contentPath: `${(0, $jghB4.CONTEXT_PATH)}${url}`,
            contentId: contentId,
            spaceKey: spaceKey || undefined,
            contentType: contentType,
            lastModifiedDate: lastModified,
            onOpen: ()=>onOpen(),
            onClose: ()=>setIsPopupOpen(false)
        });
        $[46] = contentId;
        $[47] = contentType;
        $[48] = isHovered;
        $[49] = isPopupOpen;
        $[50] = lastModified;
        $[51] = onOpen;
        $[52] = spaceKey;
        $[53] = url;
        $[54] = t24;
    } else t24 = $[54];
    let t25;
    if ($[55] !== t14 || $[56] !== t23 || $[57] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, t14, t23, t24);
        $[55] = t14;
        $[56] = t23;
        $[57] = t24;
        $[58] = t25;
    } else t25 = $[58];
    let t26;
    if ($[59] !== excerpt) {
        t26 = (0, $6p02T.processExcerpt)(excerpt);
        $[59] = excerpt;
        $[60] = t26;
    } else t26 = $[60];
    let t27;
    if ($[61] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$3daa6119b619c70c), null, t26);
        $[61] = t26;
        $[62] = t27;
    } else t27 = $[62];
    let t28;
    if ($[63] !== t25 || $[64] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), {
            onMouseOver: t9,
            onFocus: t10,
            onMouseLeave: t11,
            onBlur: t12
        }, t25, t27);
        $[63] = t25;
        $[64] = t27;
        $[65] = t28;
    } else t28 = $[65];
    return t28;
} : ({ searchResult: searchResult, searchResultIdx: searchResultIdx, onClickResult: onClickResult, onContextClickResult: onContextClickResult })=>{
    const { entityType: entityType, title: title, subtype: subtype, excerpt: excerpt, url: url, lastModified: lastModified, content: { id: contentId, type: contentType, space: { key: spaceKey } }, ancestors: ancestors, emoji: emoji, isVerified: isVerified } = searchResult;
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const lastModifiedText = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment ? (0, $dIdGO.i18n).resultLastModifiedAttachment : (0, $dIdGO.i18n).resultLastModifiedContent;
    const onOpen = ()=>{
        setIsPopupOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'advancedSearch',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'quickSummaryAdvancedSearchButton',
                attributes: {
                    contentId: contentId,
                    isAIOptedIn: isAdminHubAIEnabled,
                    edition: edition,
                    rowIndex: searchResultIdx,
                    searchSessionId: searchSessionId
                }
            }
        }).fire();
    };
    const ResultTitleWithLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        href: `${(0, $jghB4.CONTEXT_PATH)}${url}`,
        onClick: onClickResult,
        onContextMenu: onContextClickResult,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "searchResultLink"
    }, (0, $6p02T.enrichExcerpt)(title)));
    const VerifiedBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, "\u30FB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        label: "verified",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), {
        onMouseOver: ()=>setHovered(true),
        onFocus: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        onBlur: ()=>setHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
        contentType: entityType,
        subType: subtype,
        resultTitle: (0, $6p02T.cleanExcerpt)(title),
        emojiValue: emoji
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, ResultTitleWithLink, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$6acd8eb1223875ed), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b74d421c87f9e13e$export$725c9be8a2ae4e69), {
        index: searchResultIdx,
        contentId: contentId,
        spaceKey: spaceKey || '',
        ancestors: ancestors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$5c12c8af6ba308d8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, "\u30FB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), lastModifiedText), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: lastModified
    })), isVerified && VerifiedBadge)), (isHovered || isPopupOpen) && (0, $9wGTI.fg)('central_ai_quick_summary_in_advanced_search') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $514dda4d5b510fec$export$e82b88b8e9b29fb6), {
        source: "advancedSearch",
        contentPath: `${(0, $jghB4.CONTEXT_PATH)}${url}`,
        contentId: contentId,
        spaceKey: spaceKey || undefined,
        contentType: contentType,
        lastModifiedDate: lastModified,
        onOpen: ()=>onOpen(),
        onClose: ()=>setIsPopupOpen(false)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$3daa6119b619c70c), null, (0, $6p02T.processExcerpt)(excerpt)));
};






















const $439e7e41942ee3ce$export$2f06d33b3afe23bc = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { searchResult: searchResult, onClickResult: onClickResult, onContextClickResult: onContextClickResult } = t0;
    const { title: spaceName, entityType: entityType, space: t1 } = searchResult;
    const { webui: spaceUrl, icon: t2 } = t1;
    const { path: iconPath } = t2;
    let t3;
    if ($[0] !== spaceName) {
        t3 = (0, $6p02T.cleanExcerpt)(spaceName);
        $[0] = spaceName;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== entityType || $[3] !== iconPath || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
            contentType: entityType,
            iconPath: iconPath,
            resultTitle: t3
        }));
        $[2] = entityType;
        $[3] = iconPath;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const t5 = `${(0, $jghB4.CONTEXT_PATH)}${spaceUrl}`;
    let t6;
    if ($[6] !== spaceName) {
        t6 = (0, $6p02T.enrichExcerpt)(spaceName);
        $[6] = spaceName;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== onClickResult || $[9] !== onContextClickResult || $[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            href: t5,
            onClick: onClickResult,
            onContextMenu: onContextClickResult,
            className: "searchResultLink"
        }, t6)));
        $[8] = onClickResult;
        $[9] = onContextClickResult;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t4 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, t4, t7));
        $[13] = t4;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ searchResult: searchResult, onClickResult: onClickResult, onContextClickResult: onContextClickResult })=>{
    const { title: spaceName, entityType: entityType, space: { webui: spaceUrl, icon: { path: iconPath } } } = searchResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
        contentType: entityType,
        iconPath: iconPath,
        resultTitle: (0, $6p02T.cleanExcerpt)(spaceName)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        href: `${(0, $jghB4.CONTEXT_PATH)}${spaceUrl}`,
        onClick: onClickResult,
        onContextMenu: onContextClickResult,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "searchResultLink"
    }, (0, $6p02T.enrichExcerpt)(spaceName))))));
};



const $8b2f8ca9f1e3af8c$export$7311ff7a59e7e743 = (0, $2XqLN.default)((result, url)=>({
        ...result,
        url: url
    }));
const $8b2f8ca9f1e3af8c$export$44f273bad5d5a020 = ({ searchResult: searchResult, searchSessionId: searchSessionId, searchQuery: searchQuery })=>{
    let url = (0, $cb6fO.addQueryParams)(`${searchResult.url}`, {
        search_id: searchSessionId
    });
    if (searchQuery) {
        const analyticsFormattedForUrlParsing = `queryHash${(0, $7H6GR.valueSeparator)}${(0, $1AV5C.hashData)(searchQuery)}`;
        // manually doing the query params instead of using the helper function from search common due to lack of
        // addqueryparams support/overlap
        url = (0, $cb6fO.addQueryParams)(`${searchResult.url}`, {
            search_id: searchSessionId,
            additional_analytics: analyticsFormattedForUrlParsing
        });
    }
    return url;
};
const $8b2f8ca9f1e3af8c$export$a2def421b23768aa = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { searchResult: searchResult, searchResultIdx: searchResultIdx } = t0;
    const { fireAnalytics: fireAnalytics, searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    const { entityType: entityType, content: content, space: space } = searchResult;
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    const { searchQuery: searchQuery } = searchInputs;
    const backendExperiment = (0, $c6d32a8c2bb13381$export$284401669662f77b)();
    let t1;
    if ($[0] !== backendExperiment || $[1] !== content || $[2] !== entityType || $[3] !== fireAnalytics || $[4] !== searchResultIdx || $[5] !== space?.id) {
        t1 = ()=>{
            fireAnalytics({
                type: "sendUIEvent",
                actionSubject: "advancedSearchResultLink",
                action: "clicked",
                additionalAttributes: {
                    abTest: backendExperiment,
                    position: searchResultIdx,
                    metadata: {
                        entityType: entityType !== "space" ? "content" : "space",
                        contentType: entityType !== "space" && content.type,
                        contentId: entityType !== "space" && content.id,
                        spaceId: entityType !== "space" && content.space.id,
                        containerId: entityType !== "space" ? content.space?.id : space?.id
                    }
                }
            });
        };
        $[0] = backendExperiment;
        $[1] = content;
        $[2] = entityType;
        $[3] = fireAnalytics;
        $[4] = searchResultIdx;
        $[5] = space?.id;
        $[6] = t1;
    } else t1 = $[6];
    const fireClickEvent = t1;
    let t2;
    if ($[7] !== backendExperiment || $[8] !== content || $[9] !== entityType || $[10] !== fireAnalytics || $[11] !== searchResultIdx || $[12] !== space?.id) {
        t2 = ()=>{
            fireAnalytics({
                type: "sendUIEvent",
                actionSubject: "advancedSearchResultLink",
                action: "contextMenuClicked",
                additionalAttributes: {
                    abTest: backendExperiment,
                    position: searchResultIdx,
                    metadata: {
                        entityType: entityType !== "space" ? "content" : "space",
                        contentType: entityType !== "space" && content.type,
                        contentId: entityType !== "space" && content.id,
                        spaceId: entityType !== "space" && content.space.id,
                        containerId: entityType !== "space" ? content.space?.id : space?.id
                    }
                }
            });
        };
        $[7] = backendExperiment;
        $[8] = content;
        $[9] = entityType;
        $[10] = fireAnalytics;
        $[11] = searchResultIdx;
        $[12] = space?.id;
        $[13] = t2;
    } else t2 = $[13];
    const fireContextClickEvent = t2;
    let t3;
    if ($[14] !== searchQuery || $[15] !== searchResult || $[16] !== searchSessionId) {
        const url = $8b2f8ca9f1e3af8c$export$44f273bad5d5a020({
            searchQuery: searchQuery,
            searchSessionId: searchSessionId,
            searchResult: searchResult
        });
        t3 = $8b2f8ca9f1e3af8c$export$7311ff7a59e7e743(searchResult, url);
        $[14] = searchQuery;
        $[15] = searchResult;
        $[16] = searchSessionId;
        $[17] = t3;
    } else t3 = $[17];
    const processedSearchResult = t3;
    let t4;
    if ($[18] !== entityType || $[19] !== fireClickEvent || $[20] !== fireContextClickEvent || $[21] !== processedSearchResult || $[22] !== searchResultIdx) {
        const searchResultTypeComponent = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $439e7e41942ee3ce$export$2f06d33b3afe23bc), {
            searchResult: processedSearchResult,
            onClickResult: fireClickEvent,
            onContextClickResult: fireContextClickEvent
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4073f849b8cb22a9$export$9e118db64676565a), {
            searchResult: processedSearchResult,
            searchResultIdx: searchResultIdx,
            onClickResult: fireClickEvent,
            onContextClickResult: fireContextClickEvent
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$56e008c8bd1ccf7c), null, searchResultTypeComponent);
        $[18] = entityType;
        $[19] = fireClickEvent;
        $[20] = fireContextClickEvent;
        $[21] = processedSearchResult;
        $[22] = searchResultIdx;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ searchResult: searchResult, searchResultIdx: searchResultIdx })=>{
    const { fireAnalytics: fireAnalytics, searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    const { entityType: entityType, content: content, space: space } = searchResult;
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    const { searchQuery: searchQuery } = searchInputs;
    const backendExperiment = (0, $c6d32a8c2bb13381$export$284401669662f77b)();
    const fireClickEvent = (0, $42omo.useCallback)(()=>{
        fireAnalytics({
            type: 'sendUIEvent',
            actionSubject: 'advancedSearchResultLink',
            action: 'clicked',
            additionalAttributes: {
                abTest: backendExperiment,
                position: searchResultIdx,
                metadata: {
                    entityType: entityType !== 'space' ? 'content' : 'space',
                    contentType: entityType !== 'space' && content.type,
                    contentId: entityType !== 'space' && content.id,
                    spaceId: entityType !== 'space' && content.space.id,
                    containerId: entityType !== 'space' ? content.space?.id : space?.id
                }
            }
        });
    }, [
        fireAnalytics,
        entityType,
        content,
        space,
        searchResultIdx,
        backendExperiment
    ]);
    const fireContextClickEvent = (0, $42omo.useCallback)(()=>{
        fireAnalytics({
            type: 'sendUIEvent',
            actionSubject: 'advancedSearchResultLink',
            action: 'contextMenuClicked',
            additionalAttributes: {
                abTest: backendExperiment,
                position: searchResultIdx,
                metadata: {
                    entityType: entityType !== 'space' ? 'content' : 'space',
                    contentType: entityType !== 'space' && content.type,
                    contentId: entityType !== 'space' && content.id,
                    spaceId: entityType !== 'space' && content.space.id,
                    containerId: entityType !== 'space' ? content.space?.id : space?.id
                }
            }
        });
    }, [
        fireAnalytics,
        entityType,
        content,
        space,
        searchResultIdx,
        backendExperiment
    ]);
    const url = $8b2f8ca9f1e3af8c$export$44f273bad5d5a020({
        searchQuery: searchQuery,
        searchSessionId: searchSessionId,
        searchResult: searchResult
    });
    const processedSearchResult = $8b2f8ca9f1e3af8c$export$7311ff7a59e7e743(searchResult, url);
    const searchResultTypeComponent = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $439e7e41942ee3ce$export$2f06d33b3afe23bc), {
        searchResult: processedSearchResult,
        onClickResult: fireClickEvent,
        onContextClickResult: fireContextClickEvent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4073f849b8cb22a9$export$9e118db64676565a), {
        searchResult: processedSearchResult,
        searchResultIdx: searchResultIdx,
        onClickResult: fireClickEvent,
        onContextClickResult: fireContextClickEvent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$56e008c8bd1ccf7c), null, searchResultTypeComponent);
};





























const $c99b6989418b2e33$export$f72733f14b99288b = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _kqswh2mm _1e0c1txw _4t3igktf _ca0q1b66 _n3tdu2gc _syaz1rpy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _kqswh2mm _1e0c1txw _4t3igktf _ca0q1b66 _n3tdu2gc _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $c99b6989418b2e33$export$bfe738f2aaa065ec = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _4t3igktf _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _4t3igktf _syazazsu",
            __cmplp.className
        ])
    });
});


const $455256aee5342c37$export$1087c4e3145b9e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { numberOfResults: numberOfResults, totalCount: totalCount } = t0;
    let t1;
    if ($[0] !== numberOfResults || $[1] !== totalCount) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c99b6989418b2e33$export$f72733f14b99288b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c99b6989418b2e33$export$bfe738f2aaa065ec), {
            "data-testid": "advanced-search-result-count",
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $dIdGO.i18n).numberOfResults,
            values: {
                numberOfResults: numberOfResults,
                totalCount: totalCount
            }
        })));
        $[0] = numberOfResults;
        $[1] = totalCount;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ numberOfResults: numberOfResults, totalCount: totalCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c99b6989418b2e33$export$f72733f14b99288b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c99b6989418b2e33$export$bfe738f2aaa065ec), {
        "data-testid": "advanced-search-result-count",
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $dIdGO.i18n).numberOfResults,
        values: {
            numberOfResults: numberOfResults,
            totalCount: totalCount
        }
    })));
};
























var $9YwaJ = parcelRequire("9YwaJ");







const $7aa5cf5ed4869a63$export$d60800e41134dc74 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { loading: loading, hasNextPage: hasNextPage, loadMore: loadMore } = t0;
    let t1;
    if ($[0] !== hasNextPage || $[1] !== loadMore || $[2] !== loading) {
        t1 = hasNextPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchPaginationContainer), {
            loading: loading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
            onClick: loadMore,
            isLoading: loading,
            "data-test-id": "load-more-button",
            testId: "load-more-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dIdGO.i18n).paginationLoadMoreButton))) : null;
        $[0] = hasNextPage;
        $[1] = loadMore;
        $[2] = loading;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ loading: loading, hasNextPage: hasNextPage, loadMore: loadMore })=>{
    return hasNextPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchPaginationContainer), {
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        onClick: loadMore,
        isLoading: loading,
        "data-test-id": "load-more-button",
        testId: "load-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dIdGO.i18n).paginationLoadMoreButton))) : null;
};



const $bd73bcb24d697b93$var$SearchResultListNoResults = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WhPJA",
    name: "SearchResultListNoResults",
    loader: async ()=>(await (parcelRequire("57yeA"))).SearchResultListNoResults
});
const $bd73bcb24d697b93$export$e569ab70e8964a2c = ({ results: results, numResults: numResults, totalCount: totalCount, hasNextPage: hasNextPage, loadMore: loadMore, isStale: isStale, queryState: queryState, abTest: abTest, experimentLayers: experimentLayers, productEdition: productEdition })=>{
    const { sessionHasAppliedFilters: sessionHasAppliedFilters, clearFilters: clearFilters } = (0, $fGkN6.useSearchInputContext)();
    const { fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        if (!isStale && results.length) fireAnalytics({
            type: 'sendTrackEvent',
            action: 'shown',
            actionSubject: 'advancedSearchResults',
            additionalAttributes: {
                queryState: queryState,
                numResults: numResults,
                abTest: abTest,
                numberOfResultsShown: numResults,
                noResultsFetched: numResults === 0,
                numberOfDocs: numResults,
                pageNumber: numResults ? Math.ceil(numResults / (0, $jghB4.PAGE_SIZE)) : 1,
                backendExperiments: {
                    experimentLayers: experimentLayers
                },
                productEdition: productEdition
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isStale,
        results
    ]);
    return results.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "post-query-with-results-test"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $455256aee5342c37$export$1087c4e3145b9e), {
        numberOfResults: numResults,
        totalCount: totalCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        "data-testid": "advanced-search-resultlist"
    }, results.map((result, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b2f8ca9f1e3af8c$export$a2def421b23768aa), {
            key: result.url,
            searchResult: result,
            searchResultIdx: idx
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aa5cf5ed4869a63$export$d60800e41134dc74), {
        loading: false,
        hasNextPage: hasNextPage,
        loadMore: loadMore
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "post-query-no-results-test"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd73bcb24d697b93$var$SearchResultListNoResults, {
        clearFilters: clearFilters,
        withFiltersSelected: sessionHasAppliedFilters,
        queryState: queryState,
        abTest: abTest,
        experimentLayers: experimentLayers
    }));
};





















const $ff95fda3da3c99bb$export$28f1f0e024879df8 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$5e67fe52e2a75774), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$87791440d5143001), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$160e94802e028924), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c31c29c2535484c5), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null)))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$87791440d5143001), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$5e67fe52e2a75774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$160e94802e028924), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$c31c29c2535484c5), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null)))));





const $250b8dadfdbee347$export$b84e0366c3edb9f0 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchResultListLoadingContainer), null, [
            ...Array(8)
        ].map($250b8dadfdbee347$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchResultListLoadingContainer), null, [
        ...Array(8)
    ].map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ff95fda3da3c99bb$export$28f1f0e024879df8), {
            key: idx
        })));
function $250b8dadfdbee347$var$_temp(_, idx) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ff95fda3da3c99bb$export$28f1f0e024879df8), {
        key: idx
    });
}






const $04d8fc43a3f6d394$var$SearchResultListError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hyud8",
    name: "SearchResultListError",
    loader: async ()=>(await (parcelRequire("27sFv"))).SearchResultListError
});
const $04d8fc43a3f6d394$export$4ad5822afca02684 = ({ resultsRef: resultsRef })=>{
    const { queryState: queryState, loading: loading, error: error, results: results, numResults: numResults, totalCount: totalCount, hasNextPage: hasNextPage, loadMore: loadMore, abTest: abTest, experimentLayers: experimentLayers, productEdition: productEdition } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    const { showSearchAI: showSearchAI } = (0, $fGkN6.useSearchInputContext)();
    const prevResultsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(results);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        prevResultsRef.current = results;
    }, [
        results
    ]);
    const resultListRenderer = (0, $42omo.useCallback)(()=>{
        switch(queryState){
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).ERROR:
                // @ts-ignore error will always exist if QueryState.ERROR also exists, but ts cannot narrow it
                experienceTracker.fail({
                    error: error,
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($04d8fc43a3f6d394$var$SearchResultListError, null)));
            // prevQueryStateRef to show the previous results while loading (if they exist),
            // otherwise show the no input state in a loading state
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).LOADING:
                experienceTracker.start({
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                });
                if (prevResultsRef.current.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd73bcb24d697b93$export$e569ab70e8964a2c), {
                    results: prevResultsRef.current,
                    numResults: numResults,
                    totalCount: totalCount,
                    hasNextPage: hasNextPage,
                    loadMore: loadMore,
                    queryState: queryState,
                    abTest: abTest,
                    isStale: true
                }));
                else if (showSearchAI) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $250b8dadfdbee347$export$b84e0366c3edb9f0), null);
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5762a0d820ceeb6a$export$192d2d3653f9ca9d), null));
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).POSTQUERY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd73bcb24d697b93$export$e569ab70e8964a2c), {
                    results: results,
                    numResults: numResults,
                    totalCount: totalCount,
                    hasNextPage: hasNextPage,
                    loadMore: loadMore,
                    resultListRef: resultsRef,
                    queryState: queryState,
                    abTest: abTest,
                    experimentLayers: experimentLayers,
                    isStale: false,
                    productEdition: productEdition
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                }));
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).PREQUERY:
                return(// <SearchResultListLoading />
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5762a0d820ceeb6a$export$192d2d3653f9ca9d), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                })));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numResults,
        queryState,
        resultsRef,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resultListRenderer(), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cacu1.PageLoadEndEvent), null));
};












var $3Opgu = parcelRequire("3Opgu");


var $hHJ3S = parcelRequire("hHJ3S");






























var $afneb = parcelRequire("afneb");

const $57d15da5f882e220$export$a1a841ed4806404b = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $57d15da5f882e220$export$bc822a7c8e6d6ae2 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $57d15da5f882e220$export$1820cc0a1da47a5f = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $57d15da5f882e220$var$tooltipStyles = null;
const $57d15da5f882e220$export$7574cd0e3a4be128 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? function ToolTipOverride(t0, ref) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12fpd6w _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function ToolTipOverride({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12fpd6w _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, children);
});
const $57d15da5f882e220$export$1f1fe8a95db75cad = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_p12f1vno",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1vno",
            __cmplp.className
        ])
    });
});


const $fa8ad2e599580b9e$export$ba5404e9c41a327c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(32);
    const { filters: filters } = (0, $fGkN6.useSearchInputContext)();
    const { cloudId: cloudId, userId: userId, displayName: displayName, edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, showSearchAI: showSearchAI, aiTriggeredByAskAI: aiTriggeredByAskAI, aiSearchConfig: aiSearchConfig, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    let t0;
    if ($[0] !== filters) {
        t0 = (0, $iD4ky.mapFiltersToAggregator)(filters);
        $[0] = filters;
        $[1] = t0;
    } else t0 = $[1];
    const parsedFilters = t0;
    const { results: results, loading: resultsLoading } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    let t1;
    if ($[2] !== results[0]) {
        t1 = results[0] ?? {};
        $[2] = results[0];
        $[3] = t1;
    } else t1 = $[3];
    const { content: firstResultContent } = t1;
    let t2;
    if ($[4] !== firstResultContent) {
        t2 = firstResultContent ?? {};
        $[4] = firstResultContent;
        $[5] = t2;
    } else t2 = $[5];
    const { id: firstResultId, type: firstResultType } = t2;
    const showAITopicsCard = !resultsLoading && !parsedFilters.length && isAdminHubAIEnabled;
    if (showSearchAI && aiSearchConfig && searchQuery) {
        const t3 = displayName || "";
        const t4 = userId || "";
        let t5;
        if ($[6] !== t3 || $[7] !== t4) {
            t5 = {
                name: t3,
                id: t4
            };
            $[6] = t3;
            $[7] = t4;
            $[8] = t5;
        } else t5 = $[8];
        const t6 = aiTriggeredByAskAI ? "askAIButton" : "questionDetection";
        let t7;
        if ($[9] !== t6) {
            t7 = {
                triggeredBy: t6
            };
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        let t8;
        if ($[11] !== edition) {
            t8 = edition?.toString();
            $[11] = edition;
            $[12] = t8;
        } else t8 = $[12];
        let t9;
        if ($[13] !== aiSearchConfig.aiSearchQueryFunction || $[14] !== aiTriggeredByAskAI || $[15] !== cloudId || $[16] !== isAdminHubAIEnabled || $[17] !== onSearchQueryChange || $[18] !== parsedFilters || $[19] !== searchQuery || $[20] !== searchSessionId || $[21] !== t5 || $[22] !== t7 || $[23] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Opgu.SearchAIDialog), {
                query: searchQuery,
                setQuery: onSearchQueryChange,
                cloudId: cloudId,
                getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
                followUpsEnabled: true,
                onNavigate: $fa8ad2e599580b9e$var$_temp,
                searchSessionId: searchSessionId,
                userDetails: t5,
                source: "advancedSearch",
                sourceProduct: "confluence",
                extraAnalyticsAttributes: t7,
                wrapper: $fa8ad2e599580b9e$var$_temp2,
                loadingWrapper: $fa8ad2e599580b9e$var$_temp3,
                parsedFilters: parsedFilters,
                edition: t8,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                userGeneratedAI: aiTriggeredByAskAI
            });
            $[13] = aiSearchConfig.aiSearchQueryFunction;
            $[14] = aiTriggeredByAskAI;
            $[15] = cloudId;
            $[16] = isAdminHubAIEnabled;
            $[17] = onSearchQueryChange;
            $[18] = parsedFilters;
            $[19] = searchQuery;
            $[20] = searchSessionId;
            $[21] = t5;
            $[22] = t7;
            $[23] = t8;
            $[24] = t9;
        } else t9 = $[24];
        return t9;
    }
    if (showAITopicsCard && (0, $9wGTI.fg)("ai_topics_card_advanced_search")) {
        const t3 = userId ?? "";
        const t4 = displayName ?? "";
        let t5;
        if ($[25] !== cloudId || $[26] !== firstResultId || $[27] !== firstResultType || $[28] !== searchQuery || $[29] !== t3 || $[30] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hHJ3S.AITopicsCardByDocument), {
                documentId: firstResultId,
                documentType: firstResultType,
                searchQuery: searchQuery,
                cloudId: cloudId,
                userId: t3,
                userName: t4
            });
            $[25] = cloudId;
            $[26] = firstResultId;
            $[27] = firstResultType;
            $[28] = searchQuery;
            $[29] = t3;
            $[30] = t4;
            $[31] = t5;
        } else t5 = $[31];
        return t5;
    }
    return null;
} : ()=>{
    const { filters: filters } = (0, $fGkN6.useSearchInputContext)();
    const { cloudId: cloudId, userId: userId, displayName: displayName, edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, showSearchAI: showSearchAI, aiTriggeredByAskAI: aiTriggeredByAskAI, aiSearchConfig: aiSearchConfig, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    const parsedFilters = (0, $iD4ky.mapFiltersToAggregator)(filters);
    const { results: results, loading: resultsLoading } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    const { content: firstResultContent } = results[0] ?? {};
    const { id: firstResultId, type: firstResultType } = firstResultContent ?? {};
    const showAITopicsCard = !resultsLoading && !parsedFilters.length && isAdminHubAIEnabled;
    if (showSearchAI && aiSearchConfig && searchQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Opgu.SearchAIDialog), {
        query: searchQuery,
        setQuery: onSearchQueryChange,
        cloudId: cloudId,
        getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
        followUpsEnabled: true,
        onNavigate: ()=>{},
        searchSessionId: searchSessionId,
        userDetails: {
            name: displayName || '',
            id: userId || ''
        },
        source: "advancedSearch",
        sourceProduct: "confluence",
        extraAnalyticsAttributes: {
            triggeredBy: aiTriggeredByAskAI ? 'askAIButton' : 'questionDetection'
        },
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57d15da5f882e220$export$a1a841ed4806404b), null, children),
        loadingWrapper: ({ children: children_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57d15da5f882e220$export$bc822a7c8e6d6ae2), null, children_0),
        parsedFilters: parsedFilters,
        edition: edition?.toString(),
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        userGeneratedAI: aiTriggeredByAskAI
    });
    if (showAITopicsCard && (0, $9wGTI.fg)('ai_topics_card_advanced_search')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hHJ3S.AITopicsCardByDocument), {
        documentId: firstResultId,
        documentType: firstResultType,
        searchQuery: searchQuery,
        cloudId: cloudId,
        userId: userId ?? '',
        userName: displayName ?? ''
    });
    return null;
};
function $fa8ad2e599580b9e$var$_temp() {}
function $fa8ad2e599580b9e$var$_temp2(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57d15da5f882e220$export$a1a841ed4806404b), null, children);
}
function $fa8ad2e599580b9e$var$_temp3(t0) {
    const { children: children_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57d15da5f882e220$export$bc822a7c8e6d6ae2), null, children_0);
}












var $gBQBJ = parcelRequire("gBQBJ");




















const $cdb54880576a1ba2$export$c349a6e4bcccfcee = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3igktf _19pk1b66 _ekv6wadc _1sc1wadc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3igktf _19pk1b66 _ekv6wadc _1sc1wadc",
            __cmplp.className
        ])
    });
});
const $cdb54880576a1ba2$export$37b56b123f6a7a7e = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3igktf _19pk1b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3igktf _19pk1b66",
            __cmplp.className
        ])
    });
});


const $c1263d6fa2690005$export$74d1cc9467f91517 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdb54880576a1ba2$export$c349a6e4bcccfcee), {
            "data-testid": "autocorrect-wrapper"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdb54880576a1ba2$export$c349a6e4bcccfcee), {
        "data-testid": "autocorrect-wrapper"
    }, children);
const $c1263d6fa2690005$export$19d62de31dc08ace = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { loading: loading, results: results, searchSessionId: searchSessionId } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    let t0;
    if ($[0] !== onSearchQueryChange) {
        t0 = (correction)=>{
            onSearchQueryChange(correction);
        };
        $[0] = onSearchQueryChange;
        $[1] = t0;
    } else t0 = $[1];
    const onCorrectionClick = t0;
    let t1;
    if ($[2] !== cloudId || $[3] !== loading || $[4] !== onCorrectionClick || $[5] !== results || $[6] !== searchQuery || $[7] !== searchSessionId) {
        t1 = !!searchQuery && (!loading || results.length > 0) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gBQBJ.Autocorrection), {
            query: searchQuery,
            onCorrectionSelect: onCorrectionClick,
            cloudId: cloudId,
            searchSessionId: searchSessionId,
            source: "advancedSearch",
            productId: "confluence",
            container: $c1263d6fa2690005$export$74d1cc9467f91517,
            noCorrectionPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), null)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), {
            "data-testid": "autocorrect-placeholder"
        });
        $[2] = cloudId;
        $[3] = loading;
        $[4] = onCorrectionClick;
        $[5] = results;
        $[6] = searchQuery;
        $[7] = searchSessionId;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { loading: loading, results: results, searchSessionId: searchSessionId } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    const onCorrectionClick = (0, $42omo.useCallback)((correction)=>{
        onSearchQueryChange(correction);
    }, [
        onSearchQueryChange
    ]);
    return !!searchQuery && (!loading || results.length > 0) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gBQBJ.Autocorrection), {
        query: searchQuery,
        onCorrectionSelect: onCorrectionClick,
        cloudId: cloudId,
        searchSessionId: searchSessionId,
        source: "advancedSearch",
        productId: "confluence",
        container: $c1263d6fa2690005$export$74d1cc9467f91517,
        noCorrectionPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), {
        "data-testid": "autocorrect-placeholder"
    });
};






const $359d431608e653dd$export$bcb179afe377d0c2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "J2YbF",
    name: "HorizontalFilters",
    loader: async ()=>(await (parcelRequire("6AxFm"))).HorizontalFilters
});






var $1oLkX = parcelRequire("1oLkX");

const $91f77f209ee877f1$var$AdvancedSearchLayoutContent = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(14);
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== locale) {
        t0 = locale.split("-");
        $[0] = locale;
        $[1] = t0;
    } else t0 = $[1];
    const isAutocorrectionEnabled = t0[0] === "en";
    (0, $5d0f8354a84fe01a$export$ce35a99c900a2a66)();
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1oLkX.HorizontalFilterWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $359d431608e653dd$export$bcb179afe377d0c2), null));
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fa8ad2e599580b9e$export$ba5404e9c41a327c), null);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isAutocorrectionEnabled) {
        t3 = !!isAutocorrectionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c1263d6fa2690005$export$19d62de31dc08ace), null);
        $[4] = isAutocorrectionEnabled;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    let t5;
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04d8fc43a3f6d394$export$4ad5822afca02684), null);
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cacu1.PageLoadEndEvent), null);
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else {
        t4 = $[6];
        t5 = $[7];
        t6 = $[8];
    }
    let t7;
    if ($[9] !== t3) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7adf2f9ada840466$export$6e4640db3f243f9f), null, t2, t3, t4, t5, t6);
        $[9] = t3;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
        });
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7adf2f9ada840466$export$1c7ad7ad25850bd5), {
            "data-testid": "advanced-search-page"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7adf2f9ada840466$export$cb4aeb4aba07ad10), null, t7, t8));
        $[12] = t7;
        $[13] = t9;
    } else t9 = $[13];
    return t9;
} : ()=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const isAutocorrectionEnabled = locale.split('-')[0] === 'en';
    (0, $5d0f8354a84fe01a$export$ce35a99c900a2a66)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7adf2f9ada840466$export$1c7ad7ad25850bd5), {
        "data-testid": "advanced-search-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1oLkX.HorizontalFilterWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $359d431608e653dd$export$bcb179afe377d0c2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7adf2f9ada840466$export$cb4aeb4aba07ad10), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7adf2f9ada840466$export$6e4640db3f243f9f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fa8ad2e599580b9e$export$ba5404e9c41a327c), null), !!isAutocorrectionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c1263d6fa2690005$export$19d62de31dc08ace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04d8fc43a3f6d394$export$4ad5822afca02684), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cacu1.PageLoadEndEvent), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
    })));
};
const $91f77f209ee877f1$export$341d77456cd3484f = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "advanced-search-layout"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($91f77f209ee877f1$var$AdvancedSearchLayoutContent, null)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "advanced-search-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($91f77f209ee877f1$var$AdvancedSearchLayoutContent, null)));









var $hY8sQ = parcelRequire("hY8sQ");











var $bVltF = parcelRequire("bVltF");

const $caddf55329a22602$export$89425ce979aa17b3 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $42omo.useEffect)($caddf55329a22602$var$_temp, t0);
    return null;
} : ()=>{
    (0, $42omo.useEffect)(()=>{
        (0, $bVltF.searchPageLoadUFOExperience).start();
    }, []);
    return null;
};
function $caddf55329a22602$var$_temp() {
    (0, $bVltF.searchPageLoadUFOExperience).start();
}



const $0974987d69968440$export$67c540814f5fd6a4 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { isRovoEnabled: isRovoEnabledInTCS } = (0, $bQm3c.useSessionData)();
    // A user sees Full Page Search from `@atlassian/search-page` if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    const isFullPageSearchEnabled = ((0, $9wGTI.fg)('unified_search_in_confluence') || isRovoEnabledInTCS) && !(0, $9wGTI.fg)('confluence_rovo_search_opt_out');
    const getFailedSearchJourneyTriggerRovoChatExperiment = (0, $42omo.useCallback)(()=>{
        return (0, $6mKj3.expVal)('failed_search_journey_trigger_rovo_chat', 'cohort', 'control');
    }, []);
    const [shouldShowSearchPageRovoConfig, setShouldShowSearchPageRovoConfig] = (0, $42omo.useState)(false);
    const [shouldSetNudge, setShouldSetNudge] = (0, $42omo.useState)(false);
    const [shouldNudgeToQueryStarters, setShouldNudgeToQueryStarters] = (0, $42omo.useState)(false);
    const [shouldNudgeToSummarizeQuery, setShouldNudgeToSummarizeQuery] = (0, $42omo.useState)(false);
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const queryParams = getQueryParams();
    const currentQuery = queryParams?.text?.toString() ?? '';
    const searchReferrerId = (0, $42omo.useRef)(queryParams.search_id?.toString()).current;
    const searchSessionId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()).current;
    const sendSessionStartedEvent = (0, $42omo.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'advancedSearchScreen',
                action: 'started',
                actionSubject: 'advancedSearchSession',
                attributes: {
                    searchSessionId: searchSessionId,
                    searchReferrerId: searchReferrerId,
                    version: 2
                }
            }
        });
        analyticsEvent.fire();
    }, [
        createAnalyticsEvent,
        searchSessionId,
        searchReferrerId
    ]);
    const changeSearchIdInQueryParams = (0, $42omo.useCallback)(()=>{
        setQueryParams({
            search_id: searchSessionId
        }, true);
    }, [
        setQueryParams,
        searchSessionId
    ]);
    const handleRedirect = (0, $42omo.useCallback)(()=>{
        const { redirect: redirect, unsupportedFields: unsupportedFields, doubleFields: doubleFields } = getQueryParams();
        if (redirect) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirected',
                    actionSubject: 'advancedSearch',
                    source: 'advancedSearchScreen',
                    attributes: {
                        unsupportedFields: unsupportedFields,
                        doubleFields: doubleFields
                    }
                }
            }).fire();
            setQueryParams({
                redirect: null
            });
        }
        if (unsupportedFields) setQueryParams({
            unsupportedFields: null
        });
        if (doubleFields) setQueryParams({
            doubleFields: null
        });
    }, [
        createAnalyticsEvent,
        setQueryParams,
        getQueryParams
    ]);
    (0, $42omo.useEffect)(()=>{
        sendSessionStartedEvent();
        changeSearchIdInQueryParams();
        handleRedirect();
    }, [
        sendSessionStartedEvent,
        changeSearchIdInQueryParams,
        handleRedirect
    ]);
    //Failed Search Journey Trigger Rovo Chat Experiment
    // Control: use the empty AdvancedSearchRovoConfig option
    // Query Starters Only Cohort: use the AdvancedSearchRovoConfig option, do not nudge the user after 20s dwell
    // Nudge to Query Starters Cohort: use the AdvancedSearchRovoConfig option, nudge the user after 20s dwell, nudge redirects user to mini modal
    // Nudge to Summarize Query Cohort: use the AdvancedSearchRovoConfig option, nudge the user after 20s dwell, nudge redirects user to conversation where Rovo will summarize the query results
    (0, $42omo.useEffect)(()=>{
        //Only run the experiment if the user is on the full page search page or the query is non-empty
        if (!isFullPageSearchEnabled || currentQuery.length === 0) return;
        //Evaluate the experiment cohort
        const experimentCohort = getFailedSearchJourneyTriggerRovoChatExperiment();
        //If user is in control cohort, do nothing
        if (experimentCohort === 'control') {
            setShouldSetNudge(false);
            return;
        }
        //If user is in query starters only cohort, set the config and return
        if (experimentCohort === 'query-starters-only') {
            setShouldShowSearchPageRovoConfig(true);
            setShouldSetNudge(false);
        }
        //If user is in the nudge to query starters cohort, set the original search page rovo config initially, then set the config with the nudge after 20s dwell
        if (experimentCohort === 'nudge-to-query-starters') {
            setShouldShowSearchPageRovoConfig(true);
            setShouldSetNudge(true);
        }
        //If user is in the nudge to summarize query actioncohort, set the original search page rovo config initially, then set the config with the nudge after 20s dwell
        if (experimentCohort === 'nudge-to-summarize-query') {
            setShouldShowSearchPageRovoConfig(true);
            setShouldSetNudge(true);
        }
        const timeoutId = setTimeout(()=>{
            //If a nudge should be set, do so after 20s dwell time
            if (shouldSetNudge) {
                if (experimentCohort === 'nudge-to-query-starters') setShouldNudgeToQueryStarters(true);
                if (experimentCohort === 'nudge-to-summarize-query') setShouldNudgeToSummarizeQuery(true);
                setShouldSetNudge(false);
            }
        }, 20000);
        return ()=>clearTimeout(timeoutId);
    }, [
        getFailedSearchJourneyTriggerRovoChatExperiment,
        isFullPageSearchEnabled,
        currentQuery,
        createAnalyticsEvent,
        shouldSetNudge
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "advanced-search-controller"
    }, isFullPageSearchEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: (0, $dppWL.RegisteredExperience).SEARCH_PAGE,
        provider: (0, $29498a66b37ef077$export$f87ff91cbdaa6153),
        getSearchQuery: ()=>getQueryParams()?.text?.toString(),
        shouldUseSearchPageRovoConfig: shouldShowSearchPageRovoConfig,
        shouldNudgeToQueryStarters: shouldNudgeToQueryStarters,
        shouldNudgeToSummarizeQuery: shouldNudgeToSummarizeQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caddf55329a22602$export$89425ce979aa17b3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hY8sQ.SearchPage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: intl.formatMessage((0, $dIdGO.i18n).header)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fGkN6.SearchInputProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: intl.formatMessage((0, $dIdGO.i18n).header)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6d32a8c2bb13381$export$f413f968bd5eda1d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ebe98f756f87ec8a$export$62570eb54a58c251), {
        searchSessionId: searchSessionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4TB09.AnalyticsProvider), {
        searchSessionId: searchSessionId,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91f77f209ee877f1$export$341d77456cd3484f), null))))));
};





const $836ed73f3faf26ab$export$2709da4acd7d0aec = (0, $3u0dr.isReactCompilerActiveV2)() ? function AdvancedSearch() {
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "advanced-search"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0974987d69968440$export$67c540814f5fd6a4), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function AdvancedSearch() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "advanced-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0974987d69968440$export$67c540814f5fd6a4), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
    })));
};
module.exports["AdvancedSearch"] = $836ed73f3faf26ab$export$2709da4acd7d0aec;

});

parcelRegister("kvJHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $cbc8g.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("7boqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("hm6w9", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $6yCpa = parcelRequire("6yCpa");


var $dbl1i = parcelRequire("dbl1i");


var $4OGlb = parcelRequire("4OGlb");


var $2hfy2 = parcelRequire("2hfy2");

const $f62b6f09dac42d3d$export$2f6c9ab85be44d1a = (onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    if (shouldNotGetBackendExperiment) return;
    return $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig(onErrorFn, getLayerValuesFn ?? $f62b6f09dac42d3d$export$3178593b0bf95121);
};
const $f62b6f09dac42d3d$export$3178593b0bf95121 = (layerName, options)=>{
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        ...options?.fireLayerExposure === false ? {
            fireLayerExposure: false
        } : {}
    });
    const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
    return {
        name: layerNameWithoutSuffix,
        layerId: layer.get('layerId', 'default'),
        shadowId: layer.get('shadowId', null),
        // The below values might not be sent to the backend but we can still track them in the frontend
        controlId: layer.get('controlId', null),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        ...(0, $c6GJD.default).checkGate('search-experiment-overrides-backend') && {
            testId: layer.get('testId', null)
        }
    };
};
const $f62b6f09dac42d3d$export$f0d0c69a221c32ee = (onError, fireLayerExposure = true, getLayerValuesFn)=>{
    try {
        const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
            fireLayerExposure: false
        });
        let abTestId;
        let rawLayerFunctions;
        if (getLayerValuesFn) {
            const layerResult = getLayerValuesFn((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
                fireLayerExposure: false
            });
            abTestId = layerResult.abTestId ?? 'no_ab_test_id';
            rawLayerFunctions = layerResult.layerFunctions ?? [];
        } else {
            abTestId = layer.get('abTestId', 'no_ab_test_id');
            rawLayerFunctions = layer.get('layerFunctions', []);
        }
        const layerFunctions = (0, $dbl1i.mutuallyExclusiveBackendSearchLogicParametersSchema).safeParse(rawLayerFunctions).data;
        return {
            layerFunctions: layerFunctions || [],
            abTestId: abTestId,
            // The get 'mutualExclusion' is breaking in Jira when retrieving a boolean value from layer,
            // so for the compatibility, we use the abTestId to determine if it's a mutually exclusive experiment
            mutualExclusion: abTestId !== 'no_ab_test_id'
        };
    } catch (error) {
        onError?.(error);
    }
};
const $f62b6f09dac42d3d$export$ad31a6212fa2b02c = (layerName, onError)=>{
    try {
        const layer = (0, $c6GJD.default).getLayer(layerName);
        const layerValues = {
            l1Id: layer.get('l1Id', 'default'),
            l1Entity: layer.get('l1Entity', '*'),
            l2Id: layer.get('l2Id', 'default'),
            l2Entity: layer.get('l2Entity', '*'),
            l3Id: layer.get('l3Id', 'default'),
            qrId: layer.get('qrId', 'default'),
            abTestId: layer.get('abTestId', 'no_ab_test_id'),
            /**
			 * This is a map of UI features that are enabled for the combined experiment.
			 * for example:
			 * {
			 * 	uiFeature1: true,
			 * 	uiFeature2: false,
			 * }
			 */ uiFeatures: layer.get('uiFeatures', {}),
            controlId: layer.get('controlId', 'default'),
            enabled: layer.get('enabled', false)
        };
        return layerValues;
    } catch (error) {
        onError?.(error);
    }
};
const $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName, resolveLayerValues = $f62b6f09dac42d3d$export$3178593b0bf95121)=>{
    const isPremium = (0, $c6GJD.default).checkGate(featureGateName);
    if (isPremium) return resolveLayerValues(premiumLayerName);
    return resolveLayerValues(standardLayerName);
};
const $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig = (onErrorFn, resolveLayerValues = $f62b6f09dac42d3d$export$3178593b0bf95121)=>{
    try {
        const allLayers = [];
        const layer1 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer1);
        const layer2 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer2);
        const layer2Blending = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
        allLayers.push(layer2Blending);
        const isLayer3Enabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
        if (isLayer3Enabled) {
            const layer3 = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER));
            allLayers.push(layer3);
        }
        const isQueryExpansionLayerEnabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
        if (isQueryExpansionLayerEnabled) {
            const layerQueryExpansion = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
            allLayers.push(layerQueryExpansion);
        }
        const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
        const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
        return {
            experimentId: concatenatedExperimentId,
            shadowExperimentId: concatenatedShadowExperimentId,
            experimentLayers: allLayers
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return 0, $4OGlb.DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};
const $f62b6f09dac42d3d$var$isEnrolledInMutuallyExclusiveUIExperiment = (experience)=>{
    const isEnrolledInQuickFindUIExperiment = (0, $c6GJD.default).getLayerValue((0, $4OGlb.STATSIG_QUICK_FIND_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    const isEnrolledInSearchPageUIExperiment = (0, $c6GJD.default).getLayerValue((0, $4OGlb.STATSIG_FULL_PAGE_SEARCH_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    return experience === 'quick-find' && isEnrolledInQuickFindUIExperiment || experience === 'search-page' && isEnrolledInSearchPageUIExperiment;
};
const $f62b6f09dac42d3d$var$applyBackendExperimentOverrides = (backendExperiment, backendExperimentOverrides)=>{
    // Handle undefined backendExperiment by creating a minimal experiment with empty layers
    const experiment = backendExperiment || {
        experimentLayers: []
    };
    const shouldApplyOverrides = (0, $dh538.fg)('enable_rovo_search_overrides') && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return backendExperiment;
    return {
        ...experiment,
        experimentLayers: (0, $2hfy2.mergeBackendExperimentLayerOverrides)(experiment.experimentLayers ?? [], backendExperimentOverrides ?? [])
    };
};
/**
 * Helper function to apply overrides when normal experiment flow is not applicable.
 * Returns undefined if no overrides are provided, otherwise applies overrides to the backend experiment.
 */ const $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined = (experimentConfig, backendExperimentOverrides)=>{
    const shouldApplyOverrides = (0, $dh538.fg)('enable_rovo_search_overrides') && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return undefined;
    return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides(experimentConfig.backendExperiment, backendExperimentOverrides);
};
const $f62b6f09dac42d3d$export$9009723727c24828 = ({ experimentConfig: experimentConfig, entities: entities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, backendExperimentOverrides: backendExperimentOverrides, getLayerValuesFn: getLayerValuesFn })=>{
    if (experimentConfig.combinedExperiment?.enabled) return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapCombinedLayerExperiment)({
        combinedExperiment: experimentConfig.combinedExperiment
    }), backendExperimentOverrides);
    if (!experimentConfig.dynamicExperiments) return $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    if ($f62b6f09dac42d3d$var$isEnrolledInMutuallyExclusiveUIExperiment(experience)) return $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    const requestedEntities = entities.flatMap((entity)=>{
        try {
            const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $6yCpa.Ati).parse(entity);
            return [
                {
                    entity: resourceOwner,
                    subEntity: resourceType.toUpperCase()
                }
            ];
        } catch  {
            return [];
        }
    });
    // Skip layer exposure when overrides are enabled and there are overrides
    const skipLayerExposure = (0, $dh538.fg)('enable_rovo_search_overrides') && Boolean(backendExperimentOverrides?.length);
    const fireLayerExposure = !skipLayerExposure;
    const experimentParams = $f62b6f09dac42d3d$export$f0d0c69a221c32ee(undefined, fireLayerExposure, getLayerValuesFn);
    if (experimentParams?.mutualExclusion) return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapMutuallyExclusiveExperiment)({
        experimentParams: experimentParams,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    }), backendExperimentOverrides);
    return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapDynamicExperiments)({
        dynamicExperiments: experimentConfig.dynamicExperiments,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters,
        fireLayerExposure: fireLayerExposure,
        getLayerValuesFn: getLayerValuesFn
    }), backendExperimentOverrides);
};
module.exports["getBackendExperimentConfig"] = $f62b6f09dac42d3d$export$2f6c9ab85be44d1a;
module.exports["getLayerValues"] = $f62b6f09dac42d3d$export$3178593b0bf95121;
module.exports["getCombinedLayerValues"] = $f62b6f09dac42d3d$export$ad31a6212fa2b02c;
module.exports["getBackendExperiment"] = $f62b6f09dac42d3d$export$9009723727c24828;

});

parcelRegister("dbl1i", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $de7a36fee3572948$var$experimentExperienceEnum = (0, $gLLcz.z).enum([
    'search-page',
    'quick-find',
    'search-page-space-filter',
    'quick-search',
    'advanced-search',
    'sain'
]);
const $de7a36fee3572948$var$linkedEntityGranularityEnum = (0, $gLLcz.z).enum([
    'ALL_MATCHING_MESSAGES',
    'DEFAULT',
    'FULL_THREAD',
    'ONLY_LINKED_ENTITIES'
]);
const $de7a36fee3572948$var$layerFunctionBaseSchema = {
    layerType: (0, $gLLcz.z).string().startsWith('search_platform_layer_').optional(),
    entity: (0, $gLLcz.z).string().optional(),
    subEntity: (0, $gLLcz.z).string().optional(),
    hello: (0, $gLLcz.z).boolean().optional(),
    isJiraIssueIndexed: (0, $gLLcz.z).boolean().optional(),
    linkedEntityGranularity: $de7a36fee3572948$var$linkedEntityGranularityEnum.optional(),
    confluenceTier: (0, $gLLcz.z).string().array().optional(),
    productDataRegions: (0, $gLLcz.z).record((0, $gLLcz.z).string(), (0, $gLLcz.z).string().array()).optional(),
    experiences: $de7a36fee3572948$var$experimentExperienceEnum.array().optional(),
    tenantIds: (0, $gLLcz.z).string().array().optional(),
    targetingGateId: (0, $gLLcz.z).string().optional(),
    providerId: (0, $gLLcz.z).string().optional(),
    connectorSources: (0, $gLLcz.z).array((0, $gLLcz.z).string()).optional(),
    integrationAri: (0, $gLLcz.z).string().optional()
};
const $de7a36fee3572948$var$layerFunction = (0, $gLLcz.z).object($de7a36fee3572948$var$layerFunctionBaseSchema);
const $de7a36fee3572948$var$dynamicConfigSchema = (0, $gLLcz.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $gLLcz.z).NEVER;
    }
}).pipe((0, $gLLcz.z).object({
    ...$de7a36fee3572948$var$layerFunctionBaseSchema,
    statsigLayerId: (0, $gLLcz.z).string().startsWith('search_platform_')
}));
const $de7a36fee3572948$var$mutuallyExclusiveDynamicConfigSchema = (0, $gLLcz.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $gLLcz.z).NEVER;
    }
}).pipe((0, $gLLcz.z).object({
    ...$de7a36fee3572948$var$layerFunctionBaseSchema,
    layerId: (0, $gLLcz.z).string(),
    controlId: (0, $gLLcz.z).string().optional()
}));
const $de7a36fee3572948$export$4b5312b6cfd0d20a = (0, $gLLcz.z).array((0, $gLLcz.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$de7a36fee3572948$var$dynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
const $de7a36fee3572948$export$e1f2182538b46e4b = (0, $gLLcz.z).array((0, $gLLcz.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$de7a36fee3572948$var$mutuallyExclusiveDynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
module.exports["dynamicExperimentsSchema"] = $de7a36fee3572948$export$4b5312b6cfd0d20a;
module.exports["mutuallyExclusiveBackendSearchLogicParametersSchema"] = $de7a36fee3572948$export$e1f2182538b46e4b;

});

parcelRegister("2hfy2", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4OGlb = parcelRequire("4OGlb");


var $hm6w9 = parcelRequire("hm6w9");

const $c517901dc1a94583$var$WILDCARD = '*';
const $c517901dc1a94583$var$JIRA_ENTITY = 'jira';
const $c517901dc1a94583$export$8dc0dcff4d3bde7a = ({ combinedExperiment: combinedExperiment })=>{
    if (combinedExperiment) {
        const experimentLayers = [
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_NAME),
                combinedExperiment.l1Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_NAME),
                combinedExperiment.l2Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER_NAME),
                combinedExperiment.l3Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME),
                combinedExperiment.qrId
            ]
        ];
        return {
            experimentLayers: experimentLayers.map(([layerType, layerId])=>{
                let entity = $c517901dc1a94583$var$WILDCARD;
                if (layerType === (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_NAME)) entity = combinedExperiment.l1Entity ?? $c517901dc1a94583$var$WILDCARD;
                if (layerType === (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_NAME)) entity = combinedExperiment.l2Entity ?? $c517901dc1a94583$var$WILDCARD;
                return {
                    name: layerType,
                    layerId: null,
                    shadowId: null,
                    definitions: [
                        {
                            layerId: layerId,
                            shadowId: null,
                            entity: entity,
                            subEntity: $c517901dc1a94583$var$WILDCARD,
                            abTestId: combinedExperiment.abTestId ?? null
                        }
                    ],
                    analyticsDefinitions: [
                        {
                            layerId: layerId,
                            shadowId: null,
                            entity: entity,
                            subEntity: $c517901dc1a94583$var$WILDCARD,
                            abTestId: combinedExperiment.abTestId ?? null,
                            controlId: combinedExperiment.controlId ?? null
                        }
                    ]
                };
            })
        };
    }
    return {
        experimentLayers: []
    };
};
const $c517901dc1a94583$var$getLayersRelevantToSearchRequest = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    return dynamicExperiments.filter($c517901dc1a94583$var$containsTenantId(tenantId)).filter($c517901dc1a94583$export$647cb61786ce5ae0(productEdition)).filter($c517901dc1a94583$var$containsExperience(experience)).filter($c517901dc1a94583$var$isHelloTenant(isHello)).filter($c517901dc1a94583$var$containsRequestedEntities(requestedEntities)).filter($c517901dc1a94583$var$containsRequestedSubEntities(requestedEntities)).filter($c517901dc1a94583$export$273a58382ea22085(thirdPartyFilters)).filter($c517901dc1a94583$var$isJiraIssueIndexedConditionSatisfied(isJiraIssueIndexed)).filter($c517901dc1a94583$var$isLinkedEntityGranularityConditionSatisfied(linkedEntityGranularity)).filter($c517901dc1a94583$var$passesTargetingGate()).filter($c517901dc1a94583$var$satisfiesProductDataRegions(productDataRegions)).reduce((layerFunctions, currentLayerFunction)=>{
        // IF there are more than one definitions with the same definition
        // THEN only add the first one defined, (do not add this one)
        const containsCollision = layerFunctions.find((layerFunction)=>{
            if ((0, $dh538.fg)('rovo_3p_exp_targeting')) /**
					 * This isn't perfect either because there can be some edge cases where
					 * an experiment definition is included, but not used. e.g.
					 * - Defitions we have are:
					 * 			[entity: confluence, subEntity: page],
					 * 			[entity: confluence, subEntity: *]
					 * - The request is for entity: confluence, subEntity: page
					 *
					 * Both definitions would be included in the final list, but only the
					 * first would ever be used, but we fire exposures for both.
					 *
					 * To fix this, we would need to do one of the following:
					 * - Replicate all of the fan out logic here (ugly and hard to maintain),
					 *   so we know exactly which experiment definitions will get used
					 * - Fire experiment exposures in the backend
					 */ return layerFunction.layerType === currentLayerFunction.layerType && layerFunction.entity === currentLayerFunction.entity && layerFunction.subEntity === currentLayerFunction.subEntity && layerFunction.integrationAri === currentLayerFunction.integrationAri && layerFunction.providerId === currentLayerFunction.providerId && JSON.stringify(layerFunction.connectorSources?.sort()) === JSON.stringify(currentLayerFunction.connectorSources?.sort());
            else /**
					 * I think there's a bug here, what if:
					 * - layerFunctions contains
					 * 			[entity: graph, subEntity: video]
					 * 			[entity: graph, subEntity: *]
					 * - The request is for entities:
					 * 			ati:cloud:graph:design
					 * 			ati:cloud:graph:video
					 *
					 * Only the first definition would get included, but both would have
					 * been used after the 3P requests are fanned out.
					 */ return layerFunction.layerType === currentLayerFunction.layerType && (layerFunction.entity === currentLayerFunction.entity || currentLayerFunction.entity === $c517901dc1a94583$var$WILDCARD || layerFunction.entity === $c517901dc1a94583$var$WILDCARD) && (layerFunction.subEntity === currentLayerFunction.subEntity || currentLayerFunction.subEntity === $c517901dc1a94583$var$WILDCARD || layerFunction.subEntity === $c517901dc1a94583$var$WILDCARD);
        });
        return containsCollision ? layerFunctions : [
            ...layerFunctions,
            currentLayerFunction
        ];
    }, []);
};
const $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions = (experiments)=>{
    return experiments.reduce((experimentLayers, definitionWithLayerType)=>{
        const existingLayer = experimentLayers.find((layer)=>layer.name === definitionWithLayerType.layerType);
        const { controlId: _controlId, statsigLayerId: _statsigLayerId, ...newDefinition } = definitionWithLayerType.definition;
        const analyticsDefinition = {
            ...definitionWithLayerType.definition
        };
        if (!existingLayer) {
            experimentLayers.push({
                name: definitionWithLayerType.layerType,
                layerId: null,
                shadowId: null,
                definitions: [
                    newDefinition
                ],
                analyticsDefinitions: [
                    analyticsDefinition
                ]
            });
            return experimentLayers;
        }
        existingLayer.definitions?.push(newDefinition);
        existingLayer.analyticsDefinitions?.push(analyticsDefinition);
        return experimentLayers;
    }, []);
};
const $c517901dc1a94583$export$10532bc904a76c69 = ({ experimentParams: experimentParams, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    const dynamicExperiments = experimentParams?.layerFunctions || [];
    const { abTestId: abTestId } = experimentParams || {
        abTestId: null
    };
    const relevantExperiments = $c517901dc1a94583$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        return {
            definition: {
                layerId: dynamicExp.layerId,
                shadowId: null,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                controlId: dynamicExp.controlId ?? null,
                statsigLayerId: null,
                ...(0, $dh538.fg)('rovo_3p_exp_targeting') ? {
                    providerId: dynamicExp.providerId,
                    integrationARI: dynamicExp.integrationAri,
                    connectorSources: dynamicExp.connectorSources
                } : {}
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions(experiments)
    };
};
const $c517901dc1a94583$export$b9a99705ca4e42b9 = (experimentLayers, overrides)=>{
    const mergedLayers = experimentLayers.map((l)=>({
            ...l,
            // ensure that definitions and analyticsDefinitions have an array
            definitions: l.definitions ? [
                ...l.definitions
            ] : [],
            analyticsDefinitions: l.analyticsDefinitions ? [
                ...l.analyticsDefinitions
            ] : []
        }));
    for (const override of overrides){
        const overrideDefinitions = override.analyticsDefinitions ?? [];
        if (overrideDefinitions.length === 0) continue;
        const layer = mergedLayers.find((l)=>l.name === override.name);
        if (!layer) {
            // Remove controlId from definitions since they're for request payloads
            const requestDefinitions = overrideDefinitions.map(({ controlId: _controlId, ...def })=>def);
            mergedLayers.push({
                name: override.name,
                layerId: null,
                shadowId: null,
                definitions: requestDefinitions,
                analyticsDefinitions: [
                    ...overrideDefinitions
                ]
            });
            continue;
        }
        for (const overrideDef of overrideDefinitions){
            const keyEntity = overrideDef.entity ?? null;
            const keySubEntity = overrideDef.subEntity ?? null;
            const analyticsIndex = layer.analyticsDefinitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (analyticsIndex >= 0) layer.analyticsDefinitions[analyticsIndex] = overrideDef;
            else layer.analyticsDefinitions.push(overrideDef);
            const { controlId: _controlId, ...requestDef } = overrideDef;
            const requestIndex = layer.definitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (requestIndex >= 0) layer.definitions[requestIndex] = requestDef;
            else layer.definitions.push(requestDef);
        }
    }
    return mergedLayers;
};
const $c517901dc1a94583$export$37bc8313287bf4ea = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, fireLayerExposure: fireLayerExposure = true, getLayerValuesFn: getLayerValuesFn = (0, $hm6w9.getLayerValues) })=>{
    const relevantExperiments = $c517901dc1a94583$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        const { layerId: layerId, shadowId: shadowId, abTestId: abTestId, controlId: controlId } = getLayerValuesFn(dynamicExp.statsigLayerId, fireLayerExposure ? undefined : {
            fireLayerExposure: false
        });
        return {
            definition: {
                layerId: layerId,
                shadowId: shadowId,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                controlId: controlId,
                statsigLayerId: dynamicExp.statsigLayerId,
                ...(0, $dh538.fg)('rovo_3p_exp_targeting') ? {
                    providerId: dynamicExp.providerId,
                    integrationARI: dynamicExp.integrationAri,
                    connectorSources: dynamicExp.connectorSources
                } : {}
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions(experiments)
    };
};
const $c517901dc1a94583$export$647cb61786ce5ae0 = (productEdition)=>(dynamicExp)=>{
        // Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
        if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) return true;
        return !!dynamicExp.confluenceTier?.find((experimentTier)=>productEdition?.['confluence'] === experimentTier);
    };
const $c517901dc1a94583$var$isHelloTenant = (isHello)=>(dynamicExp)=>{
        if (dynamicExp.hello === undefined || dynamicExp.hello === null) return true;
        return dynamicExp.hello === isHello;
    };
const $c517901dc1a94583$var$passesTargetingGate = ()=>(dynamicExp)=>{
        if (dynamicExp.targetingGateId === undefined || dynamicExp.targetingGateId === null) return true;
        // eslint-disable-next-line @atlaskit/platform/static-feature-flags
        return (0, $dh538.fg)(dynamicExp.targetingGateId);
    };
/**
 * This is specifically used for targeting based on indexing status of the tenant.
 * This might NOT be needed once Jira indexed and ROVO in Jira is shipped to 100%
 */ const $c517901dc1a94583$var$isJiraIssueIndexedConditionSatisfied = (isJiraIssueIndexed)=>(dynamicExp)=>{
        if (isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === null || dynamicExp?.entity !== $c517901dc1a94583$var$JIRA_ENTITY) return true;
        return dynamicExp.isJiraIssueIndexed === isJiraIssueIndexed;
    };
const $c517901dc1a94583$var$isLinkedEntityGranularityConditionSatisfied = (linkedEntityGranularity)=>(dynamicExp)=>{
        if (linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === null) return true;
        return dynamicExp.linkedEntityGranularity === linkedEntityGranularity;
    };
const $c517901dc1a94583$var$containsRequestedEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.entity || dynamicExp.entity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredEntity = entityFilter.find((filteredEntity)=>dynamicExp.entity === filteredEntity.entity);
        return isFilteredEntity ?? false;
    };
const $c517901dc1a94583$var$containsRequestedSubEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.subEntity || dynamicExp.subEntity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredSubEntity = entityFilter.find((filteredEntity)=>dynamicExp.subEntity === filteredEntity.subEntity);
        return isFilteredSubEntity ?? false;
    };
/**
 * Determines whether the provided data regions (dataRegions) are defined in
 * the dynamic configuration (dynamicExp). Every data region for a given product
 * in the dynamic configuration must be specified  in order for the given
 * experiment layer to be eligible.
 *
 * @param dataRegions Represents where the data comes from comes from for
 * each product.
 * ```
 * { 'confluence': ["us-west-2"], 'compass': ["us-east-1"] }`
 * ```
 *
 * @returns a boolean that indicates whether or not the provided data regions
 * (dataRegions) are specified in the dynamic configuration (dynamicExp).
 */ const $c517901dc1a94583$var$satisfiesProductDataRegions = (dataRegions)=>(dynamicExp)=>{
        if (!dynamicExp.productDataRegions) return true;
        return Object.keys(dynamicExp.productDataRegions).map((product)=>{
            const productDataRegions = dynamicExp.productDataRegions?.[product];
            const isProductEligible = dataRegions?.[product]?.every((dataRegion)=>{
                return productDataRegions?.includes(dataRegion);
            });
            return !!isProductEligible;
        }).reduce((prev, curr)=>prev && curr);
    };
const $c517901dc1a94583$var$containsExperience = (experience)=>(dynamicExp)=>{
        if (!dynamicExp.experiences || dynamicExp.experiences.length === 0) return true;
        return dynamicExp.experiences?.find((dynamicExpExperience)=>experience === dynamicExpExperience);
    };
const $c517901dc1a94583$var$containsTenantId = (tenantId)=>(dynamicExp)=>{
        if (!dynamicExp.tenantIds || dynamicExp.tenantIds.length === 0) return true;
        return dynamicExp.tenantIds?.find((dynamicExpTenantId)=>tenantId === dynamicExpTenantId);
    };
const $c517901dc1a94583$export$273a58382ea22085 = (thirdPartyFilters)=>(dynamicExp)=>{
        if (!dynamicExp.connectorSources?.length && !dynamicExp.providerId && !dynamicExp.integrationAri) return true;
        if (!thirdPartyFilters?.thirdPartyProducts) return false;
        if (!(0, $dh538.fg)('rovo_3p_exp_targeting')) return false;
        const providerIdExp = dynamicExp.providerId ?? $c517901dc1a94583$var$WILDCARD;
        const integrationAriExp = dynamicExp.integrationAri ?? $c517901dc1a94583$var$WILDCARD;
        const connectorSourceExp = dynamicExp.connectorSources;
        const matches3pTarget = thirdPartyFilters.thirdPartyProducts.find((thirdPartyProduct)=>{
            // https://atlassian.slack.com/archives/C08CGNZTMC2/p1756690283247959
            const containsConnectorSource = thirdPartyProduct.connectorSources?.find((connectorSourceFromConfig)=>connectorSourceExp?.find((connectorSourceFromExp)=>connectorSourceFromExp === connectorSourceFromConfig));
            const matchesProviderId = providerIdExp === $c517901dc1a94583$var$WILDCARD || providerIdExp === thirdPartyProduct.providerId;
            const matchesIntegrationAri = integrationAriExp === $c517901dc1a94583$var$WILDCARD || integrationAriExp === thirdPartyProduct.integrationId;
            return matchesProviderId && matchesIntegrationAri && (!connectorSourceExp || Boolean(containsConnectorSource) // !connectorSources = wildcard
            );
        });
        return Boolean(matches3pTarget);
    };
module.exports["mapCombinedLayerExperiment"] = $c517901dc1a94583$export$8dc0dcff4d3bde7a;
module.exports["mapMutuallyExclusiveExperiment"] = $c517901dc1a94583$export$10532bc904a76c69;
module.exports["mergeBackendExperimentLayerOverrides"] = $c517901dc1a94583$export$b9a99705ca4e42b9;
module.exports["mapDynamicExperiments"] = $c517901dc1a94583$export$37bc8313287bf4ea;

});

parcelRegister("lt6Lx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $aXWIB.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { siteTitle: siteTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence")
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix) {
        // If both contentTitle and titlePrefix are empty, we're likely setting a generic title
        // (just siteTitle or siteTitle with space). If there's already a more specific title
        // (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title && !isHomePage) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("3tUdX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dppWL = parcelRequire("dppWL");


var $amW67 = parcelRequire("amW67");


var $8hjAS = parcelRequire("8hjAS");

const $f4bf02d66e85d52a$export$44a9046b553a8167 = (props)=>{
    if (props.experience === (0, $dppWL.RegisteredExperience).WHITEBOARD && !(0, $dppWL.isWhiteboardRovoConfigProviderProps)(props)) return null;
    if ((props.experience === (0, $dppWL.RegisteredExperience).VIEW_PAGE || props.experience === (0, $dppWL.RegisteredExperience).EDIT_PAGE) && !(0, $dppWL.isPageRovoConfigProviderProps)(props)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amW67.RovoConfigProviderContextProvider), {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hjAS.RovoCurrentConfigProvider), {
        provider: props.provider
    }));
};
module.exports["RovoConfigProvider"] = $f4bf02d66e85d52a$export$44a9046b553a8167;

});

parcelRegister("dppWL", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ var $56fbda2769629a59$export$50526ee9b1846f6c = /*#__PURE__*/ function(RegisteredExperience) {
    RegisteredExperience["VIEW_PAGE"] = "view-page";
    RegisteredExperience["EDIT_PAGE"] = "edit-page";
    RegisteredExperience["WHITEBOARD"] = "whiteboard";
    RegisteredExperience["SEARCH_PAGE"] = "search-page";
    return RegisteredExperience;
}({});
const $56fbda2769629a59$export$1e3f84bae31640f2 = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$9fdd72360ade08c0 = (props)=>'contentType' in props;
const $56fbda2769629a59$export$b8a252bbcf90a2cb = (props)=>'getSearchQuery' in props;
module.exports["RegisteredExperience"] = $56fbda2769629a59$export$50526ee9b1846f6c;
module.exports["isWhiteboardRovoConfigProviderProps"] = $56fbda2769629a59$export$1e3f84bae31640f2;
module.exports["isPageRovoConfigProviderProps"] = $56fbda2769629a59$export$9fdd72360ade08c0;

});

parcelRegister("amW67", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $23a8183fa434531d$var$RovoConfigProviderContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $23a8183fa434531d$export$3ae1f97e9390a638 = ()=>{
    const context = (0, $42omo.useContext)($23a8183fa434531d$var$RovoConfigProviderContext);
    if (!context) throw new Error('useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider');
    return context;
};
const $23a8183fa434531d$export$45b0916bb24b31be = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23a8183fa434531d$var$RovoConfigProviderContext.Provider, {
        value: value
    }, children);
};
module.exports["useRovoConfigProviderProps"] = $23a8183fa434531d$export$3ae1f97e9390a638;
module.exports["RovoConfigProviderContextProvider"] = $23a8183fa434531d$export$45b0916bb24b31be;

});

parcelRegister("8hjAS", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $8MKuN = parcelRequire("8MKuN");


var $6mKj3 = parcelRequire("6mKj3");


var $5ruin = parcelRequire("5ruin");

const $4d3968fc98119c84$export$9ef355ca939f0be9 = ({ provider: provider })=>{
    const { resetConfiguration: resetConfiguration, setConfiguration: setConfiguration } = (0, $5ruin.useRovoCurrentConfigStoreActions)();
    (0, $42omo.useEffect)(()=>{
        if (!provider) resetConfiguration();
        return ()=>{
            resetConfiguration();
        };
    }, [
        resetConfiguration,
        provider
    ]);
    if (!provider) return null;
    const ActiveProviderComponent = provider;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "rovo-current-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ActiveProviderComponent, {
        setConfiguration: setConfiguration
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
};
module.exports["RovoCurrentConfigProvider"] = $4d3968fc98119c84$export$9ef355ca939f0be9;

});

parcelRegister("8MKuN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $b1Jpy = parcelRequire("b1Jpy");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $42omo.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $4u5NT.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("5ruin", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $1P1Tu.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $9zUhf.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;

});

parcelRegister("dIdGO", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");

const $74bc7b529e0c42f5$var$i18nBase = (0, $aXWIB.defineMessages)({
    header: {
        id: "advanced-search.header",
        defaultMessage: "Search"
    },
    textFieldLabel: {
        id: "advanced-search.textfield.label",
        defaultMessage: "Search in Confluence"
    },
    textFieldPlaceholder: {
        id: "advanced-search.textfield.placeholder",
        defaultMessage: "Enter keywords to find pages, attachments, and more"
    },
    searchIconLabel: {
        id: "advanced-search.textfield.search.icon.label",
        defaultMessage: "Search icon"
    },
    crossIconLabel: {
        id: "advanced-search.textfield.cross.icon.label",
        defaultMessage: "Clear search bar"
    },
    clearFilterButtonText: {
        id: "advanced-search.clear.filter.button.text",
        defaultMessage: "Clear all"
    },
    skipToSearchField: {
        id: "advanced-search.search.skip.text.link",
        defaultMessage: "Jump back to search field"
    },
    landingPageHeader: {
        id: "advanced-search.search.result.landing.page.header",
        defaultMessage: "Find what you need in Confluence"
    },
    landingPageText: {
        id: "advanced-search.search.result.landing.page.text",
        defaultMessage: "Ask a question and get an answer in search"
    },
    resultNoResultHeader: {
        id: "advanced-search.search.result.no.result.header",
        defaultMessage: "We couldn\u2019t find any matches for your search."
    },
    resultNoResultSuggestion: {
        id: "advanced-search.search.result.no.result.suggestion",
        defaultMessage: "Try different keywords, fewer of them, or ones that are more general."
    },
    resultLastModifiedContent: {
        id: "advanced-search.search.result.content.lastmodified",
        defaultMessage: "Updated"
    },
    resultLastModifiedAttachment: {
        id: "advanced-search.search.result.attachment.lastmodified",
        defaultMessage: "Uploaded"
    },
    searchFilterSpace: {
        id: "advanced-search.filter.space.label",
        defaultMessage: "Space"
    },
    searchFilterContentUnderAncestor: {
        id: "advanced-search.filter.content.ancestor.label",
        defaultMessage: "Content under"
    },
    searchFilterMore: {
        id: "advanced-search.filter.more.label",
        defaultMessage: "More filters"
    },
    searchFilterArchivedContent: {
        id: "advanced-search.filter.archivedContent.label",
        defaultMessage: "Archived content"
    },
    searchContentFilterAncestorPlaceholder: {
        id: "advanced-search.filter.ancestor.placeholder",
        defaultMessage: "Select content nested under"
    },
    searchFilterAncestorRecentPages: {
        id: "advanced-search.filter.ancestor.recentpages",
        defaultMessage: "Recent pages"
    },
    searchFilterContributor: {
        id: "advanced-search.filter.contributor.label",
        defaultMessage: "Edited or created by"
    },
    searchFilterLabels: {
        id: "advanced-search.filter.labels.label",
        defaultMessage: "Labels"
    },
    searchFilterType: {
        id: "advanced-search.filter.type.label",
        defaultMessage: "Type"
    },
    searchFilterVerified: {
        id: "advanced-search.filter.verified.label",
        defaultMessage: "Verified"
    },
    typePlaceholder: {
        id: "advanced-search.type.placeholder",
        defaultMessage: "Filter by type"
    },
    typePage: {
        id: "advanced-search.type.page",
        defaultMessage: "Pages"
    },
    typeBlogpost: {
        id: "advanced-search.type.blogpost",
        defaultMessage: "Blog posts"
    },
    typeAttachment: {
        id: "advanced-search.type.attachment",
        defaultMessage: "Attachments"
    },
    typeSpace: {
        id: "advanced-search.type.space",
        defaultMessage: "Spaces"
    },
    typeWhiteboard: {
        id: "advanced-search.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    typeDatabase: {
        id: "advanced-search.type.database",
        defaultMessage: "Databases"
    },
    typeSlide: {
        id: "advanced-search.type.slide",
        defaultMessage: "Slides"
    },
    typeEmbed: {
        id: "advanced-search.type.embed",
        defaultMessage: "Smart Links"
    },
    typeComments: {
        id: "advanced-search.type.comments",
        defaultMessage: "Comments"
    },
    typeFolder: {
        id: "advanced-search.type.folders",
        defaultMessage: "Folders"
    },
    searchFilterTitle: {
        id: "advanced-search.filter.title.label",
        defaultMessage: "Search titles only"
    },
    searchFilterArchived: {
        id: "advanced-search.filter.archived.label",
        defaultMessage: "Show archived content"
    },
    paginationLoadMoreButton: {
        id: "advanced-search.load.more.text",
        defaultMessage: "Load more"
    },
    spaceFilterPlaceholder: {
        id: "advanced-search.space.filter.placeholder",
        defaultMessage: "Find a space"
    },
    userFilterPlaceholder: {
        id: "advanced-search.user.filter.placeholder",
        defaultMessage: "Find a person"
    },
    labelFilterPlaceholder: {
        id: "advanced-search.label.filter.placeholder",
        defaultMessage: "Find a label"
    },
    ancestorFilterPlaceholder: {
        id: "advanced-search.label.content.placeholder",
        defaultMessage: "Search content"
    },
    verifiedFilterPlaceholder: {
        id: "advanced-search.verified.filter.placeholder",
        defaultMessage: "Find verified content"
    },
    numberOfResults: {
        id: "advanced-search.number.results",
        defaultMessage: "Showing {numberOfResults, number} of {totalCount, number} results"
    },
    searchFilterLabelsNoText: {
        id: "advanced-search.labels.filter.no.text",
        defaultMessage: "Start typing to search for a label"
    },
    dateFilterTitle: {
        id: "advanced-search.date.filter.title",
        defaultMessage: "Last updated"
    },
    dateFilterFromTitle: {
        id: "advanced-search.date.filter.from.title",
        defaultMessage: "From"
    },
    dateFilterToTitle: {
        id: "advanced-search.date.filter.to.title",
        defaultMessage: "To"
    },
    dateFilterDateInputPlaceholder: {
        id: "advanced-search.date.filter.input.placeholder",
        defaultMessage: "Choose a date"
    },
    dateFilterAnyTime: {
        id: "advanced-search.date.filter.any.time",
        defaultMessage: "Anytime"
    },
    dateFilterToday: {
        id: "advanced-search.date.filter.today",
        defaultMessage: "Today"
    },
    dateFilterYesterday: {
        id: "advanced-search.date.filter.yesterday",
        defaultMessage: "Yesterday"
    },
    dateFilterLastWeek: {
        id: "advanced-search.date.filter.last.week",
        defaultMessage: "Past 7 days"
    },
    dateFilterLastMonth: {
        id: "advanced-search.date.filter.last.month",
        defaultMessage: "Past 30 days"
    },
    dateFilterLastYear: {
        id: "advanced-search.date.filter.last.year",
        defaultMessage: "Past year"
    },
    dateFilterCustom: {
        id: "advanced-search.date.filter.custom",
        defaultMessage: "Custom"
    },
    dateFilterCustomInvalidDateAfterToday: {
        id: "advanced-search.date.filter.custom.invalid.after.today",
        defaultMessage: "The From date can\u2019t be in the future"
    },
    dateFilterCustomInvalidToDateAfterToday: {
        id: "advanced-search.date.filter.custom.invalid.to.after.today",
        defaultMessage: "The To date can\u2019t be in the future"
    },
    dateFilterCustomInvalidDateAfterEnd: {
        id: "advanced-search.date.filter.custom.invalid.after.end",
        defaultMessage: "The From date has to be before the To date"
    },
    dateFilterToRange: {
        id: "advanced-search.date.filter.to.range",
        defaultMessage: "to"
    },
    dateFilterUpdateButton: {
        id: "advanced-search.date.filter.update.button",
        defaultMessage: "Update"
    },
    dateFilterBeforeLabel: {
        id: "advanced-search.date.filter.before.label",
        defaultMessage: "before"
    },
    dateFilterAfterLabel: {
        id: "advanced-search.date.filter.after.label",
        defaultMessage: "after"
    },
    selectorErrorMessage: {
        id: "advanced-search.filter.generic.error-message",
        defaultMessage: "Something went wrong."
    },
    xpsErrorHeader: {
        id: "advanced-search.search.result.xps.error.header",
        defaultMessage: "We\u2019re having trouble getting your results"
    },
    xpsErrorSuggestion: {
        id: "advanced-search.search.result.xps.error.suggestion",
        defaultMessage: "{link} and try again."
    },
    xpsErrorSuggestionLink: {
        id: "advanced-search.search.result.xps.error.suggestion.link",
        defaultMessage: "Refresh the page"
    },
    feedbackButton: {
        id: "advanced-search.search.feedback.button",
        defaultMessage: "Give feedback"
    },
    selectedLabel: {
        id: "advanced-search.search.selected.label",
        defaultMessage: "Selected"
    },
    suggestedLabel: {
        id: "advanced-search.search.suggested.label",
        defaultMessage: "Suggested"
    },
    resultsLabel: {
        id: "advanced-search.search.results.label",
        defaultMessage: "Results"
    },
    recentLabel: {
        id: "advanced-search.search.recent.label",
        defaultMessage: "Recent"
    },
    disabledSearchTitleOnlyTooltipMessage: {
        id: "advanced-search.search.disabled.search.title.only.tooltip",
        defaultMessage: "To search by titles only, please input your search in the search bar."
    },
    askAIButton: {
        id: "advanced-search.search.askAI.button.text",
        defaultMessage: "Ask AI"
    },
    disabledAIButtonMessage: {
        id: "advanced-search.search.askAI.disabled.button.message",
        defaultMessage: "Ask a question in search to get an answer from Atlassian Intelligence"
    },
    spaceIconLabel: {
        id: "advanced-search.result.space.icon.label",
        defaultMessage: "Space logo for {spaceName}"
    }
});
const $74bc7b529e0c42f5$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    searchFilterAncestorRecentPages: {
        id: "advanced-search.filter.ancestor.recentpages.livedocs",
        defaultMessage: "Recent pages and live docs"
    },
    typePage: {
        id: "advanced-search.type.page.livedocs",
        defaultMessage: "Pages and live docs"
    }
});
const $74bc7b529e0c42f5$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($74bc7b529e0c42f5$var$i18nBase, $74bc7b529e0c42f5$var$i18nLiveDocs);
module.exports["i18n"] = $74bc7b529e0c42f5$export$a7357cdd1f0b0168;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("4ymXE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df727533991c4aac2a7e523738f16a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $350c2601c1bf73a9$var$_react = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("42omo")));

var $350c2601c1bf73a9$var$_baseNew = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $350c2601c1bf73a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $350c2601c1bf73a9$var$AiSearchIcon = (props)=>/*#__PURE__*/ $350c2601c1bf73a9$var$_react.default.createElement($350c2601c1bf73a9$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$350c2601c1bf73a9$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $350c2601c1bf73a9$var$_default = module.exports.default = $350c2601c1bf73a9$var$AiSearchIcon;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("4acD6", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $48675c89bdefef9d$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null
};
const $48675c89bdefef9d$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        }
};
const $48675c89bdefef9d$export$72552b26ebb37b2 = (0, $1P1Tu.createStore)({
    initialState: $48675c89bdefef9d$export$d4c72bab9d6cc13a,
    actions: $48675c89bdefef9d$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $48675c89bdefef9d$export$af36d029992e7a8c = (0, $9zUhf.createActionsHook)($48675c89bdefef9d$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $48675c89bdefef9d$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $48675c89bdefef9d$export$af36d029992e7a8c;

});

parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $4c47f75c6ef52bb8$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PULL_REQUEST_WITHOUT_PIPELINES_STARTERS"] = "bitbucket-pull-request-without-pipelines-starters";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $4c47f75c6ef52bb8$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $4c47f75c6ef52bb8$export$c91e07269f22915a;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $4c47f75c6ef52bb8$export$4f757e7d9540e8f9;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("ePNCU", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $04e9M = parcelRequire("04e9M");


var $j3rr0 = parcelRequire("j3rr0");

const $1421b08aaa3d561b$export$3f8d01317e97ea46 = (0, $2XqLN.default)(async (iframeDwell)=>{
    const DwellTimeHelper = await (0, $04e9M.getDwellTimeHelper)();
    const provideDwellTimeHelper = (sendDwellEvent, dwellData, searchSessionId)=>{
        return new DwellTimeHelper(sendDwellEvent, dwellData, searchSessionId, {}, {
            iframeDwell: iframeDwell
        });
    };
    return new (0, $j3rr0.DwellTimeTracker)(provideDwellTimeHelper);
});
module.exports["getDwellTimeTracker"] = $1421b08aaa3d561b$export$3f8d01317e97ea46;

});

parcelRegister("j3rr0", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $7W8i8 = parcelRequire("7W8i8");

const $c5cbdaf017f648e2$var$logger = (0, $7W8i8.getLogger)('DwellTimeTracker');
class $c5cbdaf017f648e2$export$3b0fcaf8cb0b1472 {
    /**
   *  Stops previous dwell timer if any and starts a new one.
   *  `callback` is called at every dwell milestones and when the timer is stopped
   **/ async startAny(data, callback) {
        this.startDwellTimeHelper(data, callback);
    }
    /**
   *  Same as `startAny()`, but for Confluence Page or Blog and other content types
   **/ async startContent(spaceId, contentId, contentType, callback, searchSessionId, additionalAnalytics) {
        const dwellData = this.getEventDataForContent(spaceId, contentId, contentType, additionalAnalytics);
        await this.startDwellTimeHelper(dwellData, callback, searchSessionId).catch((e)=>{
            throw e;
        });
    }
    /**
   *  Same as `startAny()`, but for Confluence Space Overview
   **/ async startSpace(spaceId, callback, searchSessionId, additionalAnalytics) {
        const dwellData = this.getEventDataForSpace(spaceId, additionalAnalytics);
        await this.startDwellTimeHelper(dwellData, callback, searchSessionId).catch((e)=>{
            throw e;
        });
    }
    /**
   *  Stops current timer and reports final dwell time
   **/ stop() {
        if (this.dwellTimeHelper) this.dwellTimeHelper.stop();
        else $c5cbdaf017f648e2$var$logger.error`Dwell was stopped before it can get started`;
    }
    async startDwellTimeHelper(dwellData, sendDwellEvent, searchSessionId) {
        try {
            if (!this.dwellTimeHelper) {
                this.dwellTimeHelper = this.provideDwellTimeHelper(this.onDwell, dwellData, searchSessionId);
                // We call stop just to make sure TimeMe.active is false and prevent the following error
                // "DwellTimeHelper should only be initialised once per page load.""
                // https://bitbucket.org/atlassian/analytics-web-client/src/aa020a05be67317714977ceed0221e5721f1a4eb/src/dwellTimeHelper.js#lines-78
                this.dwellTimeHelper.stop();
                this.dwellTimeHelper.start();
            } else this.dwellTimeHelper.newPage(dwellData, searchSessionId);
            this.dwellTimeCallback = sendDwellEvent;
        } catch (e) {
            $c5cbdaf017f648e2$var$logger.error`Failed to start dwell time`;
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: 'disco'
            });
            throw e;
        }
    }
    constructor(provideDwellTimeHelper){
        this.provideDwellTimeHelper = void 0;
        this.dwellTimeHelper = null;
        this.dwellTimeCallback = null;
        this.onDwell = (data)=>{
            if (this.dwellTimeCallback) this.dwellTimeCallback(data);
        };
        this.getEventDataForContent = (spaceId, contentId, contentType, additionalAnalytics = {})=>{
            const analyticsContentType = contentType === 'blogpost' ? 'page' : contentType;
            return {
                containerType: 'space',
                containerId: spaceId,
                objectType: analyticsContentType,
                objectId: contentId,
                source: analyticsContentType,
                actionSubject: analyticsContentType,
                actionSubjectId: contentId,
                attributes: {
                    ...additionalAnalytics
                }
            };
        };
        this.getEventDataForSpace = (spaceId, additionalAnalytics = {})=>({
                containerType: 'space',
                containerId: spaceId,
                source: 'space',
                actionSubject: 'space',
                actionSubjectId: spaceId,
                attributes: {
                    ...additionalAnalytics
                }
            });
        this.provideDwellTimeHelper = provideDwellTimeHelper;
    }
}
module.exports["DwellTimeTracker"] = $c5cbdaf017f648e2$export$3b0fcaf8cb0b1472;

});

parcelRegister("4TB09", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $56QzY = parcelRequire("56QzY");


var $1AV5C = parcelRequire("1AV5C");


var $jghB4 = parcelRequire("jghB4");


var $iD4ky = parcelRequire("iD4ky");


var $fGkN6 = parcelRequire("fGkN6");

const $ca535cb9442e6251$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    fireAnalytics: ()=>{},
    searchSessionId: ''
});
const $ca535cb9442e6251$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { searchSessionId: searchSessionId, createAnalyticsEvent: createAnalyticsEvent, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [commonAttributes, setCommonAttributes] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[1] = t2;
    } else t2 = $[1];
    const [privateAttributes, setPrivateAttributes] = (0, $42omo.useState)(t2);
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    let t3;
    let t4;
    if ($[2] !== activationId || $[3] !== searchInputs || $[4] !== searchSessionId) {
        t3 = ()=>{
            const { searchQuery: searchQuery, filters: filters, cql: cql } = searchInputs;
            const filterSelections = (0, $iD4ky.getOptionSelections)(filters);
            const filterCategories = (0, $iD4ky.transformFiltersForAnalytics)(filterSelections);
            const archivedStatus = filterSelections.some($ca535cb9442e6251$var$_temp) ? [
                (0, $jghB4.CURRENT),
                (0, $jghB4.ARCHIVED)
            ] : [
                (0, $jghB4.CURRENT)
            ];
            setCommonAttributes({
                searchSessionId: searchSessionId,
                numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
                queryLength: searchQuery.length,
                queryHash: (0, $1AV5C.hashData)(searchQuery),
                filters: filterCategories,
                filterSelections: filterSelections,
                containerStatuses: archivedStatus,
                contentStatuses: archivedStatus,
                activationId: activationId,
                version: 2,
                api: searchInputs.queryType === "CQLQuery" ? (0, $jghB4.CONFLUENCE_SEARCH_API) : (0, $jghB4.CROSSPRODUCT_SEARCH_API),
                navdexPointType: (0, $56QzY.TOUCH),
                wordCount: (searchQuery.match(/\w+/g) || []).length,
                isCQL: cql !== undefined
            });
            setPrivateAttributes({
                query: searchQuery
            });
        };
        t4 = [
            searchInputs,
            searchSessionId,
            activationId
        ];
        $[2] = activationId;
        $[3] = searchInputs;
        $[4] = searchSessionId;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[7] !== commonAttributes || $[8] !== createAnalyticsEvent || $[9] !== privateAttributes) {
        t5 = (t6)=>{
            const { type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, additionalAttributes: additionalAttributes } = t6;
            createAnalyticsEvent({
                type: type,
                data: {
                    source: "advancedSearchScreen",
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    nonPrivacySafeAttributes: privateAttributes,
                    attributes: {
                        ...commonAttributes,
                        ...additionalAttributes
                    }
                }
            }).fire();
        };
        $[7] = commonAttributes;
        $[8] = createAnalyticsEvent;
        $[9] = privateAttributes;
        $[10] = t5;
    } else t5 = $[10];
    const fireAnalytics = t5;
    let t6;
    if ($[11] !== fireAnalytics || $[12] !== searchSessionId) {
        t6 = {
            searchSessionId: searchSessionId,
            fireAnalytics: fireAnalytics
        };
        $[11] = fireAnalytics;
        $[12] = searchSessionId;
        $[13] = t6;
    } else t6 = $[13];
    const analyticsContextValue = t6;
    let t7;
    if ($[14] !== analyticsContextValue || $[15] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ca535cb9442e6251$export$83cd6c3eba7d8d9e.Provider, {
            value: analyticsContextValue
        }, children);
        $[14] = analyticsContextValue;
        $[15] = children;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ searchSessionId: searchSessionId, createAnalyticsEvent: createAnalyticsEvent, children: children })=>{
    const [commonAttributes, setCommonAttributes] = (0, $42omo.useState)({});
    const [privateAttributes, setPrivateAttributes] = (0, $42omo.useState)({});
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    (0, $42omo.useEffect)(()=>{
        const { searchQuery: searchQuery, filters: filters, cql: cql } = searchInputs;
        const filterSelections = (0, $iD4ky.getOptionSelections)(filters);
        const filterCategories = (0, $iD4ky.transformFiltersForAnalytics)(filterSelections);
        const archivedStatus = filterSelections.some((selection)=>selection.value === (0, $jghB4.OptionIds).ARCHIVED) ? [
            (0, $jghB4.CURRENT),
            (0, $jghB4.ARCHIVED)
        ] : [
            (0, $jghB4.CURRENT)
        ];
        setCommonAttributes({
            searchSessionId: searchSessionId,
            numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
            queryLength: searchQuery.length,
            queryHash: (0, $1AV5C.hashData)(searchQuery),
            filters: filterCategories,
            filterSelections: filterSelections,
            containerStatuses: archivedStatus,
            contentStatuses: archivedStatus,
            activationId: activationId,
            version: 2,
            api: searchInputs.queryType === 'CQLQuery' ? (0, $jghB4.CONFLUENCE_SEARCH_API) : (0, $jghB4.CROSSPRODUCT_SEARCH_API),
            navdexPointType: (0, $56QzY.TOUCH),
            wordCount: (searchQuery.match(/\w+/g) || []).length,
            isCQL: cql !== undefined
        });
        setPrivateAttributes({
            query: searchQuery
        });
    }, [
        searchInputs,
        searchSessionId,
        activationId
    ]);
    const fireAnalytics = (0, $42omo.useCallback)(({ type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, additionalAttributes: additionalAttributes })=>{
        createAnalyticsEvent({
            type: type,
            data: {
                source: 'advancedSearchScreen',
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                nonPrivacySafeAttributes: privateAttributes,
                attributes: {
                    ...commonAttributes,
                    ...additionalAttributes
                }
            }
        }).fire();
    }, [
        commonAttributes,
        privateAttributes,
        createAnalyticsEvent
    ]);
    const analyticsContextValue = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            fireAnalytics: fireAnalytics
        }), [
        searchSessionId,
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ca535cb9442e6251$export$83cd6c3eba7d8d9e.Provider, {
        value: analyticsContextValue
    }, children);
};
const $ca535cb9442e6251$export$e955abb82869dc84 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($ca535cb9442e6251$export$83cd6c3eba7d8d9e);
} : ()=>{
    return (0, $42omo.useContext)($ca535cb9442e6251$export$83cd6c3eba7d8d9e);
};
function $ca535cb9442e6251$var$_temp(selection) {
    return selection.value === (0, $jghB4.OptionIds).ARCHIVED;
}
module.exports["AnalyticsProvider"] = $ca535cb9442e6251$export$1b581a2ec13e37f1;
module.exports["useAnalytics"] = $ca535cb9442e6251$export$e955abb82869dc84;

});

parcelRegister("jghB4", function(module, exports) {

var $dIdGO = parcelRequire("dIdGO");

const $29feb65a99c04950$export$aad07b8ec9031cb6 = 'default';
const $29feb65a99c04950$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $29feb65a99c04950$export$5e8718d49d6c8c22 = 'confluenceSearch';
var $29feb65a99c04950$export$67bed5d1bc1f6c29 = /*#__PURE__*/ function(FilterIds) {
    FilterIds["SPACES"] = "spaces";
    FilterIds["CONTRIBUTORS"] = "contributors";
    FilterIds["TYPE"] = "type";
    FilterIds["LABELS"] = "labels";
    FilterIds["VERIFIED"] = "verified";
    FilterIds["ANCESTOR"] = "ancestor";
    FilterIds["DATE"] = "date";
    FilterIds["MORE"] = "moreFilters";
    FilterIds["CONTENT_UNDER"] = "contentUnder";
    FilterIds["ARCHIVED_CONTENT"] = "archivedContent";
    FilterIds["SEARCH_TITLE_ONLY"] = "searchTitleOnly";
    return FilterIds;
}({});
var $29feb65a99c04950$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    OptionIds["VERIFIED"] = "verified";
    return OptionIds;
}({});
var $29feb65a99c04950$export$34af5fcca86fafea = /*#__PURE__*/ function(InputVariants) {
    InputVariants["SELECTOR_WITH_AVATAR"] = "selectorWithAvatar";
    InputVariants["SELECT"] = "select";
    InputVariants["CHECKBOX"] = "checkbox";
    InputVariants["USER_PICKER"] = "userPicker";
    InputVariants["BUTTON"] = "pillButton";
    InputVariants["SEARCH_BUTTON"] = "searchButton";
    InputVariants["DATE_PICKER"] = "datePicker";
    InputVariants["MORE"] = "more";
    InputVariants["TAG"] = "tag";
    return InputVariants;
}({});
const $29feb65a99c04950$export$8ec3d08588d2eeda = 25;
const $29feb65a99c04950$export$b014b1b85cc3561 = ',';
const $29feb65a99c04950$export$c94fdbf59dff15c8 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder'
];
const $29feb65a99c04950$export$529483abfcf12013 = 'confluence.advancedSearch';
const $29feb65a99c04950$export$1f960e9ecae3cb06 = 'ari:cloud:confluence::site/';
const $29feb65a99c04950$export$8c6bf2df244e6a99 = '/wiki';
const $29feb65a99c04950$export$eed19b551669af14 = 'CURRENT';
const $29feb65a99c04950$export$c936349447a77fe0 = 'ARCHIVED';
const $29feb65a99c04950$export$60114111d5b5f818 = [
    'CURRENT',
    'ARCHIVED'
];
var $29feb65a99c04950$export$2a1fb5b806348bf0 = /*#__PURE__*/ function(LastModifiedValues) {
    LastModifiedValues["ANY_TIME"] = "";
    LastModifiedValues["TODAY"] = "today";
    LastModifiedValues["YESTERDAY"] = "yesterday";
    LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
    LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
    LastModifiedValues["PAST_YEAR"] = "pastYear";
    LastModifiedValues["CUSTOM"] = "custom";
    LastModifiedValues["LAST_DAY"] = "lastDay";
    LastModifiedValues["LAST_WEEK"] = "lastWeek";
    LastModifiedValues["LAST_MONTH"] = "lastMonth";
    LastModifiedValues["LAST_YEAR"] = "lastYear";
    return LastModifiedValues;
}({});
const $29feb65a99c04950$export$167891dba63dc67b = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}/;
var $29feb65a99c04950$export$9da7f865fb841394 = /*#__PURE__*/ function(ConfluenceATIs) {
    ConfluenceATIs["PAGE"] = "ati:cloud:confluence:page";
    ConfluenceATIs["ATTACHMENT"] = "ati:cloud:confluence:attachment";
    ConfluenceATIs["BLOG"] = "ati:cloud:confluence:blogpost";
    ConfluenceATIs["SPACE"] = "ati:cloud:confluence:space";
    ConfluenceATIs["COMMENT"] = "ati:cloud:confluence:comment";
    ConfluenceATIs["WHITEBOARD"] = "ati:cloud:confluence:whiteboard";
    ConfluenceATIs["DATABASE"] = "ati:cloud:confluence:database";
    ConfluenceATIs["SLIDE"] = "ati:cloud:confluence:slide";
    ConfluenceATIs["EMBED"] = "ati:cloud:confluence:embed";
    ConfluenceATIs["FOLDER"] = "ati:cloud:confluence:folder";
    return ConfluenceATIs;
}({});
const $29feb65a99c04950$export$e7960fb7f4252d8 = [
    {
        value: $29feb65a99c04950$export$aad07b8ec9031cb6,
        label: {
            ...(0, $dIdGO.i18n).dateFilterAnyTime
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "today",
        label: {
            ...(0, $dIdGO.i18n).dateFilterToday
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "yesterday",
        label: {
            ...(0, $dIdGO.i18n).dateFilterYesterday
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "past7Days",
        label: {
            ...(0, $dIdGO.i18n).dateFilterLastWeek
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "past30Days",
        label: {
            ...(0, $dIdGO.i18n).dateFilterLastMonth
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "pastYear",
        label: {
            ...(0, $dIdGO.i18n).dateFilterLastYear
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "custom",
        label: {
            ...(0, $dIdGO.i18n).dateFilterCustom
        },
        isSelected: false,
        optionId: "lastModified"
    }
];
const $29feb65a99c04950$export$dbdd99aa72455639 = {
    label: {
        ...(0, $dIdGO.i18n).searchFilterTitle
    },
    value: 'title',
    isSelected: false
};
const $29feb65a99c04950$export$2f0eb3386fd9fe47 = {
    label: {
        ...(0, $dIdGO.i18n).searchFilterArchived
    },
    value: 'archived',
    isSelected: false
};
const $29feb65a99c04950$export$9d468108add3ddca = {
    value: '',
    label: '',
    isSelected: false,
    optionId: "to"
};
const $29feb65a99c04950$export$8fcd57e0ace11aa0 = {
    value: '',
    label: '',
    isSelected: false,
    optionId: "from"
};
const $29feb65a99c04950$export$3c7203d4013c68b9 = {
    value: 'verified',
    label: {
        ...(0, $dIdGO.i18n).searchFilterVerified
    },
    isSelected: false
};
const $29feb65a99c04950$export$76f9cf2ec852a055 = {
    ["spaces"]: [],
    ["contributors"]: [],
    ["type"]: [],
    ["date"]: {
        ["lastModified"]: [
            ...$29feb65a99c04950$export$e7960fb7f4252d8
        ],
        ["to"]: $29feb65a99c04950$export$9d468108add3ddca,
        ["from"]: $29feb65a99c04950$export$8fcd57e0ace11aa0
    },
    ["labels"]: [],
    ["verified"]: [
        $29feb65a99c04950$export$3c7203d4013c68b9
    ],
    ["ancestor"]: [],
    ["moreFilters"]: [
        $29feb65a99c04950$export$dbdd99aa72455639,
        $29feb65a99c04950$export$2f0eb3386fd9fe47
    ]
};
module.exports["defaultOptionValue"] = $29feb65a99c04950$export$aad07b8ec9031cb6;
module.exports["CROSSPRODUCT_SEARCH_API"] = $29feb65a99c04950$export$a4c5cde0daa9b961;
module.exports["CONFLUENCE_SEARCH_API"] = $29feb65a99c04950$export$5e8718d49d6c8c22;
module.exports["FilterIds"] = $29feb65a99c04950$export$67bed5d1bc1f6c29;
module.exports["OptionIds"] = $29feb65a99c04950$export$1118b8908e5d0501;
module.exports["PAGE_SIZE"] = $29feb65a99c04950$export$8ec3d08588d2eeda;
module.exports["QUERY_PARAM_ARRAY_SEPARATOR"] = $29feb65a99c04950$export$b014b1b85cc3561;
module.exports["DEFAULT_ENTITIES"] = $29feb65a99c04950$export$c94fdbf59dff15c8;
module.exports["CONFLUENCE_AS_EXPERIENCE"] = $29feb65a99c04950$export$529483abfcf12013;
module.exports["CONFLUENCE_ARI"] = $29feb65a99c04950$export$1f960e9ecae3cb06;
module.exports["CONTEXT_PATH"] = $29feb65a99c04950$export$8c6bf2df244e6a99;
module.exports["CURRENT"] = $29feb65a99c04950$export$eed19b551669af14;
module.exports["ARCHIVED"] = $29feb65a99c04950$export$c936349447a77fe0;
module.exports["INCLUDEARCHIVEDSTATUS"] = $29feb65a99c04950$export$60114111d5b5f818;
module.exports["LastModifiedValues"] = $29feb65a99c04950$export$2a1fb5b806348bf0;
module.exports["ConfluenceATIs"] = $29feb65a99c04950$export$9da7f865fb841394;
module.exports["lastModifiedFilterOptions"] = $29feb65a99c04950$export$e7960fb7f4252d8;
module.exports["titleFilterOption"] = $29feb65a99c04950$export$dbdd99aa72455639;
module.exports["archivedFilterOption"] = $29feb65a99c04950$export$2f0eb3386fd9fe47;
module.exports["toFilterOption"] = $29feb65a99c04950$export$9d468108add3ddca;
module.exports["fromFilterOption"] = $29feb65a99c04950$export$8fcd57e0ace11aa0;
module.exports["verifiedOption"] = $29feb65a99c04950$export$3c7203d4013c68b9;
module.exports["defaultFilterState"] = $29feb65a99c04950$export$76f9cf2ec852a055;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5YfNL = parcelRequire("5YfNL");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    if (isLivePage && isMarkdownMode) {
        let t3;
        if ($[4] !== color || $[5] !== label.id) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5YfNL.PageMarkdownIcon), {
                label: "",
                color: color,
                testId: label.id
            });
            $[4] = color;
            $[5] = label.id;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let t3;
    if ($[7] !== Icon || $[8] !== color || $[9] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[7] = Icon;
        $[8] = color;
        $[9] = label.id;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    if (isLivePage && isMarkdownMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5YfNL.PageMarkdownIcon), {
        label: "",
        color: color,
        testId: label.id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("4yBQL"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("4yBQL", function(module, exports) {

let $3517b29dbb8fa594$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3517b29dbb8fa594$var$load("cvmn7"),
    $3517b29dbb8fa594$var$load("jmFg4"),
    $3517b29dbb8fa594$var$load("lPtG0"),
    $3517b29dbb8fa594$var$load("6YfM6"),
    $3517b29dbb8fa594$var$load("6wr18"),
    $3517b29dbb8fa594$var$load("ffEVr"),
    $3517b29dbb8fa594$var$load("iivLa"),
    $3517b29dbb8fa594$var$load("ajMch"),
    $3517b29dbb8fa594$var$load("kFiBp"),
    $3517b29dbb8fa594$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("5YfNL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $c9cfd0dc6a889fde$var$SPACING_TO_SIZE = {
    none: 16,
    spacious: 20
};
const $c9cfd0dc6a889fde$export$d1952cddb6415bbf = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { label: label, color: color, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "none" : t1;
    const size = $c9cfd0dc6a889fde$var$SPACING_TO_SIZE[spacing];
    const stroke = color ?? "var(--ds-icon-subtle, #505258)";
    const hasLabel = label.length > 0;
    let t2;
    if ($[0] !== hasLabel || $[1] !== label) {
        t2 = hasLabel ? {
            "aria-label": label,
            role: "img"
        } : {
            "aria-hidden": true
        };
        $[0] = hasLabel;
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    let t5;
    if ($[3] !== stroke) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M14.0625 6.5625H8.4375V0.9375M14.0625 6.5625V10M14.0625 6.5625C14.0625 6.16232 13.9035 5.77853 13.6206 5.49556L9.50444 1.37944C9.22147 1.09647 8.83768 0.9375 8.4375 0.9375M8.4375 0.9375H2.5C1.63705 0.9375 0.9375 1.63706 0.9375 2.5V17.5C0.9375 18.3629 1.63706 19.0625 2.5 19.0625",
            stroke: stroke,
            strokeWidth: "1.875",
            strokeLinejoin: "round"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M5.9375 20V13.4375H6.40625L8.75 17.8125L11.0938 13.4375H11.5625V20",
            stroke: stroke,
            strokeWidth: "1.875",
            strokeLinejoin: "round"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M16.5625 13.5V19.0625M16.5625 19.0625L19.0625 16.5625M16.5625 19.0625L14.0625 16.5625",
            stroke: stroke,
            strokeWidth: "1.875",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        });
        $[3] = stroke;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else {
        t3 = $[4];
        t4 = $[5];
        t5 = $[6];
    }
    let t6;
    if ($[7] !== size || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            "data-testid": testId,
            width: size,
            height: size,
            ...t2,
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t3, t4, t5);
        $[7] = size;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = testId;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ label: label, color: color, spacing: spacing = 'none', testId: testId })=>{
    const size = $c9cfd0dc6a889fde$var$SPACING_TO_SIZE[spacing];
    const stroke = color ?? "var(--ds-icon-subtle, #505258)";
    const hasLabel = label.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        "data-testid": testId,
        width: size,
        height: size,
        ...hasLabel ? {
            'aria-label': label,
            role: 'img'
        } : {
            'aria-hidden': true
        },
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.0625 6.5625H8.4375V0.9375M14.0625 6.5625V10M14.0625 6.5625C14.0625 6.16232 13.9035 5.77853 13.6206 5.49556L9.50444 1.37944C9.22147 1.09647 8.83768 0.9375 8.4375 0.9375M8.4375 0.9375H2.5C1.63705 0.9375 0.9375 1.63706 0.9375 2.5V17.5C0.9375 18.3629 1.63706 19.0625 2.5 19.0625",
        stroke: stroke,
        strokeWidth: "1.875",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.9375 20V13.4375H6.40625L8.75 17.8125L11.0938 13.4375H11.5625V20",
        stroke: stroke,
        strokeWidth: "1.875",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.5625 13.5V19.0625M16.5625 19.0625L19.0625 16.5625M16.5625 19.0625L14.0625 16.5625",
        stroke: stroke,
        strokeWidth: "1.875",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
module.exports["PageMarkdownIcon"] = $c9cfd0dc6a889fde$export$d1952cddb6415bbf;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("fGkN6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $f7lNm = parcelRequire("f7lNm");


var $2XcmP = parcelRequire("2XcmP");


var $7zgzO = parcelRequire("7zgzO");


var $bQm3c = parcelRequire("bQm3c");


var $1mK5P = parcelRequire("1mK5P");





var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<cc645ed17fcdb12abb5fe53fd7c1d2be>>
 * @relayHash af199997403c9fa91fbc3a32b12c976b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4354491bd73805be1e58186d13d8ec8920c95d0b6cb3eb0215147cc20dcce77
const $c664e426328d05c8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ancestorId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventTypes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasAncestor"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSpaces"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasUsers"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnon"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKeys"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "alias": "contentTypes",
        "concreteType": "Confluence_cqlMetaData",
        "kind": "LinkedField",
        "name": "cqlMetaData",
        "plural": false,
        "selections": [
            {
                "concreteType": "CQLDisplayableType",
                "kind": "LinkedField",
                "name": "cqlContentTypes",
                "plural": true,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "label"
                    }
                ]
            }
        ]
    }, v14 = [
        {
            "items": [
                {
                    "fields": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "entityIds.0",
                                    "variableName": "userId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "entityIds"
                        },
                        {
                            "kind": "Literal",
                            "name": "entityType",
                            "value": "user"
                        },
                        {
                            "kind": "Literal",
                            "name": "features",
                            "value": [
                                "recommendedSpaces",
                                "recommendedPeople"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input.0"
                }
            ],
            "kind": "ListValue",
            "name": "input"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "entityType"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "kind": "ScalarField",
        "name": "score"
    }, v18 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v20 = {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = [
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "ABSOLUTE"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "path",
                    "storageKey": "path(type:\"ABSOLUTE\")"
                }
            ]
        }
    ], v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "SmartFeaturesUserResult",
                "kind": "LinkedField",
                "name": "result",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    {
                        "concreteType": "SmartUserFeatures",
                        "kind": "LinkedField",
                        "name": "features",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "RecommendedPeopleItem",
                                "kind": "LinkedField",
                                "name": "recommendedPeople",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "concreteType": "AtlassianUser",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v16 /*: any*/ ,
                                            v18 /*: any*/ ,
                                            v20 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUserPhoto",
                                                "kind": "LinkedField",
                                                "name": "photos",
                                                "plural": true,
                                                "selections": [
                                                    v21 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "RecommendedSpaceItem",
                                "kind": "LinkedField",
                                "name": "recommendedSpaces",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "concreteType": "Space",
                                        "kind": "LinkedField",
                                        "name": "space",
                                        "plural": false,
                                        "selections": v22 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SmartFeaturesUserResultResponse"
    }, v24 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "eventTypes",
                            "variableName": "eventTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = [
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "title"
        },
        v12 /*: any*/ 
    ], v27 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluencePage"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceBlogPost"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceWhiteboard"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceDatabase"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceEmbed"
    }, v32 = {
        "concreteType": "ActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v33 = {
        "alias": "currentUser",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v18 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            },
            v20 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v34 = {
        "condition": "hasSpaces",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "spaceKeys",
                        "variableName": "spaceKeys"
                    }
                ],
                "concreteType": "PaginatedSpaceList",
                "kind": "LinkedField",
                "name": "spaces",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": v22 /*: any*/ 
                    }
                ]
            }
        ]
    }, v35 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v36 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v37 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "KnownUser"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "UnknownUser"
    }, v39 = {
        "condition": "hasAncestor",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "ancestorData",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "ancestorId"
                    }
                ],
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "singleContent",
                "plural": false,
                "selections": v26 /*: any*/ 
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v41 = [
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFilterSupplierAdvancedSearchFilterV3Query",
            "selections": [
                v13 /*: any*/ ,
                {
                    "condition": "isAnon",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "SmartFeaturesResponse",
                            "kind": "LinkedField",
                            "name": "getSmartFeatures",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Activity",
                            "kind": "LinkedField",
                            "name": "activity",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MyActivity",
                                    "kind": "LinkedField",
                                    "name": "myActivity",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "ActivityConnection",
                                            "kind": "LinkedField",
                                            "name": "all",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityNode",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ActivityObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "object",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                v34 /*: any*/ ,
                {
                    "condition": "hasUsers",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "concreteType": "PaginatedPersonList",
                            "kind": "LinkedField",
                            "name": "confluenceUsers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        v38 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFilterSupplierAdvancedSearchFilterV3Query",
            "selections": [
                v13 /*: any*/ ,
                {
                    "condition": "isAnon",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "SmartFeaturesResponse",
                            "kind": "LinkedField",
                            "name": "getSmartFeatures",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v40 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Activity",
                            "kind": "LinkedField",
                            "name": "activity",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MyActivity",
                                    "kind": "LinkedField",
                                    "name": "myActivity",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "ActivityConnection",
                                            "kind": "LinkedField",
                                            "name": "all",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityNode",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ActivityObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "object",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v41 /*: any*/ ,
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v41 /*: any*/ ,
                                                                                    "type": "DevOpsPullRequestDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v41 /*: any*/ ,
                                                                                    "type": "MercuryPortfolio"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                v34 /*: any*/ ,
                {
                    "condition": "hasUsers",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "concreteType": "PaginatedPersonList",
                            "kind": "LinkedField",
                            "name": "confluenceUsers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v40 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        v38 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "af199997403c9fa91fbc3a32b12c976b",
            "id": "f4354491bd73805be1e58186d13d8ec8920c95d0b6cb3eb0215147cc20dcce77",
            "metadata": {},
            "name": "useFilterSupplierAdvancedSearchFilterV3Query",
            "operationKind": "query",
            "text": "query useFilterSupplierAdvancedSearchFilterV3Query($userId:String!,$isAnon:Boolean!,$accountIds:[String],$spaceKeys:[String],$ancestorId:ID,$hasUsers:Boolean!,$hasSpaces:Boolean!,$hasAncestor:Boolean!,$cloudId:ID!,$objectTypes:[String!],$eventTypes:[String!],$first:Int){getSmartFeatures(input:[{entityType:\"user\",entityIds:[$userId],features:[\"recommendedSpaces\",\"recommendedPeople\"]}])@skip(if:$isAnon){results{__typename,entityType,...on SmartFeaturesUserResultResponse{entityType,result{id,features{recommendedPeople{score,user{id,displayName,confluence{accountId},photos{value}}},recommendedSpaces{score,space{id,key,name,icon{path(type:ABSOLUTE)}}}}}}}}\n  activity@skip(if:$isAnon){myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type},...on ConfluenceBlogPost{id,title,type},...on ConfluenceWhiteboard{id,title,type},...on ConfluenceDatabase{id,title,type},...on ConfluenceEmbed{id,title,type},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}}}},pageInfo{hasNextPage}}}}\n  currentUser:confluence_atlassianUser(current:true)@skip(if:$isAnon){id,displayName,photos{value,isPrimary},confluence{accountId}},spaces(spaceKeys:$spaceKeys)@include(if:$hasSpaces){nodes{id,key,name,icon{path(type:ABSOLUTE)}}},confluenceUsers(accountIds:$accountIds)@include(if:$hasUsers){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},contentTypes:cqlMetaData{cqlContentTypes{type,label}},ancestorData:singleContent(id:$ancestorId)@include(if:$hasAncestor){id,title,type}}"
        }
    };
}();
$c664e426328d05c8$var$node.hash = "a1921ca607962bf473e7500b25585374";
var $c664e426328d05c8$export$2e2bcd8739ae039 = $c664e426328d05c8$var$node;






var $aXWIB = parcelRequire("aXWIB");


var $d4Pk4 = parcelRequire("d4Pk4");





var $95rLf = parcelRequire("95rLf");


var $kDja4 = parcelRequire("kDja4");


var $yuLaV = parcelRequire("yuLaV");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $jMyy4 = parcelRequire("jMyy4");


var $jghB4 = parcelRequire("jghB4");


var $iD4ky = parcelRequire("iD4ky");

/**
 * @generated SignedSource<<20024b220b8a541a9be780307ef83ee2>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $5ed490bb402384d5$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    return ActivitiesObjectType;
}({});
var $5ed490bb402384d5$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["VIEWED"] = "VIEWED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["EDITED"] = "EDITED";
    return ActivityEventType;
}({});
var $5ed490bb402384d5$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["JIRA"] = "JIRA";
    ActivityProduct["JIRA_BUSINESS"] = "JIRA_BUSINESS";
    ActivityProduct["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    ActivityProduct["JIRA_OPS"] = "JIRA_OPS";
    ActivityProduct["JIRA_SERVICE_DESK"] = "JIRA_SERVICE_DESK";
    ActivityProduct["CONFLUENCE"] = "CONFLUENCE";
    return ActivityProduct;
}({});



var $dIdGO = parcelRequire("dIdGO");

const $a104828753d942eb$var$normalizeActivityData = (activityData)=>{
    if (!activityData) return undefined;
    const transformedEdges = activityData.activity?.myActivity?.all?.edges?.map((edge)=>{
        const nodeData = edge?.node?.object?.data;
        return {
            cursor: edge.cursor,
            node: {
                id: edge?.node?.id || '',
                object: {
                    id: edge?.node?.object?.id || '',
                    content: nodeData ? {
                        id: nodeData.id || '',
                        title: nodeData.title || '',
                        type: nodeData.type?.toLowerCase() === 'blog_post' ? 'blogpost' : nodeData.type || ''
                    } : null
                }
            }
        };
    }) || [];
    return {
        ...activityData,
        activities: {
            myActivities: {
                viewed: {
                    edges: transformedEdges,
                    pageInfo: activityData.activity?.myActivity?.all?.pageInfo || {
                        hasNextPage: false
                    }
                }
            }
        }
    };
};
const $a104828753d942eb$export$3aa26ca92eac8d26 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useFilterSupplier(t0) {
    const $ = (0, $frIzR.c)(6);
    const { filters: filters, queryParams: queryParams, setFilters: setFilters, setUpdatedQueryParams: setUpdatedQueryParams } = t0;
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled("whiteboardsEnabled");
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database");
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("slide");
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { contributorsToHydrate: contributorsToHydrate, spacesToHydrate: spacesToHydrate, contributors: contributors, spaces: spaces, lastModified: lastModified, ancestorId: ancestorId, selectedType: selectedType } = (0, $iD4ky.getOptionsToHydrate)(queryParams, filters);
    const filtersAreInParity = (0, $iD4ky.areFiltersConsistent)(filters, [
        ...contributors,
        ...spaces,
        ...lastModified ? [
            lastModified
        ] : []
    ]);
    const typesRequireHydration = filters[(0, $jghB4.FilterIds).TYPE].length <= 1;
    const ancestorRequiresHydration = ancestorId !== "" && filters[(0, $jghB4.FilterIds).ANCESTOR].some((ancestorOption)=>Boolean(ancestorOption.isSelected && ancestorOption.value !== ancestorId));
    const shouldSkipHydration = Boolean(contributorsToHydrate.length + spacesToHydrate.length === 0 && !typesRequireHydration && !ancestorRequiresHydration);
    const objectTypes = [
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).PAGE,
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).EMBED
    ];
    if (isWhiteboardsEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).WHITEBOARD);
    if (isDatabasesEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).DATABASE);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $c664e426328d05c8$export$2e2bcd8739ae039), {
        variables: {
            userId: userId || "",
            isAnon: !userId,
            accountIds: contributorsToHydrate,
            spaceKeys: spacesToHydrate,
            ancestorId: ancestorId,
            hasUsers: userId ? contributorsToHydrate.length > 0 : false,
            hasSpaces: spacesToHydrate.length > 0,
            hasAncestor: ancestorId !== "",
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            objectTypes: objectTypes.map(String),
            eventTypes: [
                "VIEWED"
            ],
            first: 10
        },
        skip: shouldSkipHydration,
        errorPolicy: "all",
        interopApolloAggClient: true,
        onCompleted: ()=>{
            if (!shouldSkipHydration) {
                const updatedFilters = {
                    ...filters
                };
                updatedFilters[(0, $jghB4.FilterIds).SPACES] = [
                    ...spaceOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...contributorOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).TYPE] = [
                    ...typeOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).ANCESTOR] = [
                    ...ancestorOptions
                ];
                setFilters(updatedFilters);
                if (!filtersAreInParity) setUpdatedQueryParams(updatedFilters);
            }
            if (shouldSkipHydration && !filtersAreInParity) {
                const updatedFilters_0 = {
                    ...(0, $jghB4.defaultFilterState)
                };
                updatedFilters_0[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = [
                    ...filters[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option)=>({
                            ...option,
                            isSelected: lastModified === option.value
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).SPACES] = [
                    ...filters[(0, $jghB4.FilterIds).SPACES].map((option_0)=>({
                            ...option_0,
                            isSelected: !!spaces.includes(option_0.value)
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...filters[(0, $jghB4.FilterIds).CONTRIBUTORS].map((option_1)=>({
                            ...option_1,
                            isSelected: !!contributors.includes(option_1.value)
                        }))
                ];
                setFilters(updatedFilters_0);
            }
        },
        __callerPackage__: "@confluence/advanced-search"
    });
    const transformedData = $a104828753d942eb$var$normalizeActivityData(data);
    if (error) {
        if ((0, $95rLf.isExpectedApolloError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: "Expected GQL error"
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: error
        });
    }
    const defaultTypesFilterOptions = [
        {
            value: "page",
            label: formatMessage((0, $dIdGO.i18n).typePage),
            isSelected: "page" === selectedType
        },
        {
            value: "blogpost",
            label: formatMessage((0, $dIdGO.i18n).typeBlogpost),
            isSelected: "blogpost" === selectedType
        },
        {
            value: "attachment",
            label: formatMessage((0, $dIdGO.i18n).typeAttachment),
            isSelected: "attachment" === selectedType
        },
        {
            value: "space",
            label: formatMessage((0, $dIdGO.i18n).typeSpace),
            isSelected: "space" === selectedType
        },
        {
            value: "comment",
            label: formatMessage((0, $dIdGO.i18n).typeComments),
            isSelected: "comment" === selectedType
        },
        {
            value: "embed",
            label: formatMessage((0, $dIdGO.i18n).typeEmbed),
            isSelected: "embed" === selectedType
        }
    ].concat(isWhiteboardsEnabledAS ? [
        {
            value: "whiteboard",
            label: formatMessage((0, $dIdGO.i18n).typeWhiteboard),
            isSelected: "whiteboard" === selectedType
        }
    ] : []).concat(isDatabasesEnabledAS ? [
        {
            value: "database",
            label: formatMessage((0, $dIdGO.i18n).typeDatabase),
            isSelected: "database" === selectedType
        }
    ] : []).concat(isSlidesEnabledAS ? [
        {
            value: "slide",
            label: formatMessage((0, $dIdGO.i18n).typeSlide),
            isSelected: "slide" === selectedType
        }
    ] : []).concat([
        {
            value: "folder",
            label: formatMessage((0, $dIdGO.i18n).typeFolder),
            isSelected: "folder" === selectedType
        }
    ]);
    const { ancestorOptions: t1, hydratedTypes: hydratedTypes, spaceOptions: t2, contributorOptions: t3 } = (0, $iD4ky.mapDataToOptions)({
        data: transformedData,
        spaces: spaces,
        contributors: contributors,
        contributorsToHydrate: contributorsToHydrate,
        spacesToHydrate: spacesToHydrate,
        selectedType: selectedType,
        defaultTypesFilterOptions: defaultTypesFilterOptions,
        isWhiteboardsEnabledAS: isWhiteboardsEnabledAS,
        isDatabasesEnabledAS: isDatabasesEnabledAS,
        isSlidesEnabledAS: isSlidesEnabledAS,
        userId: userId
    });
    const ancestorOptions = t1;
    const spaceOptions = t2;
    const contributorOptions = t3;
    const typeOptions = [
        ...defaultTypesFilterOptions,
        ...hydratedTypes
    ];
    let t4;
    if ($[0] !== ancestorOptions || $[1] !== contributorOptions || $[2] !== loading || $[3] !== spaceOptions || $[4] !== typeOptions) {
        t4 = {
            loading: loading,
            spaceOptions: spaceOptions,
            contributorOptions: contributorOptions,
            typeOptions: typeOptions,
            ancestorOptions: ancestorOptions
        };
        $[0] = ancestorOptions;
        $[1] = contributorOptions;
        $[2] = loading;
        $[3] = spaceOptions;
        $[4] = typeOptions;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function useFilterSupplier({ filters: filters, queryParams: queryParams, setFilters: setFilters, setUpdatedQueryParams: setUpdatedQueryParams }) {
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { contributorsToHydrate: contributorsToHydrate, spacesToHydrate: spacesToHydrate, contributors: contributors, spaces: spaces, lastModified: lastModified, ancestorId: ancestorId, selectedType: selectedType } = (0, $iD4ky.getOptionsToHydrate)(queryParams, filters);
    const filtersAreInParity = (0, $iD4ky.areFiltersConsistent)(filters, [
        ...contributors,
        ...spaces,
        ...lastModified ? [
            lastModified
        ] : []
    ]);
    const typesRequireHydration = filters[(0, $jghB4.FilterIds).TYPE].length <= 1;
    const ancestorRequiresHydration = ancestorId !== '' && filters[(0, $jghB4.FilterIds).ANCESTOR].some((ancestorOption)=>Boolean(ancestorOption.isSelected && ancestorOption.value !== ancestorId));
    const shouldSkipHydration = Boolean(contributorsToHydrate.length + spacesToHydrate.length === 0 && !typesRequireHydration && !ancestorRequiresHydration);
    const objectTypes = [
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).PAGE,
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).EMBED
    ];
    if (isWhiteboardsEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).WHITEBOARD);
    if (isDatabasesEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).DATABASE);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $c664e426328d05c8$export$2e2bcd8739ae039), {
        variables: {
            userId: userId || '',
            isAnon: !userId,
            accountIds: contributorsToHydrate,
            spaceKeys: spacesToHydrate,
            ancestorId: ancestorId,
            hasUsers: userId ? contributorsToHydrate.length > 0 : false,
            hasSpaces: spacesToHydrate.length > 0,
            hasAncestor: ancestorId !== '',
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            objectTypes: objectTypes.map(String),
            eventTypes: [
                'VIEWED'
            ],
            first: 10
        },
        skip: shouldSkipHydration,
        errorPolicy: 'all',
        interopApolloAggClient: true,
        onCompleted: ()=>{
            if (!shouldSkipHydration) {
                const updatedFilters = {
                    ...filters
                };
                updatedFilters[(0, $jghB4.FilterIds).SPACES] = [
                    ...spaceOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...contributorOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).TYPE] = [
                    ...typeOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).ANCESTOR] = [
                    ...ancestorOptions
                ];
                setFilters(updatedFilters);
                if (!filtersAreInParity) setUpdatedQueryParams(updatedFilters);
            }
            if (shouldSkipHydration && !filtersAreInParity) {
                const updatedFilters_0 = {
                    ...(0, $jghB4.defaultFilterState)
                };
                updatedFilters_0[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = [
                    ...filters[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option)=>({
                            ...option,
                            isSelected: lastModified === option.value
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).SPACES] = [
                    ...filters[(0, $jghB4.FilterIds).SPACES].map((option_0)=>({
                            ...option_0,
                            isSelected: !!spaces.includes(option_0.value)
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...filters[(0, $jghB4.FilterIds).CONTRIBUTORS].map((option_1)=>({
                            ...option_1,
                            isSelected: !!contributors.includes(option_1.value)
                        }))
                ];
                setFilters(updatedFilters_0);
            }
        },
        __callerPackage__: "@confluence/advanced-search"
    });
    const transformedData = $a104828753d942eb$var$normalizeActivityData(data);
    if (error) {
        if ((0, $95rLf.isExpectedApolloError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: 'Expected GQL error'
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: error
        });
    }
    const defaultTypesFilterOptions = [
        {
            value: 'page',
            label: formatMessage((0, $dIdGO.i18n).typePage),
            isSelected: 'page' === selectedType
        },
        {
            value: 'blogpost',
            label: formatMessage((0, $dIdGO.i18n).typeBlogpost),
            isSelected: 'blogpost' === selectedType
        },
        {
            value: 'attachment',
            label: formatMessage((0, $dIdGO.i18n).typeAttachment),
            isSelected: 'attachment' === selectedType
        },
        {
            value: 'space',
            label: formatMessage((0, $dIdGO.i18n).typeSpace),
            isSelected: 'space' === selectedType
        },
        {
            value: 'comment',
            label: formatMessage((0, $dIdGO.i18n).typeComments),
            isSelected: 'comment' === selectedType
        },
        {
            value: 'embed',
            label: formatMessage((0, $dIdGO.i18n).typeEmbed),
            isSelected: 'embed' === selectedType
        }
    ].concat(isWhiteboardsEnabledAS ? [
        {
            value: 'whiteboard',
            label: formatMessage((0, $dIdGO.i18n).typeWhiteboard),
            isSelected: 'whiteboard' === selectedType
        }
    ] : []).concat(isDatabasesEnabledAS ? [
        {
            value: 'database',
            label: formatMessage((0, $dIdGO.i18n).typeDatabase),
            isSelected: 'database' === selectedType
        }
    ] : []).concat(isSlidesEnabledAS ? [
        {
            value: 'slide',
            label: formatMessage((0, $dIdGO.i18n).typeSlide),
            isSelected: 'slide' === selectedType
        }
    ] : []).concat([
        {
            value: 'folder',
            label: formatMessage((0, $dIdGO.i18n).typeFolder),
            isSelected: 'folder' === selectedType
        }
    ]);
    const { ancestorOptions: ancestorOptions, hydratedTypes: hydratedTypes, spaceOptions: spaceOptions, contributorOptions: contributorOptions } = (0, $iD4ky.mapDataToOptions)({
        data: transformedData,
        spaces: spaces,
        contributors: contributors,
        contributorsToHydrate: contributorsToHydrate,
        spacesToHydrate: spacesToHydrate,
        selectedType: selectedType,
        defaultTypesFilterOptions: defaultTypesFilterOptions,
        isWhiteboardsEnabledAS: isWhiteboardsEnabledAS,
        isDatabasesEnabledAS: isDatabasesEnabledAS,
        isSlidesEnabledAS: isSlidesEnabledAS,
        userId: userId
    });
    const typeOptions = [
        ...defaultTypesFilterOptions,
        ...hydratedTypes
    ];
    return {
        loading: loading,
        spaceOptions: spaceOptions,
        contributorOptions: contributorOptions,
        typeOptions: typeOptions,
        ancestorOptions: ancestorOptions
    };
};
























var $c2fn3 = parcelRequire("c2fn3");


var $9wGTI = parcelRequire("9wGTI");




const $8d942dc771991e4d$export$bd1c6954a81c5a8a = (0, $3u0dr.isReactCompilerActiveV2)() ? (searchQuery)=>{
    const $ = (0, $frIzR.c)(13);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { activationId: activationId, cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [queryIntent, setQueryIntent] = (0, $42omo.useState)((0, $f7lNm.QueryIntent).DEFAULT);
    const [transformedQuery, setTransformedQuery] = (0, $42omo.useState)("");
    const siteARI = `ari:cloud:confluence::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:confluence:${cloudId}:workspace/${activationId}` : "";
    let t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== isAdminHubAIEnabled || $[2] !== locale || $[3] !== orgId || $[4] !== searchQuery || $[5] !== siteARI || $[6] !== workspaceId) {
        t0 = ()=>{
            if (!searchQuery || !isAdminHubAIEnabled || !(0, $9wGTI.fg)("confluence_advanced_search_query_intent")) return;
            const callGetSmartAnswerRoute = async ()=>{
                setLoading(true);
                await (0, $c2fn3.getSmartAnswerRoute)({
                    query: searchQuery,
                    locale: locale,
                    siteId: siteARI,
                    cloudId: cloudId,
                    orgId: orgId ?? "",
                    workspaceId: workspaceId,
                    product: "confluence",
                    setQueryIntent: setQueryIntent,
                    setTransformedQuery: setTransformedQuery
                });
                setLoading(false);
            };
            callGetSmartAnswerRoute();
        };
        t1 = [
            locale,
            siteARI,
            searchQuery,
            isAdminHubAIEnabled,
            cloudId,
            workspaceId,
            orgId
        ];
        $[0] = cloudId;
        $[1] = isAdminHubAIEnabled;
        $[2] = locale;
        $[3] = orgId;
        $[4] = searchQuery;
        $[5] = siteARI;
        $[6] = workspaceId;
        $[7] = t0;
        $[8] = t1;
    } else {
        t0 = $[7];
        t1 = $[8];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[9] !== loading || $[10] !== queryIntent || $[11] !== transformedQuery) {
        t2 = {
            loading: loading,
            transformedQuery: transformedQuery,
            queryIntent: queryIntent
        };
        $[9] = loading;
        $[10] = queryIntent;
        $[11] = transformedQuery;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : (searchQuery)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { activationId: activationId, cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [queryIntent, setQueryIntent] = (0, $42omo.useState)((0, $f7lNm.QueryIntent).DEFAULT);
    const [transformedQuery, setTransformedQuery] = (0, $42omo.useState)('');
    const siteARI = `ari:cloud:confluence::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:confluence:${cloudId}:workspace/${activationId}` : '';
    (0, $42omo.useEffect)(()=>{
        if (!searchQuery || !isAdminHubAIEnabled || !(0, $9wGTI.fg)('confluence_advanced_search_query_intent')) return;
        const callGetSmartAnswerRoute = async ()=>{
            setLoading(true);
            await (0, $c2fn3.getSmartAnswerRoute)({
                query: searchQuery,
                locale: locale,
                siteId: siteARI,
                cloudId: cloudId,
                orgId: orgId ?? '',
                workspaceId: workspaceId,
                product: 'confluence',
                setQueryIntent: setQueryIntent,
                setTransformedQuery: setTransformedQuery
            });
            setLoading(false);
        };
        callGetSmartAnswerRoute();
    }, [
        locale,
        siteARI,
        searchQuery,
        isAdminHubAIEnabled,
        cloudId,
        workspaceId,
        orgId
    ]);
    return {
        loading: loading,
        transformedQuery: transformedQuery,
        queryIntent: queryIntent
    };
};


const $88423f473bb19836$export$e92004becf463495 = /*#__PURE__*/ (0, $42omo.createContext)({
    searchQuery: '',
    filters: (0, $jghB4.defaultFilterState),
    cql: undefined,
    queryType: 'AGGQuery',
    isHydrated: false,
    toggleOption: ()=>{},
    updateCustomDateRange: ()=>{},
    resetOptions: ()=>{},
    toggleDateOption: ()=>{},
    resetDateOptions: ()=>{},
    onSearchQueryChange: ()=>{},
    clearFilters: ()=>{},
    sessionHasAppliedFilters: false,
    sessionHasUserInput: false,
    onClickAskAI: ()=>{},
    showSearchAI: false,
    aiTriggeredByAskAI: false,
    aiSearchConfig: undefined
});
const $88423f473bb19836$export$cb42e09961db7f36 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($88423f473bb19836$export$e92004becf463495);
} : ()=>(0, $42omo.useContext)($88423f473bb19836$export$e92004becf463495);
const $88423f473bb19836$export$720fa7c1ee69c9fc = ({ children: children })=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const [filters, setFilters] = (0, $42omo.useState)((0, $iD4ky.initializeFilters)(queryParams));
    const setUpdatedQueryParams = (0, $42omo.useCallback)((updatedFilters)=>{
        const updatedQueryParams = (0, $iD4ky.generateUpdatedQueryParams)(updatedFilters);
        setQueryParams({
            ...updatedQueryParams
        });
    }, [
        setQueryParams
    ]);
    const { loading: loading } = (0, $a104828753d942eb$export$3aa26ca92eac8d26)({
        queryParams: queryParams,
        filters: filters,
        setFilters: setFilters,
        setUpdatedQueryParams: setUpdatedQueryParams
    });
    const cqlQuery = queryParams?.cql;
    const searchQuery = queryParams?.text?.toString() || '';
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const { loading: queryIntentLoading, queryIntent: queryIntent } = (0, $8d942dc771991e4d$export$bd1c6954a81c5a8a)(searchQuery);
    const shouldShowAIAnswer = (0, $42omo.useCallback)(()=>{
        const isAiAnswerEnabled = queryParams?.aiAnswer === 'true' && searchQuery.length > 0;
        const queryIsQuestion = (0, $2XcmP.isQuestion)({
            locale: locale,
            query: searchQuery
        });
        const isPersonIntent = !queryIntentLoading && queryIntent === (0, $f7lNm.QueryIntent).PERSON && queryParams?.aiAnswer !== 'false';
        return isAiAnswerEnabled || queryIsQuestion || isPersonIntent;
    }, [
        locale,
        queryParams?.aiAnswer,
        searchQuery,
        queryIntentLoading,
        queryIntent
    ]);
    const [showSearchAI, setShowSearchAI] = (0, $42omo.useState)(shouldShowAIAnswer);
    const [aiTriggeredByAskAI, setAITriggeredByAskAI] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const aiAnswerEnabled = shouldShowAIAnswer();
        setShowSearchAI(aiAnswerEnabled);
    }, [
        shouldShowAIAnswer
    ]);
    const { aiSearchConfig: aiSearchConfig } = (0, $1mK5P.useAISearchSupplier)({});
    const toggleOption = (0, $42omo.useCallback)(({ filterId: filterId, toggledOption: toggledOption, isMulti: isMulti })=>{
        const updatedFilters_0 = {
            ...filters
        };
        const existingOption = filters[filterId].find((filterOption)=>filterOption?.value === toggledOption?.value);
        if (existingOption) updatedFilters_0[filterId] = updatedFilters_0[filterId].map((option)=>{
            if (option.value === toggledOption.value) return {
                ...option,
                isSelected: !option.isSelected
            };
            return isMulti ? option : {
                ...option,
                isSelected: false
            };
        });
        else {
            const newSelectedOption = {
                ...toggledOption,
                isSelected: true
            };
            updatedFilters_0[filterId] = updatedFilters_0[filterId].map((option_0)=>{
                return isMulti ? option_0 : {
                    ...option_0,
                    isSelected: false
                };
            });
            updatedFilters_0[filterId] = [
                ...updatedFilters_0[filterId],
                newSelectedOption
            ];
        }
        setFilters(updatedFilters_0);
        setUpdatedQueryParams(updatedFilters_0);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const resetDateOptions = (0, $42omo.useCallback)(()=>{
        const updatedFilters_1 = {
            ...filters
        };
        updatedFilters_1[(0, $jghB4.FilterIds).DATE] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE];
        updatedFilters_1[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option_1)=>({
                ...option_1,
                isSelected: false
            }));
        updatedFilters_1[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM];
        updatedFilters_1[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO];
        setFilters(updatedFilters_1);
        setUpdatedQueryParams(updatedFilters_1);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const toggleDateOption = (0, $42omo.useCallback)((filterId_0, option_2)=>{
        const { optionId: optionId, value: value } = option_2;
        const updatedFilters_2 = {
            ...filters
        };
        if (optionId === (0, $jghB4.OptionIds).LAST_MODIFIED) updatedFilters_2[filterId_0] = {
            ...updatedFilters_2[filterId_0],
            [(0, $jghB4.OptionIds).LAST_MODIFIED]: updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).LAST_MODIFIED].map((dateOption)=>dateOption.value === value && dateOption.value !== (0, $jghB4.defaultOptionValue) ? {
                    ...dateOption,
                    isSelected: !option_2.isSelected
                } : {
                    ...dateOption,
                    isSelected: false
                }),
            [(0, $jghB4.OptionIds).TO]: {
                ...updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).TO],
                isSelected: value === (0, $jghB4.LastModifiedValues).CUSTOM ? updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).TO].isSelected : false
            },
            [(0, $jghB4.OptionIds).FROM]: {
                ...updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).FROM],
                isSelected: value === (0, $jghB4.LastModifiedValues).CUSTOM ? updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).FROM].isSelected : false
            }
        };
        else updatedFilters_2[filterId_0] = {
            ...updatedFilters_2[filterId_0],
            [`${optionId}`]: {
                ...option_2,
                isSelected: !option_2.isSelected
            }
        };
        setFilters(updatedFilters_2);
        setUpdatedQueryParams(updatedFilters_2);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const updateCustomDateRange = (0, $42omo.useCallback)((selectedFromOption, selectedToOption)=>{
        const updatedFilters_3 = {
            ...filters
        };
        updatedFilters_3[(0, $jghB4.FilterIds).DATE] = {
            ...updatedFilters_3[(0, $jghB4.FilterIds).DATE],
            [(0, $jghB4.OptionIds).FROM]: {
                ...selectedFromOption,
                isSelected: selectedFromOption.isSelected
            },
            [(0, $jghB4.OptionIds).TO]: {
                ...selectedToOption,
                isSelected: selectedToOption.isSelected
            }
        };
        setFilters(updatedFilters_3);
        setUpdatedQueryParams(updatedFilters_3);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const resetOptions = (0, $42omo.useCallback)((filterId_1)=>{
        const updatedFilters_4 = {
            ...filters
        };
        updatedFilters_4[filterId_1] = updatedFilters_4[filterId_1].map((option_3)=>{
            return {
                ...option_3,
                isSelected: false
            };
        });
        setFilters(updatedFilters_4);
        setUpdatedQueryParams(updatedFilters_4);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const onSearchQueryChange = (0, $42omo.useCallback)((newQuery)=>{
        const queryIsQuestion_0 = (0, $2XcmP.isQuestion)({
            locale: locale,
            query: newQuery
        });
        if (queryIsQuestion_0) {
            setShowSearchAI(true);
            setAITriggeredByAskAI(false);
        } else setShowSearchAI(false);
        setQueryParams({
            text: newQuery || undefined
        });
    }, [
        setQueryParams,
        locale
    ]);
    const onClickAskAI = (0, $42omo.useCallback)((newQuery_0)=>{
        setShowSearchAI(true);
        setAITriggeredByAskAI(true);
        setQueryParams({
            text: newQuery_0
        });
    }, [
        setQueryParams
    ]);
    const clearFilters = (0, $42omo.useCallback)(()=>{
        const updatedFilters_5 = {
            ...filters
        };
        Object.keys((0, $jghB4.defaultFilterState)).forEach((filterId_2)=>{
            if (filterId_2 === (0, $jghB4.FilterIds).DATE) {
                updatedFilters_5[(0, $jghB4.FilterIds).DATE] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE];
                updatedFilters_5[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option_4)=>({
                        ...option_4,
                        isSelected: false
                    }));
                updatedFilters_5[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM];
                updatedFilters_5[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO];
            } else updatedFilters_5[filterId_2] = filters[filterId_2].map((option_5)=>({
                    ...option_5,
                    isSelected: false
                }));
        });
        setFilters(updatedFilters_5);
        setUpdatedQueryParams(updatedFilters_5);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const hasAppliedFilters = (0, $iD4ky.areFiltersSelected)(filters, false);
    const queryType = cqlQuery && !hasAppliedFilters && !searchQuery ? 'CQLQuery' : 'AGGQuery';
    const contextValue = (0, $42omo.useMemo)(()=>({
            searchQuery: searchQuery,
            filters: filters,
            cql: cqlQuery,
            queryType: queryType,
            isHydrated: !loading,
            onSearchQueryChange: onSearchQueryChange,
            toggleOption: toggleOption,
            resetOptions: resetOptions,
            toggleDateOption: toggleDateOption,
            updateCustomDateRange: updateCustomDateRange,
            resetDateOptions: resetDateOptions,
            clearFilters: clearFilters,
            sessionHasAppliedFilters: hasAppliedFilters,
            sessionHasUserInput: !!searchQuery || (0, $iD4ky.areFiltersSelected)(filters, true),
            onClickAskAI: onClickAskAI,
            showSearchAI: showSearchAI,
            aiTriggeredByAskAI: aiTriggeredByAskAI,
            aiSearchConfig: aiSearchConfig
        }), [
        clearFilters,
        cqlQuery,
        filters,
        loading,
        onSearchQueryChange,
        resetOptions,
        searchQuery,
        toggleDateOption,
        updateCustomDateRange,
        resetDateOptions,
        toggleOption,
        onClickAskAI,
        showSearchAI,
        aiTriggeredByAskAI,
        aiSearchConfig,
        hasAppliedFilters,
        queryType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($88423f473bb19836$export$e92004becf463495.Provider, {
        value: contextValue
    }, children);
};
module.exports["useSearchInputContext"] = $88423f473bb19836$export$cb42e09961db7f36;
module.exports["SearchInputProvider"] = $88423f473bb19836$export$720fa7c1ee69c9fc;

});

parcelRegister("2XcmP", function(module, exports) {
//refer to
//https://hello.atlassian.net/wiki/spaces/CASRAQ/pages/2821410030/Spike+Spec+Basic+Question+Detection+Integration+in+the+FE

var $1ycSR = parcelRequire("1ycSR");


var $cNAxK = parcelRequire("cNAxK");


var $ff9it = parcelRequire("ff9it");

const $35f896f2bbb88bbe$export$f72a6b3071a7b2a5 = ({ query: query, locale: locale })=>{
    const language = locale.split('-')[0].toLowerCase();
    const queryWords = query.split(' ');
    const endsWithAQuestionMark = query.endsWith('?');
    const isLanguageWithSpaces = (0, $1ycSR.languagesWithSpaces).includes(language);
    const isLanguageWithoutSpaces = (0, $cNAxK.languagesWithoutSpaces).includes(language);
    const isLanguageSupported = isLanguageWithSpaces || isLanguageWithoutSpaces;
    if (isLanguageSupported && endsWithAQuestionMark && queryWords.length > 1) return true;
    if (isLanguageWithSpaces) {
        const languageQuestionWords = (0, $ff9it.questionWords)[language];
        return queryWords.some((queryWord)=>languageQuestionWords.includes(queryWord.toLocaleLowerCase(locale))) && queryWords.length > 1;
    }
    if (isLanguageWithoutSpaces) {
        const languageQuestionWords = language === 'zh' ? (0, $ff9it.questionWords)[locale.toLowerCase()] : (0, $ff9it.questionWords)[language];
        return languageQuestionWords.some((questionWord)=>query.includes(questionWord)) && query.length > 1;
    }
    return false;
};
module.exports["isQuestion"] = $35f896f2bbb88bbe$export$f72a6b3071a7b2a5;

});

parcelRegister("1ycSR", function(module, exports) {
// combined lists below make the complete list of languages we currently support for detection
const $a6d657773e301106$export$bd2c824c45156b2b = [
    'en',
    'de',
    'ru',
    'fr',
    'pt',
    'cs',
    'el'
];
module.exports["languagesWithSpaces"] = $a6d657773e301106$export$bd2c824c45156b2b;

});

parcelRegister("cNAxK", function(module, exports) {
const $72ac09375fa29c15$export$175fffd27b9ba43e = [
    'zh',
    'ja',
    'ko'
];
module.exports["languagesWithoutSpaces"] = $72ac09375fa29c15$export$175fffd27b9ba43e;

});

parcelRegister("ff9it", function(module, exports) {
// eslint-disable-next-line no-barrel-files/no-barrel-files


const $85a5184734448d8e$export$6f8f84a4a12a6044 = {
    en: [
        'who',
        'what',
        'when',
        'where',
        'why',
        'is',
        'how',
        'which',
        'do',
        'does',
        'are',
        'can',
        'does',
        'would',
        'will',
        'could',
        'should',
        'did',
        'has',
        'have',
        'was'
    ],
    de: [
        'wer',
        'was',
        'wann',
        'wo',
        'warum',
        'wie',
        'welcher',
        'wieviel'
    ],
    ru: [
        "\u0447\u0442\u043E",
        "\u043A\u043E\u0433\u0434\u0430",
        "\u0433\u0434\u0435",
        "\u043F\u043E\u0447\u0435\u043C\u0443",
        "\u043A\u0430\u043A",
        "\u043A\u0430\u043A\u043E\u0432\u0430",
        "\u043A\u0442\u043E",
        "\u043A\u0430\u043A\u043E\u0439",
        "\u0441\u043A\u043E\u043B\u044C\u043A\u043E",
        "\u0437\u0430\u0447\u0435\u043C",
        "\u043E\u0442\u043A\u0443\u0434\u0430",
        "\u043A\u0443\u0434\u0430"
    ],
    fr: [
        'qui',
        'quoi',
        "o\xf9",
        'quand',
        'pourquoi',
        'comment',
        'combien',
        'lequel',
        'quel',
        'quelle',
        'quels',
        'quelles'
    ],
    pt: [
        'que',
        'quem',
        'onde',
        'quando',
        'como',
        'quanto',
        'qual'
    ],
    cs: [
        'kdo',
        'co',
        'kdy',
        'kde',
        "pro\u010D",
        'jak',
        'kolik',
        "kter\xfd"
    ],
    el: [
        "\u03C4\u03B9",
        "\u03C0\u03BF\u03B9\u03BF\u03C2",
        "\u03C0\u03BF\u03B9\u03B1",
        "\u03C0\u03BF\u03B9\u03BF",
        "\u03C0\u03CC\u03C4\u03B5",
        "\u03C0\u03BF\u03CD",
        "\u03C0\u03CE\u03C2",
        "\u03B3\u03B9\u03B1\u03C4\u03AF",
        "\u03C0\u03CC\u03C3\u03BF"
    ],
    'zh-cn': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-sg': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-hk': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-mo': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-tw': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    ja: [
        "\u4F55",
        "\u306A\u306B",
        "\u8AB0",
        "\u3060\u308C",
        "\u3069\u3053",
        "\u3069\u3046\u3057\u3066",
        "\u3044\u3064",
        "\u3069\u306E",
        "\u3044\u304F\u3064",
        "\u3069\u308C"
    ],
    ko: [
        "\uBB34\uC5C7",
        "\uBB50",
        "\uC5B4\uB514",
        "\uC5B8\uC81C",
        "\uC65C",
        "\uB204\uAD6C",
        "\uC5B4\uB5BB\uAC8C",
        "\uBA87",
        "\uC5B4\uB290"
    ]
};
module.exports["questionWords"] = $85a5184734448d8e$export$6f8f84a4a12a6044;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $lzcvT.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("c2fn3", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $f7lNm = parcelRequire("f7lNm");


var $ca96q = parcelRequire("ca96q");

// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $13e20894b1795bef$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
// temporaray solution for detecting query intent for new smart answers
// TODO: remove this once BE/ML solution is ready for use
function $13e20894b1795bef$var$detectQueryIntent(query, _cloudId) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return (0, $f7lNm.QueryIntent).JIRA_ISSUE;
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return (0, $f7lNm.QueryIntent).JIRA_ISSUE;
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return (0, $f7lNm.QueryIntent).AGENT;
    return null;
}
const $13e20894b1795bef$export$af8ff827a7d12c1e = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $f7lNm.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
    };
    try {
        let queryIntent = $13e20894b1795bef$var$detectQueryIntent(query, cloudId);
        if (queryIntent) setQueryIntent(queryIntent);
        const aggResponse = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $ca96q.KnowledgeDiscoveryAnswerRouteQuery),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $ca96q.ANSWER_ROUTE_OPERATION_NAME),
            cache: {
                ttl: 300000,
                key: query
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        const response = aggResponse?.data?.knowledgeDiscovery.smartAnswersRoute;
        if (!response || response?.__typename === 'QueryError' || Boolean(response?.message)) {
            // If we have a query intent, we can use the original query
            if (queryIntent) {
                if (queryIntent === (0, $f7lNm.QueryIntent).AGENT) {
                    setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
                    return;
                }
                setTransformedQuery(query);
                return;
            }
            const error = new Error(response?.message || 'getSmartAnswerRoute error');
            handleError(error);
            return;
        }
        if (!queryIntent) {
            let beQueryIntent = response.route;
            if (beQueryIntent === (0, $f7lNm.QueryIntent).VISUAL && !(0, $dh538.fg)('hybrid_orchestrator_enable_image_search')) beQueryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
            if (beQueryIntent === (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY && selectedProduct && !$13e20894b1795bef$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $dh538.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) beQueryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
            setQueryIntent(beQueryIntent);
        }
        if (queryIntent === (0, $f7lNm.QueryIntent).AGENT) {
            setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
            return;
        }
        setTransformedQuery(response.transformedQuery);
    } catch (error) {
        handleError(error);
    }
};
module.exports["getSmartAnswerRoute"] = $13e20894b1795bef$export$af8ff827a7d12c1e;

});

parcelRegister("ca96q", function(module, exports) {
const $b4ee38bbfadb7dbb$export$9b6dcba7f888840b = 'KnowledgeDiscoveryAnswerRoute';
const $b4ee38bbfadb7dbb$export$87415d93715f6028 = `
  query ${$b4ee38bbfadb7dbb$export$9b6dcba7f888840b}(
    $siteId: String!
    $query: String!
    $locale: String!
    $metadata: KnowledgeDiscoveryMetadata
    $orgId: String
  ) {
    knowledgeDiscovery {
      smartAnswersRoute(
        siteId: $siteId
        query: $query
        locale: $locale
				metadata: $metadata
				orgId: $orgId
      ) {
        __typename
        ... on KnowledgeDiscoverySmartAnswersRoute {
          route
          transformedQuery
        }
        ... on QueryError {
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
module.exports["ANSWER_ROUTE_OPERATION_NAME"] = $b4ee38bbfadb7dbb$export$9b6dcba7f888840b;
module.exports["KnowledgeDiscoveryAnswerRouteQuery"] = $b4ee38bbfadb7dbb$export$87415d93715f6028;

});

parcelRegister("dmHCt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");

const $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.ADVANCED_SEARCH_LOAD_KEY)
});
const $39eddf90ec2ee1a9$export$8c056601d31b4cd5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$db955b49fff67969 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$c9bd41426c856cf1 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$b390264dd924c8b1 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.UNIFIED_SEARCH_LOAD_KEY)
});
module.exports["ADVANCED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac;
module.exports["ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$8c056601d31b4cd5;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$db955b49fff67969;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$c9bd41426c856cf1;
module.exports["UNIFIED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$b390264dd924c8b1;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $cbc8g.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
$parcel$export(module.exports, "createBM3PageSegmentLoadMetricRaw", () => $864083edfead32eb$export$2a2fe1e11b4e0413);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");

const { pageSegmentLoad: $864083edfead32eb$export$2a2fe1e11b4e0413 } = (0, $kyiqo.metrics);

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("cacu1", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lLRfG = parcelRequire("lLRfG");


var $dmHCt = parcelRequire("dmHCt");

const $94cd8136f02eb351$export$7999a9defd2c3cf4 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
    }));
const $94cd8136f02eb351$export$f397be5efb2fdcd6 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
            metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
    }));
module.exports["PageLoadEndEvent"] = $94cd8136f02eb351$export$7999a9defd2c3cf4;
module.exports["PageLoadEndEventUnifiedSearch"] = $94cd8136f02eb351$export$f397be5efb2fdcd6;

});

parcelRegister("lLRfG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cbc8g = parcelRequire("cbc8g");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $cbc8g.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("6Igo2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

var $57a37a05cfcf8769$exports = {};
$57a37a05cfcf8769$exports = new URL("GenericError.ea0db8e6.svg", import.meta.url).toString();


const $455c34b0e24b3e5a$export$815a543a64d7dd5e = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0q1b66 _1ekaidpf _1shmidpf",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.loading ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1b66 _1ekaidpf _1shmidpf",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.loading ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$91cab4befa1216ba = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkxncg _1e0c1txw _2lx21bp4 _4cvr1h6o _1z97kbql _1qon1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkxncg _1e0c1txw _2lx21bp4 _4cvr1h6o _1z97kbql _1qon1h6o",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$33462456345ed820 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(6);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $7sObp.default)((0, (/*@__PURE__*/$parcel$interopDefault($57a37a05cfcf8769$exports))), ")", "url(");
            $[3] = t3;
        } else t3 = $[3];
        let t4;
        if ($[4] !== __cmpls) {
            t4 = {
                ...__cmpls,
                "--_6u6us4": t3
            };
            $[4] = __cmpls;
            $[5] = t4;
        } else t4 = $[5];
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmplp,
            style: t4,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q71o12 _1lrw1f51 _1bsb68cl _4t3iplmo",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6u6us4": (0, $7sObp.default)((0, (/*@__PURE__*/$parcel$interopDefault($57a37a05cfcf8769$exports))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71o12 _1lrw1f51 _1bsb68cl _4t3iplmo",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$1c93378887204d45 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omtlke",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$8c06dfd742f74a6f = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qpxbi",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$ed4dedd23dd2ba7d = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$3bab0e8c0fc477a3 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3iyly2 _18m915vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3iyly2 _18m915vq",
            __cmplp.className
        ])
    });
});
module.exports["SearchResultListContainer"] = $455c34b0e24b3e5a$export$815a543a64d7dd5e;
module.exports["SearchMessagesContainer"] = $455c34b0e24b3e5a$export$91cab4befa1216ba;
module.exports["GenericErrorImage"] = $455c34b0e24b3e5a$export$33462456345ed820;
module.exports["ErrorSuggestionLink"] = $455c34b0e24b3e5a$export$1c93378887204d45;
module.exports["ClearFiltersButtonWrapper"] = $455c34b0e24b3e5a$export$8c06dfd742f74a6f;
module.exports["SearchPaginationContainer"] = $455c34b0e24b3e5a$export$ed4dedd23dd2ba7d;
module.exports["SearchResultListLoadingContainer"] = $455c34b0e24b3e5a$export$3bab0e8c0fc477a3;

});

parcelRegister("3ro6F", function(module, exports) {
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3gadb = parcelRequire("3gadb");


var $5azuv = parcelRequire("5azuv");


var $9VmkK = parcelRequire("9VmkK");


var $F1g0V = parcelRequire("F1g0V");

const $5c3d9d5d7ce5effd$var$itemWrapperStyles = null;
const $5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE = 24;
const $5c3d9d5d7ce5effd$var$staticItemStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithoutTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$BreadcrumbsItem = /*#__PURE__*/ (0, $42omo.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const stepTextRef = (0, $42omo.useRef)(null); // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $F1g0V.default)(truncationWidth, stepTextRef.current, iconWidthAllowance); // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }; // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5azuv.default), {
        ref: stepTextRef,
        analyticsContext: analyticsContext,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        target: target,
        testId: testId,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9VmkK.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: stepTextRef,
        target: target,
        testId: testId,
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $gMc0m.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("li", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c3d9d5d7ce5effd$export$2e2bcd8739ae039 = $5c3d9d5d7ce5effd$var$BreadcrumbsItem;
module.exports["default"] = $5c3d9d5d7ce5effd$export$2e2bcd8739ae039;

});

parcelRegister("5azuv", function(module, exports) {
/* step.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $1Whri = parcelRequire("1Whri");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");

const $bd15777e6f419ea7$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bd15777e6f419ea7$var$noop = (0, $ee7An.default);
const $bd15777e6f419ea7$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcv77o _18zrze3t _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootT26Shape: "_2rkolb4i",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $bd15777e6f419ea7$var$Step = /*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $bd15777e6f419ea7$var$noop, target: target, testId: testId, children: children, truncationWidth: truncationWidth, ...rest }, ref)=>{
    const handleClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$bd15777e6f419ea7$var$analyticsAttributes
    });
    const content = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            iconBefore,
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                ref: ref,
                className: (0, $gMc0m.default)([
                    $bd15777e6f419ea7$var$styles.text
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: href,
        onClick: handleClick,
        target: target,
        testId: testId,
        xcss: (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, !truncationWidth && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        },
        ...rest,
        children: content
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: handleClick,
        testId: testId,
        xcss: (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, !truncationWidth && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        },
        ...rest,
        children: content
    });
});
var $bd15777e6f419ea7$export$2e2bcd8739ae039 = $bd15777e6f419ea7$var$Step;
module.exports["default"] = $bd15777e6f419ea7$export$2e2bcd8739ae039;

});

parcelRegister("9VmkK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $eEA8O = parcelRequire("eEA8O");


var $ee7An = parcelRequire("ee7An");

const $b9cd9c632c3988d9$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $b9cd9c632c3988d9$var$noop = (0, $ee7An.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $b9cd9c632c3988d9$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $b9cd9c632c3988d9$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$b9cd9c632c3988d9$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $b9cd9c632c3988d9$export$2e2bcd8739ae039 = $b9cd9c632c3988d9$var$StepOld;
module.exports["default"] = $b9cd9c632c3988d9$export$2e2bcd8739ae039;

});

parcelRegister("F1g0V", function(module, exports) {
$parcel$export(module.exports, "default", () => $7675ee682b2302ec$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $7675ee682b2302ec$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $42omo.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $42omo.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $42omo.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});

parcelRegister("kGnTD", function(module, exports) {
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $k7fGo = parcelRequire("k7fGo");


var $3AVDQ = parcelRequire("3AVDQ");

const $bb8be9a617eb3e67$var$defaultMaxItems = 8;
const $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $bb8be9a617eb3e67$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $bb8be9a617eb3e67$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children;
const $bb8be9a617eb3e67$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bb8be9a617eb3e67$var$noop = (0, $ee7An.default);
const $bb8be9a617eb3e67$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $bb8be9a617eb3e67$var$breadcrumbStyles = null;
const $bb8be9a617eb3e67$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $bb8be9a617eb3e67$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $bb8be9a617eb3e67$var$noop, analyticsContext: analyticsContext, label: label = $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $bb8be9a617eb3e67$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $42omo.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $42omo.useState)(false);
    const wrapperRef = (0, $42omo.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $bb8be9a617eb3e67$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $42omo.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($bb8be9a617eb3e67$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $3AVDQ.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$bb8be9a617eb3e67$var$analyticsAttributes
    });
    const childrenArray = $bb8be9a617eb3e67$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $k7fGo.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $l998X.jsx)("nav", {
        "aria-label": label,
        ref: (0, $3654r.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $l998X.jsx)("ol", {
            "data-testid": testId,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $bb8be9a617eb3e67$var$Breadcrumbs = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)($bb8be9a617eb3e67$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $bb8be9a617eb3e67$export$2e2bcd8739ae039 = $bb8be9a617eb3e67$var$Breadcrumbs;
module.exports["default"] = $bb8be9a617eb3e67$export$2e2bcd8739ae039;

});

parcelRegister("k7fGo", function(module, exports) {
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ee7An = parcelRequire("ee7An");


var $fVUfS = parcelRequire("fVUfS");

const $7976e3e68603e041$var$noop = (0, $ee7An.default);
const $7976e3e68603e041$var$itemWrapperStyles = null;
const $7976e3e68603e041$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo"
};
const $7976e3e68603e041$var$EllipsisItem = /*#__PURE__*/ (0, $42omo.memo)(({ label: label, onClick: onClick = $7976e3e68603e041$var$noop, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("li", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: $7976e3e68603e041$var$styles.root,
            testId: testId,
            children: "\u2026"
        })
    })); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7976e3e68603e041$export$2e2bcd8739ae039 = $7976e3e68603e041$var$EllipsisItem;
module.exports["default"] = $7976e3e68603e041$export$2e2bcd8739ae039;

});

parcelRegister("3AVDQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bzNqF = parcelRequire("bzNqF");

function $bbb20e0fdee82203$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $bzNqF.default)(isExpanded);
    (0, $42omo.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}
module.exports["useOnRevealed"] = $bbb20e0fdee82203$export$e9c4922b2ecf808a;

});

parcelRegister("6p02T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("bmowW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $aXWIB.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("3DisR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3Mg7y = parcelRequire("3Mg7y");

const $2785e5028b3f2b25$export$81e857055d3e1f66 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
        color: "var(--ds-icon, #292A2E)",
        ...props
    });
module.exports["QuickSummaryIcon"] = $2785e5028b3f2b25$export$81e857055d3e1f66;

});

parcelRegister("3frzj", function(module, exports) {

let $25d8285678afe786$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25d8285678afe786$var$load("ac6oS").then(()=>parcelRequire('bA62P'));

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $gMc0m.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("57yeA", function(module, exports) {

let $3ba8296475944126$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ba8296475944126$var$load("5Q3hn").then(()=>parcelRequire('79zMz'));

});

parcelRegister("27sFv", function(module, exports) {

let $18b279322a7d2d6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18b279322a7d2d6f$var$load("kaNx1").then(()=>parcelRequire('3pSQ0'));

});

parcelRegister("hHJ3S", function(module, exports) {
/* ai-topics-card-by-document.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cVtio = parcelRequire("cVtio");


var $14qs9 = parcelRequire("14qs9");


var $gt1E3 = parcelRequire("gt1E3");


var $ljjcE = parcelRequire("ljjcE");


var $9G2ji = parcelRequire("9G2ji");


var $1OUvo = parcelRequire("1OUvo");


var $2VT7J = parcelRequire("2VT7J");


var $gK4sy = parcelRequire("gK4sy");


var $bHyMQ = parcelRequire("bHyMQ");

const $0baf31897df6f9d7$var$styles = {
    root: "_2rko12b0 _bfhkhp5a _16qst7xp _19pkpxbi"
};
const $0baf31897df6f9d7$var$TOPICS_CARD_FEEDBACK_CONTEXT = 'AI topics from topics card in advanced search';
const $0baf31897df6f9d7$var$documentMap = {
    page: (0, $ljjcE.RelatedEntityType).CONFLUENCE_PAGE,
    blogpost: (0, $ljjcE.RelatedEntityType).CONFLUENCE_BLOGPOST
};
const $0baf31897df6f9d7$var$AITopicsCardByDocumentComponent = /*#__PURE__*/ (0, $42omo.memo)(({ documentId: documentId, documentType: documentType, searchQuery: searchQuery, cloudId: cloudId, userId: userId, userName: userName })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { aiRelatedTopics: aiRelatedTopics, fetchRelatedTopics: fetchRelatedTopics, showTopics: showTopics, resetTopics: resetTopics } = (0, $bHyMQ.useRelatedTopics)();
    const principalEntityType = $0baf31897df6f9d7$var$documentMap[documentType ?? ''];
    const principalEntityId = documentId ?? '';
    const feedbackAttributes = {
        feedbackContext: $0baf31897df6f9d7$var$TOPICS_CARD_FEEDBACK_CONTEXT,
        principalEntityId: principalEntityId,
        principalEntityType: principalEntityType
    };
    const userInfo = {
        id: userId,
        name: userName
    };
    const onBadgeClickHandler = (topicId)=>{
        fireAnalyticsEvent((0, $9G2ji.onRelatedEntityClick)({
            clickedEntityId: topicId,
            clickedEntityType: (0, $ljjcE.RelatedEntityType).TOPIC,
            principalEntityType: principalEntityType,
            principalEntityId: principalEntityId,
            location: 'topicCardAdvancedSearch'
        }));
    };
    (0, $42omo.useEffect)(()=>{
        if (!principalEntityType || !searchQuery) resetTopics();
        else if (principalEntityType) fetchRelatedTopics({
            entityId: principalEntityId,
            principalEntityType: principalEntityType,
            cloudId: cloudId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        principalEntityType,
        searchQuery,
        resetTopics,
        principalEntityId,
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (showTopics) fireAnalyticsEvent((0, $9G2ji.onSurfaceShown)({
            principalEntityId: principalEntityId,
            principalEntityType: principalEntityType,
            relatedTopics: aiRelatedTopics.map((topic)=>topic.id),
            location: 'topicCardAdvancedSearch'
        }));
    }, [
        showTopics,
        fireAnalyticsEvent,
        principalEntityId,
        principalEntityType,
        aiRelatedTopics
    ]);
    if (!showTopics) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $0baf31897df6f9d7$var$styles.root,
        testId: "ai-topics-card-by-document",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.200",
                paddingBlockEnd: "space.100",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $gK4sy.messages).ai_topics_card_header_text,
                            values: {
                                searchQuery: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "bold",
                                    children: searchQuery
                                })
                            }
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            space: "space.100",
                            rowSpace: "space.100",
                            shouldWrap: true,
                            children: aiRelatedTopics.map((topic)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gt1E3.KnowledgeBadge), {
                                    name: topic.name,
                                    url: `/wiki/topics/${topic.id}`,
                                    onBadgeClick: ()=>onBadgeClickHandler(topic.id)
                                }, topic.id))
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2VT7J.AITopicsSentimentFeedback), {
                            attributes: feedbackAttributes,
                            prompt: formatMessage((0, $gK4sy.messages).ai_topics_card_feedback_prompt),
                            location: "aiTopicsCardAdvancedSearch",
                            userDetails: userInfo
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1OUvo.AITopicsFooter), {})
        ]
    });
});
const $0baf31897df6f9d7$export$dc980e08cd0dec3e = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($0baf31897df6f9d7$var$AITopicsCardByDocumentComponent, {
            ...props
        })
    });
module.exports["AITopicsCardByDocument"] = $0baf31897df6f9d7$export$dc980e08cd0dec3e;

});

parcelRegister("cVtio", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $f7lNm = parcelRequire("f7lNm");

const $ca77e5059fb214ed$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $ca77e5059fb214ed$export$e955abb82869dc84;

});

parcelRegister("1OUvo", function(module, exports) {
/* ai-topics-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $3WVxj = parcelRequire("3WVxj");


var $eLJ6t = parcelRequire("eLJ6t");


var $gK4sy = parcelRequire("gK4sy");

const $3060816262aeedc1$var$styles = {
    root: "_1rjc1b66 _18zrpxbi _uwhke4h9 _15a5nqa1 _1i531l7x _1e0c1txw _1bah1yb4"
};
const $3060816262aeedc1$export$5a4b3935f294490b = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $3060816262aeedc1$var$styles.root,
        testId: "ai-topics-footer",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3WVxj.default), {
                        text: formatMessage((0, $gK4sy.messages).ai_topics_surface_footer_beta_lozenge),
                        isRemovable: false,
                        migration_fallback: "lozenge"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                        color: "var(--ds-icon, #292A2E)",
                        label: "",
                        spacing: "compact",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: formatMessage((0, $gK4sy.messages).ai_topics_surface_footer_content_may_vary)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: formatMessage((0, $gK4sy.messages).ai_topics_surface_footer_powered_by_ai)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ6t.default), {
                        greyed: true
                    })
                ]
            })
        ]
    });
};
module.exports["AITopicsFooter"] = $3060816262aeedc1$export$5a4b3935f294490b;

});

parcelRegister("eLJ6t", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $4af0d4a8e674c639$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 15.3L17.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 15.3L6.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 10.3L6.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 10.3L17.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 16.8V19.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.00012 12.8L5.00012 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 8.80003L12.0001 5.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.0002 12.8L19.0002 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            })
        ]
    });
var $4af0d4a8e674c639$export$2e2bcd8739ae039 = $4af0d4a8e674c639$export$eaf821108be3620b;
module.exports["default"] = $4af0d4a8e674c639$export$2e2bcd8739ae039;

});

parcelRegister("2VT7J", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eRXI0 = parcelRequire("eRXI0");


var $4jIuc = parcelRequire("4jIuc");


var $cVtio = parcelRequire("cVtio");


var $8s0lk = parcelRequire("8s0lk");


var $f7lNm = parcelRequire("f7lNm");


var $in6B9 = parcelRequire("in6B9");

const $a83e8fcbfbcb3473$export$43a172640d082206 = ({ prompt: prompt, attributes: attributes, location: location, userDetails: userDetails })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const onLikeClick = ()=>{
        fireAnalyticsEvent((0, $in6B9.onSentimentClick)({
            ...attributes,
            sentiment: 'positive',
            location: location
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDislikeClick = ()=>{
        fireAnalyticsEvent((0, $in6B9.onSentimentClick)({
            ...attributes,
            sentiment: 'negative',
            location: location
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050",
        testId: "ai-topics-sentiment-feedback",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest",
                children: prompt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8s0lk.AIFeedbackV2), {
                entrypointId: (0, $f7lNm.FEEDBACK_ENTRYPOINT_ID_TOPICS),
                userDetails: userDetails,
                attributes: attributes,
                attributesWithConsent: {},
                onLikeButtonClickHandler: onLikeClick,
                onDislikeButtonClickHandler: onDislikeClick
            })
        ]
    });
};
module.exports["AITopicsSentimentFeedback"] = $a83e8fcbfbcb3473$export$43a172640d082206;

});

parcelRegister("8s0lk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7gpC4 = parcelRequire("7gpC4");


var $6uGcC = parcelRequire("6uGcC");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $f7lNm = parcelRequire("f7lNm");


var $cVShq = parcelRequire("cVShq");


var $lKYSu = parcelRequire("lKYSu");


var $Ze1Cu = parcelRequire("Ze1Cu");


const $fb8ee5ddf0b7e055$var$AkFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $fb8ee5ddf0b7e055$var$AkFeedbackFlag = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $fb8ee5ddf0b7e055$export$204772be093f4012 = ({ entrypointId: entrypointId, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, userDetails: userDetails, attributes: attributes, attributesWithConsent: attributesWithConsent = {}, liked: externalLike, customContent: // set like state from the outside
customContent, featureTitle: featureTitle })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [showFeedbackModal, setFeedbackModal] = (0, $42omo.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    const [hasConsent, setConsent] = (0, $42omo.useState)(false);
    const [liked, setLiked] = (0, $42omo.useState)(externalLike);
    const feedbackObject = {
        ...attributes,
        ...hasConsent ? attributesWithConsent : {}
    };
    const feedbackContext = Object.entries(feedbackObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $42omo.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.050",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cVShq.FeedbackButtons), {
                    setDisplayFlag: setDisplayFlag,
                    setFeedbackModal: setFeedbackModal,
                    onLikeButtonClickHandler: onLikeButtonClickHandler,
                    onDislikeButtonClickHandler: onDislikeButtonClickHandler,
                    liked: liked,
                    setLiked: setLiked
                })
            }),
            showFeedbackModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)($fb8ee5ddf0b7e055$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>{
                        setFeedbackModal(false);
                    },
                    onSubmit: ()=>{
                        setDisplayFlag(true);
                    },
                    customContent: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        children: [
                            Object.keys(attributesWithConsent).length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $lKYSu.messages).ai_answer_component_report_consent_checkbox_label),
                                onChange: toggleConsentCheckbox,
                                isChecked: hasConsent
                            }) : undefined,
                            customContent
                        ]
                    }),
                    atlassianAccountId: userDetails.id,
                    name: userDetails.name,
                    entrypointId: entrypointId,
                    additionalFields: [
                        {
                            id: (0, $f7lNm.FEEDBACK_CONTEXT_CF),
                            value: feedbackContext
                        }
                    ],
                    feedbackTitle: formatMessage((0, $lKYSu.messages).ai_answer_component_report_modal_title, {
                        featureTitle: featureTitle ?? 'Atlassian Intelligence'
                    }),
                    feedbackTitleDetails: /*#__PURE__*/ (0, $l998X.jsx)((0, $Ze1Cu.AIAnswerReportDescriptionWrapper), {
                        children: formatMessage((0, $lKYSu.messages).ai_answer_component_report_summary_label)
                    }),
                    feedbackGroupLabels: {
                        empty: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_empty_option_share_label)
                        },
                        question: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_relevance_option_label)
                        },
                        comment: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: ''
                        },
                        bug: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: ''
                        },
                        suggestion: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_other_option_label)
                        }
                    },
                    summaryPlaceholder: formatMessage((0, $lKYSu.messages).ai_answer_component_summary_placeholder_label)
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($fb8ee5ddf0b7e055$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $lKYSu.messages).ai_answer_component_feedback_flag_description)
                    })
                })
            })
        ]
    });
};
module.exports["AIFeedbackV2"] = $fb8ee5ddf0b7e055$export$204772be093f4012;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $gMc0m.default)([
                        $71feb0a29953fded$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("cVShq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $9zIwY = parcelRequire("9zIwY");


var $9FnLD = parcelRequire("9FnLD");


var $lKYSu = parcelRequire("lKYSu");

const $f7d37ee6f062b97b$var$LikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $f7d37ee6f062b97b$var$ActiveLikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
const $f7d37ee6f062b97b$var$DislikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $f7d37ee6f062b97b$var$ActiveDislikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
const $f7d37ee6f062b97b$export$c633fc044a8b8981 = ({ liked: liked, setLiked: setLiked, setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [likesDisabled, setLikesDisabled] = (0, $42omo.useState)(false);
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        onLikeButtonClickHandler && onLikeButtonClickHandler(e);
    }, [
        setDisplayFlag,
        setLiked,
        onLikeButtonClickHandler
    ]);
    const dislikeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        onDislikeButtonClickHandler && onDislikeButtonClickHandler(e);
    }, [
        setFeedbackModal,
        setLiked,
        onDislikeButtonClickHandler
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: liked === true ? $f7d37ee6f062b97b$var$ActiveLikeIcon : $f7d37ee6f062b97b$var$LikeIcon,
                onClick: likeButtonCallback,
                label: formatMessage((0, $lKYSu.messages).ai_answer_component_like_button_tooltip),
                appearance: "subtle",
                isTooltipDisabled: false,
                isDisabled: liked && likesDisabled,
                testId: "ai-answer-like-button",
                spacing: "compact"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: liked === false ? $f7d37ee6f062b97b$var$ActiveDislikeIcon : $f7d37ee6f062b97b$var$DislikeIcon,
                onClick: dislikeButtonCallback,
                label: formatMessage((0, $lKYSu.messages).ai_answer_component_dislike_button_tooltip),
                appearance: "subtle",
                isTooltipDisabled: false,
                isDisabled: !liked && likesDisabled,
                testId: "ai-answer-dislike-button",
                spacing: "compact"
            })
        ]
    });
};
module.exports["FeedbackButtons"] = $f7d37ee6f062b97b$export$c633fc044a8b8981;

});

parcelRegister("lKYSu", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9f9db0398a2d685d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {featureTitle}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the response? Let us know what happened."
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    }
});
module.exports["messages"] = $9f9db0398a2d685d$export$defe85febe8b728c;

});

parcelRegister("Ze1Cu", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $49ca0736ce81ccf3$export$8b91051e793e6316 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n3tdpxbi",
            __cmplp.className
        ])
    });
});
module.exports["AIAnswerReportDescriptionWrapper"] = $49ca0736ce81ccf3$export$8b91051e793e6316;

});

parcelRegister("6yoZS", function(module, exports) {

let $4c594eef01830b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c594eef01830b0b$var$load("hhss7"),
    $4c594eef01830b0b$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});

parcelRegister("in6B9", function(module, exports) {

var $4Zqgi = parcelRequire("4Zqgi");

const $a5ac8d89a4e0e1b2$export$c5c4147343613b24 = (sentimentClickAttributes)=>{
    try {
        return {
            action: 'clicked',
            actionSubjectId: 'aiTopic',
            actionSubject: sentimentClickAttributes.sentiment === 'positive' ? 'likeButton' : 'dislikeButton',
            eventType: 'ui',
            attributes: {
                ...sentimentClickAttributes
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onSentimentClick'
        });
        return {};
    }
};
module.exports["onSentimentClick"] = $a5ac8d89a4e0e1b2$export$c5c4147343613b24;

});

parcelRegister("gBQBJ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $igBZP = parcelRequire("igBZP");


var $dwp40 = parcelRequire("dwp40");


var $a8qZr = parcelRequire("a8qZr");


var $j118Q = parcelRequire("j118Q");


var $bF0iL = parcelRequire("bF0iL");


var $6dP89 = parcelRequire("6dP89");


var $04MMo = parcelRequire("04MMo");


var $5dFS9 = parcelRequire("5dFS9");


var $USdFJ = parcelRequire("USdFJ");


var $bNeIF = parcelRequire("bNeIF");


var $kTnHZ = parcelRequire("kTnHZ");


var $5TmpD = parcelRequire("5TmpD");

const $02100814775b6148$export$67c8b43f41ede17a = ({ label: label, onClick: onClick, corrections: corrections })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $a8qZr.TextLabelWrapper), {
                children: [
                    label,
                    ": "
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j118Q.TextCorrectionWrapper), {
                onClick: onClick,
                children: corrections.map(({ distance: distance, term: term }, index)=>{
                    const space = index === corrections.length - 1 ? '' : ' ';
                    if (distance === 0) return term.concat(space);
                    else return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("b", {
                                children: term
                            }),
                            space
                        ]
                    });
                })
            })
        ]
    });
};
const $02100814775b6148$var$AutocorrectionComponent = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, query: query, label: label, lang: lang, onCorrectionSelect: onCorrectionSelect, source: source = '', searchSessionId: searchSessionId = '', productId: productId = '', debounce: debounce = (0, $5TmpD.DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS), noCorrectionPlaceholder: noCorrectionPlaceholder })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const [corrections, setCorrections] = (0, $42omo.useState)([]);
    const correction = corrections.map((word)=>word.term).join(' ');
    const shouldFetchCorrections = (0, $kTnHZ.shouldFetchAutocorrection)(query);
    const getCorrection = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($igBZP)))((query)=>{
        return (0, $dwp40.utils).requestService({
            url: aggregatorUrl
        }, {
            path: `${(0, $5TmpD.AUTOCORRECT_API_PATH)}`,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query: query,
                    language: lang,
                    cloudId: cloudId
                })
            }
        });
    }, debounce)).current;
    const onClick = (0, $42omo.useCallback)(()=>{
        setCorrections([]);
        onCorrectionSelect(correction);
        fireAnalyticsEvent((0, $5dFS9.onAutocorrectClicked)({
            source: source,
            attributes: {
                searchSessionId: searchSessionId,
                correctionHash: (0, $04MMo.sha256Hash)(correction),
                language: lang,
                productId: productId
            }
        }));
    }, [
        onCorrectionSelect,
        correction,
        fireAnalyticsEvent,
        lang,
        productId,
        searchSessionId,
        source
    ]);
    (0, $42omo.useEffect)(()=>{
        setCorrections([]);
        if (shouldFetchCorrections) getCorrection(query).then((result)=>{
            if (!!result.termCorrections) setCorrections(result.termCorrections);
        });
    }, [
        shouldFetchCorrections,
        query,
        getCorrection
    ]);
    (0, $42omo.useEffect)(()=>{
        if (corrections.length > 0 && shouldFetchCorrections) fireAnalyticsEvent((0, $5dFS9.onAutocorrectShown)({
            source: source,
            attributes: {
                searchSessionId: searchSessionId,
                correction: (0, $04MMo.sha256Hash)(correction),
                language: lang,
                productId: productId
            }
        }));
    }, [
        shouldFetchCorrections,
        corrections,
        correction,
        fireAnalyticsEvent,
        lang,
        productId,
        query,
        searchSessionId,
        source
    ]);
    if (corrections.length === 0 || !query) return !!noCorrectionPlaceholder ? noCorrectionPlaceholder : null;
    return /*#__PURE__*/ (0, $l998X.jsx)($02100814775b6148$export$67c8b43f41ede17a, {
        label: label,
        onClick: onClick,
        corrections: corrections
    });
};
const $02100814775b6148$export$20554bfec541828d = ({ lang: propsLang, aggregatorUrl: aggregatorUrl = (0, $USdFJ.AGGREGATOR_URL), container: container, ...rest })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const intlLang = (0, $bNeIF.sanitizeLanguage)(locale);
    const lang = propsLang || intlLang;
    if (!(0, $5TmpD.isSupportedLanguage)(lang)) return null;
    const Wrapper = !!container ? container : (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
            ...props
        });
    return /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
        "data-testid": "autocorrect-wrapper",
        children: /*#__PURE__*/ (0, $l998X.jsx)($02100814775b6148$var$AutocorrectionComponent, {
            label: formatMessage((0, $bF0iL.messages).common_autocorrection_label),
            lang: lang,
            aggregatorUrl: aggregatorUrl,
            ...rest
        })
    });
};
module.exports["AutocorrectionText"] = $02100814775b6148$export$67c8b43f41ede17a;
module.exports["Autocorrection"] = $02100814775b6148$export$20554bfec541828d;

});

parcelRegister("igBZP", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d4c731e2a28427e0$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d4c731e2a28427e0$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d4c731e2a28427e0$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d4c731e2a28427e0$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("a8qZr", function(module, exports) {
// eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cStGJ = parcelRequire("cStGJ");

function $3f156aad729e8a8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3f156aad729e8a8a$export$379a552b6c4d77e1 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e2gsb010"
})({
    name: "9gup9y",
    styles: "color:var(--ds-text-accent-red, #AE2E24);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
module.exports["TextLabelWrapper"] = $3f156aad729e8a8a$export$379a552b6c4d77e1;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("j118Q", function(module, exports) {
// eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cStGJ = parcelRequire("cStGJ");

function $09364d2f9faab89b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $09364d2f9faab89b$export$98340ed1d0e44a86 = /*#__PURE__*/ (0, $cStGJ.default)("a", {
    target: "e1wannzz0"
})({
    name: "10s0jjn",
    styles: "cursor:pointer;color:var(--ds-text-accent-blue, #1558BC);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
module.exports["TextCorrectionWrapper"] = $09364d2f9faab89b$export$98340ed1d0e44a86;

});

parcelRegister("6AxFm", function(module, exports) {

let $4cc0384566ddd786$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cc0384566ddd786$var$load("lTK3c"),
    $4cc0384566ddd786$var$load("1WXdc"),
    $4cc0384566ddd786$var$load("6wr18"),
    $4cc0384566ddd786$var$load("cM6bW"),
    $4cc0384566ddd786$var$load("ffEVr"),
    $4cc0384566ddd786$var$load("hhss7"),
    $4cc0384566ddd786$var$load("cyGuT"),
    $4cc0384566ddd786$var$load("2nwxY")
]).then(()=>parcelRequire('bonfL'));

});

parcelRegister("1oLkX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e5cea1fed6b35db0$export$a4874344a0a08e9e = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_p12f1fra _1e0c116y _1n261g80 _1p57u2gc _gy1pu2gc _19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1fra _1e0c116y _1n261g80 _1p57u2gc _gy1pu2gc _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$668eb470a70772b7 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _11q71j9a _vchhusvi _1e0c1ule _16qs130s _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _11q71j9a _vchhusvi _1e0c1ule _16qs130s _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$d586e0ae81c7b89b = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1gwv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1gwv",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$c0e1e4e72a41cc80 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { context: context, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _102efhey _1t4pi7uo",
            __cmplp.context === "menu" ? "_18u01y44" : "_18u0idpf",
            __cmplp.context === "menu" ? "_24rcftgi" : "_24rc1y44",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { context: context, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _102efhey _1t4pi7uo",
            __cmplp.context === 'menu' ? "_18u01y44" : "_18u0idpf",
            __cmplp.context === 'menu' ? "_24rcftgi" : "_24rc1y44",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$e58ef81ce68260bb = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q71j9a _2rkofajl _1bsb1gwv _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71j9a _2rkofajl _1bsb1gwv _16qs130s",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$389e8eff9d059b16 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isSelected: isSelected, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3i14no _1bsb1osq _1e0c1txw _1bah1y6m _4cvr1h6o _vchhusvi _d0al73ad",
            __cmplp.isSelected ? "_19bvo7ao" : "_19bv7vkz",
            __cmplp.isSelected ? "_syaz6x5g" : "_syaz1kw7",
            __cmplp.isSelected ? "_11q71s93" : "_bfhk1j28",
            __cmplp.isSelected ? "_1kl71rih" : "_1kl7glyw",
            __cmplp.isSelected ? "_19lc1s93" : "_19lcl4ek",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i14no _1bsb1osq _1e0c1txw _1bah1y6m _4cvr1h6o _vchhusvi _d0al73ad",
            __cmplp.isSelected ? "_19bvo7ao" : "_19bv7vkz",
            __cmplp.isSelected ? "_syaz6x5g" : "_syaz1kw7",
            __cmplp.isSelected ? "_11q71s93" : "_bfhk1j28",
            __cmplp.isSelected ? "_1kl71rih" : "_1kl7glyw",
            __cmplp.isSelected ? "_19lc1s93" : "_19lcl4ek",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$1e83d727324d4b8e = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4utpp _vchhusvi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4utpp _vchhusvi",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$bf0bb6fde72bdac0 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$64dbc8be437eccf5 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q77qp0 _19itglyw _11c81kw7 _2rkofajl _1bsbymf6 _4t3i1ylp _19pkutpp _19lc7qp0 _d0altlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q77qp0 _19itglyw _11c81kw7 _2rkofajl _1bsbymf6 _4t3i1ylp _19pkutpp _19lc7qp0 _d0altlke",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$9ee345695ec4f581 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _19pk1b66 _syaz1tmw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _19pk1b66 _syaz1tmw",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$ae3a7dd4d8a05cb1 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _n7zlia51 _1e0c1txw _kqsw1if8 _154iidpf _bfhkvuon _1pbyegat",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _n7zlia51 _1e0c1txw _kqsw1if8 _154iidpf _bfhkvuon _1pbyegat",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$464eacbfb9fbeb3e = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u01wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});
module.exports["HorizontalFilterPane"] = $e5cea1fed6b35db0$export$a4874344a0a08e9e;
module.exports["PopupComponentContainer"] = $e5cea1fed6b35db0$export$668eb470a70772b7;
module.exports["SelectWrapper"] = $e5cea1fed6b35db0$export$d586e0ae81c7b89b;
module.exports["OptionInMenu"] = $e5cea1fed6b35db0$export$c0e1e4e72a41cc80;
module.exports["CustomDropdown"] = $e5cea1fed6b35db0$export$e58ef81ce68260bb;
module.exports["CustomDropdownItem"] = $e5cea1fed6b35db0$export$389e8eff9d059b16;
module.exports["CustomDateWrapper"] = $e5cea1fed6b35db0$export$1e83d727324d4b8e;
module.exports["DatePickersWrapper"] = $e5cea1fed6b35db0$export$bf0bb6fde72bdac0;
module.exports["SelectDateRangeButton"] = $e5cea1fed6b35db0$export$64dbc8be437eccf5;
module.exports["DateRangeErrorMessage"] = $e5cea1fed6b35db0$export$9ee345695ec4f581;
module.exports["HorizontalFilterWrapper"] = $e5cea1fed6b35db0$export$ae3a7dd4d8a05cb1;
module.exports["FeedbackButtonWrapper"] = $e5cea1fed6b35db0$export$464eacbfb9fbeb3e;

});

parcelRegister("hY8sQ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $eb19ddf4aa386faf$export$a54ec244c8863715 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Li_FD",
    name: "SearchPage",
    loader: async ()=>(await (parcelRequire("luiLc"))).ConfluenceSearchPage
});
module.exports["SearchPage"] = $eb19ddf4aa386faf$export$a54ec244c8863715;

});

parcelRegister("luiLc", function(module, exports) {

let $fa4af3bdec5fc567$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fa4af3bdec5fc567$var$load("h3ABO"),
    $fa4af3bdec5fc567$var$load("9GOJf"),
    $fa4af3bdec5fc567$var$load("kTth2"),
    $fa4af3bdec5fc567$var$load("lTK3c"),
    $fa4af3bdec5fc567$var$load("1WXdc"),
    $fa4af3bdec5fc567$var$load("U4fwL"),
    $fa4af3bdec5fc567$var$load("kaB35"),
    $fa4af3bdec5fc567$var$load("kbwlB"),
    $fa4af3bdec5fc567$var$load("6tWV0"),
    $fa4af3bdec5fc567$var$load("2YffH"),
    $fa4af3bdec5fc567$var$load("6wr18"),
    $fa4af3bdec5fc567$var$load("cTRjA"),
    $fa4af3bdec5fc567$var$load("33K0R"),
    $fa4af3bdec5fc567$var$load("1OHzH"),
    $fa4af3bdec5fc567$var$load("hdYRX"),
    $fa4af3bdec5fc567$var$load("kdaK8"),
    $fa4af3bdec5fc567$var$load("6qlX6"),
    $fa4af3bdec5fc567$var$load("c28JM"),
    $fa4af3bdec5fc567$var$load("kCvt5"),
    $fa4af3bdec5fc567$var$load("hyzoX"),
    $fa4af3bdec5fc567$var$load("9anPW"),
    $fa4af3bdec5fc567$var$load("6r6j2"),
    $fa4af3bdec5fc567$var$load("im1VN"),
    $fa4af3bdec5fc567$var$load("kUoOJ"),
    $fa4af3bdec5fc567$var$load("8Skll"),
    $fa4af3bdec5fc567$var$load("7gHIc"),
    $fa4af3bdec5fc567$var$load("e4wOQ"),
    $fa4af3bdec5fc567$var$load("gINGQ"),
    $fa4af3bdec5fc567$var$load("8d8a6"),
    $fa4af3bdec5fc567$var$load("cM6bW"),
    $fa4af3bdec5fc567$var$load("lk5YE"),
    $fa4af3bdec5fc567$var$load("eZnzH"),
    $fa4af3bdec5fc567$var$load("dbdNk"),
    $fa4af3bdec5fc567$var$load("h5FT3"),
    $fa4af3bdec5fc567$var$load("b81Ct"),
    $fa4af3bdec5fc567$var$load("fv7VG"),
    $fa4af3bdec5fc567$var$load("3sb7M"),
    $fa4af3bdec5fc567$var$load("5NQgH"),
    $fa4af3bdec5fc567$var$load("daVOf"),
    $fa4af3bdec5fc567$var$load("k3jER"),
    $fa4af3bdec5fc567$var$load("4Pfol"),
    $fa4af3bdec5fc567$var$load("9ldRJ"),
    $fa4af3bdec5fc567$var$load("9wzNh"),
    $fa4af3bdec5fc567$var$load("6iz6l"),
    $fa4af3bdec5fc567$var$load("4SCW2"),
    $fa4af3bdec5fc567$var$load("ffEVr"),
    $fa4af3bdec5fc567$var$load("70hqB"),
    $fa4af3bdec5fc567$var$load("f95iu"),
    $fa4af3bdec5fc567$var$load("7k1ns"),
    $fa4af3bdec5fc567$var$load("6bVVs"),
    $fa4af3bdec5fc567$var$load("7mo6o"),
    $fa4af3bdec5fc567$var$load("5GaTI"),
    $fa4af3bdec5fc567$var$load("9gVav"),
    $fa4af3bdec5fc567$var$load("elrCw"),
    $fa4af3bdec5fc567$var$load("cj0Rr"),
    $fa4af3bdec5fc567$var$load("cvmn7"),
    $fa4af3bdec5fc567$var$load("jmFg4"),
    $fa4af3bdec5fc567$var$load("Wowvf"),
    $fa4af3bdec5fc567$var$load("etEYy"),
    $fa4af3bdec5fc567$var$load("hhss7"),
    $fa4af3bdec5fc567$var$load("7EorR"),
    $fa4af3bdec5fc567$var$load("7pIPL")
]).then(()=>parcelRequire('kku53'));

});

parcelRegister("bVltF", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $95b33375becf7c06$var$COMPONENT = 'search-page';
const $95b33375becf7c06$export$a98443e214d7b1fd = new (0, $5aVN7.UFOExperience)('load', {
    type: (0, $9NDUe.ExperienceTypes).Load,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $95b33375becf7c06$var$COMPONENT
    }
});
const $95b33375becf7c06$export$e882a2ec68d19be8 = new (0, $5aVN7.UFOExperience)('search-results-load', {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $95b33375becf7c06$var$COMPONENT
    },
    timings: [
        {
            key: 'request',
            startMark: 'request_start',
            endMark: 'request_end'
        },
        {
            key: 'render',
            startMark: 'render_start',
            endMark: 'render_end'
        }
    ]
});
const $95b33375becf7c06$export$eda1f56a83aaec73 = async ()=>{
    if (!$95b33375becf7c06$export$e882a2ec68d19be8.state.final) await $95b33375becf7c06$export$e882a2ec68d19be8.abort({
        metadata: {
            reason: 'restarted'
        }
    });
    $95b33375becf7c06$export$e882a2ec68d19be8.start();
};
const $95b33375becf7c06$export$b066085d86746240 = ({ queryLength: queryLength, wordCount: wordCount })=>{
    $95b33375becf7c06$export$e882a2ec68d19be8.success({
        metadata: {
            queryLength: queryLength,
            wordCount: wordCount
        }
    });
};
const $95b33375becf7c06$export$7cc1b457adcf3334 = ()=>{
    $95b33375becf7c06$export$e882a2ec68d19be8.failure();
};
module.exports["searchPageLoadUFOExperience"] = $95b33375becf7c06$export$a98443e214d7b1fd;
module.exports["searchResultsLoadUFOExperienceStart"] = $95b33375becf7c06$export$eda1f56a83aaec73;
module.exports["searchResultsLoadUFOExperienceSuccess"] = $95b33375becf7c06$export$b066085d86746240;
module.exports["searchResultsLoadUFOExperienceError"] = $95b33375becf7c06$export$7cc1b457adcf3334;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("dYU3e", function(module, exports) {


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");




var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__ }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    let single;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    if ((0, $9wGTI.fg)('confluence_preloader_query_interop')) return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return client.query({
        query: query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext
    }).then((result)=>{
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
        return {
            ...result,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("19w2x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("JW5lP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");


var $4JWgN = parcelRequire("4JWgN");


var $dOnbq = parcelRequire("dOnbq");

const $fe7e868f8d553302$var$menuScope = '[role="menu"]';
function $fe7e868f8d553302$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($fe7e868f8d553302$var$menuScope);
    // Container itself has role="menu" — element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there's no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it's "owned" by this
    // container without passing through another role="menu" first.
    let parent = closestMenu.parentElement;
    while(parent && parent !== container){
        if (parent.getAttribute('role') === 'menu') // There's a parent menu between the closest menu and the
        // container — the element is in a nested sub-menu.
        return false;
        parent = parent.parentElement;
    }
    // The closest menu is directly inside the container (no nesting).
    return parent === container;
}
function $fe7e868f8d553302$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $hTKp4.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($fe7e868f8d553302$var$menuScope) !== container) return;
        }
        if (event.key === (0, $4JWgN.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $dOnbq.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $dOnbq.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $dOnbq.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $dOnbq.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it's a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($fe7e868f8d553302$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $42omo.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $fFa3V.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}
module.exports["isAtCurrentMenuLevel"] = $fe7e868f8d553302$export$f1bba0ef464d60af;
module.exports["useArrowNavigation"] = $fe7e868f8d553302$export$23dfbae28e0cc453;

});

parcelRegister("3pU8m", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $7p5xt = parcelRequire("7p5xt");


var $56M4r = parcelRequire("56M4r");


var $iTh4n = parcelRequire("iTh4n");


var $jwNgW = parcelRequire("jwNgW");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $a61a6d10c0a933b0$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $jwNgW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p5xt.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $iTh4n.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $a61a6d10c0a933b0$export$2e2bcd8739ae039 = $a61a6d10c0a933b0$var$DropdownItemCheckbox;
module.exports["default"] = $a61a6d10c0a933b0$export$2e2bcd8739ae039;

});

parcelRegister("iTh4n", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $ade312c7505f4d8d$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $ade312c7505f4d8d$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $ade312c7505f4d8d$export$2e2bcd8739ae039 = $ade312c7505f4d8d$var$CheckboxIcon;
module.exports["default"] = $ade312c7505f4d8d$export$2e2bcd8739ae039;

});

parcelRegister("jwNgW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1FJYC = parcelRequire("1FJYC");


var $5g4rt = parcelRequire("5g4rt");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $05848c92b720c3b2$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $42omo.useContext)((0, $5g4rt.SelectionStoreContext));
    const groupId = (0, $42omo.useContext)((0, $1FJYC.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $05848c92b720c3b2$export$2e2bcd8739ae039 = $05848c92b720c3b2$var$useCheckboxState;
module.exports["default"] = $05848c92b720c3b2$export$2e2bcd8739ae039;

});

parcelRegister("1FJYC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5d17552b6cb2fab4$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $42omo.createContext)('');
module.exports["CheckboxGroupContext"] = $5d17552b6cb2fab4$export$baf37c4be89255b8;

});

parcelRegister("fKL7x", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");


var $1FJYC = parcelRequire("1FJYC");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1FJYC.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $b6be4855f2bf1ca8$export$2e2bcd8739ae039 = $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup;
module.exports["default"] = $b6be4855f2bf1ca8$export$2e2bcd8739ae039;

});

parcelRegister("eyfm5", function(module, exports) {
const $6fd46c311db8d44c$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });
module.exports["listItem"] = $6fd46c311db8d44c$export$76c7e83ecc9cdf05;

});

parcelRegister("2FFuS", function(module, exports) {

var $enilC = parcelRequire("enilC");

const $a4fc62108e90d067$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $enilC.createTextNodes)(content)
    });
module.exports["paragraph"] = $a4fc62108e90d067$export$9c206ddddb32a9b;

});

parcelRegister("enilC", function(module, exports) {

var $aoDcQ = parcelRequire("aoDcQ");

function $b397a3d9dc60a40a$export$3a269a5941b62f04(nodes) {
    return nodes.map($b397a3d9dc60a40a$export$72b9432ea0656b50);
}
function $b397a3d9dc60a40a$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $aoDcQ.text)(str) : str;
}
module.exports["createTextNodes"] = $b397a3d9dc60a40a$export$3a269a5941b62f04;

});

parcelRegister("aoDcQ", function(module, exports) {
const $cb8b1b1eb7a280a9$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });
module.exports["text"] = $cb8b1b1eb7a280a9$export$6f093cfa640b7166;

});

parcelRegister("2daQU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $b400565b9de87bc3$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$var$WidthObserver;
module.exports["default"] = $b400565b9de87bc3$export$2e2bcd8739ae039;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $aXWIB = parcelRequire("aXWIB");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $d21a741e0de1277a$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $d21a741e0de1277a$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$d21a741e0de1277a$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $d21a741e0de1277a$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

function $e1a1ee666860bb23$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("euACo", function(module, exports) {
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $035a46a85e451274$var$iconStyles = null;
const $035a46a85e451274$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $035a46a85e451274$var$baseHcmStyles = null;
const $035a46a85e451274$var$primaryEqualsSecondaryHcmStyles = null;
const $035a46a85e451274$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $035a46a85e451274$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $l998X.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $035a46a85e451274$var$sizeStyles[size]
        ])
    });
});
var $035a46a85e451274$export$2e2bcd8739ae039 = $035a46a85e451274$export$f04a61298a47a40f;
module.exports["Icon"] = $035a46a85e451274$export$f04a61298a47a40f;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("7p2SJ", function(module, exports) {

var $9tehW = parcelRequire("9tehW");


var $2KLMV = parcelRequire("2KLMV");

const $9de29032692b3583$var$AsyncSelect = (0, $2KLMV.default)((0, $9tehW.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9de29032692b3583$export$2e2bcd8739ae039 = $9de29032692b3583$var$AsyncSelect;
module.exports["default"] = $9de29032692b3583$export$2e2bcd8739ae039;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($568c54c2a75aa99b$export$a775919ebd7dd28a.clear, $568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("9QfXi", function(module, exports) {
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $2P8Ax = parcelRequire("2P8Ax");


var $dh538 = parcelRequire("dh538");


var $eFvgJ = parcelRequire("eFvgJ");


var $ei7H8 = parcelRequire("ei7H8");


var $e2ssP = parcelRequire("e2ssP");


var $lQ9rc = parcelRequire("lQ9rc");

const $05e49d7ff5fc6a12$var$getCodeBlockStyles = {
    rootT26Shape: "_2rko1mok",
    root: "_11c819w5 _2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhk187e _syazi7uo _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1xv3 _1vbw1xv3 _1v9c1xv3 _1srnt0uh _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gsb9t _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909i8nm _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgc124n _bu7z124n _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3wu06 _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eihtd5cb _t9zbd5cb _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t36i7uo _137bh55r _1k7di7uo _97li16jw _12nh9lu1 _1g0517qg _i2igqmo9 _326zi7uo _113p1rpy _1n6t16jw _tgu817qg _1k4716jw _g0lxi7uo _ys4e1rpy _7gp8h55r _1yvqqmo9 _1vwwqmo9 _1rjuqmo9 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o6qmo9 _kxov17qg _1np517qg _m2f517qg _1b9t16jw _1tq616jw _1rd216jw _1pbk16jw _k3li16jw _13zt1rpy _2g12fb2s _k86bqmo9 _b5iy1rpy _gti31rpy _1f0g16jw _9d3e17qg _qdia16jw _72uv16jw",
    showLineNumbers: "_1707efft _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
}; /**
    * __Code block__
    *
    * A code block highlights an entire block of code and keeps the formatting.
    *
    * - [Examples](https://atlassian.design/components/code/code-block/examples)
    * - [Code](https://atlassian.design/components/code/code-block/code)
    * - [Usage](https://atlassian.design/components/code/code-block/usage)
    */ 
const $05e49d7ff5fc6a12$var$CodeBlock = /*#__PURE__*/ (0, $42omo.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $42omo.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $42omo.useState)(false); // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $ei7H8.getLineNumWidth)(numLines) : 0; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled; // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $42omo.useEffect)(()=>{
        const schedule = (0, $2P8Ax.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $eFvgJ.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $42omo.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $42omo.useMemo)(()=>(0, $e2ssP.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]); // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lQ9rc.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $gMc0m.default)([
            $05e49d7ff5fc6a12$var$getCodeBlockStyles.root,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $05e49d7ff5fc6a12$var$getCodeBlockStyles.rootT26Shape,
            shouldWrapLongLines ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.shouldWrapLongLines : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.showLineNumbers : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $05e49d7ff5fc6a12$export$2e2bcd8739ae039 = $05e49d7ff5fc6a12$var$CodeBlock;
module.exports["default"] = $05e49d7ff5fc6a12$export$2e2bcd8739ae039;

});

parcelRegister("eFvgJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $762b8efdd2f451a9$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $762b8efdd2f451a9$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $42omo.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $42omo.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};
module.exports["useHighlightLines"] = $762b8efdd2f451a9$export$84415a200bdf33ed;

});

parcelRegister("ei7H8", function(module, exports) {
const $89bf9ce5f21eb7b0$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
module.exports["getLineNumWidth"] = $89bf9ce5f21eb7b0$export$cb7aec0206b595d2;

});

parcelRegister("e2ssP", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $cTQmR = parcelRequire("cTQmR");

const $93742eb3c537aef5$export$f38728011c178796 = (0, $2XqLN.default)((language)=>{
    if (!language) return '';
    const match = (0, $cTQmR.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});
module.exports["normalizeLanguage"] = $93742eb3c537aef5$export$f38728011c178796;

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});

parcelRegister("lQ9rc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e33420ccf6f6f193$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $fjCXq = parcelRequire("fjCXq");

var $e33420ccf6f6f193$export$2e2bcd8739ae039 = (0, $fjCXq.default);

});

parcelRegister("fjCXq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5sMDX = parcelRequire("5sMDX");

// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $d73ab72549e3e177$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $l998X.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, $5sMDX.default);
    AsyncHighlighter.astGeneratorPromise = void 0;
    return AsyncHighlighter;
};

const $d73ab72549e3e177$var$asyncGenerator = $d73ab72549e3e177$var$generator({
    loader: ()=>(parcelRequire("bhcM2")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $d73ab72549e3e177$export$2e2bcd8739ae039 = $d73ab72549e3e177$var$asyncGenerator;
module.exports["default"] = $d73ab72549e3e177$export$2e2bcd8739ae039;

});

parcelRegister("5sMDX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9THMM = parcelRequire("9THMM");


var $39xAV = parcelRequire("39xAV");

/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $65cd19df82755559$var$Highlight = /*#__PURE__*/ (0, $42omo.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $9THMM.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39xAV.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $65cd19df82755559$export$2e2bcd8739ae039 = $65cd19df82755559$var$Highlight;
module.exports["default"] = $65cd19df82755559$export$2e2bcd8739ae039;

});

parcelRegister("9THMM", function(module, exports) {
$parcel$export(module.exports, "default", () => $91ea43af234a8926$export$2e2bcd8739ae039);

var $5izKv = parcelRequire("5izKv");


var $gOgW3 = parcelRequire("gOgW3");


var $6RvGZ = parcelRequire("6RvGZ");


var $dA1U5 = parcelRequire("dA1U5");

const $91ea43af234a8926$var$newLineRegex = /\n/g;
function $91ea43af234a8926$var$getNewLines(str) {
    return str.match($91ea43af234a8926$var$newLineRegex);
}
function $91ea43af234a8926$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $dA1U5.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $5izKv.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $6RvGZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $91ea43af234a8926$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $gOgW3.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $gOgW3.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});

parcelRegister("5izKv", function(module, exports) {

var $gOgW3 = parcelRequire("gOgW3");


var $2hcc9 = parcelRequire("2hcc9");

function $837f3297854d8fe5$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $gOgW3.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $2hcc9.default)(lineNumber));
            return children;
        }
    };
}
var $837f3297854d8fe5$export$2e2bcd8739ae039 = $837f3297854d8fe5$var$createLineGenerator;
module.exports["default"] = $837f3297854d8fe5$export$2e2bcd8739ae039;

});

parcelRegister("gOgW3", function(module, exports) {
$parcel$export(module.exports, "default", () => $09aff78a89d513cf$export$2e2bcd8739ae039);

var $2hcc9 = parcelRequire("2hcc9");

function $09aff78a89d513cf$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});

parcelRegister("2hcc9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c2f4afe5a9a95f7$export$2e2bcd8739ae039);
function $3c2f4afe5a9a95f7$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});

parcelRegister("6RvGZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7ca1712ff76e68a$export$2e2bcd8739ae039);

var $gOgW3 = parcelRequire("gOgW3");

function $f7ca1712ff76e68a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $gOgW3.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $f7ca1712ff76e68a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("dA1U5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a86ea0fafcbd9c5$export$2e2bcd8739ae039);
function $1a86ea0fafcbd9c5$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch  {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});

parcelRegister("39xAV", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a0d4443c5f07c9$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dalCl = parcelRequire("dalCl");

function $33a0d4443c5f07c9$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dalCl.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});

parcelRegister("dalCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $60fb1400ee6b4dd3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");


var $8L2tn = parcelRequire("8L2tn");

function $60fb1400ee6b4dd3$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $60fb1400ee6b4dd3$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $03WRT.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $8L2tn.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $60fb1400ee6b4dd3$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});

parcelRegister("8L2tn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef41ad946a85b2e$export$2e2bcd8739ae039);

var $dalCl = parcelRequire("dalCl");

function $cef41ad946a85b2e$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dalCl.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});

parcelRegister("bhcM2", function(module, exports) {

let $835b30d7ea57673f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $835b30d7ea57673f$var$load("7PMju").then(()=>parcelRequire('kw2OH'));

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("e6pbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4452a63831cbd09$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $a4452a63831cbd09$var$t() {
    return $a4452a63831cbd09$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $a4452a63831cbd09$var$t.apply(this, arguments);
}
const $a4452a63831cbd09$var$n = [
    "children",
    "options"
], $a4452a63831cbd09$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $a4452a63831cbd09$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($a4452a63831cbd09$var$i || ($a4452a63831cbd09$var$i = {}));
const $a4452a63831cbd09$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $a4452a63831cbd09$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $a4452a63831cbd09$var$o = [
    "style",
    "script"
], $a4452a63831cbd09$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $a4452a63831cbd09$var$s = /mailto:/i, $a4452a63831cbd09$var$d = /\n{2,}$/, $a4452a63831cbd09$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $a4452a63831cbd09$var$p = /^ *> ?/gm, $a4452a63831cbd09$var$f = /^ {2,}\n/, $a4452a63831cbd09$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $a4452a63831cbd09$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $a4452a63831cbd09$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $a4452a63831cbd09$var$k = /^(?:\n *)*\n/, $a4452a63831cbd09$var$x = /\r\n?/g, $a4452a63831cbd09$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $a4452a63831cbd09$var$v = /^\[\^([^\]]+)]/, $a4452a63831cbd09$var$S = /\f/g, $a4452a63831cbd09$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $a4452a63831cbd09$var$$ = /^\s*?\[(x|\s)\]/, $a4452a63831cbd09$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $a4452a63831cbd09$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $a4452a63831cbd09$var$T = /^<!--[\s\S]*?(?:-->)/, $a4452a63831cbd09$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $a4452a63831cbd09$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $a4452a63831cbd09$var$M = /^\{.*\}$/, $a4452a63831cbd09$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $a4452a63831cbd09$var$I = /^<([^ >]+@[^ >]+)>/, $a4452a63831cbd09$var$U = /^<([^ >]+:\/[^ >]+)>/, $a4452a63831cbd09$var$D = /-([a-z])?/gi, $a4452a63831cbd09$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $a4452a63831cbd09$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $a4452a63831cbd09$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$P = /(\[|\])/g, $a4452a63831cbd09$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $a4452a63831cbd09$var$W = /\t/g, $a4452a63831cbd09$var$G = /(^ *\||\| *$)/g, $a4452a63831cbd09$var$Z = /^ *:-+: *$/, $a4452a63831cbd09$var$q = /^ *:-+ *$/, $a4452a63831cbd09$var$Q = /^ *-+: *$/, $a4452a63831cbd09$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $a4452a63831cbd09$var$X = new RegExp(`^([*_])\\1${$a4452a63831cbd09$var$V}\\1\\1(?!\\1)`), $a4452a63831cbd09$var$J = new RegExp(`^([*_])${$a4452a63831cbd09$var$V}\\1(?!\\1|\\w)`), $a4452a63831cbd09$var$K = new RegExp(`^==${$a4452a63831cbd09$var$V}==`), $a4452a63831cbd09$var$Y = new RegExp(`^~~${$a4452a63831cbd09$var$V}~~`), $a4452a63831cbd09$var$ee = /^\\([^0-9A-Za-z\s])/, $a4452a63831cbd09$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $a4452a63831cbd09$var$ne = /^\n+/, $a4452a63831cbd09$var$re = /^([ \t]*)/, $a4452a63831cbd09$var$ie = /\\([^\\])/g, $a4452a63831cbd09$var$le = / *\n+$/, $a4452a63831cbd09$var$ae = /(?:^|\n)( *)$/, $a4452a63831cbd09$var$oe = "(?:\\d+\\.)", $a4452a63831cbd09$var$ce = "(?:[*+-])";
function $a4452a63831cbd09$var$se(e) {
    return "( *)(" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + ") +";
}
const $a4452a63831cbd09$var$de = $a4452a63831cbd09$var$se(1), $a4452a63831cbd09$var$ue = $a4452a63831cbd09$var$se(2);
function $a4452a63831cbd09$var$pe(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue));
}
const $a4452a63831cbd09$var$fe = $a4452a63831cbd09$var$pe(1), $a4452a63831cbd09$var$he = $a4452a63831cbd09$var$pe(2);
function $a4452a63831cbd09$var$me(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $a4452a63831cbd09$var$ge = $a4452a63831cbd09$var$me(1), $a4452a63831cbd09$var$ye = $a4452a63831cbd09$var$me(2);
function $a4452a63831cbd09$var$ke(e) {
    const t = 1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $a4452a63831cbd09$var$xe = $a4452a63831cbd09$var$ke(1), $a4452a63831cbd09$var$be = $a4452a63831cbd09$var$ke(2);
function $a4452a63831cbd09$var$ve(e, t) {
    const n = 1 === t, i = n ? $a4452a63831cbd09$var$xe : $a4452a63831cbd09$var$be, l = n ? $a4452a63831cbd09$var$ge : $a4452a63831cbd09$var$ye, a = n ? $a4452a63831cbd09$var$fe : $a4452a63831cbd09$var$he;
    return {
        match (e, t, n) {
            const r = $a4452a63831cbd09$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($a4452a63831cbd09$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($a4452a63831cbd09$var$le, "\n\n")) : (r.inline = !0, h = s.replace($a4452a63831cbd09$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $a4452a63831cbd09$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $a4452a63831cbd09$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $a4452a63831cbd09$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $a4452a63831cbd09$var$$e = [
    $a4452a63831cbd09$var$u,
    $a4452a63831cbd09$var$m,
    $a4452a63831cbd09$var$g,
    $a4452a63831cbd09$var$w,
    $a4452a63831cbd09$var$z,
    $a4452a63831cbd09$var$C,
    $a4452a63831cbd09$var$T,
    $a4452a63831cbd09$var$j,
    $a4452a63831cbd09$var$ge,
    $a4452a63831cbd09$var$xe,
    $a4452a63831cbd09$var$ye,
    $a4452a63831cbd09$var$be
], $a4452a63831cbd09$var$we = [
    ...$a4452a63831cbd09$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $a4452a63831cbd09$var$L,
    $a4452a63831cbd09$var$B
];
function $a4452a63831cbd09$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $a4452a63831cbd09$var$ze(e) {
    return $a4452a63831cbd09$var$Q.test(e) ? "right" : $a4452a63831cbd09$var$Z.test(e) ? "center" : $a4452a63831cbd09$var$q.test(e) ? "left" : null;
}
function $a4452a63831cbd09$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $a4452a63831cbd09$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $a4452a63831cbd09$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($a4452a63831cbd09$var$G, "").split("|").map($a4452a63831cbd09$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $a4452a63831cbd09$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $a4452a63831cbd09$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.paragraph
    };
}
function $a4452a63831cbd09$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $a4452a63831cbd09$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $a4452a63831cbd09$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $a4452a63831cbd09$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$a4452a63831cbd09$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $a4452a63831cbd09$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $a4452a63831cbd09$var$De(e) {
    return e.replace($a4452a63831cbd09$var$ie, "$1");
}
function $a4452a63831cbd09$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $a4452a63831cbd09$var$Fe = (e, t, n)=>({
        children: $a4452a63831cbd09$var$je(t, e[1], n)
    });
function $a4452a63831cbd09$var$Pe() {
    return {};
}
function $a4452a63831cbd09$var$_e() {
    return null;
}
function $a4452a63831cbd09$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $a4452a63831cbd09$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $a4452a63831cbd09$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $a4452a63831cbd09$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $a4452a63831cbd09$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $a4452a63831cbd09$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $a4452a63831cbd09$var$t({}, n, l, {
            className: $a4452a63831cbd09$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($a4452a63831cbd09$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $a4452a63831cbd09$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($a4452a63831cbd09$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $42omo.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($a4452a63831cbd09$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($a4452a63831cbd09$var$O) && (e = e.replace($a4452a63831cbd09$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $a4452a63831cbd09$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($a4452a63831cbd09$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($a4452a63831cbd09$var$L.test(u) || $a4452a63831cbd09$var$B.test(u)) && (n[d] = $42omo.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$a4452a63831cbd09$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $a4452a63831cbd09$export$3e2338ea76b578c9, i.slugify = i.slugify || $a4452a63831cbd09$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $a4452a63831cbd09$var$t({}, $a4452a63831cbd09$var$a, i.namedCodesToUnicode) : $a4452a63831cbd09$var$a, i.createElement = i.createElement || $42omo.createElement;
    const q = [], Q = {}, V = {
        [$a4452a63831cbd09$export$e0aa44767d8750d5.blockQuote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($a4452a63831cbd09$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakLine]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$f),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakThematic]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$h),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $a4452a63831cbd09$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeFenced]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeInline]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnoteReference]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $a4452a63831cbd09$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.gfmTask]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.heading]: {
            match: $a4452a63831cbd09$var$Me(i.enforceAtxHeadings ? $a4452a63831cbd09$var$C : $a4452a63831cbd09$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[2], n),
                    id: i.slugify(e[2], $a4452a63831cbd09$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.headingSetext]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.heading
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($a4452a63831cbd09$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $a4452a63831cbd09$var$we.some((e)=>e.test(c)) ? $a4452a63831cbd09$var$He : $a4452a63831cbd09$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $a4452a63831cbd09$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlComment]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$T),
            order: 1,
            parse: ()=>({}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.image]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.link]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$Ne(t, e[1], n),
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $a4452a63831cbd09$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                };
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.orderedList]: $a4452a63831cbd09$var$ve(d, 1),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.unorderedList]: $a4452a63831cbd09$var$ve(d, 2),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$k),
            order: 3,
            parse: $a4452a63831cbd09$var$Pe,
            render: ()=>"\n"
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.paragraph]: {
            match: $a4452a63831cbd09$var$Ie,
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.ref]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refImage]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refLink]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($a4452a63831cbd09$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.table]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$j),
            order: 1,
            parse: $a4452a63831cbd09$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $a4452a63831cbd09$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $a4452a63831cbd09$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.text]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($a4452a63831cbd09$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textBolded]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEmphasized]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEscaped]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textMarked]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$K),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Y),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock], delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($a4452a63831cbd09$var$x, "\n").replace($a4452a63831cbd09$var$S, "").replace($a4452a63831cbd09$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $a4452a63831cbd09$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $a4452a63831cbd09$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $a4452a63831cbd09$var$n);
    return $42omo.cloneElement($a4452a63831cbd09$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("l5jcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6c7fb5a91851c05d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $kXb3C = parcelRequire("kXb3C");

function $6c7fb5a91851c05d$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4ce94c9023f0019e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

function $4ce94c9023f0019e$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("9J3bP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $458cec0faf8f188b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $kXb3C = parcelRequire("kXb3C");

function $458cec0faf8f188b$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("7G33r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b1b906ca2447e962$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $kXb3C = parcelRequire("kXb3C");

function $b1b906ca2447e962$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("8d3zB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $487ca0b42e22d1f4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $kXb3C = parcelRequire("kXb3C");

function $487ca0b42e22d1f4$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kNUwp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dwp40 = parcelRequire("dwp40");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $25BDS = parcelRequire("25BDS");


var $7I6bH = parcelRequire("7I6bH");

const $c1ef33da072a3fc0$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ef33da072a3fc0$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ef33da072a3fc0$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ef33da072a3fc0$export$19524a749d98a458 = 'search-config';
const $c1ef33da072a3fc0$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ef33da072a3fc0$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch, update: $c1ef33da072a3fc0$var$update3pCache } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$44d1e7c4ef26c467
});
const $c1ef33da072a3fc0$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ef33da072a3fc0$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ef33da072a3fc0$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ef33da072a3fc0$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ef33da072a3fc0$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {};
    if ((0, $dh538.fg)('rovo-search-config-endpoints-operation-name')) queryParams['operationName'] = 'searchPageFirstPartyConfig';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ef33da072a3fc0$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {};
    if ((0, $dh538.fg)('rovo-search-config-endpoints-operation-name')) queryParams['operationName'] = 'searchPageThirdPartyConfig';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $7I6bH.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $7I6bH.generate3pHash)(userId, cloudId);
    return $c1ef33da072a3fc0$var$update3pCache(key.toString(), updater);
};
const $c1ef33da072a3fc0$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $25BDS.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ef33da072a3fc0$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ef33da072a3fc0$export$6916ea7f169882e0;
module.exports["getUserLoomAuthStatus"] = $c1ef33da072a3fc0$export$46e3d34ee7b8c58a;

});

parcelRegister("2qzBQ", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $44766eafbe4aebec$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $44766eafbe4aebec$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $44766eafbe4aebec$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $44766eafbe4aebec$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $44766eafbe4aebec$export$5c07a4287a46fa1f;

});

parcelRegister("jnPv4", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $5G9KX = parcelRequire("5G9KX");


var $6jKOp = parcelRequire("6jKOp");


var $3WVPu = parcelRequire("3WVPu");


var $5b4k9 = parcelRequire("5b4k9");


var $YBuvR = parcelRequire("YBuvR");

const $582af5ffd704fa53$export$e89e805418f4d2c = (args)=>{
    const { name: name } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
	 * NOTE: Scope control (QS-9209)
	 *
	 * The storage adapter system is introduced specifically so the combined search config cache
	 * can participate in host-provided persistence (e.g., Confluence SSR local storage).
	 *
	 * The combined config experiment (`search_combined_config`, QS-9091) must be enabled for the
	 * adapter system to be used.
	 */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5b4k9.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $5G9KX.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $5G9KX.setLocalStorageItem)(key, value)
    };
    function isCombinedConfigEnabled() {
        return (0, $c6GJD.default).getExperimentValue('search_combined_config', 'isEnabled', false) === true;
    }
    function shouldUseAdapterSystemForThisCache() {
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY && isCombinedConfigEnabled();
    }
    const getCacheInstance = ()=>{
        /**
		 * We lazily create the cache instance to avoid the issue in SSR
		 * where the localStorage isn't available.
		 */ if (!cacheInstance) {
            cacheInstance = (0, $3WVPu.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $YBuvR.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold (e.g. gate transition from direct localStorage
                    // to StorageManager) or the factory isn't registered yet, fall back to the
                    // raw localStorage key. This ensures stale-but-present data from the
                    // pre-transition era is served immediately rather than blocking on the network
                    // and potentially timing out the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $YBuvR.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $5G9KX.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $6jKOp.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $582af5ffd704fa53$export$e89e805418f4d2c;

});

parcelRegister("5G9KX", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $c4TO3 = parcelRequire("c4TO3");

const $34a6846e1e43ece9$export$5aa524d86254b4f = (key, value)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).setItem(key, value);
    else localStorage.setItem(key, value);
};
const $34a6846e1e43ece9$export$93d719890ad66653 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $34a6846e1e43ece9$export$5df15f289f441790 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? item : null;
};
const $34a6846e1e43ece9$export$baf306891f1b93bd = (key)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).removeItem(key);
    else localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $34a6846e1e43ece9$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $34a6846e1e43ece9$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $34a6846e1e43ece9$export$5df15f289f441790;

});

parcelRegister("6jKOp", function(module, exports) {
const $cb37190253d46910$var$NOT_AVAILABLE = 'not_available';
const $cb37190253d46910$export$fca3401e33379daf = (result)=>{
    if (result && typeof result === 'object' && 'extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            traceId: gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $cb37190253d46910$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $cb37190253d46910$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $cb37190253d46910$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $cb37190253d46910$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $cb37190253d46910$export$4acb28c262cd52bd;

});

parcelRegister("3WVPu", function(module, exports) {
const $fc16ad90038db0a8$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $fc16ad90038db0a8$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $fc16ad90038db0a8$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $fc16ad90038db0a8$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $fc16ad90038db0a8$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $fc16ad90038db0a8$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $fc16ad90038db0a8$export$8bedcca5bbd73999 = (args)=>{
    return new $fc16ad90038db0a8$var$Cache(args);
};
module.exports["getInstance"] = $fc16ad90038db0a8$export$8bedcca5bbd73999;

});

parcelRegister("3Tbc2", function(module, exports) {

var $fQifp = parcelRequire("fQifp");

const $3c05ea8f13f2fd4c$export$ff01cc10d3c607be = 6000; // default timeout
const $3c05ea8f13f2fd4c$var$DEGRADE_ERROR = new (0, $fQifp.DegradeError)('Promise is degraded');
class $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $3c05ea8f13f2fd4c$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($3c05ea8f13f2fd4c$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9;

});

parcelRegister("fQifp", function(module, exports) {
class $821f2e34e1284477$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $821f2e34e1284477$export$85bf8e4fb143676a;

});

parcelRegister("25BDS", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $5eb733f1658cb27e$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $5eb733f1658cb27e$export$42b67d93e908c9dc;

});

parcelRegister("7I6bH", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $bf230724a07e1336$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $bf230724a07e1336$export$f80795c7fd0ce9fc;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("6rSJC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");

/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $aabc54d8ecf8c9ec$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $42omo.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $aabc54d8ecf8c9ec$export$2e2bcd8739ae039 = $aabc54d8ecf8c9ec$var$CheckboxField;
module.exports["default"] = $aabc54d8ecf8c9ec$export$2e2bcd8739ae039;

});

parcelRegister("d2kvf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1HnpQ = parcelRequire("1HnpQ");


var $i3GYc = parcelRequire("i3GYc");

// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $7cea5ab07179eb6f$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $i3GYc.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1HnpQ.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: children
        })
    });
};
var $7cea5ab07179eb6f$export$2e2bcd8739ae039 = $7cea5ab07179eb6f$var$TabPanel;
module.exports["default"] = $7cea5ab07179eb6f$export$2e2bcd8739ae039;

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8jHAi = parcelRequire("8jHAi");


var $7CgcZ = parcelRequire("7CgcZ");

const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold');
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;
module.exports["default"] = $3c9171fc16956912$export$2e2bcd8739ae039;

});

parcelRegister("7CgcZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7642E = parcelRequire("7642E");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 */ const $6846287c8ee6bf50$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    if ((0, $dh538.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $5TXU5.SmartLinkSize).Small:
        case (0, $5TXU5.SmartLinkSize).Medium:
            return undefined;
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            // SmartLinkSize.Small, SmartLinkSize.Medium, and undefined all
            // previously mapped to size="16" which has been removed. Render
            // the icon directly (no tile) for these sizes.
            return undefined;
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectIcon, props);
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $6846287c8ee6bf50$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                color: $6846287c8ee6bf50$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { shape: _shape, UNSAFE_circleReplacementComponent: _unsafe, ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $6846287c8ee6bf50$export$3acc3fb10995f020;
module.exports["renderIconPerSize"] = $6846287c8ee6bf50$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $6846287c8ee6bf50$export$87c3646d0e299cfe;

});

parcelRegister("e3TOY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5ae331244e5ce5f0d911605ea315070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3cca56e09704fd9$var$_react = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("42omo")));

var $a3cca56e09704fd9$var$_baseNew = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3cca56e09704fd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3cca56e09704fd9$var$AudioIcon = (props)=>/*#__PURE__*/ $a3cca56e09704fd9$var$_react.default.createElement($a3cca56e09704fd9$var$_baseNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$a3cca56e09704fd9$var$AudioIcon.displayName = 'AudioIcon';
var $a3cca56e09704fd9$var$_default = module.exports.default = $a3cca56e09704fd9$var$AudioIcon;

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold');
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold');
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold');
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("dlbUV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9b667b04182af2ad$var$_react = $9b667b04182af2ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $9b667b04182af2ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b667b04182af2ad$var$Archive16Icon = (props)=>/*#__PURE__*/ $9b667b04182af2ad$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9b667b04182af2ad$var$Archive16Icon.displayName = 'Archive16Icon';
var $9b667b04182af2ad$var$_default = module.exports.default = $9b667b04182af2ad$var$Archive16Icon;

});

parcelRegister("fX9Sa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b9d4063230652121$var$_react = $b9d4063230652121$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $b9d4063230652121$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b9d4063230652121$var$Archive24Icon = (props)=>/*#__PURE__*/ $b9d4063230652121$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$b9d4063230652121$var$Archive24Icon.displayName = 'Archive24Icon';
var $b9d4063230652121$var$_default = module.exports.default = $b9d4063230652121$var$Archive24Icon;

});

parcelRegister("d5BUD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $987926a28539ecdc$var$_react = $987926a28539ecdc$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $987926a28539ecdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $987926a28539ecdc$var$Gif16Icon = (props)=>/*#__PURE__*/ $987926a28539ecdc$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$987926a28539ecdc$var$Gif16Icon.displayName = 'Gif16Icon';
var $987926a28539ecdc$var$_default = module.exports.default = $987926a28539ecdc$var$Gif16Icon;

});

parcelRegister("b4DX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $80ff0f2ee8339e7f$var$_react = $80ff0f2ee8339e7f$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $80ff0f2ee8339e7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80ff0f2ee8339e7f$var$Gif24Icon = (props)=>/*#__PURE__*/ $80ff0f2ee8339e7f$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$80ff0f2ee8339e7f$var$Gif24Icon.displayName = 'Gif24Icon';
var $80ff0f2ee8339e7f$var$_default = module.exports.default = $80ff0f2ee8339e7f$var$Gif24Icon;

});

parcelRegister("d8Kpd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $991004eb95b782af$var$_react = $991004eb95b782af$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $991004eb95b782af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $991004eb95b782af$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $991004eb95b782af$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$991004eb95b782af$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $991004eb95b782af$var$_default = module.exports.default = $991004eb95b782af$var$ExcelSpreadsheet16Icon;

});

parcelRegister("gH8Rx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c277896da6578a99$var$_react = $c277896da6578a99$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $c277896da6578a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c277896da6578a99$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $c277896da6578a99$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c277896da6578a99$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $c277896da6578a99$var$_default = module.exports.default = $c277896da6578a99$var$ExcelSpreadsheet24Icon;

});

parcelRegister("hY1Uy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d14985c3ed2ec0ae$var$_react = $d14985c3ed2ec0ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $d14985c3ed2ec0ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $d14985c3ed2ec0ae$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d14985c3ed2ec0ae$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $d14985c3ed2ec0ae$var$_default = module.exports.default = $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon;

});

parcelRegister("dfQbH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a652876e1a65311$var$_react = $9a652876e1a65311$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $9a652876e1a65311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a652876e1a65311$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $9a652876e1a65311$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a652876e1a65311$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $9a652876e1a65311$var$_default = module.exports.default = $9a652876e1a65311$var$PowerpointPresentation24Icon;

});

parcelRegister("90Icb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $68f6656ee3eec0b2$var$_react = $68f6656ee3eec0b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $68f6656ee3eec0b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68f6656ee3eec0b2$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $68f6656ee3eec0b2$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$68f6656ee3eec0b2$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $68f6656ee3eec0b2$var$_default = module.exports.default = $68f6656ee3eec0b2$var$WordDocument16Icon;

});

parcelRegister("lkBga", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f8785e41f79a32cd$var$_react = $f8785e41f79a32cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $f8785e41f79a32cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8785e41f79a32cd$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $f8785e41f79a32cd$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f8785e41f79a32cd$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $f8785e41f79a32cd$var$_default = module.exports.default = $f8785e41f79a32cd$var$WordDocument24Icon;

});

parcelRegister("11LZV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0bfb1dce28d59ddd$var$_react = $0bfb1dce28d59ddd$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $0bfb1dce28d59ddd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bfb1dce28d59ddd$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $0bfb1dce28d59ddd$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$0bfb1dce28d59ddd$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $0bfb1dce28d59ddd$var$_default = module.exports.default = $0bfb1dce28d59ddd$var$PdfDocument16Icon;

});

parcelRegister("lzyQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fb47e6517d9f8e39$var$_react = $fb47e6517d9f8e39$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $fb47e6517d9f8e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb47e6517d9f8e39$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $fb47e6517d9f8e39$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fb47e6517d9f8e39$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $fb47e6517d9f8e39$var$_default = module.exports.default = $fb47e6517d9f8e39$var$PdfDocument24Icon;

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("7r4Rz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $6iY4P = parcelRequire("6iY4P");


var $j6GAe = parcelRequire("j6GAe");


var $7CgcZ = parcelRequire("7CgcZ");

const $a1b21c3b6fc75776$var$BlogIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $6iY4P.default), (0, $j6GAe.default));
$a1b21c3b6fc75776$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a1b21c3b6fc75776$export$2e2bcd8739ae039 = $a1b21c3b6fc75776$var$BlogIconWithColor;
module.exports["default"] = $a1b21c3b6fc75776$export$2e2bcd8739ae039;

});

parcelRegister("GFtWS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $66dpz = parcelRequire("66dpz");


var $fAGae = parcelRequire("fAGae");


var $7CgcZ = parcelRequire("7CgcZ");

const $fc75dd15b55d0661$var$LiveDocumentIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $66dpz.default), (0, $fAGae.default));
$fc75dd15b55d0661$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $fc75dd15b55d0661$export$2e2bcd8739ae039 = $fc75dd15b55d0661$var$LiveDocumentIconWithColor;
module.exports["default"] = $fc75dd15b55d0661$export$2e2bcd8739ae039;

});

parcelRegister("8PFSM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $009878891f6679eb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $kXb3C = parcelRequire("kXb3C");

function $009878891f6679eb$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("gPNUg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1babd35f9918b35a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba2400aa1a21e98b14b3159dd611e30a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $fP78j = parcelRequire("fP78j");

function $1babd35f9918b35a$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("iZCav", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0686486f925c9ddd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $kXb3C = parcelRequire("kXb3C");

function $0686486f925c9ddd$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("8wyB4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b36b776ec4bd4602$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7a14286959c742e345710a87afb558>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $fP78j = parcelRequire("fP78j");

function $b36b776ec4bd4602$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
}

});

parcelRegister("5NrIb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $692c05f58e5d3ef7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $kXb3C = parcelRequire("kXb3C");

function $692c05f58e5d3ef7$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("iAJNI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5112347e60ca9722$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934923571ddda86dcc15b2804cd6fdd5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $fP78j = parcelRequire("fP78j");

function $5112347e60ca9722$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
}

});

parcelRegister("gV3jM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2708dfe0209c3c78$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $kXb3C = parcelRequire("kXb3C");

function $2708dfe0209c3c78$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("i9OUl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $db9e370fec44d3db$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6d6e475381a024c19a88e7f303e38fe>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $fP78j = parcelRequire("fP78j");

function $db9e370fec44d3db$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
}

});

parcelRegister("2tvDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c067814582e1346f67a8106048fd7b>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $fP78j = parcelRequire("fP78j");

function $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("1WiZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c77f4c6a2336f8ae$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $kXb3C = parcelRequire("kXb3C");

function $c77f4c6a2336f8ae$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("ey7ks", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c86924eeed42fcc2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed150536831ff7c67188f4dba2c48b6d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $fP78j = parcelRequire("fP78j");

function $c86924eeed42fcc2$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
}

});

parcelRegister("9Q0L0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4648df99867255b9e8ae22693a4d25a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $fP78j = parcelRequire("fP78j");

function $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
}

});

parcelRegister("cKqka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4b99d5ed076c1160$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $kXb3C = parcelRequire("kXb3C");

function $4b99d5ed076c1160$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("5rEH7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $011790d80979173b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b52a9f186ad8e116ad7e1e0109b235a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $fP78j = parcelRequire("fP78j");

function $011790d80979173b$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("7Jxvl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ef63a9b3b9aed96b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $kXb3C = parcelRequire("kXb3C");

function $ef63a9b3b9aed96b$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("alMZU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1b8a825273197b02$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b59d4caf81c32d029adf911a314af4f7>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $fP78j = parcelRequire("fP78j");

function $1b8a825273197b02$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("kMqyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $cb2f9539166b293e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30f3baace5bcd49b8a2c522228cf7a06>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $fP78j = parcelRequire("fP78j");

function $cb2f9539166b293e$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("lWQXA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d00f1f002e9877f9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64afc1ac758289e96d875e903d67be0d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $fP78j = parcelRequire("fP78j");

function $d00f1f002e9877f9$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
}

});

parcelRegister("4KIbP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $627ab7f82241d2c9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $kXb3C = parcelRequire("kXb3C");

function $627ab7f82241d2c9$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("aV3Bk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $18453b22d1a1a3c1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c592506fff69a014ca0cf24d97c237af>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $fP78j = parcelRequire("fP78j");

function $18453b22d1a1a3c1$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fX4W8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $042d51f21cf4898d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2862d801ef69d165822b8118797782a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $fP78j = parcelRequire("fP78j");

function $042d51f21cf4898d$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("4P3K9", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $4fbbebc17c1a2887$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $4fbbebc17c1a2887$export$19ee667f3f7a6ec3;

});

parcelRegister("h982G", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $i25hX = parcelRequire("i25hX");

const $a5e138d08f3fc65b$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $a5e138d08f3fc65b$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $a5e138d08f3fc65b$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $a5e138d08f3fc65b$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $a5e138d08f3fc65b$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($a5e138d08f3fc65b$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $a5e138d08f3fc65b$var$allowedOrigins.includes(hostname));
};
const $a5e138d08f3fc65b$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $a5e138d08f3fc65b$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $a5e138d08f3fc65b$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $a5e138d08f3fc65b$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $42omo.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $a5e138d08f3fc65b$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $42omo.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $a5e138d08f3fc65b$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};
module.exports["ROVO_POST_MESSAGE_EVENT_TYPE"] = $a5e138d08f3fc65b$export$cabfb6cc8c48b099;
module.exports["RovoPostMessagePubsubListener"] = $a5e138d08f3fc65b$export$e5e1a9c59c299631;
module.exports["useRovoPostMessageToPubsub"] = $a5e138d08f3fc65b$export$5340cc94dd0ecbea;

});

parcelRegister("gKlAz", function(module, exports) {

var $eG1Z0 = parcelRequire("eG1Z0");


var $aoDcQ = parcelRequire("aoDcQ");

function $ac303ab343815a94$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $aoDcQ.text)(maybeNode) : maybeNode;
    if ((0, $eG1Z0.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $eG1Z0.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
module.exports["applyMark"] = $ac303ab343815a94$export$50d34f59d07755a2;

});

parcelRegister("eG1Z0", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9abe739d14fcbdba$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}
function $9abe739d14fcbdba$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}
module.exports["isDuplicateMark"] = $9abe739d14fcbdba$export$5ec47a80d7cc0dfa;
module.exports["duplicateMarkError"] = $9abe739d14fcbdba$export$db1000b9ac08ce57;

});

parcelRegister("iJQnc", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $0c4bf63002e7b177$export$6565f9f03506010b = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'code'
    }, maybeNode);
module.exports["code"] = $0c4bf63002e7b177$export$6565f9f03506010b;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("ksiqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee44b6768ad41edb$export$2e2bcd8739ae039);

var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $ee44b6768ad41edb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $922yL.default)(dirtyDate, -amount);
}

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("ce4zM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7p4As = parcelRequire("7p4As");


var $kUQ8q = parcelRequire("kUQ8q");


var $2NzjA = parcelRequire("2NzjA");


var $fkwyI = parcelRequire("fkwyI");

const $7916cd98c58646d3$export$1d9b6b20d392c702 = (props)=>{
    const { href: href, onClick: onClick, ...rest } = props;
    const context = (0, $fkwyI.useTeamsNavigationContext)();
    const input = (0, $2NzjA.buildNavigationInput)({
        ...props,
        href: href ?? '',
        context: context,
        onBeforeNavigate: onClick
    });
    const navigationProps = (0, $kUQ8q.getNavigationProps)(input);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        ...rest,
        ...navigationProps
    });
};
module.exports["TeamsLinkButton"] = $7916cd98c58646d3$export$1d9b6b20d392c702;

});

parcelRegister("kUQ8q", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $2NzjA = parcelRequire("2NzjA");


var $bO6QG = parcelRequire("bO6QG");

function $198f8477e4ad60c0$export$9f4607ca273c83d(input) {
    const { href: rawHref, intent: intent, context: context, onClick: rawOnClick } = input;
    const previewPanelProps = 'previewPanelProps' in input ? input.previewPanelProps : undefined;
    const resolvedIntent = intent !== 'unknown' ? intent : (0, $bO6QG.classifyNavigationIntent)(rawHref);
    const openLinkInNewTab = resolvedIntent === 'external' || context.forceExternalIntent;
    // Prefix relative hrefs with the context entry point for the current product
    const href = (0, $dh538.fg)('ptc-fix-teams-isolated-links') ? (0, $2NzjA.prefixWithContextEntryPoint)(rawHref, context.contextEntryPoint) : openLinkInNewTab ? rawHref : (0, $2NzjA.prefixWithContextEntryPoint)(rawHref, context.contextEntryPoint ?? '');
    if (openLinkInNewTab) return {
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        onClick: (...args)=>{
            const e = args[0];
            rawOnClick?.(...args);
            if (e.defaultPrevented) return;
            e.preventDefault();
            window.open(href, '_blank', 'noopener noreferrer');
        }
    };
    return {
        href: href,
        target: '_self',
        onClick: (...args)=>{
            const e = args[0];
            rawOnClick?.(...args);
            if (e.defaultPrevented) return;
            // Handle left-click with modifier keys (let browser handle it)
            if (e.button === 0 && (0, $2NzjA.isModified)(e)) return;
            if (previewPanelProps && context.openPreviewPanel) try {
                context.openPreviewPanel({
                    ari: previewPanelProps.ari,
                    name: previewPanelProps.name,
                    url: href
                });
                e.preventDefault();
                return;
            } catch  {
            // Fall through to navigation below if opening the preview panel fails
            }
            // Handle left-clicks without modifier keys
            if (context.navigate && // only use navigate when a handler is provided
            (0, $2NzjA.isTeamsAppRoute)(href) && // only SPA navigate for townsquare routes
            e.button === 0 && // only use navigate for left mouse button clicks
            !(0, $2NzjA.isModified)(e) // let browser handle clicks with modifier
            ) {
                e.preventDefault();
                const routePath = (0, $2NzjA.getRoutePathFromUrl)(href);
                context.navigate(routePath);
                return;
            }
        }
    };
}
module.exports["getNavigationProps"] = $198f8477e4ad60c0$export$9f4607ca273c83d;

});

parcelRegister("2NzjA", function(module, exports) {
// A collection of utility functions for the teams-app-internal-navigation package.

var $dh538 = parcelRequire("dh538");

const $37f03f3dd6637609$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $37f03f3dd6637609$export$f9ded33a1a6c97c7 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $37f03f3dd6637609$export$ced0c1c5c19926df = (url)=>{
    try {
        const path = $37f03f3dd6637609$export$78cf1468c39d05b1(url);
        const hostname = new URL(url).hostname;
        return (hostname.includes('home.atlassian') || $37f03f3dd6637609$export$634ecc602a6871aa(hostname) || $37f03f3dd6637609$export$9186ccba8effc5de(hostname)) && path.includes('/people');
    } catch  {
        return false;
    }
};
const $37f03f3dd6637609$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ((0, $dh538.fg)('ptc-fix-teams-isolated-links')) {
        if ($37f03f3dd6637609$export$895d6838d29edd02(path) || // do not prefix for absolute URL
        contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
        path.startsWith('/')) return path;
        return `${contextEntryPoint}/${path}`;
    }
    if ($37f03f3dd6637609$export$895d6838d29edd02(path) || !contextEntryPoint || path.startsWith('/') || path.startsWith(contextEntryPoint)) return path;
    return `${contextEntryPoint}/${path}`;
};
const $37f03f3dd6637609$export$78cf1468c39d05b1 = (url)=>{
    try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.pathname;
    } catch  {
        // fallback for malformed URLs
        return url;
    }
};
function $37f03f3dd6637609$export$e0ed33167fbba483({ href: href, context: context, onBeforeNavigate: onBeforeNavigate, ...intentProps }) {
    return intentProps.intent === 'action' ? {
        href: href,
        intent: intentProps.intent,
        previewPanelProps: intentProps.previewPanelProps,
        context: context,
        onClick: onBeforeNavigate
    } : {
        href: href,
        intent: intentProps.intent,
        context: context,
        onClick: onBeforeNavigate
    };
}
// FedRAMP domain patterns used by Atlassian products
const $37f03f3dd6637609$var$FEDRAMP_DOMAIN_PATTERNS = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
// Isolated Cloud domain pattern
const $37f03f3dd6637609$var$ISOLATED_CLOUD_DOMAIN_PATTERN = /atlassian-isolated\.net/;
const $37f03f3dd6637609$export$634ecc602a6871aa = (hostname)=>{
    return $37f03f3dd6637609$var$FEDRAMP_DOMAIN_PATTERNS.test(hostname.toLowerCase());
};
const $37f03f3dd6637609$export$9186ccba8effc5de = (hostname)=>{
    return $37f03f3dd6637609$var$ISOLATED_CLOUD_DOMAIN_PATTERN.test(hostname.toLowerCase());
};
module.exports["isModified"] = $37f03f3dd6637609$export$f9ded33a1a6c97c7;
module.exports["isTeamsAppRoute"] = $37f03f3dd6637609$export$ced0c1c5c19926df;
module.exports["getRoutePathFromUrl"] = $37f03f3dd6637609$export$78cf1468c39d05b1;
module.exports["isFedramp"] = $37f03f3dd6637609$export$634ecc602a6871aa;
module.exports["isIsolatedCloud"] = $37f03f3dd6637609$export$9186ccba8effc5de;
module.exports["prefixWithContextEntryPoint"] = $37f03f3dd6637609$export$715c8f9057ac0c01;
module.exports["buildNavigationInput"] = $37f03f3dd6637609$export$e0ed33167fbba483;

});

parcelRegister("bO6QG", function(module, exports) {

var $2NzjA = parcelRequire("2NzjA");

// List of domains that are considered Atlassian domains - taken from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $e6ddea2768c8fc71$var$ATLASSIAN_DOMAINS = [
    'localhost',
    '127.0.0.1',
    'atlassian.com',
    'atlassian.net',
    'atl-paas.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'trello.com',
    'loom.com',
    'atlassian-dev.net',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net',
    'atlassian-us-gov.com',
    'atlassian-us-gov.net',
    'atlassian-fex.com',
    'atlassian-fex.net',
    'atlassian-stg-fedm.com',
    'atlassian-stg-fedm.net',
    'atlassian-isolated.net'
];
/** Extra roots for staging links */ const $e6ddea2768c8fc71$var$STAGING_SUFFIXES = [
    'staging.atlassian.io',
    'atl-test.space',
    'jira-dev.com',
    'stg-jira.com',
    'staging.paas-inf.net'
];
function $e6ddea2768c8fc71$var$matchesDomainList(hostname, domains) {
    const lower = hostname.toLowerCase();
    return domains.some((domain)=>lower === domain || lower.endsWith('.' + domain));
}
function $e6ddea2768c8fc71$var$isAtlassianDomain(hostname) {
    const lower = hostname.toLowerCase();
    return $e6ddea2768c8fc71$var$matchesDomainList(hostname, $e6ddea2768c8fc71$var$ATLASSIAN_DOMAINS) || $e6ddea2768c8fc71$var$matchesDomainList(hostname, $e6ddea2768c8fc71$var$STAGING_SUFFIXES) || (0, $2NzjA.isFedramp)(lower) || (0, $2NzjA.isIsolatedCloud)(lower);
}
const $e6ddea2768c8fc71$var$REFERENCE_DOMAINS = [
    'support.atlassian.com',
    'developer.atlassian.com',
    'community.atlassian.com'
];
function $e6ddea2768c8fc71$var$isReferenceDomain(hostname) {
    return $e6ddea2768c8fc71$var$matchesDomainList(hostname, $e6ddea2768c8fc71$var$REFERENCE_DOMAINS);
}
function $e6ddea2768c8fc71$export$f293869d7b7da38b(href) {
    const IS_ABSOLUTE_LINK_REGEX = /^(?:(http|https):\/\/)/;
    const IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
    const isAbsolute = IS_ABSOLUTE_LINK_REGEX.test(href);
    const isNonHttpBased = IS_NON_HTTP_BASED.test(href);
    const isRelative = !isAbsolute && !isNonHttpBased;
    if (isRelative) return 'navigation';
    let parsedUrl;
    try {
        parsedUrl = new URL(href);
    } catch  {
        return 'unknown';
    }
    if (!$e6ddea2768c8fc71$var$isAtlassianDomain(parsedUrl.hostname)) return 'external';
    if ($e6ddea2768c8fc71$var$isReferenceDomain(parsedUrl.hostname)) return 'reference';
    if ($e6ddea2768c8fc71$var$isAtlassianDomain(parsedUrl.hostname)) return 'navigation';
    return 'unknown';
}
module.exports["classifyNavigationIntent"] = $e6ddea2768c8fc71$export$f293869d7b7da38b;

});

parcelRegister("fkwyI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $2c55f0ec14db1a69$var$NavigationContextReact = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $2c55f0ec14db1a69$export$e41452ac1c641b11({ value: value, children: children }) {
    const ancestorEntryPoint = (0, $42omo.useContext)($2c55f0ec14db1a69$var$NavigationContextReact)?.contextEntryPoint;
    const contextValue = (0, $42omo.useMemo)(()=>!value.contextEntryPoint && ancestorEntryPoint ? {
            ...value,
            contextEntryPoint: ancestorEntryPoint
        } : value, [
        ancestorEntryPoint,
        value
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($2c55f0ec14db1a69$var$NavigationContextReact.Provider, {
        value: contextValue,
        children: children
    });
}
function $2c55f0ec14db1a69$export$f3c3decdfa7dda68() {
    const context = (0, $42omo.useContext)($2c55f0ec14db1a69$var$NavigationContextReact);
    return context ?? {};
}
module.exports["TeamsNavigationProvider"] = $2c55f0ec14db1a69$export$e41452ac1c641b11;
module.exports["useTeamsNavigationContext"] = $2c55f0ec14db1a69$export$f3c3decdfa7dda68;

});

parcelRegister("aCzn4", function(module, exports) {
const $26c671ba196278bc$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
module.exports["isBasicClick"] = $26c671ba196278bc$export$eddcd8a5b7e09991;

});

parcelRegister("kPml2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f767605c1291541e11ee398674a3c525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f299e6000fe75318$var$_react = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("42omo")));

var $f299e6000fe75318$var$_baseNew = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f299e6000fe75318$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f299e6000fe75318$var$LocationIcon = (props)=>/*#__PURE__*/ $f299e6000fe75318$var$_react.default.createElement($f299e6000fe75318$var$_baseNew.default, Object.assign({
        name: "LocationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$f299e6000fe75318$var$LocationIcon.displayName = 'LocationIcon';
var $f299e6000fe75318$var$_default = module.exports.default = $f299e6000fe75318$var$LocationIcon;

});

parcelRegister("3gzdJ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $kUQ8q = parcelRequire("kUQ8q");


var $2NzjA = parcelRequire("2NzjA");


var $fkwyI = parcelRequire("fkwyI");

const $4ac461805307bdc4$export$72d1cecfc3326890 = (props)=>{
    const { href: href, onClick: onClick, children: children, ...rest } = props;
    const context = (0, $fkwyI.useTeamsNavigationContext)();
    const input = (0, $2NzjA.buildNavigationInput)({
        ...props,
        href: href ?? '',
        context: context,
        onBeforeNavigate: onClick
    });
    const { onClick: composedOnClick, href: resolvedHref, target: target, rel: rel } = (0, $kUQ8q.getNavigationProps)(input);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        ...rest,
        href: resolvedHref,
        target: target,
        rel: rel,
        onClick: composedOnClick,
        children: children
    });
};
module.exports["TeamsLink"] = $4ac461805307bdc4$export$72d1cecfc3326890;

});

parcelRegister("8nlrk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $lAwme = parcelRequire("lAwme");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");

const $6b7f2dce15d051f7$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $42omo.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics(`ui.${(0, $bUp2E.getActionSubject)(profileType)}.rendered.spinner`, {
            firedAt: Math.round((0, $caPHA.getPageTime)()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAwme.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });
};
module.exports["LoadingState"] = $6b7f2dce15d051f7$export$62aa48085237e36f;

});

parcelRegister("7Y4kW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");

const $eb50cc4a563796fc$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $eb50cc4a563796fc$export$38f9b635c1c454e7;

});

parcelRegister("lBFuf", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $hge3g = parcelRequire("hge3g");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $7Y4kW = parcelRequire("7Y4kW");


var $jz7J7 = parcelRequire("jz7J7");

const $204b57ff8caef44c$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $204b57ff8caef44c$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $204b57ff8caef44c$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7Y4kW.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($204b57ff8caef44c$var$styles.queryText, whiteSpacePreWrap && $204b57ff8caef44c$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $204b57ff8caef44c$export$76b47032dcd9063b = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                xcss: $204b57ff8caef44c$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $204b57ff8caef44c$var$styles.queryText,
                        children: formatMessage((0, $jz7J7.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});
module.exports["ChatPill"] = $204b57ff8caef44c$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $204b57ff8caef44c$export$76b47032dcd9063b;

});

parcelRegister("jz7J7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5fc6573ead9ef7c8$var$message = (0, $aXWIB.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse agents"
    }
});
var $5fc6573ead9ef7c8$export$2e2bcd8739ae039 = $5fc6573ead9ef7c8$var$message;
module.exports["default"] = $5fc6573ead9ef7c8$export$2e2bcd8739ae039;

});

parcelRegister("eLQM6", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b100a9eece33ac5b$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2ybME")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b100a9eece33ac5b$var$LazyDatasourceTableView, props));
};
var $b100a9eece33ac5b$export$2e2bcd8739ae039 = $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $b100a9eece33ac5b$export$2e2bcd8739ae039;

});

parcelRegister("2ybME", function(module, exports) {

let $1db7e5bbd1e51621$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1db7e5bbd1e51621$var$load("dbdNk"),
    $1db7e5bbd1e51621$var$load("h5FT3"),
    $1db7e5bbd1e51621$var$load("lTK3c"),
    $1db7e5bbd1e51621$var$load("1WXdc"),
    $1db7e5bbd1e51621$var$load("cvmn7"),
    $1db7e5bbd1e51621$var$load("jmFg4"),
    $1db7e5bbd1e51621$var$load("6wr18"),
    $1db7e5bbd1e51621$var$load("5pvpJ"),
    $1db7e5bbd1e51621$var$load("eXGjr"),
    $1db7e5bbd1e51621$var$load("iNa18"),
    $1db7e5bbd1e51621$var$load("8makw"),
    $1db7e5bbd1e51621$var$load("ffEVr"),
    $1db7e5bbd1e51621$var$load("hhss7"),
    $1db7e5bbd1e51621$var$load("kHOMt"),
    $1db7e5bbd1e51621$var$load("7EorR"),
    $1db7e5bbd1e51621$var$load("Wowvf"),
    $1db7e5bbd1e51621$var$load("etEYy"),
    $1db7e5bbd1e51621$var$load("7ixUU")
]).then(()=>parcelRequire('jfuml'));

});

parcelRegister("4Ldep", function(module, exports) {
$parcel$export(module.exports, "default", () => $3775d0b53e1446a0$export$2e2bcd8739ae039);

var $dhNqt = parcelRequire("dhNqt");


var $b5utg = parcelRequire("b5utg");

function $3775d0b53e1446a0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeftStartOfDay = (0, $dhNqt.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $dhNqt.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("7NoXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a320422a745418e6$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fs5Wi = parcelRequire("fs5Wi");


var $1GQGM = parcelRequire("1GQGM");


const $a320422a745418e6$var$MediaViewer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9ZaHy")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a320422a745418e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fs5Wi.default), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GQGM.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($a320422a745418e6$var$MediaViewer, {
                ...props
            })
        })
    });
}

});

parcelRegister("fs5Wi", function(module, exports) {
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $70BxX = parcelRequire("70BxX");


var $cOrQJ = parcelRequire("cOrQJ");

const $379228055afe24f5$export$442b7be89436c101 = '#101214';
const $379228055afe24f5$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $70BxX.default), {
        blankedColor: $379228055afe24f5$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $379228055afe24f5$export$2e2bcd8739ae039 = $379228055afe24f5$var$ModalSpinner;
module.exports["default"] = $379228055afe24f5$export$2e2bcd8739ae039;

});

parcelRegister("70BxX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9DX83 = parcelRequire("9DX83");

const $9f2ec0906c10b2d9$var$ModalSpinner = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9DX83.default), props);
var $9f2ec0906c10b2d9$export$2e2bcd8739ae039 = $9f2ec0906c10b2d9$var$ModalSpinner;
module.exports["default"] = $9f2ec0906c10b2d9$export$2e2bcd8739ae039;

});

parcelRegister("9DX83", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed42ad447c5e042f$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $ed42ad447c5e042f$var$blanketStyles = null;
const $ed42ad447c5e042f$var$spinnerStyles = null;
const $ed42ad447c5e042f$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ed42ad447c5e042f$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundColor: blankedColor || $ed42ad447c5e042f$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large",
        appearance: invertSpinnerColor || $ed42ad447c5e042f$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("1GQGM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");

const $86b842c4b2e17806$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: 510,
        children: children
    });
module.exports["MediaViewerPortal"] = $86b842c4b2e17806$export$51aee4c01b17acde;

});

parcelRegister("9ZaHy", function(module, exports) {

let $74521ca87926c44b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74521ca87926c44b$var$load("hRqzw"),
    $74521ca87926c44b$var$load("cvmn7"),
    $74521ca87926c44b$var$load("jmFg4"),
    $74521ca87926c44b$var$load("f35QR"),
    $74521ca87926c44b$var$load("eVYW1"),
    $74521ca87926c44b$var$load("ls0Um"),
    $74521ca87926c44b$var$load("020xd"),
    $74521ca87926c44b$var$load("eTBsW"),
    $74521ca87926c44b$var$load("bYxCZ"),
    $74521ca87926c44b$var$load("6HBYC"),
    $74521ca87926c44b$var$load("eDqo1"),
    $74521ca87926c44b$var$load("lxiFd"),
    $74521ca87926c44b$var$load("1oiJ6"),
    $74521ca87926c44b$var$load("huUvS"),
    $74521ca87926c44b$var$load("6wr18"),
    $74521ca87926c44b$var$load("llcfA"),
    $74521ca87926c44b$var$load("azCDs"),
    $74521ca87926c44b$var$load("dT77m"),
    $74521ca87926c44b$var$load("8j9XC"),
    $74521ca87926c44b$var$load("ffEVr"),
    $74521ca87926c44b$var$load("6vhrJ"),
    $74521ca87926c44b$var$load("fxC6e"),
    $74521ca87926c44b$var$load("kknf5"),
    $74521ca87926c44b$var$load("hPalR"),
    $74521ca87926c44b$var$load("jDjSj"),
    $74521ca87926c44b$var$load("8059b"),
    $74521ca87926c44b$var$load("3QZdB"),
    $74521ca87926c44b$var$load("3M4Om"),
    $74521ca87926c44b$var$load("4jPsO"),
    $74521ca87926c44b$var$load("72780"),
    $74521ca87926c44b$var$load("hszIA"),
    $74521ca87926c44b$var$load("2fk6g"),
    $74521ca87926c44b$var$load("ajMch"),
    $74521ca87926c44b$var$load("hhss7"),
    $74521ca87926c44b$var$load("cKkZK")
]).then(()=>parcelRequire('gamJO'));

});

parcelRegister("20uDq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1763584a95cbcc22$var$_react = $1763584a95cbcc22$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $1763584a95cbcc22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1763584a95cbcc22$var$Image24Icon = (props)=>/*#__PURE__*/ $1763584a95cbcc22$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1763584a95cbcc22$var$Image24Icon.displayName = 'Image24Icon';
var $1763584a95cbcc22$var$_default = module.exports.default = $1763584a95cbcc22$var$Image24Icon;

});

parcelRegister("gguok", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bd75b70c5b19ffcb$var$_react = $bd75b70c5b19ffcb$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $bd75b70c5b19ffcb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bd75b70c5b19ffcb$var$Audio24Icon = (props)=>/*#__PURE__*/ $bd75b70c5b19ffcb$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bd75b70c5b19ffcb$var$Audio24Icon.displayName = 'Audio24Icon';
var $bd75b70c5b19ffcb$var$_default = module.exports.default = $bd75b70c5b19ffcb$var$Audio24Icon;

});

parcelRegister("hXc8o", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d1215bfee3cc0270$var$_react = $d1215bfee3cc0270$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $d1215bfee3cc0270$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d1215bfee3cc0270$var$Video24Icon = (props)=>/*#__PURE__*/ $d1215bfee3cc0270$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d1215bfee3cc0270$var$Video24Icon.displayName = 'Video24Icon';
var $d1215bfee3cc0270$var$_default = module.exports.default = $d1215bfee3cc0270$var$Video24Icon;

});

parcelRegister("djgQ6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9b0a1cae716cd1ca$var$_react = $9b0a1cae716cd1ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $9b0a1cae716cd1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b0a1cae716cd1ca$var$Generic24Icon = (props)=>/*#__PURE__*/ $9b0a1cae716cd1ca$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9b0a1cae716cd1ca$var$Generic24Icon.displayName = 'Generic24Icon';
var $9b0a1cae716cd1ca$var$_default = module.exports.default = $9b0a1cae716cd1ca$var$Generic24Icon;

});

parcelRegister("41GKb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ee869754fb919da$var$_react = $2ee869754fb919da$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $2ee869754fb919da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ee869754fb919da$var$Image16Icon = (props)=>/*#__PURE__*/ $2ee869754fb919da$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$2ee869754fb919da$var$Image16Icon.displayName = 'Image16Icon';
var $2ee869754fb919da$var$_default = module.exports.default = $2ee869754fb919da$var$Image16Icon;

});

parcelRegister("d4cCP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $983571389684b329$var$_react = $983571389684b329$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $983571389684b329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $983571389684b329$var$Audio16Icon = (props)=>/*#__PURE__*/ $983571389684b329$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$983571389684b329$var$Audio16Icon.displayName = 'Audio16Icon';
var $983571389684b329$var$_default = module.exports.default = $983571389684b329$var$Audio16Icon;

});

parcelRegister("ayTrS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7b081747db76b4a8$var$_react = $7b081747db76b4a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $7b081747db76b4a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7b081747db76b4a8$var$Video16Icon = (props)=>/*#__PURE__*/ $7b081747db76b4a8$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$7b081747db76b4a8$var$Video16Icon.displayName = 'Video16Icon';
var $7b081747db76b4a8$var$_default = module.exports.default = $7b081747db76b4a8$var$Video16Icon;

});

parcelRegister("8DZd1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64b1721c286de662$var$_react = $64b1721c286de662$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $64b1721c286de662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64b1721c286de662$var$Generic16Icon = (props)=>/*#__PURE__*/ $64b1721c286de662$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$64b1721c286de662$var$Generic16Icon.displayName = 'Generic16Icon';
var $64b1721c286de662$var$_default = module.exports.default = $64b1721c286de662$var$Generic16Icon;

});

parcelRegister("7t8Pn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $570216d1bcbf60e3$var$_react = $570216d1bcbf60e3$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $570216d1bcbf60e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $570216d1bcbf60e3$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $570216d1bcbf60e3$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$570216d1bcbf60e3$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $570216d1bcbf60e3$var$_default = module.exports.default = $570216d1bcbf60e3$var$SourceCode24Icon;

});

parcelRegister("i0btU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bwC67 = parcelRequire("bwC67");

const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $aXWIB.useIntl)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;
module.exports["default"] = $806263e9564ebacc$export$2e2bcd8739ae039;

});

parcelRegister("bwC67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gjAAG = parcelRequire("gjAAG");

const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6T5MV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2MjVl")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("fUTmq")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5twea")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("fqTiF")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("hOoVI")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("hzBID")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("iMxZ4")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("6A71H")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("45QCs")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("kqeHl")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dJ6Pi")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("l2oJQ")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("7Z8O5")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("akIwc")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5QC19")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("jwFdt")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("57HTs")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("ca1Du")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("eD8co")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("b0J0o")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("bloIQ")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dVKWy")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("1ux4r")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("dct7i")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("gxykE")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9677e")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lksJj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("1mGBp")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("8yPjD")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5twea")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $1cb8431546098045$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $1cb8431546098045$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $1cb8431546098045$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $1cb8431546098045$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $1cb8431546098045$export$702321a50d74536e;
module.exports["LoginAgain"] = $1cb8431546098045$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $1cb8431546098045$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $1cb8431546098045$export$d0a3169680473b6c;

});

parcelRegister("gjAAG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $898c0db98da1400a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $898c0db98da1400a$export$defe85febe8b728c;

});

parcelRegister("6T5MV", function(module, exports) {

let $503c5e8d0af51132$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $503c5e8d0af51132$var$load("4Mixi"),
    $503c5e8d0af51132$var$load("1jsQH"),
    $503c5e8d0af51132$var$load("i5eMd"),
    $503c5e8d0af51132$var$load("bv8GZ"),
    $503c5e8d0af51132$var$load("i9sd0"),
    $503c5e8d0af51132$var$load("4DYJ5"),
    $503c5e8d0af51132$var$load("gyXEE"),
    $503c5e8d0af51132$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("2MjVl", function(module, exports) {

let $205f84f31c80d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $205f84f31c80d263$var$load("cjveN"),
    $205f84f31c80d263$var$load("deyvi"),
    $205f84f31c80d263$var$load("4UPfH"),
    $205f84f31c80d263$var$load("cdeuH"),
    $205f84f31c80d263$var$load("aNg21"),
    $205f84f31c80d263$var$load("hfFxJ"),
    $205f84f31c80d263$var$load("1Mp9N"),
    $205f84f31c80d263$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("fUTmq", function(module, exports) {

let $b967077948092e7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b967077948092e7e$var$load("8XGJb"),
    $b967077948092e7e$var$load("6dERU"),
    $b967077948092e7e$var$load("gd4qs"),
    $b967077948092e7e$var$load("7gF8f"),
    $b967077948092e7e$var$load("YEGhv"),
    $b967077948092e7e$var$load("gofGr"),
    $b967077948092e7e$var$load("dBb6q"),
    $b967077948092e7e$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("fqTiF", function(module, exports) {

let $b3c42e30442687ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3c42e30442687ea$var$load("hdvZr"),
    $b3c42e30442687ea$var$load("kTurq"),
    $b3c42e30442687ea$var$load("fviv5"),
    $b3c42e30442687ea$var$load("djb49"),
    $b3c42e30442687ea$var$load("d8WL7"),
    $b3c42e30442687ea$var$load("2RQvP"),
    $b3c42e30442687ea$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("hOoVI", function(module, exports) {

let $cf7a71ba4d1a7d13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf7a71ba4d1a7d13$var$load("4ViGN"),
    $cf7a71ba4d1a7d13$var$load("j0PWv"),
    $cf7a71ba4d1a7d13$var$load("eBoC7"),
    $cf7a71ba4d1a7d13$var$load("ksTQ6"),
    $cf7a71ba4d1a7d13$var$load("j5F5K"),
    $cf7a71ba4d1a7d13$var$load("7NpX8"),
    $cf7a71ba4d1a7d13$var$load("cukQS"),
    $cf7a71ba4d1a7d13$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("hzBID", function(module, exports) {

let $ccb2f6c0baa217fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ccb2f6c0baa217fd$var$load("32vlK"),
    $ccb2f6c0baa217fd$var$load("dlmud"),
    $ccb2f6c0baa217fd$var$load("bNv64"),
    $ccb2f6c0baa217fd$var$load("5CGnz"),
    $ccb2f6c0baa217fd$var$load("dXu4x"),
    $ccb2f6c0baa217fd$var$load("bFU3Y"),
    $ccb2f6c0baa217fd$var$load("3CucM"),
    $ccb2f6c0baa217fd$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("iMxZ4", function(module, exports) {

let $dac712373986424e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dac712373986424e$var$load("7snhF"),
    $dac712373986424e$var$load("bAoKR"),
    $dac712373986424e$var$load("X0Jic"),
    $dac712373986424e$var$load("34YSq"),
    $dac712373986424e$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("6A71H", function(module, exports) {

let $4cab8e2500c81e40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cab8e2500c81e40$var$load("bjoGV"),
    $4cab8e2500c81e40$var$load("cbkj0"),
    $4cab8e2500c81e40$var$load("4Afgd"),
    $4cab8e2500c81e40$var$load("9Oxgj"),
    $4cab8e2500c81e40$var$load("18TX5"),
    $4cab8e2500c81e40$var$load("exaJ2"),
    $4cab8e2500c81e40$var$load("lp8Wm"),
    $4cab8e2500c81e40$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("45QCs", function(module, exports) {

let $2fb07220bd68990e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fb07220bd68990e$var$load("8oiz7"),
    $2fb07220bd68990e$var$load("17m16"),
    $2fb07220bd68990e$var$load("cMubu"),
    $2fb07220bd68990e$var$load("kAg8V"),
    $2fb07220bd68990e$var$load("9Cdzw"),
    $2fb07220bd68990e$var$load("hcCcg"),
    $2fb07220bd68990e$var$load("cHWSM"),
    $2fb07220bd68990e$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("kqeHl", function(module, exports) {

let $ede1a31387791599$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ede1a31387791599$var$load("hFxmj"),
    $ede1a31387791599$var$load("b4NO6"),
    $ede1a31387791599$var$load("3fLE9"),
    $ede1a31387791599$var$load("fM2oh"),
    $ede1a31387791599$var$load("guNAg"),
    $ede1a31387791599$var$load("j9KTb"),
    $ede1a31387791599$var$load("b37xN"),
    $ede1a31387791599$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("l2oJQ", function(module, exports) {

let $f50cf970562150c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f50cf970562150c0$var$load("BXOZB"),
    $f50cf970562150c0$var$load("1K1Fj"),
    $f50cf970562150c0$var$load("8hOn0"),
    $f50cf970562150c0$var$load("xnqy2"),
    $f50cf970562150c0$var$load("cM3gY"),
    $f50cf970562150c0$var$load("3hjAq"),
    $f50cf970562150c0$var$load("7PjNK"),
    $f50cf970562150c0$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("7Z8O5", function(module, exports) {

let $5d050fbd5facb726$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d050fbd5facb726$var$load("9Xiuh"),
    $5d050fbd5facb726$var$load("38sfA"),
    $5d050fbd5facb726$var$load("h4OCL"),
    $5d050fbd5facb726$var$load("awkVi"),
    $5d050fbd5facb726$var$load("6yRq3"),
    $5d050fbd5facb726$var$load("2bCHJ"),
    $5d050fbd5facb726$var$load("ktSfi"),
    $5d050fbd5facb726$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("akIwc", function(module, exports) {

let $785e4e149392f9ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $785e4e149392f9ad$var$load("7Odo3"),
    $785e4e149392f9ad$var$load("bjmre"),
    $785e4e149392f9ad$var$load("bcQs2"),
    $785e4e149392f9ad$var$load("11DLa"),
    $785e4e149392f9ad$var$load("cft22"),
    $785e4e149392f9ad$var$load("fdXnq"),
    $785e4e149392f9ad$var$load("iouLY"),
    $785e4e149392f9ad$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("5QC19", function(module, exports) {

let $441f4c94ccb114d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $441f4c94ccb114d1$var$load("4VkvT"),
    $441f4c94ccb114d1$var$load("asvK9"),
    $441f4c94ccb114d1$var$load("aBa7j"),
    $441f4c94ccb114d1$var$load("barSq"),
    $441f4c94ccb114d1$var$load("gctEz"),
    $441f4c94ccb114d1$var$load("cItJR"),
    $441f4c94ccb114d1$var$load("hPZE5"),
    $441f4c94ccb114d1$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("jwFdt", function(module, exports) {

let $e370fa3387d5e3b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e370fa3387d5e3b0$var$load("g5qJV"),
    $e370fa3387d5e3b0$var$load("7v6wU"),
    $e370fa3387d5e3b0$var$load("b544F"),
    $e370fa3387d5e3b0$var$load("a8heY"),
    $e370fa3387d5e3b0$var$load("9PPH7"),
    $e370fa3387d5e3b0$var$load("SctKm"),
    $e370fa3387d5e3b0$var$load("dzIm8"),
    $e370fa3387d5e3b0$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("57HTs", function(module, exports) {

let $3bafa7864906c813$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3bafa7864906c813$var$load("dPa6p"),
    $3bafa7864906c813$var$load("aEpRh"),
    $3bafa7864906c813$var$load("K6fhx"),
    $3bafa7864906c813$var$load("6hlNE"),
    $3bafa7864906c813$var$load("1y1eN"),
    $3bafa7864906c813$var$load("1fJz1"),
    $3bafa7864906c813$var$load("jqwnR"),
    $3bafa7864906c813$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("ca1Du", function(module, exports) {

let $8da7b01006dab874$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8da7b01006dab874$var$load("iG4uh"),
    $8da7b01006dab874$var$load("3fuR9"),
    $8da7b01006dab874$var$load("gZU54"),
    $8da7b01006dab874$var$load("2bqSD"),
    $8da7b01006dab874$var$load("e8jpx"),
    $8da7b01006dab874$var$load("9yA8o"),
    $8da7b01006dab874$var$load("bGhLc"),
    $8da7b01006dab874$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("b0J0o", function(module, exports) {

let $80429af000af95fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $80429af000af95fd$var$load("bSjyK"),
    $80429af000af95fd$var$load("hlJc4"),
    $80429af000af95fd$var$load("j6IGj"),
    $80429af000af95fd$var$load("6tWAg"),
    $80429af000af95fd$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("bloIQ", function(module, exports) {

let $8424d53b9bbb3a1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8424d53b9bbb3a1f$var$load("9tVE8"),
    $8424d53b9bbb3a1f$var$load("fMrUo"),
    $8424d53b9bbb3a1f$var$load("4Wdqb"),
    $8424d53b9bbb3a1f$var$load("bJykp"),
    $8424d53b9bbb3a1f$var$load("fjbzp"),
    $8424d53b9bbb3a1f$var$load("448N7"),
    $8424d53b9bbb3a1f$var$load("9v6ER"),
    $8424d53b9bbb3a1f$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("1ux4r", function(module, exports) {

let $11623ef14a88be02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11623ef14a88be02$var$load("6UAlo"),
    $11623ef14a88be02$var$load("9eNkX"),
    $11623ef14a88be02$var$load("k10Cs"),
    $11623ef14a88be02$var$load("dh2Er"),
    $11623ef14a88be02$var$load("1pFHs"),
    $11623ef14a88be02$var$load("gBDdh"),
    $11623ef14a88be02$var$load("8Mz40"),
    $11623ef14a88be02$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("dct7i", function(module, exports) {

let $99c2fb5138729985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c2fb5138729985$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("gxykE", function(module, exports) {

let $c0aa5c07dc440dda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c0aa5c07dc440dda$var$load("9Yw4z"),
    $c0aa5c07dc440dda$var$load("h0uBE"),
    $c0aa5c07dc440dda$var$load("1n8w9"),
    $c0aa5c07dc440dda$var$load("eBLgB"),
    $c0aa5c07dc440dda$var$load("d0Fxy"),
    $c0aa5c07dc440dda$var$load("6NHX3"),
    $c0aa5c07dc440dda$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("9677e", function(module, exports) {

let $69fa319b49dca515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69fa319b49dca515$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("lksJj", function(module, exports) {

let $f871c05e7ad2e071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f871c05e7ad2e071$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("1mGBp", function(module, exports) {

let $0fe8e47223ece87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0fe8e47223ece87f$var$load("ia9y3"),
    $0fe8e47223ece87f$var$load("j9OUx"),
    $0fe8e47223ece87f$var$load("l079e"),
    $0fe8e47223ece87f$var$load("bV8sS"),
    $0fe8e47223ece87f$var$load("kKXTS"),
    $0fe8e47223ece87f$var$load("ebljE"),
    $0fe8e47223ece87f$var$load("hF4v3"),
    $0fe8e47223ece87f$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("8yPjD", function(module, exports) {

let $63b94def09bd7557$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63b94def09bd7557$var$load("15ncj"),
    $63b94def09bd7557$var$load("gDiIK"),
    $63b94def09bd7557$var$load("f1B4n"),
    $63b94def09bd7557$var$load("eLlpV"),
    $63b94def09bd7557$var$load("7sItg"),
    $63b94def09bd7557$var$load("j4dSZ"),
    $63b94def09bd7557$var$load("1Tuyb"),
    $63b94def09bd7557$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("l2474", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gURmQ")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;
module.exports["default"] = $d23df821b2d2d994$export$2e2bcd8739ae039;

});

parcelRegister("gURmQ", function(module, exports) {

let $c50b45f90fc6d653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c50b45f90fc6d653$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});

parcelRegister("7uLCZ", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $2HVlJ = parcelRequire("2HVlJ");



var $lPGZG = parcelRequire("lPGZG");


var $dlky5 = parcelRequire("dlky5");

var $575047a4d1f8def0$export$bb38bb9a1161268 = 'unmounted';
var $575047a4d1f8def0$export$84cbff306f539230 = 'exited';
var $575047a4d1f8def0$export$df38205c966be359 = 'entering';
var $575047a4d1f8def0$export$78e9e6e3e014d60a = 'entered';
var $575047a4d1f8def0$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $575047a4d1f8def0$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
                _this.appearStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else initialStatus = $575047a4d1f8def0$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $575047a4d1f8def0$export$bb38bb9a1161268;
        else initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $575047a4d1f8def0$export$bb38bb9a1161268) return {
            status: $575047a4d1f8def0$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $575047a4d1f8def0$export$df38205c966be359 && status !== $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else if (status === $575047a4d1f8def0$export$df38205c966be359 || status === $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $575047a4d1f8def0$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $dlky5.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $575047a4d1f8def0$export$84cbff306f539230) this.setState({
            status: $575047a4d1f8def0$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $575047a4d1f8def0$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $575047a4d1f8def0$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $575047a4d1f8def0$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $575047a4d1f8def0$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $575047a4d1f8def0$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bDniu.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lPGZG.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$575047a4d1f8def0$var$Transition.contextType = (0, $lPGZG.default);
$575047a4d1f8def0$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $575047a4d1f8def0$var$noop() {}
$575047a4d1f8def0$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $575047a4d1f8def0$var$noop,
    onEntering: $575047a4d1f8def0$var$noop,
    onEntered: $575047a4d1f8def0$var$noop,
    onExit: $575047a4d1f8def0$var$noop,
    onExiting: $575047a4d1f8def0$var$noop,
    onExited: $575047a4d1f8def0$var$noop
};
$575047a4d1f8def0$var$Transition.UNMOUNTED = $575047a4d1f8def0$export$bb38bb9a1161268;
$575047a4d1f8def0$var$Transition.EXITED = $575047a4d1f8def0$export$84cbff306f539230;
$575047a4d1f8def0$var$Transition.ENTERING = $575047a4d1f8def0$export$df38205c966be359;
$575047a4d1f8def0$var$Transition.ENTERED = $575047a4d1f8def0$export$78e9e6e3e014d60a;
$575047a4d1f8def0$var$Transition.EXITING = $575047a4d1f8def0$export$4aacc83d4d59139f;
var $575047a4d1f8def0$export$2e2bcd8739ae039 = $575047a4d1f8def0$var$Transition;
module.exports["default"] = $575047a4d1f8def0$export$2e2bcd8739ae039;

});

parcelRegister("2HVlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8c1559a495fd3f$export$2e2bcd8739ae039);
var $1f8c1559a495fd3f$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("lPGZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4fb61bd619d593$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $fe4fb61bd619d593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);

});

parcelRegister("dlky5", function(module, exports) {
var $9b6d2d196fd1178d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $9b6d2d196fd1178d$export$7d26bbb1236dafd6;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $4HDYO.defaultRegistry).getStore($2c362c1c58e43242$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) will refetch and surface the error via its normal
        // path. `onError` is purely for the warm callsite's observability.
        actions.updateCacheEntry(queryKey, {
            isFetching: false
        });
        onError?.(error);
    });
};
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $42omo.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["prefetchQuery"] = $2c362c1c58e43242$export$96097db97bddd5cd;
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("8CAML", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $ece6631c27d5e331$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $ece6631c27d5e331$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $ece6631c27d5e331$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $ece6631c27d5e331$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $8Igpw.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $ece6631c27d5e331$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $ece6631c27d5e331$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $ece6631c27d5e331$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $ece6631c27d5e331$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $ece6631c27d5e331$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $ece6631c27d5e331$export$ba203f24e0131ba7;

});

parcelRegister("iswAx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");


var $9EfFC = parcelRequire("9EfFC");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $9uTsJ = parcelRequire("9uTsJ");


var $bOrYy = parcelRequire("bOrYy");


var $kpYGL = parcelRequire("kpYGL");


var $1yaYZ = parcelRequire("1yaYZ");


var $9eLw5 = parcelRequire("9eLw5");


var $26nu6 = parcelRequire("26nu6");


var $cqFPV = parcelRequire("cqFPV");


var $fQF1W = parcelRequire("fQF1W");


var $eOn3v = parcelRequire("eOn3v");


var $5kyLi = parcelRequire("5kyLi");

const $baa53903be441878$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $baa53903be441878$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $baa53903be441878$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $26nu6.isSystemAgent)(agent) || (0, $26nu6.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $26nu6.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            testId: "atlassian-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: authoringTeam.profile_url,
                target: "_blank",
                onClick: onClick,
                children: authoringTeam.display_name
            })
        });
        const aaid = agent.creator ? $baa53903be441878$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($baa53903be441878$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $dh538.fg)('rovo_agent_support_a2a_avatar') ? (0, $bOrYy.isForgeAgentByCreatorType)(agent.creator_type) : (0, $26nu6.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: agent.creator
    });
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $baa53903be441878$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $fBMbo.di)($baa53903be441878$export$5d980898591175e);
    const { profile: profile, client: client } = $baa53903be441878$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { atlasURL: atlasURL } = (0, $fQF1W.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $5kyLi.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick,
            children: fullName
        });
    }
    return profileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9uTsJ.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $baa53903be441878$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $eOn3v.useProfileClient)();
    const profile = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $baa53903be441878$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $baa53903be441878$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $baa53903be441878$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $cqFPV.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $baa53903be441878$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $baa53903be441878$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $baa53903be441878$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $baa53903be441878$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $baa53903be441878$export$6d876204c5d593ac;

});

parcelRegister("26nu6", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $04c28723649a2305$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $04c28723649a2305$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $04c28723649a2305$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $dh538.fg)('rovo_agent_support_a2a_avatar');
const $04c28723649a2305$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $04c28723649a2305$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $04c28723649a2305$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira'
};
module.exports["isSystemAgent"] = $04c28723649a2305$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $04c28723649a2305$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $04c28723649a2305$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $04c28723649a2305$export$7091e3bee2adaacb;
module.exports["BrowseCategories"] = $04c28723649a2305$export$916e4870f74f205b;

});

parcelRegister("cqFPV", function(module, exports) {
const $570a782ebb8f75e0$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $570a782ebb8f75e0$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $570a782ebb8f75e0$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $570a782ebb8f75e0$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $570a782ebb8f75e0$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE;
const $570a782ebb8f75e0$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$HIPAA_ERROR_CODE;
const $570a782ebb8f75e0$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $570a782ebb8f75e0$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $570a782ebb8f75e0$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $570a782ebb8f75e0$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $570a782ebb8f75e0$export$429080cfef3412f2;

});

parcelRegister("fQF1W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $827Ne = parcelRequire("827Ne");


var $dYtRL = parcelRequire("dYtRL");

const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $42omo.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202;

});

parcelRegister("827Ne", function(module, exports) {

var $6FQwA = parcelRequire("6FQwA");


var $bhcGS = parcelRequire("bhcGS");

const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    return (0, $bhcGS.isStaging)() ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $5ae4133df3384b49$export$5105758c0e772381;
module.exports["getAtlasURL"] = $5ae4133df3384b49$export$bfee0f88bf621ad3;

});

parcelRegister("6FQwA", function(module, exports) {

var $kGZ7I = parcelRequire("kGZ7I");

const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("kGZ7I", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];
module.exports["ROVO_PARAM_PREFIX"] = $0075612de7c1f282$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $0075612de7c1f282$export$3cd6b610e7ede579;

});

parcelRegister("bhcGS", function(module, exports) {
const $f2c917fe02396491$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $f2c917fe02396491$export$23da1d24a38b0bde;

});

parcelRegister("dYtRL", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $9eLw5 = parcelRequire("9eLw5");


var $hGGLc = parcelRequire("hGGLc");

const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    (0, $fBMbo.di)((0, $9eLw5.useQuery));
    const experience = (0, $hUyPY.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};
module.exports["useTenantDataController"] = $63d59501eb65c4db$export$b863fec6791eae25;

});

parcelRegister("hGGLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8CAML = parcelRequire("8CAML");

const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$var$cache = new Map();
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    // If AIFC is enabled, use the new caching
    if ((0, $dh538.fg)('aifc_create_enabled')) {
        // Check if we already have a pending promise or cached result
        if ($0fc4c72c92b990ea$var$cache.has(cloudId)) return $0fc4c72c92b990ea$var$cache.get(cloudId);
        const response = await (0, $8CAML.performGqlFetch)({
            gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        });
        const result = response.data?.tenantContexts?.[0];
        if (result) // Store the promise in the cache
        $0fc4c72c92b990ea$var$cache.set(cloudId, result);
        return result;
    }
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
module.exports["getCloudUrlFromId"] = $0fc4c72c92b990ea$export$d4ace54df9bd6bb1;

});

parcelRegister("eOn3v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $fHxn4 = parcelRequire("fHxn4");

const $1bde4828e2efe4cf$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $1bde4828e2efe4cf$var$client;
const $1bde4828e2efe4cf$export$d43dc22a8337ee9f = ()=>{
    (0, $fBMbo.di)((0, $fHxn4.default));
    const profileClient = (0, $42omo.useMemo)(()=>{
        if (!$1bde4828e2efe4cf$var$client) // To support di
        $1bde4828e2efe4cf$var$client = new (0, $fHxn4.default)({
            url: $1bde4828e2efe4cf$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $1bde4828e2efe4cf$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $1bde4828e2efe4cf$export$d43dc22a8337ee9f;

});

parcelRegister("5kyLi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b55ef878efda143d$var$message = (0, $aXWIB.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $b55ef878efda143d$export$2e2bcd8739ae039 = $b55ef878efda143d$var$message;
module.exports["default"] = $b55ef878efda143d$export$2e2bcd8739ae039;

});

parcelRegister("5gEqE", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $2CHXX = parcelRequire("2CHXX");

const $815712ef274e8115$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    selectedSpace: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined
};
const $815712ef274e8115$var$store = (0, $1P1Tu.createStore)({
    name: 'uiStore',
    initialState: $815712ef274e8115$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$815712ef274e8115$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $815712ef274e8115$var$useStore = (0, $9zUhf.createHook)($815712ef274e8115$var$store);
const $815712ef274e8115$export$13a6c73a57f1d6a6 = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId
        })
});
const $815712ef274e8115$export$81a40d215ef1c1de = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $815712ef274e8115$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId }] = $815712ef274e8115$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $815712ef274e8115$export$cd2fc25ddd3752d4 = (0, $9zUhf.createActionsHook)($815712ef274e8115$var$store);
module.exports["useEmptyChatLaunchSelector"] = $815712ef274e8115$export$13a6c73a57f1d6a6;
module.exports["useActiveTabSelector"] = $815712ef274e8115$export$81a40d215ef1c1de;
module.exports["useUIStore"] = $815712ef274e8115$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $815712ef274e8115$export$cd2fc25ddd3752d4;

});

parcelRegister("4iPjq", function(module, exports) {

var $aqrhZ = parcelRequire("aqrhZ");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("daT1z")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $74848600c16eb369$var$_default_1 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);
var $74848600c16eb369$export$2e2bcd8739ae039 = $74848600c16eb369$var$_default_1;
module.exports["default"] = $74848600c16eb369$export$2e2bcd8739ae039;

});

parcelRegister("5wEPK", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $knjgj.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lQSkW.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)($99bf16152ad1d840$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $918lS.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $jrfDA.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $56c0565d5892d700$var$useConstructor(()=>(0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $l998X.jsx)($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $56c0565d5892d700$export$36ecc935abdc3636 = ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

function $4548d496336bec74$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback),
        children: children
    });
}
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {});
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $atwsN.EmptyState), {
            header: header,
            renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c2ARh.GenericErrorSVG), {}),
            description: description
        })
    });
};
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ab7LA.LazyMessagesProvider), {
        children: children
    });
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale),
        children: children
    });
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("49ni4")),
    da: ()=>(parcelRequire("9i24I")),
    de: ()=>(parcelRequire("3GGRL")),
    en_GB: ()=>(parcelRequire("f9H50")),
    en_ZZ: ()=>(parcelRequire("ecHgQ")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("b9n7m")),
    fi: ()=>(parcelRequire("9Ymrs")),
    fr: ()=>(parcelRequire("c09we")),
    hu: ()=>(parcelRequire("eWHOv")),
    it: ()=>(parcelRequire("joBHN")),
    ja: ()=>(parcelRequire("EDSZV")),
    ko: ()=>(parcelRequire("f5q2I")),
    nb: ()=>(parcelRequire("rJqkb")),
    nl: ()=>(parcelRequire("58PdT")),
    pl: ()=>(parcelRequire("enArn")),
    pt_BR: ()=>(parcelRequire("5XYTp")),
    ru: ()=>(parcelRequire("k3D4M")),
    sv: ()=>(parcelRequire("819Nj")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("hE3F1")),
    zh: ()=>(parcelRequire("dpRbE"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("49ni4", function(module, exports) {

let $305a11b60fea096a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $305a11b60fea096a$var$load("4Mixi"),
    $305a11b60fea096a$var$load("1jsQH"),
    $305a11b60fea096a$var$load("i5eMd"),
    $305a11b60fea096a$var$load("bv8GZ"),
    $305a11b60fea096a$var$load("i9sd0"),
    $305a11b60fea096a$var$load("4DYJ5"),
    $305a11b60fea096a$var$load("gyXEE"),
    $305a11b60fea096a$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("9i24I", function(module, exports) {

let $6c376795d61b5f16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c376795d61b5f16$var$load("cjveN"),
    $6c376795d61b5f16$var$load("deyvi"),
    $6c376795d61b5f16$var$load("4UPfH"),
    $6c376795d61b5f16$var$load("cdeuH"),
    $6c376795d61b5f16$var$load("aNg21"),
    $6c376795d61b5f16$var$load("hfFxJ"),
    $6c376795d61b5f16$var$load("1Mp9N"),
    $6c376795d61b5f16$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("3GGRL", function(module, exports) {

let $2af68baa2ba0afdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2af68baa2ba0afdb$var$load("8XGJb"),
    $2af68baa2ba0afdb$var$load("6dERU"),
    $2af68baa2ba0afdb$var$load("gd4qs"),
    $2af68baa2ba0afdb$var$load("7gF8f"),
    $2af68baa2ba0afdb$var$load("YEGhv"),
    $2af68baa2ba0afdb$var$load("gofGr"),
    $2af68baa2ba0afdb$var$load("dBb6q"),
    $2af68baa2ba0afdb$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("f9H50", function(module, exports) {

let $b0891d001c3b0f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0891d001c3b0f5d$var$load("hdvZr"),
    $b0891d001c3b0f5d$var$load("kTurq"),
    $b0891d001c3b0f5d$var$load("fviv5"),
    $b0891d001c3b0f5d$var$load("djb49"),
    $b0891d001c3b0f5d$var$load("d8WL7"),
    $b0891d001c3b0f5d$var$load("2RQvP"),
    $b0891d001c3b0f5d$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("ecHgQ", function(module, exports) {

let $a573c0545bc835b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a573c0545bc835b1$var$load("4ViGN"),
    $a573c0545bc835b1$var$load("j0PWv"),
    $a573c0545bc835b1$var$load("eBoC7"),
    $a573c0545bc835b1$var$load("ksTQ6"),
    $a573c0545bc835b1$var$load("j5F5K"),
    $a573c0545bc835b1$var$load("7NpX8"),
    $a573c0545bc835b1$var$load("cukQS"),
    $a573c0545bc835b1$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("b9n7m", function(module, exports) {

let $81e277acab2bd080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81e277acab2bd080$var$load("32vlK"),
    $81e277acab2bd080$var$load("dlmud"),
    $81e277acab2bd080$var$load("bNv64"),
    $81e277acab2bd080$var$load("5CGnz"),
    $81e277acab2bd080$var$load("dXu4x"),
    $81e277acab2bd080$var$load("bFU3Y"),
    $81e277acab2bd080$var$load("3CucM"),
    $81e277acab2bd080$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("9Ymrs", function(module, exports) {

let $742b201de0044ee5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $742b201de0044ee5$var$load("bjoGV"),
    $742b201de0044ee5$var$load("cbkj0"),
    $742b201de0044ee5$var$load("4Afgd"),
    $742b201de0044ee5$var$load("9Oxgj"),
    $742b201de0044ee5$var$load("18TX5"),
    $742b201de0044ee5$var$load("exaJ2"),
    $742b201de0044ee5$var$load("lp8Wm"),
    $742b201de0044ee5$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("c09we", function(module, exports) {

let $8bccde637f75ef88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8bccde637f75ef88$var$load("8oiz7"),
    $8bccde637f75ef88$var$load("17m16"),
    $8bccde637f75ef88$var$load("cMubu"),
    $8bccde637f75ef88$var$load("kAg8V"),
    $8bccde637f75ef88$var$load("9Cdzw"),
    $8bccde637f75ef88$var$load("hcCcg"),
    $8bccde637f75ef88$var$load("cHWSM"),
    $8bccde637f75ef88$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("eWHOv", function(module, exports) {

let $ae1877f695269b3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae1877f695269b3f$var$load("hFxmj"),
    $ae1877f695269b3f$var$load("b4NO6"),
    $ae1877f695269b3f$var$load("3fLE9"),
    $ae1877f695269b3f$var$load("fM2oh"),
    $ae1877f695269b3f$var$load("guNAg"),
    $ae1877f695269b3f$var$load("j9KTb"),
    $ae1877f695269b3f$var$load("b37xN"),
    $ae1877f695269b3f$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("joBHN", function(module, exports) {

let $e1ed81b248c56b08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1ed81b248c56b08$var$load("BXOZB"),
    $e1ed81b248c56b08$var$load("1K1Fj"),
    $e1ed81b248c56b08$var$load("8hOn0"),
    $e1ed81b248c56b08$var$load("xnqy2"),
    $e1ed81b248c56b08$var$load("cM3gY"),
    $e1ed81b248c56b08$var$load("3hjAq"),
    $e1ed81b248c56b08$var$load("7PjNK"),
    $e1ed81b248c56b08$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("EDSZV", function(module, exports) {

let $07a2ad1527c69f6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07a2ad1527c69f6b$var$load("9Xiuh"),
    $07a2ad1527c69f6b$var$load("38sfA"),
    $07a2ad1527c69f6b$var$load("h4OCL"),
    $07a2ad1527c69f6b$var$load("awkVi"),
    $07a2ad1527c69f6b$var$load("6yRq3"),
    $07a2ad1527c69f6b$var$load("2bCHJ"),
    $07a2ad1527c69f6b$var$load("ktSfi"),
    $07a2ad1527c69f6b$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("f5q2I", function(module, exports) {

let $afbb862f455b1607$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afbb862f455b1607$var$load("7Odo3"),
    $afbb862f455b1607$var$load("bjmre"),
    $afbb862f455b1607$var$load("bcQs2"),
    $afbb862f455b1607$var$load("11DLa"),
    $afbb862f455b1607$var$load("cft22"),
    $afbb862f455b1607$var$load("fdXnq"),
    $afbb862f455b1607$var$load("iouLY"),
    $afbb862f455b1607$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("rJqkb", function(module, exports) {

let $0535c1e8d4cff100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0535c1e8d4cff100$var$load("4VkvT"),
    $0535c1e8d4cff100$var$load("asvK9"),
    $0535c1e8d4cff100$var$load("aBa7j"),
    $0535c1e8d4cff100$var$load("barSq"),
    $0535c1e8d4cff100$var$load("gctEz"),
    $0535c1e8d4cff100$var$load("cItJR"),
    $0535c1e8d4cff100$var$load("hPZE5"),
    $0535c1e8d4cff100$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("58PdT", function(module, exports) {

let $3be56eed8368bce0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3be56eed8368bce0$var$load("g5qJV"),
    $3be56eed8368bce0$var$load("7v6wU"),
    $3be56eed8368bce0$var$load("b544F"),
    $3be56eed8368bce0$var$load("a8heY"),
    $3be56eed8368bce0$var$load("9PPH7"),
    $3be56eed8368bce0$var$load("SctKm"),
    $3be56eed8368bce0$var$load("dzIm8"),
    $3be56eed8368bce0$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("enArn", function(module, exports) {

let $a77f7b0327a81145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a77f7b0327a81145$var$load("dPa6p"),
    $a77f7b0327a81145$var$load("aEpRh"),
    $a77f7b0327a81145$var$load("K6fhx"),
    $a77f7b0327a81145$var$load("6hlNE"),
    $a77f7b0327a81145$var$load("1y1eN"),
    $a77f7b0327a81145$var$load("1fJz1"),
    $a77f7b0327a81145$var$load("jqwnR"),
    $a77f7b0327a81145$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5XYTp", function(module, exports) {

let $4581b27058c75bd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4581b27058c75bd4$var$load("iG4uh"),
    $4581b27058c75bd4$var$load("3fuR9"),
    $4581b27058c75bd4$var$load("gZU54"),
    $4581b27058c75bd4$var$load("2bqSD"),
    $4581b27058c75bd4$var$load("e8jpx"),
    $4581b27058c75bd4$var$load("9yA8o"),
    $4581b27058c75bd4$var$load("bGhLc"),
    $4581b27058c75bd4$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("k3D4M", function(module, exports) {

let $e9a266292735eae2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9a266292735eae2$var$load("9tVE8"),
    $e9a266292735eae2$var$load("fMrUo"),
    $e9a266292735eae2$var$load("4Wdqb"),
    $e9a266292735eae2$var$load("bJykp"),
    $e9a266292735eae2$var$load("fjbzp"),
    $e9a266292735eae2$var$load("448N7"),
    $e9a266292735eae2$var$load("9v6ER"),
    $e9a266292735eae2$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("819Nj", function(module, exports) {

let $5d6603af87dbf1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d6603af87dbf1fc$var$load("6UAlo"),
    $5d6603af87dbf1fc$var$load("9eNkX"),
    $5d6603af87dbf1fc$var$load("k10Cs"),
    $5d6603af87dbf1fc$var$load("dh2Er"),
    $5d6603af87dbf1fc$var$load("1pFHs"),
    $5d6603af87dbf1fc$var$load("gBDdh"),
    $5d6603af87dbf1fc$var$load("8Mz40"),
    $5d6603af87dbf1fc$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("hE3F1", function(module, exports) {

let $cd890306c10c6d8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd890306c10c6d8a$var$load("ia9y3"),
    $cd890306c10c6d8a$var$load("j9OUx"),
    $cd890306c10c6d8a$var$load("l079e"),
    $cd890306c10c6d8a$var$load("bV8sS"),
    $cd890306c10c6d8a$var$load("kKXTS"),
    $cd890306c10c6d8a$var$load("ebljE"),
    $cd890306c10c6d8a$var$load("hF4v3"),
    $cd890306c10c6d8a$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("dpRbE", function(module, exports) {

let $9c46ddff53e4b24d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c46ddff53e4b24d$var$load("15ncj"),
    $9c46ddff53e4b24d$var$load("gDiIK"),
    $9c46ddff53e4b24d$var$load("f1B4n"),
    $9c46ddff53e4b24d$var$load("eLlpV"),
    $9c46ddff53e4b24d$var$load("7sItg"),
    $9c46ddff53e4b24d$var$load("j4dSZ"),
    $9c46ddff53e4b24d$var$load("1Tuyb"),
    $9c46ddff53e4b24d$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("daT1z", function(module, exports) {

let $9976e434b14901e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9976e434b14901e1$var$load("cvmn7"),
    $9976e434b14901e1$var$load("jmFg4"),
    $9976e434b14901e1$var$load("6wr18"),
    $9976e434b14901e1$var$load("dbdNk"),
    $9976e434b14901e1$var$load("h5FT3"),
    $9976e434b14901e1$var$load("7EorR"),
    $9976e434b14901e1$var$load("ffEVr"),
    $9976e434b14901e1$var$load("Wowvf"),
    $9976e434b14901e1$var$load("hhss7"),
    $9976e434b14901e1$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("io1wY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62ba7e132800466$export$2e2bcd8739ae039);

var $4Ldep = parcelRequire("4Ldep");


var $ksiqf = parcelRequire("ksiqf");


var $b5utg = parcelRequire("b5utg");

function $d62ba7e132800466$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $4Ldep.default)(dirtyDate, (0, $ksiqf.default)(Date.now(), 1));
}

});

parcelRegister("l7fKC", function(module, exports) {
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, $a3c14e992c9fdb13$var$styles.toolbarResponsive, $a3c14e992c9fdb13$var$styles.hiddenSelectors, $a3c14e992c9fdb13$var$styles.toolbarSeparator, $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j0UQK.ViewEventEmitter), {
                actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $l998X.jsx)((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = ({ children: children, label: label, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
            "aria-label": label,
            "data-toolbar-type": "primary",
            children: children
        })
    });
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssueUpdated: "_152xglyw _1cn41ule _1j4d1ule _1n52glyw _1nd71ule _lf431ule _103bglyw _1p0z1ule _g5yu1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmCommentUpdated: "_s2iiglyw _o4331ule _1u301ule _u7j1glyw _c7al1ule _14ob1ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$var$updatedPresetStyleMap = {
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssueUpdated,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmCommentUpdated
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (0, $1oCLl.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $bc8e1bf6110fb52a$var$updatedPresetStyleMap;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, isUpdatedConfig ? $bc8e1bf6110fb52a$var$updatedPresetStyleMap[breakpointPreset] : $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("12Oyv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            let index = doc?.activeElement ? focusableElements.findIndex((el)=>el === doc?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("j0UQK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");


var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");


var $7akU4 = parcelRequire("7akU4");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        if (!shouldSkipInitRender) {
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            // During SSR, renderToStaticMarkup + container.innerHTML (in portal) clobbers the
            // contentDOMWrapper that was appended above. The React ref callback
            // (forwardRef) never fires in renderToStaticMarkup, so contentDOM is
            // left detached. Re-attach it by finding the marked SSR ref target.
            if ((0, $eTj7Y.isSSR)() && this.domRef && (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) {
                const refTarget = this.domRef.querySelector('[data-ssr-content-dom-ref]');
                if (refTarget) this.handleRef(refTarget);
            }
        }
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $led7c = parcelRequire("led7c");


var $d7ZU3 = parcelRequire("d7ZU3");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || (0, $eTj7Y.isSSR)()) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("7akU4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");


var $eTj7Y = parcelRequire("eTj7Y");

const $76978b4203515d8f$export$27292f9d0a2a0aef = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        ref: ref,
        "data-ssr-content-dom-ref": (0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? '' : undefined
    }));
module.exports["NodeViewContentHole"] = $76978b4203515d8f$export$27292f9d0a2a0aef;

});

parcelRegister("1iV2p", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0f33b76a01973541$var$_react = $0f33b76a01973541$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $0f33b76a01973541$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0f33b76a01973541$var$SourceCode16Icon = (props)=>/*#__PURE__*/ $0f33b76a01973541$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm6.639 8.417L4.253 8.1l2.589-2.51a.924.924 0 1 0-1.288-1.328L2.281 7.435a.925.925 0 0 0 0 1.328l3.07 2.976a.925.925 0 1 0 1.288-1.328m7.203-3.173L10.77 4.26a.924.924 0 1 0-1.286 1.33l2.385 2.313-2.588 2.51a.924.924 0 1 0 1.287 1.327l3.274-3.173a.925.925 0 0 0 0-1.328"/></svg>`
    }, props, {
        size: 'small'
    }));
$0f33b76a01973541$var$SourceCode16Icon.displayName = 'SourceCode16Icon';
var $0f33b76a01973541$var$_default = module.exports.default = $0f33b76a01973541$var$SourceCode16Icon;

});

parcelRegister("cI0rA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9409f042c788dd08$export$2e2bcd8739ae039);

var $4Ldep = parcelRequire("4Ldep");


var $b5utg = parcelRequire("b5utg");

function $9409f042c788dd08$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $4Ldep.default)(dirtyDate, Date.now());
}

});

parcelRegister("fSNb6", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $kfZYI = parcelRequire("kfZYI");

var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $4IhTl = parcelRequire("4IhTl");


var $7gB19 = parcelRequire("7gB19");


var $7LErD = parcelRequire("7LErD");

// default configs is also config for production env
const $23c58483533ad0ac$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com'
};
const $23c58483533ad0ac$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$isolatedCloudConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    // Note that the env type passed to getUrlForDomainInContext (e.g. prod) doesn't matter
    // in Isolated Cloud, so this will work for staging IC too
    atlassianAccountUrl: (0, $kfZYI.getUrlForDomainInContext)('id', 'prod') ?? 'id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: `https://team.${(0, $T9xHm.isolatedCloudDomain)() ?? ''}`
};
const $23c58483533ad0ac$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralDisabled: true
};
const $23c58483533ad0ac$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $23c58483533ad0ac$var$environmentOverrides = {
    'prod-east': $23c58483533ad0ac$var$productionConfig,
    local: {
        ...(0, $7LErD.LOCAL_PRODUCTION_BACKEND) ? $23c58483533ad0ac$var$productionConfig : $23c58483533ad0ac$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: typeof (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))) !== 'undefined' ? `${(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.hostname}:3000` : 'localhost:3000'
        }
    },
    test: {
        ...$23c58483533ad0ac$var$localAndTestConfig
    },
    adev: $23c58483533ad0ac$var$devAndStagingConfig,
    'stg-east': $23c58483533ad0ac$var$devAndStagingConfig,
    fedramp: $23c58483533ad0ac$var$fedrampConfig
};
const $23c58483533ad0ac$var$cachedConfig = {};
function $23c58483533ad0ac$export$634ecc602a6871aa() {
    return (0, $lzcvT.isFedRamp)();
}
function $23c58483533ad0ac$export$44487a86467333c3() {
    const env = $23c58483533ad0ac$export$634ecc602a6871aa() ? 'fedramp' : (0, $7gB19.getEnv)();
    const appName = (0, $4IhTl.getAppName)();
    const key = `${env}_${appName}`;
    if (!$23c58483533ad0ac$var$cachedConfig[key]) {
        if ((0, $T9xHm.isIsolatedCloud)()) $23c58483533ad0ac$var$cachedConfig[key] = $23c58483533ad0ac$var$isolatedCloudConfig;
        else if ($23c58483533ad0ac$var$EnvOverrideKeys.includes(env)) $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides['prod-east']
        };
    }
    return $23c58483533ad0ac$var$cachedConfig[key];
}
module.exports["isFedramp"] = $23c58483533ad0ac$export$634ecc602a6871aa;
module.exports["getConfig"] = $23c58483533ad0ac$export$44487a86467333c3;

});

parcelRegister("4IhTl", function(module, exports) {
var $e50b5a5f7ee21567$export$b767e803e7ca9563 = /*#__PURE__*/ function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    return AppNames;
}({});
function $e50b5a5f7ee21567$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}
module.exports["AppNames"] = $e50b5a5f7ee21567$export$b767e803e7ca9563;
module.exports["getAppName"] = $e50b5a5f7ee21567$export$dcecb2dbc7fe753c;

});

parcelRegister("7gB19", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $7LErD = parcelRequire("7LErD");

var $c1805fedb6ad58a9$export$e7dfafc24fab792e = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}({});
const $c1805fedb6ad58a9$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $c1805fedb6ad58a9$var$presetEnv;
const $c1805fedb6ad58a9$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $c1805fedb6ad58a9$var$presetEnv = envOverride;
};
function $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e() {
    if ($c1805fedb6ad58a9$var$presetEnv) return $c1805fedb6ad58a9$var$presetEnv;
    if (0, $7LErD.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).__env__;
}
function $c1805fedb6ad58a9$export$15b8d8b1ba394f55() {
    return $c1805fedb6ad58a9$export$d76bdf9f4281ae1b[$c1805fedb6ad58a9$export$4bd44a2aa29d3d6e()];
}
module.exports["setEnv"] = $c1805fedb6ad58a9$export$84bc02d3c7a6b55f;
module.exports["getEnv"] = $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e;

});

parcelRegister("7LErD", function(module, exports) {
// @ts-ignore
const $015647182f1a27ed$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $015647182f1a27ed$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;
module.exports["DEV"] = $015647182f1a27ed$export$404582bc18fe4d9e;
module.exports["LOCAL_PRODUCTION_BACKEND"] = $015647182f1a27ed$export$771a63345d182ddd;

});

parcelRegister("6aZ5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb8521585dee6236$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $aZdSX = parcelRequire("aZdSX");

var $bb8521585dee6236$export$2e2bcd8739ae039 = (0, $aZdSX.default);

});

parcelRegister("aZdSX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $iK7QL = parcelRequire("iK7QL");

var $9EUfN = parcelRequire("9EUfN");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $fDXXi = parcelRequire("fDXXi");


var $g5lKx = parcelRequire("g5lKx");


var $81aSu = parcelRequire("81aSu");


var $2qY37 = parcelRequire("2qY37");


var $bUp2E = parcelRequire("bUp2E");


var $aCzn4 = parcelRequire("aCzn4");


var $fVnHQ = parcelRequire("fVnHQ");


var $caPHA = parcelRequire("caPHA");


var $k5hbH = parcelRequire("k5hbH");


var $lIPgo = parcelRequire("lIPgo");


var $2q1np = parcelRequire("2q1np");

class $5b8c19cec0dfc921$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $81aSu.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $2qY37.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $k5hbH.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $g5lKx.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showTimer = 0;
        this.hideTimer = 0;
        this.openedByHover = false;
        this.openTime = 0;
        this.fireAnalytics = (eventKey, ...attributes)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.fireEvent) this.props.fireEvent(eventKey, ...attributes);
        };
        this.fireAnalyticsWithDuration = (eventKey, generator)=>{
            const duration = (0, $caPHA.getPageTime)() - this.openTime;
            const attributes = generator(duration);
            this.fireAnalytics(eventKey, attributes);
        };
        this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        };
        this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $caPHA.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        };
        this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $aCzn4.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'click',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
        };
        this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'hover',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
            this.showProfilecard((0, $fVnHQ.DELAY_MS_SHOW));
        };
        this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
        };
        this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'click',
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId,
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
            }
        };
        this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        };
        this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        };
        this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        };
        this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, this.fireAnalytics),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.onErrorBoundary = ()=>{
            this.fireAnalytics('ui.teamProfileCard.rendered.errorBoundary', {
                ...(0, $bUp2E.PACKAGE_META_DATA),
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                duration: 0
            });
            this.setState({
                renderError: true
            });
        };
        this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $2q1np.default), {
                        analytics: this.fireAnalyticsWithDuration
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lIPgo.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        };
        this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iK7QL.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $9EUfN.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        };
        this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $2qY37.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
$5b8c19cec0dfc921$export$f811dc569217c959.defaultProps = {
    actions: [],
    trigger: 'hover',
    position: 'bottom-start',
    triggerLinkType: 'link',
    shouldRenderToParent: true
};
const $5b8c19cec0dfc921$var$TeamProfileCardTrigger = (props)=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    if ((0, $dh538.fg)('people-teams-deprecate-profilecard-teams')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($5b8c19cec0dfc921$export$f811dc569217c959, {
        ...props,
        fireEvent: fireEvent
    });
};
/**
 * @deprecated This component is deprecated and provides no functionality.
 * It now simply renders its children without any profile card behavior.
 * Please use `@atlassian/team-profilecard` instead for team profile card functionality.
 */ const $5b8c19cec0dfc921$var$_default_1 = (0, $aXWIB.injectIntl)($5b8c19cec0dfc921$var$TeamProfileCardTrigger);
var $5b8c19cec0dfc921$export$2e2bcd8739ae039 = $5b8c19cec0dfc921$var$_default_1;
module.exports["default"] = $5b8c19cec0dfc921$export$2e2bcd8739ae039;

});

parcelRegister("k5hbH", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $2b2ce0b0062a7857$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $2b2ce0b0062a7857$export$2e2bcd8739ae039 = $2b2ce0b0062a7857$export$e926676385687eaf;
module.exports["ErrorBoundary"] = $2b2ce0b0062a7857$export$e926676385687eaf;

});

parcelRegister("lIPgo", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $8c4f830abcac73ad$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jZ73o")));
module.exports["TeamProfileCardLazy"] = $8c4f830abcac73ad$export$82a49d896f41ca78;

});

parcelRegister("jZ73o", function(module, exports) {

let $e8c92f8bbeab3b1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8c92f8bbeab3b1c$var$load("lTK3c"),
    $e8c92f8bbeab3b1c$var$load("1WXdc"),
    $e8c92f8bbeab3b1c$var$load("6wr18"),
    $e8c92f8bbeab3b1c$var$load("ffEVr"),
    $e8c92f8bbeab3b1c$var$load("hhss7"),
    $e8c92f8bbeab3b1c$var$load("Wowvf"),
    $e8c92f8bbeab3b1c$var$load("jnkIk")
]).then(()=>parcelRequire('3PwS1'));

});

parcelRegister("2q1np", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e9a613b6d3c33c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $by9Aj = parcelRequire("by9Aj");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");

var $08e9a613b6d3c33c$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $42omo.useEffect)(()=>{
        analytics('ui.teamProfileCard.rendered.spinner', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $by9Aj.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardContent), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
                })
            })
        ]
    });
};

});

parcelRegister("by9Aj", function(module, exports) {
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $jv8de = parcelRequire("jv8de");

const $45954f322eeb538a$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rko12b0 _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    grayoutImage: "_kdam7g3v"
};
const $45954f322eeb538a$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardtriggerwrapper)
    });
const $45954f322eeb538a$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $45954f322eeb538a$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label, isDisabled: isDisabled })=>isLoading || !image ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardheader, isDisabled && $45954f322eeb538a$var$styles.grayoutImage),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $jv8de.CoverImage), {
        alt: label || '',
        src: image,
        isDisabled: isDisabled
    });
const $45954f322eeb538a$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardcontent),
        ...props
    });
const $45954f322eeb538a$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.loadingwrapper),
        ...props
    });
module.exports["CardWrapper"] = $45954f322eeb538a$export$6aa22a823032b784;
module.exports["CardHeader"] = $45954f322eeb538a$export$5665775b26e26c5d;
module.exports["CardContent"] = $45954f322eeb538a$export$64ef9b8c11710c47;
module.exports["LoadingWrapper"] = $45954f322eeb538a$export$43a792a870d28db2;

});

parcelRegister("jv8de", function(module, exports) {
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $51d6e29b89f36ec6$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13li12b0 _qrwq12b0 _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug",
    imageNext: "_4t3i1osq _5ral1dfr",
    grayoutImage: "_kdam7g3v"
};
const $51d6e29b89f36ec6$export$a65e282337ff0f53 = ({ src: src, alt: alt = '', isDisabled: isDisabled })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const imgRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: containerRef,
        xcss: $51d6e29b89f36ec6$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: (0, $1Whri.cx)((0, $dh538.fg)('cover-header-image-team-profilecard') ? $51d6e29b89f36ec6$var$styles.imageNext : $51d6e29b89f36ec6$var$styles.image, isDisabled && $51d6e29b89f36ec6$var$styles.grayoutImage)
        })
    });
};
module.exports["CoverImage"] = $51d6e29b89f36ec6$export$a65e282337ff0f53;

});

parcelRegister("O1c6O", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");

const $a6f5bf930119200a$export$f7434a73419cbe6f = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $a6f5bf930119200a$export$73b91fac7f27799f({ data: data, children: children }) {
    const analyticsContextData = (0, $42omo.useMemo)(()=>{
        if (typeof data === 'object') return {
            ...$a6f5bf930119200a$export$f7434a73419cbe6f,
            ...data
        };
        return $a6f5bf930119200a$export$f7434a73419cbe6f;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PeopleTeamsAnalyticsContext), {
        data: analyticsContextData,
        children: children
    });
}
module.exports["TeamsAppAnalyticsContext"] = $a6f5bf930119200a$export$73b91fac7f27799f;

});

parcelRegister("jYxBx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");

const $e8adb0147cc02fce$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getArtifact: null
});
function $e8adb0147cc02fce$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return new (0, $g58eM.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e8adb0147cc02fce$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $e8adb0147cc02fce$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8adb0147cc02fce$export$ca1b33377afa620);
function $e8adb0147cc02fce$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { getArtifact: getArtifact } = $e8adb0147cc02fce$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $e8adb0147cc02fce$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $e8adb0147cc02fce$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $e8adb0147cc02fce$export$3b241cde208d2c5e;

});

parcelRegister("e31DP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jYxBx = parcelRequire("jYxBx");


var $h4NLj = parcelRequire("h4NLj");


var $6hu6G = parcelRequire("6hu6G");

const $5e20bb9e4d5269b7$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $jYxBx.useFlightDeckContext)();
    return (0, $42omo.useMemo)(()=>(0, $6hu6G.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $h4NLj.FD_CLIENT_FETCH_PROPS).name, (0, $h4NLj.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};
module.exports["useActivityClient"] = $5e20bb9e4d5269b7$export$6620595b7f837f8f;

});

parcelRegister("jSpMW", function(module, exports) {


(function(global, factory) {
    factory(module.exports, (parcelRequire("4zBBx")), (parcelRequire("42omo")));
})(module.exports, function(exports1, lottie, React) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var lottie__default = /*#__PURE__*/ _interopDefaultLegacy(lottie);
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[r] = t, e;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _objectWithoutProperties(e, t) {
        if (null == e) return {};
        var o, r, i = _objectWithoutPropertiesLoose(e, t);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
        }
        return i;
    }
    function _objectWithoutPropertiesLoose(r, e) {
        if (null == r) return {};
        var t = {};
        for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
            if (e.includes(n)) continue;
            t[n] = r[n];
        }
        return t;
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var _excluded$1 = [
        "animationData",
        "loop",
        "autoplay",
        "initialSegment",
        "onComplete",
        "onLoopComplete",
        "onEnterFrame",
        "onSegmentStart",
        "onConfigReady",
        "onDataReady",
        "onDataFailed",
        "onLoadedImages",
        "onDOMLoaded",
        "onDestroy",
        "lottieRef",
        "renderer",
        "name",
        "assetsPath",
        "rendererSettings"
    ];
    var useLottie = function useLottie(props, style) {
        var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
        props.lottieRef;
        props.renderer;
        props.name;
        props.assetsPath;
        props.rendererSettings;
        var rest = _objectWithoutProperties(props, _excluded$1);
        var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
        var animationInstanceRef = React.useRef();
        var animationContainer = React.useRef(null);
        /*
          ======================================
              INTERACTION METHODS
          ======================================
       */ /**
     * Play
     */ var play = function play() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.play();
        };
        /**
     * Stop
     */ var stop = function stop() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.stop();
        };
        /**
     * Pause
     */ var pause = function pause() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.pause();
        };
        /**
     * Set animation speed
     * @param speed
     */ var setSpeed = function setSpeed(speed) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSpeed(speed);
        };
        /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */ var goToAndPlay = function goToAndPlay(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndPlay(value, isFrame);
        };
        /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */ var goToAndStop = function goToAndStop(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndStop(value, isFrame);
        };
        /**
     * Set animation direction
     * @param direction
     */ var setDirection = function setDirection(direction) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setDirection(direction);
        };
        /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */ var playSegments = function playSegments(segments, forceFlag) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.playSegments(segments, forceFlag);
        };
        /**
     * Set sub frames
     * @param useSubFrames
     */ var setSubframe = function setSubframe(useSubFrames) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSubframe(useSubFrames);
        };
        /**
     * Get animation duration
     * @param inFrames
     */ var getDuration = function getDuration(inFrames) {
            var _a;
            return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
        };
        /**
     * Destroy animation
     */ var destroy = function destroy() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Removing the reference to the animation so separate cleanups are skipped.
            // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
            animationInstanceRef.current = undefined;
        };
        /*
          ======================================
              LOTTIE
          ======================================
       */ /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */ var loadAnimation = function loadAnimation() {
            var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _a;
            // Return if the container ref is null
            if (!animationContainer.current) return;
            // Destroy any previous instance
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Build the animation configuration
            var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
                container: animationContainer.current
            });
            // Save the animation instance
            animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
            setAnimationLoaded(!!animationInstanceRef.current);
            // Return a function that will clean up
            return function() {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
                animationInstanceRef.current = undefined;
            };
        };
        /**
     * (Re)Initialize when animation data changed
     */ React.useEffect(function() {
            var onUnmount = loadAnimation();
            // Clean up on unmount
            return function() {
                return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            animationData,
            loop
        ]);
        // Update the autoplay state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            animationInstanceRef.current.autoplay = !!autoplay;
        }, [
            autoplay
        ]);
        // Update the initial segment state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            // When null should reset to default animation length
            if (!initialSegment) {
                animationInstanceRef.current.resetSegments(true);
                return;
            }
            // If it's not a valid segment, do nothing
            if (!Array.isArray(initialSegment) || !initialSegment.length) return;
            // If the current position it's not in the new segment
            // set the current position to start
            if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) animationInstanceRef.current.currentRawFrame = initialSegment[0];
            // Update the segment
            animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
        }, [
            initialSegment
        ]);
        /*
          ======================================
              EVENTS
          ======================================
       */ /**
     * Reinitialize listener on change
     */ React.useEffect(function() {
            var partialListeners = [
                {
                    name: "complete",
                    handler: onComplete
                },
                {
                    name: "loopComplete",
                    handler: onLoopComplete
                },
                {
                    name: "enterFrame",
                    handler: onEnterFrame
                },
                {
                    name: "segmentStart",
                    handler: onSegmentStart
                },
                {
                    name: "config_ready",
                    handler: onConfigReady
                },
                {
                    name: "data_ready",
                    handler: onDataReady
                },
                {
                    name: "data_failed",
                    handler: onDataFailed
                },
                {
                    name: "loaded_images",
                    handler: onLoadedImages
                },
                {
                    name: "DOMLoaded",
                    handler: onDOMLoaded
                },
                {
                    name: "destroy",
                    handler: onDestroy
                }
            ];
            var listeners = partialListeners.filter(function(listener) {
                return listener.handler != null;
            });
            if (!listeners.length) return;
            var deregisterList = listeners.map(/**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */ function(listener) {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.addEventListener(listener.name, listener.handler);
                // Return a function to deregister this listener
                return function() {
                    var _a;
                    (_a = animationInstanceRef.current) === null || _a === void 0 || _a.removeEventListener(listener.name, listener.handler);
                };
            });
            // Deregister listeners on unmount
            return function() {
                deregisterList.forEach(function(deregister) {
                    return deregister();
                });
            };
        }, [
            onComplete,
            onLoopComplete,
            onEnterFrame,
            onSegmentStart,
            onConfigReady,
            onDataReady,
            onDataFailed,
            onLoadedImages,
            onDOMLoaded,
            onDestroy
        ]);
        /**
     * Build the animation view
     */ var View = /*#__PURE__*/ React__default["default"].createElement("div", _objectSpread2({
            style: style,
            ref: animationContainer
        }, rest));
        return {
            View: View,
            play: play,
            stop: stop,
            pause: pause,
            setSpeed: setSpeed,
            goToAndStop: goToAndStop,
            goToAndPlay: goToAndPlay,
            setDirection: setDirection,
            playSegments: playSegments,
            setSubframe: setSubframe,
            getDuration: getDuration,
            destroy: destroy,
            animationContainerRef: animationContainer,
            animationLoaded: animationLoaded,
            animationItem: animationInstanceRef.current
        };
    };
    // helpers
    function getContainerVisibility(container) {
        var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height = _container$getBoundin.height;
        var current = window.innerHeight - top;
        var max = window.innerHeight + height;
        return current / max;
    }
    function getContainerCursorPosition(container, cursorX, cursorY) {
        var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width = _container$getBoundin2.width, height = _container$getBoundin2.height;
        var x = (cursorX - left) / width;
        var y = (cursorY - top) / height;
        return {
            x: x,
            y: y
        };
    }
    var useInitInteractivity = function useInitInteractivity(_ref) {
        var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
        React.useEffect(function() {
            var wrapper = wrapperRef.current;
            if (!wrapper || !animationItem || !actions.length) return;
            animationItem.stop();
            var scrollModeHandler = function scrollModeHandler() {
                var assignedSegment = null;
                var scrollHandler = function scrollHandler() {
                    var currentPercent = getContainerVisibility(wrapper);
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref2) {
                        var visibility = _ref2.visibility;
                        return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    if (action.type === "seek" && action.visibility && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
                        //! goToAndStop must be relative to the start of the current segment
                        animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                    }
                    if (action.type === "loop") {
                        // Loop: Loop a given frames
                        if (assignedSegment === null) {
                            // if not playing any segments currently. play those segments and save to state
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        } else {
                            // if playing any segments currently.
                            //check if segments in state are equal to the frames selected by action
                            if (assignedSegment !== action.frames) {
                                // if they are not equal. new segments are to be loaded
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            } else if (animationItem.isPaused) {
                                // if they are equal the play method must be called only if lottie is paused
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            }
                        }
                    }
                    if (action.type === "play" && animationItem.isPaused) {
                        // Play: Reset segments and continue playing full animation from current position
                        animationItem.resetSegments(true);
                        animationItem.play();
                    }
                    if (action.type === "stop") // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                };
                document.addEventListener("scroll", scrollHandler);
                return function() {
                    document.removeEventListener("scroll", scrollHandler);
                };
            };
            var cursorModeHandler = function cursorModeHandler() {
                var handleCursor = function handleCursor(_x, _y) {
                    var x = _x;
                    var y = _y;
                    // Resolve cursor position if cursor is inside container
                    if (x !== -1 && y !== -1) {
                        // Get container cursor position
                        var pos = getContainerCursorPosition(wrapper, x, y);
                        // Use the resolved position
                        x = pos.x;
                        y = pos.y;
                    }
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref3) {
                        var position = _ref3.position;
                        if (position && Array.isArray(position.x) && Array.isArray(position.y)) return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
                        if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) return x === position.x && y === position.y;
                        return false;
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    // Process action types:
                    if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
                        var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
                        animationItem.playSegments(action.frames, true);
                        animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
                    }
                    if (action.type === "loop") animationItem.playSegments(action.frames, true);
                    if (action.type === "play") {
                        // Play: Reset segments and continue playing full animation from current position
                        if (animationItem.isPaused) animationItem.resetSegments(false);
                        animationItem.playSegments(action.frames);
                    }
                    if (action.type === "stop") animationItem.goToAndStop(action.frames[0], true);
                };
                var mouseMoveHandler = function mouseMoveHandler(ev) {
                    handleCursor(ev.clientX, ev.clientY);
                };
                var mouseOutHandler = function mouseOutHandler() {
                    handleCursor(-1, -1);
                };
                wrapper.addEventListener("mousemove", mouseMoveHandler);
                wrapper.addEventListener("mouseout", mouseOutHandler);
                return function() {
                    wrapper.removeEventListener("mousemove", mouseMoveHandler);
                    wrapper.removeEventListener("mouseout", mouseOutHandler);
                };
            };
            switch(mode){
                case "scroll":
                    return scrollModeHandler();
                case "cursor":
                    return cursorModeHandler();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            mode,
            animationItem
        ]);
    };
    var useLottieInteractivity = function useLottieInteractivity(_ref4) {
        var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
        var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
        useInitInteractivity({
            actions: actions,
            animationItem: animationItem,
            mode: mode,
            wrapperRef: animationContainerRef
        });
        return View;
    };
    var _excluded = [
        "style",
        "interactivity"
    ];
    var Lottie = function Lottie(props) {
        var _a, _b, _c;
        var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
        /**
     * Initialize the 'useLottie' hook
     */ var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
        /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */ React.useEffect(function() {
            if (props.lottieRef) props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            (_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current
        ]);
        return useLottieInteractivity({
            lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            },
            actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
            mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
        });
    };
    Object.defineProperty(exports1, 'LottiePlayer', {
        enumerable: true,
        get: function() {
            return lottie__default["default"];
        }
    });
    exports1["default"] = Lottie;
    exports1.useLottie = useLottie;
    exports1.useLottieInteractivity = useLottieInteractivity;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("7Zbm6", function(module, exports) {
var $313b937e83fff73c$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
var $313b937e83fff73c$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});
var $313b937e83fff73c$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $313b937e83fff73c$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    // Value at component initialization
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    // Value if the network call fails
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    // Value if the network call times out
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    return NLPSearchErrorState;
}({});
var $313b937e83fff73c$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
var $313b937e83fff73c$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});
var $313b937e83fff73c$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
var $313b937e83fff73c$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
var $313b937e83fff73c$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
var $313b937e83fff73c$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
module.exports["NLPSearchResultFormat"] = $313b937e83fff73c$export$e20550b618a28239;
module.exports["NLPSearchJSONResultFormat"] = $313b937e83fff73c$export$eae917983a0398aa;
module.exports["NLPSearchErrorState"] = $313b937e83fff73c$export$9405d23bea8d0d8b;
module.exports["NLPSearchErrorCodes"] = $313b937e83fff73c$export$6b1112c70cca65d3;
module.exports["NLPSearchResultContainerDataTypeContainerType"] = $313b937e83fff73c$export$7c6c2f9c68de2e45;
module.exports["NLPSearchCustomDefinitionType"] = $313b937e83fff73c$export$12b805d25b464b8d;
module.exports["AIAnswerQueryStreamType"] = $313b937e83fff73c$export$130eddddf4243f3f;
module.exports["AIAnswerAPIType"] = $313b937e83fff73c$export$e7b798431c659b80;

});

parcelRegister("7DCm4", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $399439794f928dc1$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $399439794f928dc1$export$5b2a28beea8d66c3 = new (0, $5aVN7.UFOExperience)(`${$399439794f928dc1$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $399439794f928dc1$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $399439794f928dc1$export$5b2a28beea8d66c3;

});

parcelRegister("7DA0P", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bhuAa = parcelRequire("bhuAa");

const $6a1b9fb9a12a7345$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $bhuAa.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });
module.exports["SearchDialog"] = $6a1b9fb9a12a7345$export$2aadebb53f6015f6;

});

parcelRegister("bhuAa", function(module, exports) {
parcelRequire("42omo");


var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

const $c28fa387cd30d0f7$export$dcefba65c42da69c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e101cjwc0"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $2azjJ.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $2azjJ.dialogWidth};` : '', " box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);border-radius:var(--ds-radius-large, 8px);background-color:var(--ds-surface-overlay, #FFFFFF);overflow:hidden;margin-top:", (0, $2azjJ.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
module.exports["SearchDialogWrapper"] = $c28fa387cd30d0f7$export$dcefba65c42da69c;

});

parcelRegister("2azjJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $5648f131343e99e5$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$5648f131343e99e5$var$AkGrid(multiplier * num),
        half: ()=>$5648f131343e99e5$var$AkGrid(0.5 * num),
        twice: ()=>$5648f131343e99e5$var$AkGrid(2 * num)
    });
const $5648f131343e99e5$export$85fc379452d91af0 = $5648f131343e99e5$var$AkGrid(1);
const $5648f131343e99e5$export$b9930dabfa4a3a3 = '56px';
const $5648f131343e99e5$export$f6af7620e8789c39 = '200px';
const $5648f131343e99e5$export$64d8573e83b64ff8 = '150px';
const $5648f131343e99e5$export$a3da89b899389ed8 = '780px';
const $5648f131343e99e5$export$ce4512df260a325a = 780;
const $5648f131343e99e5$export$a406031ed42c8e02 = '1130px';
const $5648f131343e99e5$export$e00021bea368c518 = $5648f131343e99e5$export$85fc379452d91af0.multiple(4);
const $5648f131343e99e5$export$30310ee354b45eb0 = $5648f131343e99e5$export$85fc379452d91af0.multiple(6);
module.exports["grid"] = $5648f131343e99e5$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $5648f131343e99e5$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $5648f131343e99e5$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $5648f131343e99e5$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $5648f131343e99e5$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $5648f131343e99e5$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $5648f131343e99e5$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $5648f131343e99e5$export$30310ee354b45eb0;

});

parcelRegister("5k6WH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $uRQKa = parcelRequire("uRQKa");


var $6ttbq = parcelRequire("6ttbq");

const $479e1e8ac650b5b6$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    (0, $42omo.useEffect)(()=>{
        if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $479e1e8ac650b5b6$export$c537e63161742ce3;

});

parcelRegister("h8GF6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb4c0b04d74b34ec32eb001d1db58986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7a446cadbb9b140$var$_react = $c7a446cadbb9b140$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7a446cadbb9b140$var$_baseNew = $c7a446cadbb9b140$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7a446cadbb9b140$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CollapseVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the height of an element to its smallest size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7a446cadbb9b140$var$CollapseVerticalIcon = (props)=>/*#__PURE__*/ $c7a446cadbb9b140$var$_react.default.createElement($c7a446cadbb9b140$var$_baseNew.default, Object.assign({
        name: "CollapseVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 7.25h16v1.5H0zm7.47 2.72a.75.75 0 0 1 1.06 0l3.25 3.25-1.06 1.06-1.97-1.97V16h-1.5v-3.69l-1.97 1.97-1.06-1.06zM5.28 1.72l1.97 1.97V0h1.5v3.69l1.97-1.97 1.06 1.06-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 2.78z"/>`
    }, props));
$c7a446cadbb9b140$var$CollapseVerticalIcon.displayName = 'CollapseVerticalIcon';
var $c7a446cadbb9b140$var$_default = module.exports.default = $c7a446cadbb9b140$var$CollapseVerticalIcon;

});

parcelRegister("7lL49", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $827bbb02634e926d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    /**
   * Messages for the AI Answer Component
   */ ai_answer_component_initial_title_text: {
        id: "search_ai.ai_answer_component.initial_title_text",
        defaultMessage: "Ask questions in search and get answers based on the content you have access to"
    },
    ai_answer_component_beta_status_label: {
        id: "search_ai.ai_answer_component.beta_status_label",
        defaultMessage: "Beta"
    },
    ai_answer_component_title_text: {
        id: "search_ai.ai_answer_component.title_text",
        defaultMessage: "Atlassian Intelligence"
    },
    ai_answer_component_title_text_loading: {
        id: "search_ai.ai_answer_component.title_text_loading",
        defaultMessage: "is working..."
    },
    ai_answer_component_title_text_loading_reading_aids: {
        id: "search_ai.ai_answer_component.title_text_loading_reading_aids",
        defaultMessage: "Generating"
    },
    ai_answer_component_title_text_loaded: {
        id: "search_ai.ai_answer_component.title_text_loaded",
        defaultMessage: "Answered by"
    },
    ai_answer_component_button_text: {
        id: "ai_answer_component_button_text",
        defaultMessage: "Ask AI"
    },
    ai_answer_component_result_error_text: {
        id: "search_ai.ai_answer_component.result_error_text",
        defaultMessage: "{brandName} couldn't generate an answer for you. Try rephrasing or explore using filters in {advancedSearchLink}."
    },
    ai_answer_component_result_error_advanced_search_link: {
        id: "search_ai.ai_answer_component.result_error_advanced_search_link",
        defaultMessage: "advanced search"
    },
    ai_answer_component_source_label: {
        id: "search_ai.ai_answer_component.source_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_reference_label: {
        id: "search_ai.ai_answer_component.reference_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_source_page_icon_label: {
        id: "search_ai.ai_answer_component.source_page_icon_label",
        defaultMessage: "Source Page Icon"
    },
    ai_answer_expand_button_label: {
        id: "search_ai.ai_answer_component.expand_button_label",
        defaultMessage: "Show more"
    },
    ai_answer_collapse_button_label: {
        id: "search_ai.ai_answer_component.collapse_button_label",
        defaultMessage: "Show less"
    },
    ai_answer_component_information_icon_tooltip_text: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_text",
        defaultMessage: "Information quality may vary. {informationLink}"
    },
    ai_answer_component_information_icon_tooltip_link: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_link",
        defaultMessage: "Learn why"
    },
    ai_answer_component_feedback_label: {
        id: "search_ai.ai_answer_component_feedback_label",
        defaultMessage: "Was this helpful?"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_answer_component_report_button: {
        id: "search_ai.ai_answer_component_report_button",
        defaultMessage: "Report this"
    },
    ai_answer_component_report_success_text: {
        id: "search_ai.ai_answer_component_report_success_text",
        defaultMessage: "Report submitted"
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {brandName}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the AI response? Let us know what happened."
    },
    ai_answer_component_report_empty_option_label: {
        id: "search_ai.ai_answer_component_report_empty_option_label",
        defaultMessage: "I want to report..."
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    sac_ai_answer_component_report_relevance_option_label: {
        id: "search_ai.sac_ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t accurate"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    sac_ai_answer_component_report_unhelpful_links_option_label: {
        id: "search_ai.sac_ai_answer_component_report_unhelpful_links_option_label",
        defaultMessage: "Unhelpful links"
    },
    sac_ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.sac_ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "Too slow"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    sac_ai_answer_component_report_other_option_label: {
        id: "search_ai.sac_ai_answer_component_report_other_option_label",
        defaultMessage: "Other"
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_followups_label: {
        id: "search_ai.ai_answer_component_followups_label",
        defaultMessage: "Ask a follow up question"
    },
    ai_answer_component_error_state_subjective_query: {
        id: "search_ai.ai_answer_component_error_state_subjective_query",
        defaultMessage: "That seems like a subjective question, so {brandName} can\u2019t answer it for you right now."
    },
    ai_answer_component_error_state_keyword: {
        id: "search_ai.ai_answer_component_error_state_keyword",
        defaultMessage: "{brandName} couldn\u2019t understand your question, possibly because it didn\u2019t include enough details. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_error_state_acceptable_use: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use",
        defaultMessage: "{brandName} can\u2019t provide you with a response, as it might go against {acceptableUseLink}. Please try asking another question."
    },
    ai_answer_component_error_state_acceptable_use_link: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    ai_answer_component_error_state_network: {
        id: "search_ai.ai_answer_component_error_state_network",
        defaultMessage: "{brandName} can't provide a response right now. Read more in our {supportLink}."
    },
    ai_answer_component_error_state_hipaa: {
        id: "search_ai.ai_answer_component_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    ai_answer_component_error_state_no_answer: {
        id: "search_ai.ai_answer_component_error_state_no_answer",
        defaultMessage: "{brandName} doesn\u2019t have enough data to provide a response right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_open_ai_rate_limit_error: {
        id: "search_ai.ai_answer_component_open_ai_rate_limit_error",
        defaultMessage: "Excessive use has been detected with {brandName}. Try again later. Read more in our {supportLink}."
    },
    ai_answer_component_support_link: {
        id: "search_ai.ai_answer_component_support_link",
        defaultMessage: "support documentation"
    },
    ai_answer_component_hipaa_compliance_link: {
        id: "search_ai.ai_answer_component_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    },
    ai_answer_component_error_state_no_who_is_answer: {
        id: "search_ai.ai_answer_component_error_state_no_who_is_answer",
        defaultMessage: "{brandName} couldn\u2019t find a match for this person in your organisation. It\u2019s possible that there was a misspelling in your search, this person goes by another name, or that this person doesn\u2019t work here."
    },
    ai_answer_component_disclaimer_who_question: {
        id: "search_ai.ai_answer_component_disclaimer_who_question",
        defaultMessage: "This information is solely based on what\u2019s in your knowledge base and may not always be accurate."
    },
    ai_answer_permission_label: {
        id: "search_ai.ai_answer_permission_label",
        defaultMessage: "Answers may include information from pages that are restricted to others but visible to you."
    },
    ai_answer_dialog_cancel_label: {
        id: "search_ai.ai_answer_dialog_cancel_label",
        defaultMessage: "Dive deeper into the {searchResultsLink}"
    },
    ai_answer_dialog_search_results_label: {
        id: "search_ai.ai_answer_dialog_search_results_label",
        defaultMessage: "search results"
    },
    ai_answer_dialog_teams_not_found_message: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message",
        defaultMessage: "Some teams may not be found on this site due to"
    },
    ai_answer_dialog_teams_not_found_message_link: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message_link",
        defaultMessage: "changes in team visibility."
    },
    ai_answer_onboarding_banner_title: {
        id: "search_ai.ai_answer_onboarding_banner_title",
        defaultMessage: "Try Atlassian Intelligence in search"
    },
    ai_answer_onboarding_banner_v1_info: {
        id: "search_ai.ai_answer_onboarding_banner_v1_info",
        defaultMessage: "<b>Example:</b>How do I submit expenses for reimbursement?"
    },
    ai_answer_onboarding_banner_info: {
        id: "search_ai.ai_answer_onboarding_banner_info",
        defaultMessage: "Ask about a project or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_onboarding_banner_tooltip_link: {
        id: "search_ai.ai_answer_onboarding_banner_tooltip_link",
        defaultMessage: "Learn more"
    },
    ai_answer_onboarding_close_button_text: {
        id: "search_ai.ai_answer_onboarding_close_button_text",
        defaultMessage: "Close"
    },
    ai_answer_onboarding_banner_example_query_vacation_policy: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_vacation_policy",
        defaultMessage: "What is the vacation policy?"
    },
    ai_answer_onboarding_banner_example_query_expenses: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_expenses",
        defaultMessage: "How to submit expenses for reimbursement?"
    },
    ai_answer_dialog_loaded_footer_sac: {
        id: "search_ai.ai_answer_dialog_loaded_footer_sac",
        defaultMessage: "Powered by AI"
    },
    ai_answer_dialog_loaded_footer: {
        id: "search_ai.ai_answer_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    ai_answer_dialog_footer_more_options_tooltip: {
        id: "search_ai.ai_answer_dialog_footer_more_options_tooltip",
        defaultMessage: "More options"
    },
    ai_answer_dialog_updated: {
        id: "search_ai.ai_answer_dialog_updated",
        defaultMessage: "Updated"
    },
    ai_answer_who_questions_frequent_locations_header: {
        id: "search_ai.ai_answer_who_questions_frequent_locations_header",
        defaultMessage: "Frequent locations"
    },
    ai_answer_who_questions_frequent_collaborators_header: {
        id: "search_ai.ai_answer_who_questions_frequent_collaborators_header",
        defaultMessage: "Frequent collaborators"
    },
    ai_answer_who_question_team_section_member_count: {
        id: "search_ai.ai_answer_who_question_team_section_member_count",
        defaultMessage: "{count, plural, =0 {No members} one {# member} other {# members}}"
    },
    ai_answer_who_questions_teams_header: {
        id: "search_ai.ai_answer_who_questions_teams_header",
        defaultMessage: "Teams"
    },
    ai_answer_who_questions_view_profile: {
        id: "search_ai.ai_answer_who_questions_view_profile",
        defaultMessage: "View profile"
    },
    ai_answer_who_questions_hover_role_icon: {
        id: "search_ai.ai_answer_who_questions_hover_role_icon",
        defaultMessage: "Role"
    },
    ai_answer_who_questions_hover_department_icon: {
        id: "search_ai.ai_answer_who_questions_hover_department_icon",
        defaultMessage: "Department"
    },
    ai_answer_who_questions_hover_location_icon: {
        id: "search_ai.ai_answer_who_questions_hover_location_icon",
        defaultMessage: "Location"
    },
    ai_answer_who_questions_hover_local_time_icon: {
        id: "search_ai.ai_answer_who_questions_hover_local_time_icon",
        defaultMessage: "Local time"
    },
    ai_answer_who_questions_hover_email_icon: {
        id: "search_ai.ai_answer_who_questions_hover_email_icon",
        defaultMessage: "Email"
    },
    ai_answer_who_questions_footer_header: {
        id: "search_ai.ai_answer_who_questions_footer_header",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numMatches} additional {numMatches, plural, =1 {match} other {matches}}"
    },
    ai_answer_dialog_footer_content_quality_short: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_short",
        defaultMessage: "Uses AI. Verify results."
    },
    ai_answer_dialog_footer_beta_tag: {
        id: "search_ai.ai_answer_dialog_footer_beta_tag",
        defaultMessage: "BETA"
    },
    ai_answer_dialog_footer_content_quality_long: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_long",
        defaultMessage: "Uses AI. Verify results."
    },
    reading_aids_dialog_information_icon_tooltip_link: {
        id: "search_ai.reading_aids_dialog_information_icon_tooltip_link",
        defaultMessage: "Learn more"
    },
    reading_aids_dialog_loaded_footer: {
        id: "search_ai.reading_aids_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    reading_aids_dialog_disclaimer: {
        id: "search_ai.reading_aids_dialog_disclaimer",
        defaultMessage: "Information may vary."
    },
    reading_aids_dialog_disclaimer_link: {
        id: "search_ai.reading_aids_dialog_disclaimer_link",
        defaultMessage: "Learn why"
    },
    reading_aids_defined_by: {
        id: "search_ai.reading_aids_dialog_defined_by",
        defaultMessage: "Defined by"
    },
    reading_aids_see_edit_history: {
        id: "search_ai.reading_aids_dialog_see_edit_history",
        defaultMessage: "See all edit history"
    },
    ai_answer_admin_message: {
        id: "search_ai.ai_answer_admin_message",
        defaultMessage: "Unleash the knowledge in your Confluence by asking questions in search and getting answers from Atlassian Intelligence."
    },
    ai_answer_admin_turn_on_atlassian_intelligence: {
        id: "search_ai.ai_admin_turn_on_atlassian_intelligence",
        defaultMessage: "Turn on Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_header: {
        id: "search_ai.ai_answer_admin_info_popup_header",
        defaultMessage: "Get answers from Atlassian Intelligence in search"
    },
    ai_answer_admin_info_popup_banner_alt_text: {
        id: "search_ai.ai_answer_admin_info_popup_banner_alt_text",
        defaultMessage: "Search input with example query \"What is the vacation policy?\""
    },
    ai_answer_admin_info_popup_link: {
        id: "search_ai.ai_answer_admin_info_popup_link",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_dismiss: {
        id: "search_ai.ai_answer_admin_info_popup_dismiss",
        defaultMessage: "Dismiss"
    },
    ai_answer_generating_text: {
        id: "search_ai.ai_answer_generating_text",
        defaultMessage: "Generating"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_generating_icon_alt_text: {
        id: "search_ai.ai_answer_generating_icon_alt_text",
        defaultMessage: "Generating icon"
    },
    ai_answer_button_tooltip_message: {
        id: "search_ai_answer_prompt.ask_ai_button.tooltip",
        defaultMessage: "Ask a question in search to get an answer from Atlassian Intelligence"
    },
    ai_answer_reading_aids_banner_header: {
        id: "search_ai.reading_aids.banner_header",
        defaultMessage: "Define any term with AI, not just acronyms"
    },
    ai_answer_reading_aids_banner_description: {
        id: "search_ai.reading_aids.banner_description",
        defaultMessage: "Get definitions for project terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    reading_aids_edited_definition_report_modal_title: {
        id: "search_ai.reading_aids_edited_definition_report_modal_title",
        defaultMessage: "Help us improve Definitions"
    },
    reading_aids_edited_definition_report_label: {
        id: "search_ai.reading_aids_edited_definition_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    knowledge_cards_view_team: {
        id: "search_ai.knowledge_cards.view_team",
        defaultMessage: "View team"
    },
    knowledge_cards_team_subheader: {
        id: "search_ai.knowledge_cards.team_subheader",
        defaultMessage: "Team"
    },
    knowledge_cards_copy_email_address: {
        id: "search_ai.knowledge_cards.copy_email_address",
        defaultMessage: "Copy email address"
    },
    knowledge_cards_recent_work_subheader: {
        id: "search_ai.knowledge_cards.recent_work_subheader",
        defaultMessage: "Recent work"
    },
    knowledge_cards_worked_on_subheader: {
        id: "search_ai.knowledge_cards.worked_on_subheader",
        defaultMessage: "Worked on"
    },
    knowledge_cards_collaborators_subheader: {
        id: "search_ai.knowledge_cards.collaborators_subheader",
        defaultMessage: "Collaborators"
    },
    knowledge_cards_recent_work_empty: {
        id: "search_ai.knowledge_cards.recent_work_empty",
        defaultMessage: "No recent work"
    },
    knowledge_cards_collaborators_empty: {
        id: "search_ai.knowledge_cards.collaborators_empty",
        defaultMessage: "No recent collaborators"
    },
    knowledge_cards_teammembers_empty: {
        id: "search_ai.knowledge_cards.teammembers_empty",
        defaultMessage: "No team members"
    },
    knowledge_cards_view_all_link: {
        id: "search_ai.knowledge_cards.view_all_link",
        defaultMessage: "View all"
    },
    knowledge_cards_team_members_subheader: {
        id: "search_ai.knowledge_cards.team_members_subheader",
        defaultMessage: "Team members"
    },
    knowledge_cards_view_agent: {
        id: "search_ai.knowledge_cards.view_agent",
        defaultMessage: "View agent"
    },
    knowledge_cards_agent_subheader: {
        id: "search_ai.knowledge_cards.agent_subheader",
        defaultMessage: "AI Agent"
    },
    knowledge_cards_rovo_agent_by: {
        id: "search_ai.knowledge_cards.rovo_agent_by",
        defaultMessage: "by"
    },
    knowledge_cards_teams_subheader: {
        id: "search_ai.knowledge_cards.teams_subheader",
        defaultMessage: "Teams"
    },
    knowledge_cards_team_member_count: {
        id: "search_ai.knowledge_cards.team_member_count",
        defaultMessage: "{count} members"
    },
    knowledge_cards_person_hover_profile_link: {
        id: "search_ai.knowledge_cards.person_hover_profile_link",
        defaultMessage: "View profile"
    },
    ai_answer_onboarding_banner_info_galaxia: {
        id: "search_ai.ai_answer_onboarding_banner_info-galaxia",
        defaultMessage: "Ask about a space or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_reading_aids_banner_description_galaxia: {
        id: "search_ai.reading_aids.banner_description-galaxia",
        defaultMessage: "Get definitions for space terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    knowledge_cards_person_org_chart_label: {
        id: "search_ai.knowledge_cards_person_org_chart_label",
        defaultMessage: "Reporting line"
    },
    knowledge_cards_person_org_chart_modal_header: {
        id: "search_ai.knowledge_cards_person_org_chart_modal_header",
        defaultMessage: "Reporting Line"
    },
    ai_answer_sac_feedback_option_not_relevant: {
        id: "search_ai.sac_feedback_option_not_relevant",
        defaultMessage: "Wasn't relevant"
    },
    ai_answer_sac_feedback_option_not_accurate: {
        id: "search_ai.sac_feedback_option_not_accurate",
        defaultMessage: "Wasn't accurate"
    },
    ai_answer_sac_feedback_option_too_slow: {
        id: "search_ai.sac_feedback_option_too_slow",
        defaultMessage: "Too slow"
    },
    ai_answer_sac_feedback_option_unhelpful: {
        id: "search_ai.sac_feedback_option_unhelpful",
        defaultMessage: "Unhelpful links"
    },
    ai_answer_sac_feedback_option_other: {
        id: "search_ai.sac_feedback_option_other",
        defaultMessage: "Other"
    }
});
module.exports["messages"] = $827bbb02634e926d$export$defe85febe8b728c;

});

parcelRegister("ab1fW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lBFuf = parcelRequire("lBFuf");


var $kIvLT = parcelRequire("kIvLT");


var $jA9SA = parcelRequire("jA9SA");

const $de70ae3c39f94954$export$668058776bea98f5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const analyticsPropertiesRef = (0, $42omo.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $42omo.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref,
        children: followUpText
    });
});
module.exports["FollowUpButton"] = $de70ae3c39f94954$export$668058776bea98f5;

});

parcelRegister("2YIh2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $4JDbp = parcelRequire("4JDbp");


var $g91Ox = parcelRequire("g91Ox");

const $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT = 180;
const $2fb19ef32ab04e83$var$unbouncedStyles = {
    name: "_11c81qyo _1reo15vq _18m915vq _k48p1wq8 _y3gn1h6o _1bto1l2s _1e0ccj1k _sudp1e54 _1yyjcs5v"
};
const $2fb19ef32ab04e83$var$styles = {
    emptyLine: "_4t3igktf"
};
function $2fb19ef32ab04e83$export$4c094c8f61edecb4({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(0);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $g91Ox.PersonCardWrapper), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.default), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                        src: avatarUrl,
                        name: name,
                        size: width < $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "h2",
                                xcss: $2fb19ef32ab04e83$var$unbouncedStyles.name,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 1,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: [
                                    location,
                                    localTime
                                ].filter(Boolean).join(' ')
                            }),
                            shouldShowEmptyLine && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $2fb19ef32ab04e83$var$styles.emptyLine
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
module.exports["PersonCard"] = $2fb19ef32ab04e83$export$4c094c8f61edecb4;

});

parcelRegister("g91Ox", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $ead1b65abe4e11c5$var$wrapperStyles = {
    root: "_2rko1mok _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _4t3i1osq _1ul91lit _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _kqswh2mm _9oik1r31 _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
const $ead1b65abe4e11c5$export$a3474cd1dd8e70a = ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ead1b65abe4e11c5$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`,
        children: children
    });
};
module.exports["PersonCardWrapper"] = $ead1b65abe4e11c5$export$a3474cd1dd8e70a;

});

parcelRegister("bvjDB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63af381965cffd1b2653ae2b97232288>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8601d29e65a3bd86$var$_react = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("42omo")));

var $8601d29e65a3bd86$var$_baseNew = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8601d29e65a3bd86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minimize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8601d29e65a3bd86$var$MinimizeIcon = (props)=>/*#__PURE__*/ $8601d29e65a3bd86$var$_react.default.createElement($8601d29e65a3bd86$var$_baseNew.default, Object.assign({
        name: "MinimizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 14H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$8601d29e65a3bd86$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $8601d29e65a3bd86$var$_default = module.exports.default = $8601d29e65a3bd86$var$MinimizeIcon;

});

parcelRegister("69PnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bb7135644f74cd$var$_react = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $47bb7135644f74cd$var$_baseNew = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $47bb7135644f74cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47bb7135644f74cd$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $47bb7135644f74cd$var$_react.default.createElement($47bb7135644f74cd$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$47bb7135644f74cd$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $47bb7135644f74cd$var$_default = module.exports.default = $47bb7135644f74cd$var$ArrowUpRightIcon;

});

parcelRegister("39EIK", function(module, exports) {
/* knowledge-cards-topics.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $aK1zu = parcelRequire("aK1zu");

const $7dad6b71e18043a2$var$styles = {
    root: ""
};
const $7dad6b71e18043a2$export$71025593c3acaa9c = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $7dad6b71e18043a2$var$styles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aK1zu.AITopicsByPerson), {
            ...props
        })
    });
};
module.exports["KnowledgeCardsTopics"] = $7dad6b71e18043a2$export$71025593c3acaa9c;

});

parcelRegister("9D6Kx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::240d2a2d2ecd17e4d685f807cd1b54f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $702cfde9ca1d470b$var$_react = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("42omo")));

var $702cfde9ca1d470b$var$_baseNew = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $702cfde9ca1d470b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $702cfde9ca1d470b$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $702cfde9ca1d470b$var$_react.default.createElement($702cfde9ca1d470b$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$702cfde9ca1d470b$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $702cfde9ca1d470b$var$_default = module.exports.default = $702cfde9ca1d470b$var$BookWithBookmarkIcon;

});

parcelRegister("aUwPP", function(module, exports) {

var $9LRzA = parcelRequire("9LRzA");


var $5abq6 = parcelRequire("5abq6");


var $b9lC3 = parcelRequire("b9lC3");


var $87fJd = parcelRequire("87fJd");

const $8f944f557ac62b40$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $9LRzA.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $b9lC3.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $b9lC3.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $b9lC3.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $87fJd.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $8f944f557ac62b40$export$171e576bb7c729fa;

});

parcelRegister("b9lC3", function(module, exports) {

var $aU3dp = parcelRequire("aU3dp");

var $d925B = parcelRequire("d925B");


var $dhoHU = parcelRequire("dhoHU");


var $5abq6 = parcelRequire("5abq6");


var $kecXX = parcelRequire("kecXX");


var $by9bj = parcelRequire("by9bj");

const $a4290f7701cf1730$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $a4290f7701cf1730$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $dhoHU.toggleBlockMark)(indentation, getNewIndentationAttrs, $a4290f7701cf1730$export$54db194d337db321)(state, dispatch);
    };
}
function $a4290f7701cf1730$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $kecXX.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $a4290f7701cf1730$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $by9bj.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $a4290f7701cf1730$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getIndentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $a4290f7701cf1730$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getOutdentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $a4290f7701cf1730$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $dhoHU.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $a4290f7701cf1730$export$54db194d337db321;
module.exports["getIndentCommand"] = $a4290f7701cf1730$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $a4290f7701cf1730$export$620b2a1f10eb3a5f;

});

parcelRegister("kecXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4de3432317ffe3$export$2e2bcd8739ae039);
function $2d4de3432317ffe3$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("by9bj", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aU3dp = parcelRequire("aU3dp");

const $a44445544afb543f$var$indentTypes = {
    paragraph: (0, $aU3dp.INDENT_TYPE).PARAGRAPH,
    heading: (0, $aU3dp.INDENT_TYPE).HEADING
};
function $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $a44445544afb543f$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $a44445544afb543f$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $a44445544afb543f$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $a44445544afb543f$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $a44445544afb543f$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $a44445544afb543f$export$4f15b45384b61427;

});

parcelRegister("87fJd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $kTbzR = parcelRequire("kTbzR");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");


var $b9lC3 = parcelRequire("b9lC3");

function $e60d68c782a1a955$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $b9lC3.getIndentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.outdent)), (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $kTbzR.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $8m4tT.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
var $e60d68c782a1a955$export$2e2bcd8739ae039 = $e60d68c782a1a955$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $e60d68c782a1a955$export$e832373cff8dec22;

});

parcelRegister("1R3zJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e6d73fa950add8a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afa74181baaa67be5e1a2274a7254425>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $fP78j = parcelRequire("fP78j");

function $e6d73fa950add8a3$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("bTdbD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48827792ad56aec1327e3c5557d624a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a7f0f5cf9a8ca34$var$_react = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("42omo")));

var $8a7f0f5cf9a8ca34$var$_baseNew = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8a7f0f5cf9a8ca34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a7f0f5cf9a8ca34$var$PagesIcon = (props)=>/*#__PURE__*/ $8a7f0f5cf9a8ca34$var$_react.default.createElement($8a7f0f5cf9a8ca34$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$8a7f0f5cf9a8ca34$var$PagesIcon.displayName = 'PagesIcon';
var $8a7f0f5cf9a8ca34$var$_default = module.exports.default = $8a7f0f5cf9a8ca34$var$PagesIcon;

});

parcelRegister("lM0k7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f9c25083e911723e75d25e884618325>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd9e54e9a7d9c520$var$_react = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("42omo")));

var $fd9e54e9a7d9c520$var$_baseNew = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fd9e54e9a7d9c520$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Design task' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd9e54e9a7d9c520$var$PenIcon = (props)=>/*#__PURE__*/ $fd9e54e9a7d9c520$var$_react.default.createElement($fd9e54e9a7d9c520$var$_baseNew.default, Object.assign({
        name: "PenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.72.72a.75.75 0 0 1 .73-.194l9.167 2.522a2 2 0 0 1 1.461 1.739l.294 3.083a2 2 0 0 1 2.042.483L15.78 9.72a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-1.366-1.366a2 2 0 0 1-.484-2.042l-3.083-.294a2 2 0 0 1-1.74-1.46L.528 1.448A.75.75 0 0 1 .72.72m12.634 8.694a.5.5 0 0 0-.707 0l-3.233 3.232a.5.5 0 0 0 0 .707l.836.836 3.94-3.94zM6.636 5.575a1.624 1.624 0 0 1 2.114 1.55 1.625 1.625 0 1 1-3.175-.49l-2.85-2.85 1.77 6.435a.5.5 0 0 0 .435.365l4.04.384 1.999-2-.384-4.04a.5.5 0 0 0-.365-.435l-6.435-1.77z" clip-rule="evenodd"/>`
    }, props));
$fd9e54e9a7d9c520$var$PenIcon.displayName = 'PenIcon';
var $fd9e54e9a7d9c520$var$_default = module.exports.default = $fd9e54e9a7d9c520$var$PenIcon;

});

parcelRegister("6bRC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Doctype = module.exports.CDATA = module.exports.Tag = module.exports.Style = module.exports.Script = module.exports.Comment = module.exports.Directive = module.exports.Text = module.exports.Root = module.exports.isTag = module.exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */ var $481d5bd0dde00292$var$ElementType;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($481d5bd0dde00292$var$ElementType = module.exports.ElementType || (module.exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ function $481d5bd0dde00292$var$isTag(elem) {
    return elem.type === $481d5bd0dde00292$var$ElementType.Tag || elem.type === $481d5bd0dde00292$var$ElementType.Script || elem.type === $481d5bd0dde00292$var$ElementType.Style;
}
module.exports.isTag = $481d5bd0dde00292$var$isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */ module.exports.Root = $481d5bd0dde00292$var$ElementType.Root;
/** Type for Text */ module.exports.Text = $481d5bd0dde00292$var$ElementType.Text;
/** Type for <? ... ?> */ module.exports.Directive = $481d5bd0dde00292$var$ElementType.Directive;
/** Type for <!-- ... --> */ module.exports.Comment = $481d5bd0dde00292$var$ElementType.Comment;
/** Type for <script> tags */ module.exports.Script = $481d5bd0dde00292$var$ElementType.Script;
/** Type for <style> tags */ module.exports.Style = $481d5bd0dde00292$var$ElementType.Style;
/** Type for Any tag */ module.exports.Tag = $481d5bd0dde00292$var$ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */ module.exports.CDATA = $481d5bd0dde00292$var$ElementType.CDATA;
/** Type for <!doctype ...> */ module.exports.Doctype = $481d5bd0dde00292$var$ElementType.Doctype;

});

parcelRegister("7Rnqo", function(module, exports) {
module.exports = {
    trueFunc: function trueFunc() {
        return true;
    },
    falseFunc: function falseFunc() {
        return false;
    }
};

});

parcelRegister("fftKo", function(module, exports) {

var $bGFyo = parcelRequire("bGFyo");

const $b19f54e58e62e654$var$reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const $b19f54e58e62e654$var$reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const $b19f54e58e62e654$var$actionTypes = new Map([
    [
        126 /* Tilde */ ,
        (0, $bGFyo.AttributeAction).Element
    ],
    [
        94 /* Circumflex */ ,
        (0, $bGFyo.AttributeAction).Start
    ],
    [
        36 /* Dollar */ ,
        (0, $bGFyo.AttributeAction).End
    ],
    [
        42 /* Asterisk */ ,
        (0, $bGFyo.AttributeAction).Any
    ],
    [
        33 /* ExclamationMark */ ,
        (0, $bGFyo.AttributeAction).Not
    ],
    [
        124 /* Pipe */ ,
        (0, $bGFyo.AttributeAction).Hyphen
    ]
]);
// Pseudos, whose data property is parsed as well.
const $b19f54e58e62e654$var$unpackPseudos = new Set([
    "has",
    "not",
    "matches",
    "is",
    "where",
    "host",
    "host-context"
]);
function $b19f54e58e62e654$export$41d1fe2780697dca(selector) {
    switch(selector.type){
        case (0, $bGFyo.SelectorType).Adjacent:
        case (0, $bGFyo.SelectorType).Child:
        case (0, $bGFyo.SelectorType).Descendant:
        case (0, $bGFyo.SelectorType).Parent:
        case (0, $bGFyo.SelectorType).Sibling:
        case (0, $bGFyo.SelectorType).ColumnCombinator:
            return true;
        default:
            return false;
    }
}
const $b19f54e58e62e654$var$stripQuotesFromPseudos = new Set([
    "contains",
    "icontains"
]);
// Unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L152
function $b19f54e58e62e654$var$funescape(_, escaped, escapedWhitespace) {
    const high = parseInt(escaped, 16) - 0x10000;
    // NaN means non-codepoint
    return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xd800, high & 0x3ff | 0xdc00);
}
function $b19f54e58e62e654$var$unescapeCSS(str) {
    return str.replace($b19f54e58e62e654$var$reEscape, $b19f54e58e62e654$var$funescape);
}
function $b19f54e58e62e654$var$isQuote(c) {
    return c === 39 /* SingleQuote */  || c === 34 /* DoubleQuote */ ;
}
function $b19f54e58e62e654$var$isWhitespace(c) {
    return c === 32 /* Space */  || c === 9 /* Tab */  || c === 10 /* NewLine */  || c === 12 /* FormFeed */  || c === 13 /* CarriageReturn */ ;
}
function $b19f54e58e62e654$export$98e6a39c04603d36(selector) {
    const subselects = [];
    const endIndex = $b19f54e58e62e654$var$parseSelector(subselects, `${selector}`, 0);
    if (endIndex < selector.length) throw new Error(`Unmatched selector: ${selector.slice(endIndex)}`);
    return subselects;
}
function $b19f54e58e62e654$var$parseSelector(subselects, selector, selectorIndex) {
    let tokens = [];
    function getName(offset) {
        const match = selector.slice(selectorIndex + offset).match($b19f54e58e62e654$var$reName);
        if (!match) throw new Error(`Expected name, found ${selector.slice(selectorIndex)}`);
        const [name] = match;
        selectorIndex += offset + name.length;
        return $b19f54e58e62e654$var$unescapeCSS(name);
    }
    function stripWhitespace(offset) {
        selectorIndex += offset;
        while(selectorIndex < selector.length && $b19f54e58e62e654$var$isWhitespace(selector.charCodeAt(selectorIndex)))selectorIndex++;
    }
    function readValueWithParenthesis() {
        selectorIndex += 1;
        const start = selectorIndex;
        let counter = 1;
        for(; counter > 0 && selectorIndex < selector.length; selectorIndex++){
            if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  && !isEscaped(selectorIndex)) counter++;
            else if (selector.charCodeAt(selectorIndex) === 41 /* RightParenthesis */  && !isEscaped(selectorIndex)) counter--;
        }
        if (counter) throw new Error("Parenthesis not matched");
        return $b19f54e58e62e654$var$unescapeCSS(selector.slice(start, selectorIndex - 1));
    }
    function isEscaped(pos) {
        let slashCount = 0;
        while(selector.charCodeAt(--pos) === 92 /* BackSlash */ )slashCount++;
        return (slashCount & 1) === 1;
    }
    function ensureNotTraversal() {
        if (tokens.length > 0 && $b19f54e58e62e654$export$41d1fe2780697dca(tokens[tokens.length - 1])) throw new Error("Did not expect successive traversals.");
    }
    function addTraversal(type) {
        if (tokens.length > 0 && tokens[tokens.length - 1].type === (0, $bGFyo.SelectorType).Descendant) {
            tokens[tokens.length - 1].type = type;
            return;
        }
        ensureNotTraversal();
        tokens.push({
            type: type
        });
    }
    function addSpecialAttribute(name, action) {
        tokens.push({
            type: (0, $bGFyo.SelectorType).Attribute,
            name: name,
            action: action,
            value: getName(1),
            namespace: null,
            ignoreCase: "quirks"
        });
    }
    /**
     * We have finished parsing the current part of the selector.
     *
     * Remove descendant tokens at the end if they exist,
     * and return the last index, so that parsing can be
     * picked up from here.
     */ function finalizeSubselector() {
        if (tokens.length && tokens[tokens.length - 1].type === (0, $bGFyo.SelectorType).Descendant) tokens.pop();
        if (tokens.length === 0) throw new Error("Empty sub-selector");
        subselects.push(tokens);
    }
    stripWhitespace(0);
    if (selector.length === selectorIndex) return selectorIndex;
    loop: while(selectorIndex < selector.length){
        const firstChar = selector.charCodeAt(selectorIndex);
        switch(firstChar){
            // Whitespace
            case 32 /* Space */ :
            case 9 /* Tab */ :
            case 10 /* NewLine */ :
            case 12 /* FormFeed */ :
            case 13 /* CarriageReturn */ :
                if (tokens.length === 0 || tokens[0].type !== (0, $bGFyo.SelectorType).Descendant) {
                    ensureNotTraversal();
                    tokens.push({
                        type: (0, $bGFyo.SelectorType).Descendant
                    });
                }
                stripWhitespace(1);
                break;
            // Traversals
            case 62 /* GreaterThan */ :
                addTraversal((0, $bGFyo.SelectorType).Child);
                stripWhitespace(1);
                break;
            case 60 /* LessThan */ :
                addTraversal((0, $bGFyo.SelectorType).Parent);
                stripWhitespace(1);
                break;
            case 126 /* Tilde */ :
                addTraversal((0, $bGFyo.SelectorType).Sibling);
                stripWhitespace(1);
                break;
            case 43 /* Plus */ :
                addTraversal((0, $bGFyo.SelectorType).Adjacent);
                stripWhitespace(1);
                break;
            // Special attribute selectors: .class, #id
            case 46 /* Period */ :
                addSpecialAttribute("class", (0, $bGFyo.AttributeAction).Element);
                break;
            case 35 /* Hash */ :
                addSpecialAttribute("id", (0, $bGFyo.AttributeAction).Equals);
                break;
            case 91 /* LeftSquareBracket */ :
                {
                    stripWhitespace(1);
                    // Determine attribute name and namespace
                    let name;
                    let namespace = null;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ ) // Equivalent to no namespace
                    name = getName(1);
                    else if (selector.startsWith("*|", selectorIndex)) {
                        namespace = "*";
                        name = getName(2);
                    } else {
                        name = getName(0);
                        if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) {
                            namespace = name;
                            name = getName(1);
                        }
                    }
                    stripWhitespace(0);
                    // Determine comparison operation
                    let action = (0, $bGFyo.AttributeAction).Exists;
                    const possibleAction = $b19f54e58e62e654$var$actionTypes.get(selector.charCodeAt(selectorIndex));
                    if (possibleAction) {
                        action = possibleAction;
                        if (selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) throw new Error("Expected `=`");
                        stripWhitespace(2);
                    } else if (selector.charCodeAt(selectorIndex) === 61 /* Equal */ ) {
                        action = (0, $bGFyo.AttributeAction).Equals;
                        stripWhitespace(1);
                    }
                    // Determine value
                    let value = "";
                    let ignoreCase = null;
                    if (action !== "exists") {
                        if ($b19f54e58e62e654$var$isQuote(selector.charCodeAt(selectorIndex))) {
                            const quote = selector.charCodeAt(selectorIndex);
                            let sectionEnd = selectorIndex + 1;
                            while(sectionEnd < selector.length && (selector.charCodeAt(sectionEnd) !== quote || isEscaped(sectionEnd)))sectionEnd += 1;
                            if (selector.charCodeAt(sectionEnd) !== quote) throw new Error("Attribute value didn't end");
                            value = $b19f54e58e62e654$var$unescapeCSS(selector.slice(selectorIndex + 1, sectionEnd));
                            selectorIndex = sectionEnd + 1;
                        } else {
                            const valueStart = selectorIndex;
                            while(selectorIndex < selector.length && (!$b19f54e58e62e654$var$isWhitespace(selector.charCodeAt(selectorIndex)) && selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */  || isEscaped(selectorIndex)))selectorIndex += 1;
                            value = $b19f54e58e62e654$var$unescapeCSS(selector.slice(valueStart, selectorIndex));
                        }
                        stripWhitespace(0);
                        // See if we have a force ignore flag
                        const forceIgnore = selector.charCodeAt(selectorIndex) | 0x20;
                        // If the forceIgnore flag is set (either `i` or `s`), use that value
                        if (forceIgnore === 115 /* LowerS */ ) {
                            ignoreCase = false;
                            stripWhitespace(1);
                        } else if (forceIgnore === 105 /* LowerI */ ) {
                            ignoreCase = true;
                            stripWhitespace(1);
                        }
                    }
                    if (selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */ ) throw new Error("Attribute selector didn't terminate");
                    selectorIndex += 1;
                    const attributeSelector = {
                        type: (0, $bGFyo.SelectorType).Attribute,
                        name: name,
                        action: action,
                        value: value,
                        namespace: namespace,
                        ignoreCase: ignoreCase
                    };
                    tokens.push(attributeSelector);
                    break;
                }
            case 58 /* Colon */ :
                {
                    if (selector.charCodeAt(selectorIndex + 1) === 58 /* Colon */ ) {
                        tokens.push({
                            type: (0, $bGFyo.SelectorType).PseudoElement,
                            name: getName(2).toLowerCase(),
                            data: selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  ? readValueWithParenthesis() : null
                        });
                        continue;
                    }
                    const name = getName(1).toLowerCase();
                    let data = null;
                    if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */ ) {
                        if ($b19f54e58e62e654$var$unpackPseudos.has(name)) {
                            if ($b19f54e58e62e654$var$isQuote(selector.charCodeAt(selectorIndex + 1))) throw new Error(`Pseudo-selector ${name} cannot be quoted`);
                            data = [];
                            selectorIndex = $b19f54e58e62e654$var$parseSelector(data, selector, selectorIndex + 1);
                            if (selector.charCodeAt(selectorIndex) !== 41 /* RightParenthesis */ ) throw new Error(`Missing closing parenthesis in :${name} (${selector})`);
                            selectorIndex += 1;
                        } else {
                            data = readValueWithParenthesis();
                            if ($b19f54e58e62e654$var$stripQuotesFromPseudos.has(name)) {
                                const quot = data.charCodeAt(0);
                                if (quot === data.charCodeAt(data.length - 1) && $b19f54e58e62e654$var$isQuote(quot)) data = data.slice(1, -1);
                            }
                            data = $b19f54e58e62e654$var$unescapeCSS(data);
                        }
                    }
                    tokens.push({
                        type: (0, $bGFyo.SelectorType).Pseudo,
                        name: name,
                        data: data
                    });
                    break;
                }
            case 44 /* Comma */ :
                finalizeSubselector();
                tokens = [];
                stripWhitespace(1);
                break;
            default:
                {
                    if (selector.startsWith("/*", selectorIndex)) {
                        const endIndex = selector.indexOf("*/", selectorIndex + 2);
                        if (endIndex < 0) throw new Error("Comment was not terminated");
                        selectorIndex = endIndex + 2;
                        // Remove leading whitespace
                        if (tokens.length === 0) stripWhitespace(0);
                        break;
                    }
                    let namespace = null;
                    let name;
                    if (firstChar === 42 /* Asterisk */ ) {
                        selectorIndex += 1;
                        name = "*";
                    } else if (firstChar === 124 /* Pipe */ ) {
                        name = "";
                        if (selector.charCodeAt(selectorIndex + 1) === 124 /* Pipe */ ) {
                            addTraversal((0, $bGFyo.SelectorType).ColumnCombinator);
                            stripWhitespace(2);
                            break;
                        }
                    } else if ($b19f54e58e62e654$var$reName.test(selector.slice(selectorIndex))) name = getName(0);
                    else break loop;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 124 /* Pipe */ ) {
                        namespace = name;
                        if (selector.charCodeAt(selectorIndex + 1) === 42 /* Asterisk */ ) {
                            name = "*";
                            selectorIndex += 2;
                        } else name = getName(1);
                    }
                    tokens.push(name === "*" ? {
                        type: (0, $bGFyo.SelectorType).Universal,
                        namespace: namespace
                    } : {
                        type: (0, $bGFyo.SelectorType).Tag,
                        name: name,
                        namespace: namespace
                    });
                }
        }
    }
    finalizeSubselector();
    return selectorIndex;
}
module.exports["isTraversal"] = $b19f54e58e62e654$export$41d1fe2780697dca;
module.exports["parse"] = $b19f54e58e62e654$export$98e6a39c04603d36;

});

parcelRegister("bGFyo", function(module, exports) {
$parcel$export(module.exports, "SelectorType", () => $8823d9a2a18ac4eb$export$4e8b093ec8dcab0d);
$parcel$export(module.exports, "AttributeAction", () => $8823d9a2a18ac4eb$export$dbc3de62b8fcdc89);
var $8823d9a2a18ac4eb$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["Attribute"] = "attribute";
    SelectorType["Pseudo"] = "pseudo";
    SelectorType["PseudoElement"] = "pseudo-element";
    SelectorType["Tag"] = "tag";
    SelectorType["Universal"] = "universal";
    // Traversals
    SelectorType["Adjacent"] = "adjacent";
    SelectorType["Child"] = "child";
    SelectorType["Descendant"] = "descendant";
    SelectorType["Parent"] = "parent";
    SelectorType["Sibling"] = "sibling";
    SelectorType["ColumnCombinator"] = "column-combinator";
})($8823d9a2a18ac4eb$export$4e8b093ec8dcab0d || ($8823d9a2a18ac4eb$export$4e8b093ec8dcab0d = {}));
const $8823d9a2a18ac4eb$export$b378b9ead145a8a4 = {
    Unknown: null,
    QuirksMode: "quirks",
    IgnoreCase: true,
    CaseSensitive: false
};
var $8823d9a2a18ac4eb$export$dbc3de62b8fcdc89;
(function(AttributeAction) {
    AttributeAction["Any"] = "any";
    AttributeAction["Element"] = "element";
    AttributeAction["End"] = "end";
    AttributeAction["Equals"] = "equals";
    AttributeAction["Exists"] = "exists";
    AttributeAction["Hyphen"] = "hyphen";
    AttributeAction["Not"] = "not";
    AttributeAction["Start"] = "start";
})($8823d9a2a18ac4eb$export$dbc3de62b8fcdc89 || ($8823d9a2a18ac4eb$export$dbc3de62b8fcdc89 = {}));

});

parcelRegister("2aBVB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sequence = module.exports.generate = module.exports.compile = module.exports.parse = void 0;

var $cYV4C = parcelRequire("cYV4C");

Object.defineProperty(module.exports, "parse", {
    enumerable: true,
    get: function() {
        return $cYV4C.parse;
    }
});

var $iqfbE = parcelRequire("iqfbE");

Object.defineProperty(module.exports, "compile", {
    enumerable: true,
    get: function() {
        return $iqfbE.compile;
    }
});
Object.defineProperty(module.exports, "generate", {
    enumerable: true,
    get: function() {
        return $iqfbE.generate;
    }
});
/**
 * Parses and compiles a formula to a highly optimized function.
 * Combination of {@link parse} and {@link compile}.
 *
 * If the formula doesn't match any elements,
 * it returns [`boolbase`](https://github.com/fb55/boolbase)'s `falseFunc`.
 * Otherwise, a function accepting an _index_ is returned, which returns
 * whether or not the passed _index_ matches the formula.
 *
 * Note: The nth-rule starts counting at `1`, the returned function at `0`.
 *
 * @param formula The formula to compile.
 * @example
 * const check = nthCheck("2n+3");
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 */ function $1949efacd65a495e$var$nthCheck(formula) {
    return (0, $iqfbE.compile)((0, $cYV4C.parse)(formula));
}
module.exports.default = $1949efacd65a495e$var$nthCheck;
/**
 * Parses and compiles a formula to a generator that produces a sequence of indices.
 * Combination of {@link parse} and {@link generate}.
 *
 * @param formula The formula to compile.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing</caption>
 *
 * ```js
 * const gen = nthCheck.sequence('2n+3')
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value</caption>
 *
 * ```js
 *
 * const gen = nthCheck.sequence('-2n+5');
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */ function $1949efacd65a495e$var$sequence(formula) {
    return (0, $iqfbE.generate)((0, $cYV4C.parse)(formula));
}
module.exports.sequence = $1949efacd65a495e$var$sequence;

});

parcelRegister("cYV4C", function(module, exports) {
"use strict";
// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = void 0;
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
var $97375c385ba9f00e$var$whitespace = new Set([
    9,
    10,
    12,
    13,
    32
]);
var $97375c385ba9f00e$var$ZERO = "0".charCodeAt(0);
var $97375c385ba9f00e$var$NINE = "9".charCodeAt(0);
/**
 * Parses an expression.
 *
 * @throws An `Error` if parsing fails.
 * @returns An array containing the integer step size and the integer offset of the nth rule.
 * @example nthCheck.parse("2n+3"); // returns [2, 3]
 */ function $97375c385ba9f00e$var$parse(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") return [
        2,
        0
    ];
    else if (formula === "odd") return [
        2,
        1
    ];
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    var idx = 0;
    var a = 0;
    var sign = readSign();
    var number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        } else sign = number = 0;
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) throw new Error("n-th rule couldn't be parsed ('".concat(formula, "')"));
    return [
        a,
        sign * number
    ];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") idx++;
        return 1;
    }
    function readNumber() {
        var start = idx;
        var value = 0;
        while(idx < formula.length && formula.charCodeAt(idx) >= $97375c385ba9f00e$var$ZERO && formula.charCodeAt(idx) <= $97375c385ba9f00e$var$NINE){
            value = value * 10 + (formula.charCodeAt(idx) - $97375c385ba9f00e$var$ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while(idx < formula.length && $97375c385ba9f00e$var$whitespace.has(formula.charCodeAt(idx)))idx++;
    }
}
module.exports.parse = $97375c385ba9f00e$var$parse;

});

parcelRegister("iqfbE", function(module, exports) {
"use strict";
var $d6966f8086ce294a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generate = module.exports.compile = void 0;

var $d6966f8086ce294a$var$boolbase_1 = $d6966f8086ce294a$var$__importDefault((parcelRequire("7Rnqo")));
/**
 * Returns a function that checks if an elements index matches the given rule
 * highly optimized to return the fastest solution.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A highly optimized function that returns whether an index matches the nth-check.
 * @example
 *
 * ```js
 * const check = nthCheck.compile([2, 3]);
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 * ```
 */ function $d6966f8086ce294a$var$compile(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */ if (b < 0 && a <= 0) return $d6966f8086ce294a$var$boolbase_1.default.falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1) return function(index) {
        return index <= b;
    };
    if (a === 0) return function(index) {
        return index === b;
    };
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1) return b < 0 ? $d6966f8086ce294a$var$boolbase_1.default.trueFunc : function(index) {
        return index >= b;
    };
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */ var absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    var bMod = (b % absA + absA) % absA;
    return a > 1 ? function(index) {
        return index >= b && index % absA === bMod;
    } : function(index) {
        return index <= b && index % absA === bMod;
    };
}
module.exports.compile = $d6966f8086ce294a$var$compile;
/**
 * Returns a function that produces a monotonously increasing sequence of indices.
 *
 * If the sequence has an end, the returned function will return `null` after
 * the last index in the sequence.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing (2n+3)</caption>
 *
 * ```js
 * const gen = nthCheck.generate([2, 3])
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value (-2n+10)</caption>
 *
 * ```js
 *
 * const gen = nthCheck.generate([-2, 5]);
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */ function $d6966f8086ce294a$var$generate(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    var n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        var aPos_1 = -a;
        // Get `b mod a`
        var minValue_1 = (b % aPos_1 + aPos_1) % aPos_1;
        return function() {
            var val = minValue_1 + aPos_1 * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0) return b < 0 ? function() {
        return null;
    } : function() {
        return n++ === 0 ? b : null;
    };
    if (b < 0) b += a * Math.ceil(-b / a);
    return function() {
        return a * n++ + b;
    };
}
module.exports.generate = $d6966f8086ce294a$var$generate;

});

parcelRegister("iPfZG", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2Fndw = parcelRequire("2Fndw");


var $iiBJH = parcelRequire("iiBJH");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $8cBM8 = parcelRequire("8cBM8");

const $d1e26a6c07491d4a$var$SpotlightWithVariables = (0, $iiBJH.default)((0, $8cBM8.default));
const $d1e26a6c07491d4a$export$f57123e11f24bec9 = (0, $3Npfo.default)($d1e26a6c07491d4a$var$SpotlightWithVariables);
const $d1e26a6c07491d4a$var$SpotlightWithMessage = (0, $k5HOq.default)($d1e26a6c07491d4a$export$f57123e11f24bec9, 'spotlight');
function $d1e26a6c07491d4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1e26a6c07491d4a$var$SpotlightWithMessage, props));
}

});

parcelRegister("iiBJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfa45347111319c$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $3Sftg = parcelRequire("3Sftg");

function $3cfa45347111319c$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $42omo.Component) {
        render() {
            const props = $3cfa45347111319c$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $3cfa45347111319c$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3Sftg.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3Sftg", function(module, exports) {

var $g47C5 = parcelRequire("g47C5");

var $4xewT = parcelRequire("4xewT");

function $e4ebe363c373022b$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $e4ebe363c373022b$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4xewT.runTemplateForUrl)(input, variables) : (0, $4xewT.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $g47C5.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $e4ebe363c373022b$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $e4ebe363c373022b$export$d808999430a3f186;

});

parcelRegister("g47C5", function(module, exports) {
const $e428a4697dceb24e$export$e26f00bd90899835 = 'success';
const $e428a4697dceb24e$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $e428a4697dceb24e$export$edb46161045fece7;

});

parcelRegister("4xewT", function(module, exports) {

var $i0lyP = parcelRequire("i0lyP");


var $cpDxi = parcelRequire("cpDxi");


var $g47C5 = parcelRequire("g47C5");


var $cuEWu = parcelRequire("cuEWu");

function $ace38877ac0d85ab$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $i0lyP.default)(template);
    return (0, $cuEWu.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ace38877ac0d85ab$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForUrl)(epTemplate, variables);
}
function $ace38877ac0d85ab$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $ace38877ac0d85ab$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $ace38877ac0d85ab$export$5681b97796b74884;

});

parcelRegister("i0lyP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2be59bfe0ce0113$export$2e2bcd8739ae039);

var $bz2UO = parcelRequire("bz2UO");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $e2be59bfe0ce0113$var$UNESCAPED_MATCH = 1;
const $e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS = 2;
const $e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS = 5;
function $e2be59bfe0ce0113$export$2e2bcd8739ae039(template) {
    const parts = (0, $bz2UO.regexpParts)(template, $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("bz2UO", function(module, exports) {
function $78901a26ed98192e$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $78901a26ed98192e$export$b16d411b3b6d6dff;

});

parcelRegister("cpDxi", function(module, exports) {

var $cuEWu = parcelRequire("cuEWu");


var $48gB0 = parcelRequire("48gB0");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $9d422126fe4600e0$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $cuEWu.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $9d422126fe4600e0$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForUrl(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForHtml(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, (0, $48gB0.default));
}
function $9d422126fe4600e0$export$d10ae881b12b8ef2(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForUrl);
}
function $9d422126fe4600e0$export$ca536300dbd6350(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $9d422126fe4600e0$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $9d422126fe4600e0$export$ca536300dbd6350;

});

parcelRegister("cuEWu", function(module, exports) {

var $1rjmQ = parcelRequire("1rjmQ");

function $5e0333abe2221126$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $5e0333abe2221126$export$4a33186abb06007b(template) {
    const variableParts = $5e0333abe2221126$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $1rjmQ.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $5e0333abe2221126$export$4a33186abb06007b;

});

parcelRegister("1rjmQ", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $56c35590cbe5b17a$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $56c35590cbe5b17a$export$c150c7c1a29f33d8;

});

parcelRegister("48gB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d527f6527719db2$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $8d527f6527719db2$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("3Npfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $924fbb9a636b21af$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

var $924fbb9a636b21af$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $42omo.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $1DWH0.default)()(EngagementEventsWrapper);
};

});

parcelRegister("k5HOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47b6edde9367a4f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

var $e47b6edde9367a4f$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $42omo.useState)(null);
        const unsubscribeRef = (0, $42omo.useRef)(null);
        const removeConfigRef = (0, $42omo.useRef)(null);
        const canSubscribe = (0, $42omo.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $42omo.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $42omo.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $42omo.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $42omo.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $42omo.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $42omo.useRef)(engagementId);
        const previousMessageType = (0, $42omo.useRef)(messageType);
        const previousOnMessageDisposition = (0, $42omo.useRef)(onMessageDisposition);
        (0, $42omo.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("8cBM8", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $gj7hi = parcelRequire("gj7hi");


var $5RBJ9 = parcelRequire("5RBJ9");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $hzth4 = parcelRequire("hzth4");

var $19Jj3 = parcelRequire("19Jj3");

var $eSpLK = parcelRequire("eSpLK");


var $7cTWR = parcelRequire("7cTWR");


var $8953F = parcelRequire("8953F");


var $9A5yV = parcelRequire("9A5yV");

function $86110ead6fe3e8af$var$_defineProperty(e, r, t) {
    return (r = $86110ead6fe3e8af$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $86110ead6fe3e8af$var$_toPropertyKey(t) {
    var i = $86110ead6fe3e8af$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $86110ead6fe3e8af$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $86110ead6fe3e8af$var$styles = {
    image: "_1bsb1osq"
};
const $86110ead6fe3e8af$export$f14689466e4eca7a = ({ isMigrated: isMigrated = false, ...rest })=>{
    if (isMigrated && (0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($86110ead6fe3e8af$var$MigratedAkSpotlight, rest);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($86110ead6fe3e8af$var$DeprecatedAkSpotlight, rest);
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $86110ead6fe3e8af$var$DeprecatedAkSpotlight extends (0, $42omo.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
    }
}
$86110ead6fe3e8af$var$_defineProperty($86110ead6fe3e8af$var$DeprecatedAkSpotlight, "defaultProps", {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
});
const $86110ead6fe3e8af$var$MigratedAkSpotlight = (props)=>{
    const placement = (0, $8953F.translations).dialogPlacement(props.dialogPlacement);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const dismiss = (0, $42omo.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), props.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: props.image,
        alt: "",
        className: (0, $gMc0m.default)([
            $86110ead6fe3e8af$var$styles.image
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, props.secondaryAction && (props.secondaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSpLK.SpotlightSecondaryLink), {
        onClick: dismiss,
        ...props.secondaryAction.data,
        href: props.secondaryAction.data?.url || '',
        target: props.secondaryAction.data?.target
    }, props.secondaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: dismiss,
        ...props.secondaryAction.data
    }, props.secondaryText)), props.primaryAction && (props.primaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hzth4.SpotlightPrimaryLink), {
        onClick: dismiss,
        ...props.primaryAction.data,
        href: props.primaryAction.data?.url || '',
        target: props.primaryAction.data?.target
    }, props.primaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: dismiss,
        ...props.primaryAction.data
    }, props.primaryText))))));
};
var $86110ead6fe3e8af$export$2e2bcd8739ae039 = $86110ead6fe3e8af$export$f14689466e4eca7a;
module.exports["default"] = $86110ead6fe3e8af$export$2e2bcd8739ae039;

});

parcelRegister("hzth4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");

const $ccaffbcaf2b62b3e$var$styles = {
    root: "_2rko12b0 _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr",
    outline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6d8yml _18zr12x7 _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27",
    primary: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6da755 _18zr12x7 _bfhk1856 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3hf2y _1nrm1r31 _c2waglyw _1iohnqa1 _1di6g6ey"
};
const $ccaffbcaf2b62b3e$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, appearance: appearance = 'outline', href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $1Whri.cx)($ccaffbcaf2b62b3e$var$styles.root, $ccaffbcaf2b62b3e$var$styles[appearance]),
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    }));
module.exports["SpotlightPrimaryLink"] = $ccaffbcaf2b62b3e$export$82ba9bc832fb64;

});

parcelRegister("eSpLK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");

const $8b5e95512cfdb346$var$styles = {
    root: "_2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zr12x7 _1rjcv77o _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27"
};
const $8b5e95512cfdb346$export$797d360648cfd970 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $8b5e95512cfdb346$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    }));
module.exports["SpotlightSecondaryLink"] = $8b5e95512cfdb346$export$797d360648cfd970;

});

parcelRegister("7cTWR", function(module, exports) {
const $31e3ef3c9b5f37b6$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $31e3ef3c9b5f37b6$export$e7d79186651244da;

});

parcelRegister("8953F", function(module, exports) {
const $59e8e8c8e0635f86$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
   * All of the following are actually invalid in CSS selectors.
   * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
   * If it turns out other characters are used, add them as needed.
   *
   * (space) — descendant combinator
   * > — child combinator
   * + — adjacent sibling combinator
   * ~ — general sibling combinator
   * . — class selector
   * # — ID selector
   * : — pseudo-class/element
   * [ ] — attribute selectors
   * ( ) — functional notation
   * , — selector list separator
   * * — universal selector
   * | — namespace separator
   * " ' — string delimiters
   * \ — escape character
   * Characters not allowed in unescaped identifiers:
   * Digits 0-9 cannot be the first character
   * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
   */ return value.replaceAll(' ', '-').replaceAll('/', '-');
};
const $59e8e8c8e0635f86$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $59e8e8c8e0635f86$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $59e8e8c8e0635f86$var$placementMap[value || 'bottom left'];
};
const $59e8e8c8e0635f86$export$150b732325d14d04 = {
    target: $59e8e8c8e0635f86$export$44271b4f0c6a3563,
    dialogPlacement: $59e8e8c8e0635f86$export$608d2c28a2f3926e
};
module.exports["translations"] = $59e8e8c8e0635f86$export$150b732325d14d04;

});

parcelRegister("9A5yV", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $8cb2cd879eafccd1$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $8cb2cd879eafccd1$export$2e2bcd8739ae039;

});

parcelRegister("lgqtG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $k7Tf7 = parcelRequire("k7Tf7");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $759182b58ca4f194$export$e040768d915476be = ({ children: children })=>{
    if ((0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
$759182b58ca4f194$export$e040768d915476be.displayName = 'SpotlightManager';
module.exports["SpotlightManager"] = $759182b58ca4f194$export$e040768d915476be;

});

parcelRegister("2Ehdd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5izcQ = parcelRequire("5izcQ");


var $dh538 = parcelRequire("dh538");


var $a90ar = parcelRequire("a90ar");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $46b4de62a9eb0177$export$e29577842f211e22 = ({ children: children, name: name })=>{
    if ((0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children);
};
$46b4de62a9eb0177$export$e29577842f211e22.displayName = 'SpotlightTarget';
module.exports["SpotlightTarget"] = $46b4de62a9eb0177$export$e29577842f211e22;

});

parcelRegister("iD4ky", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bCECL = parcelRequire("bCECL");


var $1ggpj = parcelRequire("1ggpj");


var $aF4oY = parcelRequire("aF4oY");


var $jghB4 = parcelRequire("jghB4");

const $1bdc45b11c697012$export$c28a8c055ae64bad = (date, isStartOfDay)=>{
    const currentDate = new Date(date);
    return isStartOfDay ? new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()).toISOString().split('Z')[0] : new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), 23, 59, 59, 999).toISOString().split('Z')[0];
};
// generates truncated iso strings for last modified filter defaults (today, yesterday, etc)
// considering the user's locale-based definition of start OR end of day
const $1bdc45b11c697012$var$getUTCDateRange = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        from: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        to: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
const $1bdc45b11c697012$export$416386056bdfd75 = (filters, activationId)=>{
    const confluenceFilters = {};
    const selectedSpaces = filters[(0, $jghB4.FilterIds).SPACES].filter((spaceOption)=>spaceOption.value !== 'default' && spaceOption.isSelected);
    if (selectedSpaces.length > 0) confluenceFilters.spacesFilter = selectedSpaces.map((spaceOption)=>spaceOption.value);
    const selectedContributors = filters[(0, $jghB4.FilterIds).CONTRIBUTORS].filter((contributorOption)=>contributorOption.value !== 'default' && contributorOption.isSelected);
    if (selectedContributors.length > 0) confluenceFilters.contributorsFilter = selectedContributors.map((contributorOption)=>contributorOption.value);
    const selectedLabels = filters[(0, $jghB4.FilterIds).LABELS].filter((labelOption)=>labelOption.isSelected);
    if (selectedLabels.length > 0) confluenceFilters.labelsFilter = selectedLabels.map((labelOption)=>labelOption.value);
    const selectedMoreFilterOptions = filters[(0, $jghB4.FilterIds).MORE].filter((moreFilterOption)=>moreFilterOption.isSelected);
    if (selectedMoreFilterOptions.length > 0) {
        const selectedValues = selectedMoreFilterOptions.map((moreFilterOption)=>moreFilterOption.value);
        if (selectedValues.includes((0, $jghB4.OptionIds).ARCHIVED)) {
            // Casting SearchConfluenceDocumentStatus & SearchContainerStatus as enum[] cannot match string[]
            confluenceFilters.contentStatuses = (0, $jghB4.INCLUDEARCHIVEDSTATUS);
            confluenceFilters.containerStatus = (0, $jghB4.INCLUDEARCHIVEDSTATUS);
        }
        if (selectedValues.includes((0, $jghB4.OptionIds).TITLE)) confluenceFilters.titleMatchOnly = true;
    }
    const selectedAncestorFilterOptions = filters[(0, $jghB4.FilterIds).ANCESTOR].filter((moreFilterOption)=>moreFilterOption.isSelected);
    if (selectedAncestorFilterOptions.length > 0 && selectedAncestorFilterOptions[0].value) confluenceFilters.ancestorIdsFilter = selectedAncestorFilterOptions.map(({ type: type, value: value })=>{
        if (type && (0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(type)) return `activation/${activationId}/${value}`;
        return value;
    });
    const selectedDateFilters = filters[(0, $jghB4.FilterIds).DATE].lastModified.filter((dateOption)=>dateOption.value !== 'default' && dateOption.isSelected);
    if (selectedDateFilters.length > 0) {
        // only one date filter can be applied at a time
        const selectedDateFilter = selectedDateFilters[0];
        const selectedDateFilterType = selectedDateFilter.value;
        let from;
        let to;
        if (selectedDateFilterType !== 'custom') {
            const transformedDateRange = $1bdc45b11c697012$export$36818d8e5e22a67e(selectedDateFilterType);
            const dateRange = $1bdc45b11c697012$export$c36e5c6cc6379ee7[transformedDateRange]?.dateRange;
            from = dateRange?.from || '';
            to = dateRange?.to || '';
        } else {
            from = filters[(0, $jghB4.FilterIds).DATE].from.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].from.value, true) : null;
            to = filters[(0, $jghB4.FilterIds).DATE].to.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].to.value, false) : null;
        }
        if (!(selectedDateFilterType === 'custom' && !from && !to)) {
            const lastModifiedRange = {
                field: (0, $aF4oY.SearchConfluenceRangeField).LASTMODIFIED,
                gt: from,
                lt: to
            };
            confluenceFilters.range = [
                lastModifiedRange
            ];
        }
    }
    const isVerified = filters[(0, $jghB4.FilterIds).VERIFIED].some((option)=>option.value === (0, $jghB4.FilterIds).VERIFIED && option.isSelected);
    if (isVerified) confluenceFilters.isVerified = isVerified;
    return confluenceFilters;
};
const $1bdc45b11c697012$export$c36e5c6cc6379ee7 = {
    [(0, $jghB4.LastModifiedValues).ANY_TIME]: {},
    [(0, $jghB4.LastModifiedValues).TODAY]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(0, 0)
    },
    [(0, $jghB4.LastModifiedValues).YESTERDAY]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(1, 1)
    },
    [(0, $jghB4.LastModifiedValues).PAST_SEVEN_DAYS]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(7, 0)
    },
    [(0, $jghB4.LastModifiedValues).PAST_THIRTY_DAYS]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(30, 0)
    },
    [(0, $jghB4.LastModifiedValues).PAST_YEAR]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(365, 0)
    },
    [(0, $jghB4.LastModifiedValues).CUSTOM]: {}
};
const $1bdc45b11c697012$export$36818d8e5e22a67e = (lastModifiedValue)=>{
    //translates previously-used values ("lastDay", "lastWeek", "lastMonth", "lastYear")
    switch(lastModifiedValue){
        case (0, $jghB4.LastModifiedValues).LAST_DAY:
            return (0, $jghB4.LastModifiedValues).TODAY;
        case (0, $jghB4.LastModifiedValues).LAST_WEEK:
            return (0, $jghB4.LastModifiedValues).PAST_SEVEN_DAYS;
        case (0, $jghB4.LastModifiedValues).LAST_MONTH:
            return (0, $jghB4.LastModifiedValues).PAST_THIRTY_DAYS;
        case (0, $jghB4.LastModifiedValues).LAST_YEAR:
            return (0, $jghB4.LastModifiedValues).PAST_YEAR;
        default:
            return lastModifiedValue;
    }
};
const $1bdc45b11c697012$export$71d48e62a870acb2 = (queryParams, filters)=>({
        contributors: queryParams?.contributors ? queryParams.contributors.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : [],
        spaces: queryParams?.spaces ? queryParams.spaces.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : [],
        contributorsToHydrate: (queryParams?.contributors ? queryParams.contributors.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : []).filter((key)=>!filters[(0, $jghB4.FilterIds).CONTRIBUTORS].some((option)=>option.value === key) || filters[(0, $jghB4.FilterIds).CONTRIBUTORS].some((option)=>option.value === key && option.avatarUrl === undefined)),
        spacesToHydrate: (queryParams?.spaces ? queryParams.spaces.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : []).filter((key)=>!filters[(0, $jghB4.FilterIds).SPACES].some((option)=>option.value === key) || filters[(0, $jghB4.FilterIds).SPACES].some((option)=>option.value === key && option.avatarUrl === undefined)),
        ancestorId: queryParams?.ancestor || '',
        selectedType: queryParams?.type,
        lastModified: queryParams?.lastModified ? $1bdc45b11c697012$export$36818d8e5e22a67e(queryParams.lastModified) : undefined
    });
// This function generates the initial option array for a given filterId
// using the default options (with appropriate isSelected value)
// & any non-default option selections transformed into FilterOption objects
const $1bdc45b11c697012$var$transformQueryParams = (defaultOptions, params)=>{
    const queryParams = [
        ...params
    ];
    const selectedDefaults = defaultOptions.map((option)=>({
            ...option,
            isSelected: queryParams.includes(option.value)
        }));
    const optionsFromParams = queryParams.filter((param)=>param && !selectedDefaults.some(({ value: value })=>value === param)).map((paramValue)=>({
            isSelected: true,
            value: paramValue,
            label: paramValue
        }));
    return [
        ...selectedDefaults,
        ...optionsFromParams
    ];
};
const $1bdc45b11c697012$export$3e02c678c13755e4 = (queryParams)=>{
    const { lastModified: lastModified = '', from: from = '', to: to = '', spaces: spaces = '', contributors: contributors = '', labels: labels = '', type: type = '', verified: verified = '', title: title, archived: archived, ancestor: ancestor } = queryParams;
    return {
        [(0, $jghB4.FilterIds).DATE]: {
            [(0, $jghB4.OptionIds).LAST_MODIFIED]: $1bdc45b11c697012$var$transformQueryParams((0, $jghB4.lastModifiedFilterOptions), [
                $1bdc45b11c697012$export$36818d8e5e22a67e(lastModified.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))[0])
            ]),
            [(0, $jghB4.OptionIds).TO]: {
                ...(0, $jghB4.toFilterOption),
                value: to || '',
                isSelected: !!to
            },
            [(0, $jghB4.OptionIds).FROM]: {
                ...(0, $jghB4.fromFilterOption),
                value: from || '',
                isSelected: !!from
            }
        },
        [(0, $jghB4.FilterIds).SPACES]: $1bdc45b11c697012$var$transformQueryParams([], spaces.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).CONTRIBUTORS]: $1bdc45b11c697012$var$transformQueryParams([], contributors.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).LABELS]: $1bdc45b11c697012$var$transformQueryParams([], labels.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).TYPE]: $1bdc45b11c697012$var$transformQueryParams([], type.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).ANCESTOR]: ancestor ? [
            {
                label: '',
                value: ancestor || '',
                isSelected: !!ancestor
            }
        ] : [],
        [(0, $jghB4.FilterIds).VERIFIED]: [
            {
                ...(0, $jghB4.verifiedOption),
                isSelected: !!verified
            }
        ],
        [(0, $jghB4.FilterIds).MORE]: [
            {
                ...(0, $jghB4.titleFilterOption),
                isSelected: !!title
            },
            {
                ...(0, $jghB4.archivedFilterOption),
                isSelected: !!archived
            }
        ]
    };
};
const $1bdc45b11c697012$export$be6bb39088374ba = (filters)=>{
    const updatedQueryParams = {};
    Object.entries(filters).forEach(([filterId, filterValues])=>{
        if (filterId === (0, $jghB4.FilterIds).MORE) {
            const selectedValues = filterValues.filter((filter)=>filter && filter.isSelected && filter.value).map((filter)=>filter.value.toString());
            updatedQueryParams[(0, $jghB4.OptionIds).ARCHIVED] = selectedValues.includes((0, $jghB4.OptionIds).ARCHIVED) || undefined;
            updatedQueryParams[(0, $jghB4.OptionIds).TITLE] = selectedValues.includes((0, $jghB4.OptionIds).TITLE) || undefined;
        } else if (filterId === (0, $jghB4.FilterIds).DATE) Object.keys(filterValues).forEach((param)=>{
            if (param === (0, $jghB4.OptionIds).LAST_MODIFIED) {
                const selectedOption = filterValues[param].find((filter)=>filter.isSelected);
                updatedQueryParams[param] = selectedOption ? selectedOption.value.toString() : undefined;
            } else if (param === (0, $jghB4.OptionIds).TO || param === (0, $jghB4.OptionIds).FROM) {
                const isCustom = updatedQueryParams[(0, $jghB4.OptionIds).LAST_MODIFIED] === (0, $jghB4.LastModifiedValues).CUSTOM;
                updatedQueryParams[param] = !!filterValues[param]?.isSelected && isCustom ? filterValues[param].value.toString() : undefined;
            }
        });
        else if (filterId === (0, $jghB4.FilterIds).VERIFIED) {
            const selectedValues = filterValues.filter((filter)=>filter && filter.isSelected && filter.value).map((filter)=>filter.value.toString());
            updatedQueryParams[(0, $jghB4.OptionIds).VERIFIED] = selectedValues.includes('verified') || undefined;
        } else {
            const selectedValues = filterValues.filter((filter)=>filter && filter.isSelected && filter.value).map((filter)=>filter.value.toString());
            updatedQueryParams[filterId] = selectedValues.length ? selectedValues.join((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : undefined;
        }
    });
    return {
        ...updatedQueryParams
    };
};
const $1bdc45b11c697012$export$dd5cf00ceb58ef45 = (filterId, filters)=>{
    const options = filters[filterId];
    if (!options) return [];
    if (filterId === (0, $jghB4.FilterIds).DATE) {
        const dateFilterSelections = [];
        if (!!filters[filterId][(0, $jghB4.OptionIds).LAST_MODIFIED].some((option)=>option.isSelected)) dateFilterSelections.push({
            ...filters[filterId][(0, $jghB4.OptionIds).LAST_MODIFIED].find((option)=>option.isSelected)
        });
        if (!!filters[filterId][(0, $jghB4.OptionIds).FROM].isSelected) dateFilterSelections.push(filters[filterId][(0, $jghB4.OptionIds).FROM]);
        if (!!filters[filterId][(0, $jghB4.OptionIds).TO].isSelected) dateFilterSelections.push(filters[filterId][(0, $jghB4.OptionIds).TO]);
        return dateFilterSelections;
    }
    if (!Array.isArray(options)) return !!options?.isSelected ? [
        options
    ] : [];
    return options.filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue)).map((option)=>({
            ...option,
            filterId: filterId
        })) || [];
};
const $1bdc45b11c697012$export$72a062c4cf43576 = (filters)=>{
    const allSelectedOptions = [];
    Object.keys(filters).forEach((filterId)=>{
        const optionSelections = $1bdc45b11c697012$export$dd5cf00ceb58ef45(filterId, filters).map((option)=>({
                value: option.value,
                isSmartDefault: !!option.isSmartDefault,
                filterId: filterId
            }));
        allSelectedOptions.push(optionSelections);
    });
    return allSelectedOptions.flat();
};
const $1bdc45b11c697012$export$5e1edcb3c154ab79 = (filterSelections)=>{
    const transformedFilters = filterSelections.map((option)=>option.filterId === (0, $jghB4.FilterIds).TYPE ? `type.${option.value}` : option.filterId);
    return Array.from(new Set(transformedFilters));
};
const $1bdc45b11c697012$export$7e427c967bc760a = (filters, skipMoreFilters)=>{
    return Object.keys(filters).some((filterId)=>{
        switch(filterId){
            case (0, $jghB4.FilterIds).DATE:
                return filters[filterId][(0, $jghB4.OptionIds).LAST_MODIFIED].some((lastModifiedOption)=>lastModifiedOption.isSelected) || filters[filterId][(0, $jghB4.OptionIds).TO].isSelected || filters[filterId][(0, $jghB4.OptionIds).FROM].isSelected;
            case (0, $jghB4.FilterIds).MORE:
                //we don't count "more" filter option selections as user input when using this function
                //for agg query skip - these selections require additional input to have an effect
                return skipMoreFilters ? false : filters[filterId].some((filterOption)=>!!filterOption?.isSelected);
            default:
                return filters[filterId].some((filterOption)=>!!filterOption?.isSelected);
        }
    });
};
const $1bdc45b11c697012$var$transformAncestorSelection = (option)=>{
    return {
        value: option.value,
        label: option.label,
        isSelected: option.isSelected,
        type: option.type,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: option.type || 'page'
        })
    };
};
const $1bdc45b11c697012$export$99a866ffa3af7d8b = ({ data: data, spaces: spaces, contributors: contributors, contributorsToHydrate: contributorsToHydrate, spacesToHydrate: spacesToHydrate, selectedType: selectedType, defaultTypesFilterOptions: defaultTypesFilterOptions, isWhiteboardsEnabledAS: isWhiteboardsEnabledAS, isDatabasesEnabledAS: isDatabasesEnabledAS, isSlidesEnabledAS: isSlidesEnabledAS, userId: userId })=>{
    const recommendations = data?.getSmartFeatures?.results?.[0]?.result?.[0]?.features;
    const hydratedUsers = (data?.confluenceUsers?.nodes || []).map((user)=>({
            value: user.accountId || '',
            label: user?.displayName || '',
            avatarUrl: user?.profilePicture?.path || '',
            isSelected: true
        }));
    const userRecommendations = (recommendations?.recommendedPeople || []).map((user)=>({
            value: user?.user?.id || '',
            label: user?.user?.displayName || '',
            avatarUrl: user?.user?.photos?.[0]?.value || '',
            isSelected: contributors.includes(user?.user?.id || ''),
            isSmartDefault: true
        })).filter((option)=>!contributorsToHydrate.includes(option.value) || option.value === userId);
    const hydratedSpaces = (data?.spaces?.nodes || []).map((space)=>({
            value: space?.key || '',
            label: space?.name || '',
            avatarUrl: space?.icon?.path || '',
            isSelected: true
        }));
    const spaceRecommendations = (recommendations?.recommendedSpaces || []).map((space)=>({
            value: space?.space?.key || '',
            label: space?.space?.name || '',
            avatarUrl: space?.space?.icon?.path || '',
            isSelected: spaces.includes(space?.space?.key || ''),
            isSmartDefault: true
        })).filter((option)=>!spacesToHydrate.includes(option.value));
    const hydratedTypes = (data?.contentTypes?.cqlContentTypes.filter((contentType)=>defaultTypesFilterOptions.find((defaultType)=>{
            const { type: type } = contentType;
            if (type?.toLowerCase() === 'whiteboard' && !isWhiteboardsEnabledAS) // When FF is off return true to ensure that we do not include whiteboard content type in hydrated list
            return true;
            if (type?.toLowerCase() === 'database' && !isDatabasesEnabledAS) // When FF is off return true to ensure that we do not include database content type in hydrated list
            return true;
            if (type?.toLowerCase() === 'slide' && !isSlidesEnabledAS) // When FF is off return true to ensure that we do not include slide content type in hydrated list
            return true;
            if (type?.toLowerCase() === 'folder') // When FF is off return true to ensure that we do not include folder content type in hydrated list
            return true;
            return defaultType.value === type;
        }) === undefined) || []).map((type)=>({
            value: type?.type || '',
            label: type?.label || '',
            isSelected: type?.type === selectedType
        }));
    const hydratedAncestor = data?.ancestorData?.id ? {
        value: data?.ancestorData?.id || '',
        label: data?.ancestorData?.title || '',
        type: data?.ancestorData?.type || '',
        isSelected: true
    } : undefined;
    const ancestorRecommendations = data?.activities?.myActivities?.viewed?.edges ? data?.activities?.myActivities?.viewed?.edges.filter((node)=>node?.node?.object?.content).map((node)=>({
            value: node?.node?.object?.content?.id || '',
            label: node?.node?.object?.content?.title || '',
            isSelected: false,
            type: node?.node?.object?.content?.type || ''
        })) : [];
    const ancestorOptions = [
        ...hydratedAncestor ? [
            hydratedAncestor
        ] : [],
        ...ancestorRecommendations
    ].filter((ancestorOption)=>ancestorOption?.value && ancestorOption.value !== '').map((ancestor)=>$1bdc45b11c697012$var$transformAncestorSelection(ancestor));
    const currentUserOption = data?.currentUser?.confluence?.accountId && !contributors.includes(data.currentUser.confluence.accountId) ? {
        value: data.currentUser.confluence.accountId,
        label: data?.currentUser?.displayName || '',
        avatarUrl: data?.currentUser?.photos.find(({ isPrimary: isPrimary })=>isPrimary)?.value || '',
        isSelected: false,
        isSmartDefault: true
    } : undefined;
    return {
        ancestorOptions: ancestorOptions,
        hydratedTypes: hydratedTypes,
        spaceOptions: hydratedSpaces.length < 5 ? [
            ...hydratedSpaces,
            ...spaceRecommendations.slice(0, 5 - hydratedSpaces.length)
        ] : [
            ...hydratedSpaces
        ],
        contributorOptions: hydratedUsers.length < 5 ? [
            ...hydratedUsers,
            ...currentUserOption ? [
                currentUserOption
            ] : [],
            ...userRecommendations.slice(0, 5 - hydratedUsers.length)
        ] : [
            ...hydratedUsers,
            ...currentUserOption ? [
                currentUserOption
            ] : []
        ]
    };
};
const $1bdc45b11c697012$export$2e52d13370d3e128 = (filters, keysFromQueryParams)=>{
    const quickSearchFilters = [
        ...filters[(0, $jghB4.FilterIds).SPACES].filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue)),
        ...filters[(0, $jghB4.FilterIds).CONTRIBUTORS].filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue)),
        ...filters[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue))
    ].map(({ value: value })=>value);
    return [
        ...quickSearchFilters,
        ...keysFromQueryParams
    ].length === 0 || keysFromQueryParams.every((key)=>quickSearchFilters.includes(key)) && quickSearchFilters.some((selectedValue)=>keysFromQueryParams.includes(selectedValue));
};
const $1bdc45b11c697012$export$1625b883b0fea34d = (filters)=>{
    if (!filters) return [];
    const selectedFilters = [];
    if (filters[(0, $jghB4.FilterIds).SPACES]) {
        const spaceKeys = filters[(0, $jghB4.FilterIds).SPACES].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (spaceKeys.length > 0) selectedFilters.push({
            '@type': 'spaces',
            spaceKeys: spaceKeys
        });
    }
    if (filters[(0, $jghB4.FilterIds).CONTRIBUTORS]) {
        const accountIds = filters[(0, $jghB4.FilterIds).CONTRIBUTORS].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (accountIds.length > 0) selectedFilters.push({
            '@type': 'contributors',
            accountIds: accountIds
        });
    }
    const selectedDateFilters = filters[(0, $jghB4.FilterIds).DATE].lastModified.filter((dateOption)=>dateOption.value !== 'default' && dateOption.isSelected);
    if (selectedDateFilters.length > 0) {
        const selectedDateFilter = selectedDateFilters[0];
        const selectedDateFilterType = selectedDateFilter.value;
        let from;
        let to;
        if (selectedDateFilterType !== 'custom') {
            const transformedDateRange = $1bdc45b11c697012$export$36818d8e5e22a67e(selectedDateFilterType);
            const dateRange = $1bdc45b11c697012$export$c36e5c6cc6379ee7[transformedDateRange]?.dateRange;
            from = dateRange?.from || '';
            to = dateRange?.to || '';
        } else {
            from = filters[(0, $jghB4.FilterIds).DATE].from.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].from.value, true) : null;
            to = filters[(0, $jghB4.FilterIds).DATE].to.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].to.value, false) : null;
        }
        if (!(selectedDateFilterType === 'custom' && !from && !to)) selectedFilters.push({
            '@type': 'lastModified',
            from: from,
            to: to
        });
    }
    if (filters[(0, $jghB4.FilterIds).LABELS]) {
        const labels = filters[(0, $jghB4.FilterIds).LABELS].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (labels.length > 0) selectedFilters.push({
            '@type': 'labels',
            labels: labels
        });
    }
    if (filters[(0, $jghB4.FilterIds).MORE]) filters[(0, $jghB4.FilterIds).MORE].filter((moreFilterOption)=>moreFilterOption.isSelected).forEach((moreFilterOption)=>{
        if (moreFilterOption.value === (0, $jghB4.OptionIds).TITLE) selectedFilters.push({
            '@type': 'titleMatchOnly',
            titleMatchOnly: true
        });
        if (moreFilterOption.value === (0, $jghB4.OptionIds).ARCHIVED) {
            selectedFilters.push({
                '@type': 'statuses',
                statuses: (0, $jghB4.INCLUDEARCHIVEDSTATUS)
            });
            selectedFilters.push({
                '@type': 'containerStatuses',
                containerStatuses: (0, $jghB4.INCLUDEARCHIVEDSTATUS)
            });
        }
    });
    if (filters[(0, $jghB4.FilterIds).ANCESTOR]) {
        const ancestorIds = filters[(0, $jghB4.FilterIds).ANCESTOR].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (ancestorIds.length > 0) selectedFilters.push({
            '@type': 'ancestorIds',
            ancestorIds: ancestorIds
        });
    }
    return selectedFilters;
};
module.exports["createAggFilters"] = $1bdc45b11c697012$export$416386056bdfd75;
module.exports["getOptionsToHydrate"] = $1bdc45b11c697012$export$71d48e62a870acb2;
module.exports["initializeFilters"] = $1bdc45b11c697012$export$3e02c678c13755e4;
module.exports["generateUpdatedQueryParams"] = $1bdc45b11c697012$export$be6bb39088374ba;
module.exports["getOptionSelections"] = $1bdc45b11c697012$export$72a062c4cf43576;
module.exports["transformFiltersForAnalytics"] = $1bdc45b11c697012$export$5e1edcb3c154ab79;
module.exports["areFiltersSelected"] = $1bdc45b11c697012$export$7e427c967bc760a;
module.exports["mapDataToOptions"] = $1bdc45b11c697012$export$99a866ffa3af7d8b;
module.exports["areFiltersConsistent"] = $1bdc45b11c697012$export$2e52d13370d3e128;
module.exports["mapFiltersToAggregator"] = $1bdc45b11c697012$export$1625b883b0fea34d;

});

parcelRegister("aF4oY", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $b8f8a57464dd98a0$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["ATTACHMENT"] = "ATTACHMENT";
    ConfluenceContentType["BLOG_POST"] = "BLOG_POST";
    ConfluenceContentType["COMMENT"] = "COMMENT";
    ConfluenceContentType["PAGE"] = "PAGE";
    ConfluenceContentType["WHITEBOARD"] = "WHITEBOARD";
    return ConfluenceContentType;
}({});
var $b8f8a57464dd98a0$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $b8f8a57464dd98a0$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["CURRENT"] = "CURRENT";
    SearchConfluenceDocumentStatus["ARCHIVED"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["DRAFT"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({});
var $b8f8a57464dd98a0$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchConfluenceRangeField["CREATED"] = "CREATED";
    return SearchConfluenceRangeField;
}({});
var $b8f8a57464dd98a0$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["ARCHIVED"] = "ARCHIVED";
    SearchContainerStatus["CURRENT"] = "CURRENT";
    return SearchContainerStatus;
}({});
var $b8f8a57464dd98a0$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["OPEN"] = "OPEN";
    SearchIssueStatusCategory["DONE"] = "DONE";
    return SearchIssueStatusCategory;
}({});
var $b8f8a57464dd98a0$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["software"] = "software";
    SearchProjectType["business"] = "business";
    SearchProjectType["service_desk"] = "service_desk";
    SearchProjectType["product_discovery"] = "product_discovery";
    return SearchProjectType;
}({});
var $b8f8a57464dd98a0$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["database"] = "database";
    SearchResultType["whiteboard"] = "whiteboard";
    SearchResultType["embed"] = "embed";
    SearchResultType["folder"] = "folder";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["dashboard"] = "dashboard";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["goal"] = "goal";
    SearchResultType["project_update"] = "project_update";
    SearchResultType["goal_update"] = "goal_update";
    SearchResultType["tag"] = "tag";
    SearchResultType["focus_area"] = "focus_area";
    SearchResultType["focus_area_status_update"] = "focus_area_status_update";
    SearchResultType["question"] = "question";
    SearchResultType["learning"] = "learning";
    SearchResultType["document"] = "document";
    SearchResultType["repository"] = "repository";
    SearchResultType["component"] = "component";
    SearchResultType["presentation"] = "presentation";
    SearchResultType["spreadsheet"] = "spreadsheet";
    SearchResultType["message"] = "message";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $b8f8a57464dd98a0$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchThirdPartyRangeField["CREATED"] = "CREATED";
    return SearchThirdPartyRangeField;
}({});
 // Note: Original file contained additional custom exports that need manual review:
 // SearchAnalyticsInput, SearchBoardFilter, SearchCommonFilter, SearchCommonRangeFilter, SearchCommonRangeFilterFields, SearchExperimentContextInput, SearchExperimentLayer, SearchExternalContainerFilter, SearchExternalContentFormatFilter, SearchExternalDepthFilter, SearchExternalFilter, SearchFilterInput, SearchJiraFilter, SearchJiraIssueFilter, SearchJiraProjectFilter, SearchLayerDefinition, SearchMercuryFilter, SearchThirdPartyFilter, SearchThirdPartyProduct, SearchThirdPartyRangeFilter, SearchTrelloFilter
 // Please verify these are handled correctly in your codebase.
module.exports["SearchConfluenceRangeField"] = $b8f8a57464dd98a0$export$641731d7c91b88de;

});


//# sourceMappingURL=AdvancedSearch.db5779f2.js.map
